export default [
  {
    "locale": "en",
    "language": {
      "name": "English"
    },
    "country": {
      "name": "International"
    }
  },
  {
    "locale": "aa-ER",
    "language": {
      "name": "Afar",
      "name_local": "Afar",
      "iso_639_1": "aa",
      "iso_639_2": "aar",
      "iso_639_3": "aar",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "af-NA",
    "language": {
      "name": "Afrikaans",
      "name_local": "Afrikaans",
      "iso_639_1": "af",
      "iso_639_2": "afr",
      "iso_639_3": "afr",
      "countries": [
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "Namibia",
      "name_local": "Namibia",
      "code": "NA",
      "area_sq_km": 825615,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Windhoek",
      "capital_latitude": -22.55941,
      "capital_longitude": 17.08323,
      "currency": "Namibian Dollar",
      "currency_local": "Namibian dollar",
      "currency_code": "NAD",
      "currency_symbol": "$",
      "currency_numeric": 516,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        }
      ],
      "flag": "🇳🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AO",
        "BW",
        "ZA",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 516,
      "iso_3166_1_alpha2": "NA",
      "iso_3166_1_alpha3": "NAM",
      "tld": "na",
      "vehicle_code": "NAM",
      "fips10": "WA",
      "un_locode": "NA",
      "stanag_1059": "NAM",
      "ioc": "NAM",
      "fifa": "NAM",
      "itu": "NMB",
      "uic": "",
      "maritime": 659,
      "mmc": 649
    }
  },
  {
    "locale": "af-ZA",
    "language": {
      "name": "Afrikaans",
      "name_local": "Afrikaans",
      "iso_639_1": "af",
      "iso_639_2": "afr",
      "iso_639_3": "afr",
      "countries": [
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "am-ET",
    "language": {
      "name": "Amharic",
      "name_local": "አማርኛ",
      "iso_639_1": "am",
      "iso_639_2": "amh",
      "iso_639_3": "amh",
      "countries": [
        {
          "name": "Ethiopia",
          "name_local": "ኢትዮጵያ Ityop̣p̣əya",
          "code": "ET"
        }
      ]
    },
    "country": {
      "name": "Ethiopia",
      "name_local": "ኢትዮጵያ Ityop̣p̣əya",
      "code": "ET",
      "area_sq_km": 1104300,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Addis Ababa",
      "capital_latitude": 9.02497,
      "capital_longitude": 38.74689,
      "currency": "Birr",
      "currency_local": "Ethiopian birr",
      "currency_code": "ETB",
      "currency_symbol": "Br",
      "currency_numeric": 230,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Amharic",
          "name_local": "አማርኛ",
          "iso_639_1": "am",
          "iso_639_2": "amh",
          "iso_639_3": "amh"
        }
      ],
      "flag": "🇪🇹",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ER",
        "KE",
        "SO",
        "SS",
        "SD"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 231,
      "iso_3166_1_alpha2": "ET",
      "iso_3166_1_alpha3": "ETH",
      "tld": "et",
      "vehicle_code": "ETH",
      "fips10": "ET",
      "un_locode": "ET",
      "stanag_1059": "ETH",
      "ioc": "ETH",
      "fifa": "ETH",
      "itu": "ETH",
      "uic": "",
      "maritime": 624,
      "mmc": 636
    }
  },
  {
    "locale": "ar-EG",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Egypt",
      "name_local": "مصر Miṣr",
      "code": "EG",
      "area_sq_km": 1002450,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Cairo",
      "capital_latitude": 30.06263,
      "capital_longitude": 31.24967,
      "currency": "Egypt Pound",
      "currency_local": "Egyptian pound",
      "currency_code": "EGP",
      "currency_symbol": "£",
      "currency_numeric": 818,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piasters",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇪🇬",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "IL",
        "LY",
        "PS",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 818,
      "iso_3166_1_alpha2": "EG",
      "iso_3166_1_alpha3": "EGY",
      "tld": "eg",
      "vehicle_code": "ET",
      "fips10": "EG",
      "un_locode": "EG",
      "stanag_1059": "EGY",
      "ioc": "EGY",
      "fifa": "EGY",
      "itu": "EGY",
      "uic": "90 ET",
      "maritime": 622,
      "mmc": 602
    }
  },
  {
    "locale": "ar-DZ",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Algeria",
      "name_local": "الجزائر al-Dschazā’ir",
      "code": "DZ",
      "area_sq_km": 2381741,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Algiers",
      "capital_latitude": 36.7525,
      "capital_longitude": 3.04197,
      "currency": "Algerian Dinar",
      "currency_local": "Algerian dinar",
      "currency_code": "DZD",
      "currency_symbol": "د.ج",
      "currency_numeric": 12,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇩🇿",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "TN",
        "LY",
        "NE",
        "EH",
        "MR",
        "ML",
        "MA"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 12,
      "iso_3166_1_alpha2": "DZ",
      "iso_3166_1_alpha3": "DZA",
      "tld": "dz",
      "vehicle_code": "DZ",
      "fips10": "AG",
      "un_locode": "DZ",
      "stanag_1059": "DZA",
      "ioc": "ALG",
      "fifa": "ALG",
      "itu": "ALG",
      "uic": "92 DZ",
      "maritime": 605,
      "mmc": 603
    }
  },
  {
    "locale": "ar-BH",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Bahrain",
      "name_local": "البحرين al-Bahrain",
      "code": "BH",
      "area_sq_km": 765,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Manama",
      "capital_latitude": 26.21536,
      "capital_longitude": 50.5832,
      "currency": "Bahrain Dinar",
      "currency_local": "Bahraini dinar",
      "currency_code": "BHD",
      "currency_symbol": ".د.ب",
      "currency_numeric": 48,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇧🇭",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####|###",
      "postal_code_regex": "^(\\d{3}\\d?)$",
      "iso_3166_1_numeric": 48,
      "iso_3166_1_alpha2": "BH",
      "iso_3166_1_alpha3": "BHR",
      "tld": "bh",
      "vehicle_code": "BRN",
      "fips10": "BA",
      "un_locode": "BH",
      "stanag_1059": "BHR",
      "ioc": "BRN",
      "fifa": "BHR",
      "itu": "BHR",
      "uic": "",
      "maritime": 408,
      "mmc": 426
    }
  },
  {
    "locale": "ar-DJ",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Djibouti",
      "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
      "code": "DJ",
      "area_sq_km": 23200,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Djibouti",
      "capital_latitude": 11.58901,
      "capital_longitude": 43.14503,
      "currency": "Djibouti Franc",
      "currency_local": "Djiboutian franc",
      "currency_code": "DJF",
      "currency_symbol": "Fr",
      "currency_numeric": 262,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇩🇯",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "ER",
        "ET",
        "SO"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 262,
      "iso_3166_1_alpha2": "DJ",
      "iso_3166_1_alpha3": "DJI",
      "tld": "dj",
      "vehicle_code": "DJI",
      "fips10": "DJ",
      "un_locode": "DJ",
      "stanag_1059": "DJI",
      "ioc": "DJI",
      "fifa": "DJI",
      "itu": "DJI",
      "uic": "",
      "maritime": 621,
      "mmc": 638
    }
  },
  {
    "locale": "ar-ER",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "ar-IQ",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Iraq",
      "name_local": "جمهورية العراق / Al-´Iraq",
      "code": "IQ",
      "area_sq_km": 438317,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Baghdad",
      "capital_latitude": 33.34058,
      "capital_longitude": 44.40088,
      "currency": "Iraqi Dinar",
      "currency_local": "Iraqi dinar",
      "currency_code": "IQD",
      "currency_symbol": "ع.د",
      "currency_numeric": 368,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "Kurdish",
          "name_local": "Kurdî",
          "iso_639_1": "ku",
          "iso_639_2": "kur",
          "iso_639_3": "kur"
        }
      ],
      "flag": "🇮🇶",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "IR",
        "JO",
        "KW",
        "SA",
        "SY",
        "TR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 368,
      "iso_3166_1_alpha2": "IQ",
      "iso_3166_1_alpha3": "IRQ",
      "tld": "iq",
      "vehicle_code": "IRQ",
      "fips10": "IZ",
      "un_locode": "IQ",
      "stanag_1059": "IRQ",
      "ioc": "IRQ",
      "fifa": "IRQ",
      "itu": "IRQ",
      "uic": "99 IRQ",
      "maritime": 425,
      "mmc": 418
    }
  },
  {
    "locale": "ar-IL",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Israel",
      "name_local": "ישראל / Yisra’el / Isra’il",
      "code": "IL",
      "area_sq_km": 20770,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Jerusalem",
      "capital_latitude": 31.76904,
      "capital_longitude": 35.21633,
      "currency": "New Israeli Sheqel",
      "currency_local": "Israeli new shekel",
      "currency_code": "ILS",
      "currency_symbol": "₪",
      "currency_numeric": 376,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Agorot",
      "languages": [
        {
          "name": "Hebrew (modern)",
          "name_local": "עברית",
          "iso_639_1": "he",
          "iso_639_2": "heb",
          "iso_639_3": "heb"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇮🇱",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "EG",
        "JO",
        "LB",
        "PS",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 376,
      "iso_3166_1_alpha2": "IL",
      "iso_3166_1_alpha3": "ISR",
      "tld": "il",
      "vehicle_code": "IL",
      "fips10": "IS",
      "un_locode": "IL",
      "stanag_1059": "ISR",
      "ioc": "ISR",
      "fifa": "ISR",
      "itu": "ISR",
      "uic": "95 IL",
      "maritime": 428,
      "mmc": 425
    }
  },
  {
    "locale": "ar-YE",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Yemen",
      "name_local": "الجمهورية اليمنية / Al-Yaman",
      "code": "YE",
      "area_sq_km": 527968,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Sanaa",
      "capital_latitude": 15.35472,
      "capital_longitude": 44.20667,
      "currency": "Jemen Rial",
      "currency_local": "Yemeni rial",
      "currency_code": "YER",
      "currency_symbol": "﷼",
      "currency_numeric": 886,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇾🇪",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "OM",
        "SA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 887,
      "iso_3166_1_alpha2": "YE",
      "iso_3166_1_alpha3": "YEM",
      "tld": "ye",
      "vehicle_code": "YEM",
      "fips10": "YM",
      "un_locode": "YE",
      "stanag_1059": "YEM",
      "ioc": "YEM",
      "fifa": "YEM",
      "itu": "YEM",
      "uic": "",
      "maritime": "473, 475",
      "mmc": 421
    }
  },
  {
    "locale": "ar-JO",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Jordan",
      "name_local": "الأُرْدُنّ  / Al-Urdunn",
      "code": "JO",
      "area_sq_km": 89342,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Amman",
      "capital_latitude": 31.95522,
      "capital_longitude": 35.94503,
      "currency": "Jordanian Dinar",
      "currency_local": "Jordanian dinar",
      "currency_code": "JOD",
      "currency_symbol": "د.ا",
      "currency_numeric": 400,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piaster",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇯🇴",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "IQ",
        "IL",
        "PS",
        "SA",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 400,
      "iso_3166_1_alpha2": "JO",
      "iso_3166_1_alpha3": "JOR",
      "tld": "jo",
      "vehicle_code": "JOR",
      "fips10": "JO",
      "un_locode": "JO",
      "stanag_1059": "JOR",
      "ioc": "JOR",
      "fifa": "JOR",
      "itu": "JOR",
      "uic": "",
      "maritime": 438,
      "mmc": 416
    }
  },
  {
    "locale": "ar-QA",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Qatar",
      "name_local": "قطر / Qatar",
      "code": "QA",
      "area_sq_km": 11586,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Doha",
      "capital_latitude": 25.27932,
      "capital_longitude": 51.52245,
      "currency": "Qatari Rial",
      "currency_local": "Qatari riyal",
      "currency_code": "QAR",
      "currency_symbol": "ر.ق",
      "currency_numeric": 634,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Dirham",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇶🇦",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "SA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 634,
      "iso_3166_1_alpha2": "QA",
      "iso_3166_1_alpha3": "QAT",
      "tld": "qa",
      "vehicle_code": "Q",
      "fips10": "QA",
      "un_locode": "QA",
      "stanag_1059": "QAT",
      "ioc": "QAT",
      "fifa": "QAT",
      "itu": "QAT",
      "uic": "",
      "maritime": 466,
      "mmc": 427
    }
  },
  {
    "locale": "ar-KM",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Comoros",
      "name_local": "القمر جزر / قمر / Comores",
      "code": "KM",
      "area_sq_km": 1862,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Moroni",
      "capital_latitude": -11.70216,
      "capital_longitude": 43.25506,
      "currency": "Comorian Franc",
      "currency_local": "Comorian franc",
      "currency_code": "KMF",
      "currency_symbol": "Fr",
      "currency_numeric": 174,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇰🇲",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 174,
      "iso_3166_1_alpha2": "KM",
      "iso_3166_1_alpha3": "COM",
      "tld": "km",
      "vehicle_code": "COM",
      "fips10": "CN",
      "un_locode": "KM",
      "stanag_1059": "COM",
      "ioc": "COM",
      "fifa": "COM",
      "itu": "COM",
      "uic": "",
      "maritime": "616, 620",
      "mmc": 654
    }
  },
  {
    "locale": "ar-KW",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Kuwait",
      "name_local": "Al-Kuwayt",
      "code": "KW",
      "area_sq_km": 17818,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Kuwait City",
      "capital_latitude": 29.36972,
      "capital_longitude": 47.97833,
      "currency": "Kuwaiti Dinar",
      "currency_local": "Kuwaiti dinar",
      "currency_code": "KWD",
      "currency_symbol": "د.ك",
      "currency_numeric": 414,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇰🇼",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "IQ",
        "SA"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 414,
      "iso_3166_1_alpha2": "KW",
      "iso_3166_1_alpha3": "KWT",
      "tld": "kw",
      "vehicle_code": "KWT",
      "fips10": "KU",
      "un_locode": "KW",
      "stanag_1059": "KWT",
      "ioc": "KUW",
      "fifa": "KUW",
      "itu": "KWT",
      "uic": "",
      "maritime": 447,
      "mmc": 419
    }
  },
  {
    "locale": "ar-LB",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Lebanon",
      "name_local": "Lubnan",
      "code": "LB",
      "area_sq_km": 10452,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Beirut",
      "capital_latitude": 33.88894,
      "capital_longitude": 35.49442,
      "currency": "Lebanese Pound",
      "currency_local": "Lebanese pound",
      "currency_code": "LBP",
      "currency_symbol": "ل.ل",
      "currency_numeric": 422,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piastres",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇱🇧",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "IL",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#### ####|####",
      "postal_code_regex": "^(\\d{4}(\\d{4})?)$",
      "iso_3166_1_numeric": 422,
      "iso_3166_1_alpha2": "LB",
      "iso_3166_1_alpha3": "LBN",
      "tld": "lb",
      "vehicle_code": "RL",
      "fips10": "LE",
      "un_locode": "LB",
      "stanag_1059": "LBN",
      "ioc": "LBN",
      "fifa": "LIB",
      "itu": "LBN",
      "uic": "",
      "maritime": 450,
      "mmc": 415
    }
  },
  {
    "locale": "ar-LY",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Libya",
      "name_local": "Libiya",
      "code": "LY",
      "area_sq_km": 1759540,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Tripoli",
      "capital_latitude": 32.87519,
      "capital_longitude": 13.18746,
      "currency": "Libyan Dinar",
      "currency_local": "Libyan dinar",
      "currency_code": "LYD",
      "currency_symbol": "ل.د",
      "currency_numeric": 434,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Dirhams",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇱🇾",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "DZ",
        "TD",
        "EG",
        "NE",
        "SD",
        "TN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 434,
      "iso_3166_1_alpha2": "LY",
      "iso_3166_1_alpha3": "LBY",
      "tld": "ly",
      "vehicle_code": "LAR",
      "fips10": "LY",
      "un_locode": "LY",
      "stanag_1059": "LBY",
      "ioc": "LBA",
      "fifa": "LBY",
      "itu": "LBY",
      "uic": "",
      "maritime": 642,
      "mmc": 606
    }
  },
  {
    "locale": "ar-MA",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Morocco",
      "name_local": "Al-Maghrib",
      "code": "MA",
      "area_sq_km": 446550,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Rabat",
      "capital_latitude": 34.01325,
      "capital_longitude": -6.83255,
      "currency": "Moroccan Dirham",
      "currency_local": "Moroccan dirham",
      "currency_code": "MAD",
      "currency_symbol": "د.م.",
      "currency_numeric": 504,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇲🇦",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "DZ",
        "EH",
        "ES"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 504,
      "iso_3166_1_alpha2": "MA",
      "iso_3166_1_alpha3": "MAR",
      "tld": "ma",
      "vehicle_code": "MA",
      "fips10": "MO",
      "un_locode": "MA",
      "stanag_1059": "MAR",
      "ioc": "MAR",
      "fifa": "MAR",
      "itu": "MRC",
      "uic": "93 MA",
      "maritime": 242,
      "mmc": 604
    }
  },
  {
    "locale": "ar-MR",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Mauritania",
      "name_local": "Muritaniya/Mauritanie",
      "code": "MR",
      "area_sq_km": 1030700,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Nouakchott",
      "capital_latitude": 18.08581,
      "capital_longitude": -15.9785,
      "currency": "Mauritanian Ouguiya",
      "currency_local": "",
      "currency_code": "MRO",
      "currency_symbol": "",
      "currency_numeric": 478,
      "currency_subunit_value": 5,
      "currency_subunit_name": "Khoums",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇲🇷",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "DZ",
        "ML",
        "SN",
        "EH"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 478,
      "iso_3166_1_alpha2": "MR",
      "iso_3166_1_alpha3": "MRT",
      "tld": "mr",
      "vehicle_code": "RIM",
      "fips10": "MR",
      "un_locode": "MR",
      "stanag_1059": "MRT",
      "ioc": "MTN",
      "fifa": "MTN",
      "itu": "MTN",
      "uic": "",
      "maritime": 654,
      "mmc": 609
    }
  },
  {
    "locale": "ar-OM",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Oman",
      "name_local": "´Uman",
      "code": "OM",
      "area_sq_km": 309500,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Muscat",
      "capital_latitude": 23.61387,
      "capital_longitude": 58.5922,
      "currency": "Omani Rial",
      "currency_local": "Omani rial",
      "currency_code": "OMR",
      "currency_symbol": "ر.ع.",
      "currency_numeric": 512,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Baizas",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇴🇲",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [
        "SA",
        "AE",
        "YE"
      ],
      "is_landlocked": false,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 512,
      "iso_3166_1_alpha2": "OM",
      "iso_3166_1_alpha3": "OMN",
      "tld": "om",
      "vehicle_code": "OM",
      "fips10": "MU",
      "un_locode": "OM",
      "stanag_1059": "OMN",
      "ioc": "OMA",
      "fifa": "OMA",
      "itu": "OMA",
      "uic": "",
      "maritime": 461,
      "mmc": 422
    }
  },
  {
    "locale": "ar-PS",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Palestine",
      "name_local": "Filastin",
      "code": "PS",
      "area_sq_km": 6220,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Ramallah",
      "capital_latitude": 31.89964,
      "capital_longitude": 35.20422,
      "currency": "New Israeli Sheqel",
      "currency_local": "Israeli new shekel",
      "currency_code": "ILS",
      "currency_symbol": "₪",
      "currency_numeric": 376,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Agorot",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇵🇸",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "IL",
        "EG",
        "JO"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 275,
      "iso_3166_1_alpha2": "PS",
      "iso_3166_1_alpha3": "PSE",
      "tld": "ps",
      "vehicle_code": "WB",
      "fips10": "WE",
      "un_locode": "",
      "stanag_1059": "PSE",
      "ioc": "PLE",
      "fifa": "PLE",
      "itu": "",
      "uic": "",
      "maritime": 443,
      "mmc": ""
    }
  },
  {
    "locale": "ar-SA",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Saudi Arabia",
      "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
      "code": "SA",
      "area_sq_km": 2149690,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Riyadh",
      "capital_latitude": 24.68773,
      "capital_longitude": 46.72185,
      "currency": "Saudi Rial",
      "currency_local": "Saudi riyal",
      "currency_code": "SAR",
      "currency_symbol": "ر.س",
      "currency_numeric": 682,
      "currency_subunit_value": 20,
      "currency_subunit_name": "Qirshes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇸🇦",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "IQ",
        "JO",
        "KW",
        "OM",
        "QA",
        "AE",
        "YE"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 682,
      "iso_3166_1_alpha2": "SA",
      "iso_3166_1_alpha3": "SAU",
      "tld": "sa",
      "vehicle_code": "KSA",
      "fips10": "SA",
      "un_locode": "SA",
      "stanag_1059": "SAU",
      "ioc": "KSA",
      "fifa": "KSA",
      "itu": "ARS",
      "uic": "",
      "maritime": 403,
      "mmc": 420
    }
  },
  {
    "locale": "ar-SO",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Somalia",
      "name_local": "Soomaaliya / Somalia / الصومال",
      "code": "SO",
      "area_sq_km": 637657,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Mogadishu",
      "capital_latitude": 2.03711,
      "capital_longitude": 45.34375,
      "currency": "Somalian Shilling",
      "currency_local": "Somali shilling",
      "currency_code": "SOS",
      "currency_symbol": "Sh",
      "currency_numeric": 706,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centesimi",
      "languages": [
        {
          "name": "Somali",
          "name_local": "Soomaaliga",
          "iso_639_1": "so",
          "iso_639_2": "som",
          "iso_639_3": "som"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇸🇴",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "KE"
      ],
      "is_landlocked": false,
      "postal_code_format": "@@  #####",
      "postal_code_regex": "^([A-Z]{2}\\d{5})$",
      "iso_3166_1_numeric": 706,
      "iso_3166_1_alpha2": "SO",
      "iso_3166_1_alpha3": "SOM",
      "tld": "so",
      "vehicle_code": "SO",
      "fips10": "SO",
      "un_locode": "SO",
      "stanag_1059": "SOM",
      "ioc": "SOM",
      "fifa": "SOM",
      "itu": "SOM",
      "uic": "",
      "maritime": 666,
      "mmc": 637
    }
  },
  {
    "locale": "ar-SD",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Sudan",
      "name_local": "جمهورية السودان / As-Sūdān",
      "code": "SD",
      "area_sq_km": 1886068,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Khartoum",
      "capital_latitude": 15.55177,
      "capital_longitude": 32.53241,
      "currency": "Sudanese Pound",
      "currency_local": "Sudanese pound",
      "currency_code": "SDG",
      "currency_symbol": "",
      "currency_numeric": 938,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piaster",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇩",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "CF",
        "TD",
        "EG",
        "ER",
        "ET",
        "LY",
        "SS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 729,
      "iso_3166_1_alpha2": "SD",
      "iso_3166_1_alpha3": "SDN",
      "tld": "sd",
      "vehicle_code": "SUD",
      "fips10": "SU",
      "un_locode": "SD",
      "stanag_1059": "SDN",
      "ioc": "SUD",
      "fifa": "SDN",
      "itu": "SDN",
      "uic": "",
      "maritime": 662,
      "mmc": 634
    }
  },
  {
    "locale": "ar-SY",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Syria",
      "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
      "code": "SY",
      "area_sq_km": 185180,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Damascus",
      "capital_latitude": 33.5102,
      "capital_longitude": 36.29128,
      "currency": "Syrian Pound",
      "currency_local": "Syrian pound",
      "currency_code": "SYP",
      "currency_symbol": "£",
      "currency_numeric": 760,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piastres",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇸🇾",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "IQ",
        "IL",
        "JO",
        "LB",
        "TR"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 760,
      "iso_3166_1_alpha2": "SY",
      "iso_3166_1_alpha3": "SYR",
      "tld": "sy",
      "vehicle_code": "SYR",
      "fips10": "SY",
      "un_locode": "SY",
      "stanag_1059": "SYR",
      "ioc": "SYR",
      "fifa": "SYR",
      "itu": "SYR",
      "uic": "97 SYR",
      "maritime": 468,
      "mmc": 417
    }
  },
  {
    "locale": "ar-TD",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Chad",
      "name_local": "جمهوريّة تشاد / Tchad",
      "code": "TD",
      "area_sq_km": 1284000,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "N'Djamena",
      "capital_latitude": 12.10672,
      "capital_longitude": 15.0444,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇹🇩",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "CF",
        "LY",
        "NE",
        "NG",
        "SD"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 148,
      "iso_3166_1_alpha2": "TD",
      "iso_3166_1_alpha3": "TCD",
      "tld": "td",
      "vehicle_code": "TD",
      "fips10": "CD",
      "un_locode": "TD",
      "stanag_1059": "TCD",
      "ioc": "CHA",
      "fifa": "CHA",
      "itu": "TCD",
      "uic": "",
      "maritime": 670,
      "mmc": 622
    }
  },
  {
    "locale": "ar-TN",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "Tunisia",
      "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
      "code": "TN",
      "area_sq_km": 163610,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Tunis",
      "capital_latitude": 36.81897,
      "capital_longitude": 10.16579,
      "currency": "Tunesian Dinar",
      "currency_local": "Tunisian dinar",
      "currency_code": "TND",
      "currency_symbol": "د.ت",
      "currency_numeric": 788,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Millimes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇹🇳",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "DZ",
        "LY"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 788,
      "iso_3166_1_alpha2": "TN",
      "iso_3166_1_alpha3": "TUN",
      "tld": "tn",
      "vehicle_code": "TN",
      "fips10": "TS",
      "un_locode": "TN",
      "stanag_1059": "TUN",
      "ioc": "TUN",
      "fifa": "TUN",
      "itu": "TUN",
      "uic": "91 TN",
      "maritime": 672,
      "mmc": 605
    }
  },
  {
    "locale": "ar-AE",
    "language": {
      "name": "Arabic",
      "name_local": "العربية",
      "iso_639_1": "ar",
      "iso_639_2": "ara",
      "iso_639_3": "ara",
      "countries": [
        {
          "name": "Egypt",
          "name_local": "مصر Miṣr",
          "code": "EG"
        },
        {
          "name": "Algeria",
          "name_local": "الجزائر al-Dschazā’ir",
          "code": "DZ"
        },
        {
          "name": "Bahrain",
          "name_local": "البحرين al-Bahrain",
          "code": "BH"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        },
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        },
        {
          "name": "Yemen",
          "name_local": "الجمهورية اليمنية / Al-Yaman",
          "code": "YE"
        },
        {
          "name": "Jordan",
          "name_local": "الأُرْدُنّ  / Al-Urdunn",
          "code": "JO"
        },
        {
          "name": "Qatar",
          "name_local": "قطر / Qatar",
          "code": "QA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Kuwait",
          "name_local": "Al-Kuwayt",
          "code": "KW"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Libya",
          "name_local": "Libiya",
          "code": "LY"
        },
        {
          "name": "Morocco",
          "name_local": "Al-Maghrib",
          "code": "MA"
        },
        {
          "name": "Mauritania",
          "name_local": "Muritaniya/Mauritanie",
          "code": "MR"
        },
        {
          "name": "Oman",
          "name_local": "´Uman",
          "code": "OM"
        },
        {
          "name": "Palestine",
          "name_local": "Filastin",
          "code": "PS"
        },
        {
          "name": "Saudi Arabia",
          "name_local": "المملكة العربية السعودية / Al-´Arabiya as-Sa´",
          "code": "SA"
        },
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "Syria",
          "name_local": "Sūriyya / Suriya / الجمهورية العربية السورية",
          "code": "SY"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Tunisia",
          "name_local": "تونس / الجمهورية التونسية / Tūnisiyya",
          "code": "TN"
        },
        {
          "name": "United Arab Emirates",
          "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
          "code": "AE"
        }
      ]
    },
    "country": {
      "name": "United Arab Emirates",
      "name_local": "الإمارات العربية المتحدة / Al-Imarat al-´Arab",
      "code": "AE",
      "area_sq_km": 83600,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Abu Dhabi",
      "capital_latitude": 24.46667,
      "capital_longitude": 54.36667,
      "currency": "Arabic Dirham",
      "currency_local": "United Arab Emirates dirham",
      "currency_code": "AED",
      "currency_symbol": "د.إ",
      "currency_numeric": 784,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇦🇪",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [
        "OM",
        "SA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 784,
      "iso_3166_1_alpha2": "AE",
      "iso_3166_1_alpha3": "ARE",
      "tld": "ae",
      "vehicle_code": "UAE",
      "fips10": "AE",
      "un_locode": "AE",
      "stanag_1059": "ARE",
      "ioc": "UAE",
      "fifa": "UAE",
      "itu": "UAE",
      "uic": "",
      "maritime": "470, 471",
      "mmc": "424, 430, 431"
    }
  },
  {
    "locale": "ay-BO",
    "language": {
      "name": "Aymara",
      "name_local": "aymar aru",
      "iso_639_1": "ay",
      "iso_639_2": "aym",
      "iso_639_3": "aym",
      "countries": [
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        }
      ]
    },
    "country": {
      "name": "Bolivia",
      "name_local": "Bolivia",
      "code": "BO",
      "area_sq_km": 1098581,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Sucre",
      "capital_latitude": -19.03332,
      "capital_longitude": -65.26274,
      "currency": "Boliviano",
      "currency_local": "Bolivian boliviano",
      "currency_code": "BOB",
      "currency_symbol": "Bs.",
      "currency_numeric": 68,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Aymara",
          "name_local": "aymar aru",
          "iso_639_1": "ay",
          "iso_639_2": "aym",
          "iso_639_3": "aym"
        },
        {
          "name": "Quechua",
          "name_local": "Runa Simi",
          "iso_639_1": "qu",
          "iso_639_2": "que",
          "iso_639_3": "que"
        }
      ],
      "flag": "🇧🇴",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BR",
        "CL",
        "PY",
        "PE"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 68,
      "iso_3166_1_alpha2": "BO",
      "iso_3166_1_alpha3": "BOL",
      "tld": "bo",
      "vehicle_code": "BOL",
      "fips10": "BL",
      "un_locode": "BO",
      "stanag_1059": "BOL",
      "ioc": "BOL",
      "fifa": "BOL",
      "itu": "BOL",
      "uic": "",
      "maritime": 720,
      "mmc": 736
    }
  },
  {
    "locale": "az-AZ",
    "language": {
      "name": "Azerbaijani",
      "name_local": "azərbaycan dili",
      "iso_639_1": "az",
      "iso_639_2": "aze",
      "iso_639_3": "aze",
      "countries": [
        {
          "name": "Azerbaijan",
          "name_local": "Azərbaycan",
          "code": "AZ"
        }
      ]
    },
    "country": {
      "name": "Azerbaijan",
      "name_local": "Azərbaycan",
      "code": "AZ",
      "area_sq_km": 86600,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Baku",
      "capital_latitude": 40.37767,
      "capital_longitude": 49.89201,
      "currency": "Manat",
      "currency_local": "Azerbaijani manat",
      "currency_code": "AZN",
      "currency_symbol": "₼",
      "currency_numeric": 944,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Qäpi",
      "languages": [
        {
          "name": "Azerbaijani",
          "name_local": "azərbaycan dili",
          "iso_639_1": "az",
          "iso_639_2": "aze",
          "iso_639_3": "aze"
        }
      ],
      "flag": "🇦🇿",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [
        "AM",
        "GE",
        "IR",
        "RU",
        "TR"
      ],
      "is_landlocked": true,
      "postal_code_format": "AZ ####",
      "postal_code_regex": "^(?:AZ)*(\\d{4})$",
      "iso_3166_1_numeric": 31,
      "iso_3166_1_alpha2": "AZ",
      "iso_3166_1_alpha3": "AZE",
      "tld": "az",
      "vehicle_code": "AZ",
      "fips10": "AJ",
      "un_locode": "AZ",
      "stanag_1059": "AZE",
      "ioc": "AZE",
      "fifa": "AZE",
      "itu": "AZE",
      "uic": "57 AZE",
      "maritime": 423,
      "mmc": 400
    }
  },
  {
    "locale": "be-BY",
    "language": {
      "name": "Belarusian",
      "name_local": "беларуская мова",
      "iso_639_1": "be",
      "iso_639_2": "bel",
      "iso_639_3": "bel",
      "countries": [
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        }
      ]
    },
    "country": {
      "name": "Belarus",
      "name_local": "Беларусь",
      "code": "BY",
      "area_sq_km": 207600,
      "continent": "Europe",
      "region": "Eastern Europe",
      "capital_name": "Minsk",
      "capital_latitude": 53.9,
      "capital_longitude": 27.56667,
      "currency": "Belarus Rubel",
      "currency_local": "",
      "currency_code": "BYR",
      "currency_symbol": "",
      "currency_numeric": 933,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kapejek",
      "languages": [
        {
          "name": "Belarusian",
          "name_local": "беларуская мова",
          "iso_639_1": "be",
          "iso_639_2": "bel",
          "iso_639_3": "bel"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇧🇾",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "LV",
        "LT",
        "PL",
        "RU",
        "UA"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 112,
      "iso_3166_1_alpha2": "BY",
      "iso_3166_1_alpha3": "BLR",
      "tld": "by",
      "vehicle_code": "BY",
      "fips10": "BO",
      "un_locode": "BY",
      "stanag_1059": "BLR",
      "ioc": "BLR",
      "fifa": "BLR",
      "itu": "BLR",
      "uic": "21 BLR",
      "maritime": 206,
      "mmc": 257
    }
  },
  {
    "locale": "bn-BD",
    "language": {
      "name": "Bengali",
      "name_local": "বাংলা",
      "iso_639_1": "bn",
      "iso_639_2": "ben",
      "iso_639_3": "ben",
      "countries": [
        {
          "name": "Bangladesh",
          "name_local": "বাংলাদেশ Bāṃlādeś",
          "code": "BD"
        }
      ]
    },
    "country": {
      "name": "Bangladesh",
      "name_local": "বাংলাদেশ Bāṃlādeś",
      "code": "BD",
      "area_sq_km": 147570,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Dhaka",
      "capital_latitude": 23.7104,
      "capital_longitude": 90.40744,
      "currency": "Taka",
      "currency_local": "Bangladeshi taka",
      "currency_code": "BDT",
      "currency_symbol": "৳",
      "currency_numeric": 50,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Poisha",
      "languages": [
        {
          "name": "Bengali",
          "name_local": "বাংলা",
          "iso_639_1": "bn",
          "iso_639_2": "ben",
          "iso_639_3": "ben"
        }
      ],
      "flag": "🇧🇩",
      "timezones": [
        "UTC+06:00"
      ],
      "borders": [
        "MM",
        "IN"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 50,
      "iso_3166_1_alpha2": "BD",
      "iso_3166_1_alpha3": "BGD",
      "tld": "bd",
      "vehicle_code": "BD",
      "fips10": "BG",
      "un_locode": "BD",
      "stanag_1059": "BGD",
      "ioc": "BAN",
      "fifa": "BAN",
      "itu": "BGD",
      "uic": "BAN",
      "maritime": 405,
      "mmc": 470
    }
  },
  {
    "locale": "bi-VU",
    "language": {
      "name": "Bislama",
      "name_local": "Bislama",
      "iso_639_1": "bi",
      "iso_639_2": "bis",
      "iso_639_3": "bis",
      "countries": [
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        }
      ]
    },
    "country": {
      "name": "Vanuatu",
      "name_local": "Vanuatu",
      "code": "VU",
      "area_sq_km": 12189,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Port-Vila",
      "capital_latitude": -17.73381,
      "capital_longitude": 168.32188,
      "currency": "Vatu",
      "currency_local": "Vanuatu vatu",
      "currency_code": "VUV",
      "currency_symbol": "Vt",
      "currency_numeric": 548,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Bislama",
          "name_local": "Bislama",
          "iso_639_1": "bi",
          "iso_639_2": "bis",
          "iso_639_3": "bis"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇻🇺",
      "timezones": [
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 548,
      "iso_3166_1_alpha2": "VU",
      "iso_3166_1_alpha3": "VUT",
      "tld": "vu",
      "vehicle_code": "VAN",
      "fips10": "NH",
      "un_locode": "VU",
      "stanag_1059": "VUT",
      "ioc": "VAN",
      "fifa": "VAN",
      "itu": "VUT",
      "uic": "",
      "maritime": "576, 577",
      "mmc": 541
    }
  },
  {
    "locale": "bs-BA",
    "language": {
      "name": "Bosnian",
      "name_local": "bosanski jezik",
      "iso_639_1": "bs",
      "iso_639_2": "bos",
      "iso_639_3": "bos",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Bosnia and Herzegovina",
      "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
      "code": "BA",
      "area_sq_km": 51209,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Sarajevo",
      "capital_latitude": 43.84864,
      "capital_longitude": 18.35644,
      "currency": "Convertible Mark",
      "currency_local": "Bosnia and Herzegovina convertible mark",
      "currency_code": "BAM",
      "currency_symbol": "",
      "currency_numeric": 977,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fening",
      "languages": [
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        },
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇧🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "HR",
        "ME",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 70,
      "iso_3166_1_alpha2": "BA",
      "iso_3166_1_alpha3": "BIH",
      "tld": "ba",
      "vehicle_code": "BIH",
      "fips10": "BK",
      "un_locode": "BA",
      "stanag_1059": "BIH",
      "ioc": "BIH",
      "fifa": "BIH",
      "itu": "BIH",
      "uic": "44-50 BIH",
      "maritime": 478,
      "mmc": 218
    }
  },
  {
    "locale": "bs-ME",
    "language": {
      "name": "Bosnian",
      "name_local": "bosanski jezik",
      "iso_639_1": "bs",
      "iso_639_2": "bos",
      "iso_639_3": "bos",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Montenegro",
      "name_local": "Црна Гора / Crna Gora / Mali i Zi",
      "code": "ME",
      "area_sq_km": 13812,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Podgorica",
      "capital_latitude": 42.44111,
      "capital_longitude": 19.26361,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        },
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        }
      ],
      "flag": "🇲🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "BA",
        "HR",
        "XK",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 499,
      "iso_3166_1_alpha2": "ME",
      "iso_3166_1_alpha3": "MNE",
      "tld": "me",
      "vehicle_code": "MNE",
      "fips10": "MJ",
      "un_locode": "ME",
      "stanag_1059": "",
      "ioc": "MNE",
      "fifa": "MNE",
      "itu": "MNE",
      "uic": "62 CG",
      "maritime": 262,
      "mmc": 297
    }
  },
  {
    "locale": "bg-BG",
    "language": {
      "name": "Bulgarian",
      "name_local": "български език",
      "iso_639_1": "bg",
      "iso_639_2": "bul",
      "iso_639_3": "bul",
      "countries": [
        {
          "name": "Bulgaria",
          "name_local": "България",
          "code": "BG"
        }
      ]
    },
    "country": {
      "name": "Bulgaria",
      "name_local": "България",
      "code": "BG",
      "area_sq_km": 110879,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Sofia",
      "capital_latitude": 42.69751,
      "capital_longitude": 23.32415,
      "currency": "Bulgarian Lev",
      "currency_local": "Bulgarian lev",
      "currency_code": "BGN",
      "currency_symbol": "лв",
      "currency_numeric": 975,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Stotinki",
      "languages": [
        {
          "name": "Bulgarian",
          "name_local": "български език",
          "iso_639_1": "bg",
          "iso_639_2": "bul",
          "iso_639_3": "bul"
        }
      ],
      "flag": "🇧🇬",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "GR",
        "MK",
        "RO",
        "RS",
        "TR"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 100,
      "iso_3166_1_alpha2": "BG",
      "iso_3166_1_alpha3": "BGR",
      "tld": "bg",
      "vehicle_code": "BG",
      "fips10": "BU",
      "un_locode": "BG",
      "stanag_1059": "BGR",
      "ioc": "BUL",
      "fifa": "BUL",
      "itu": "BUL",
      "uic": "52 BG",
      "maritime": 207,
      "mmc": 284
    }
  },
  {
    "locale": "byn-ER",
    "language": {
      "name": "Bilen",
      "name_local": "ብሊና",
      "iso_639_1": "",
      "iso_639_2": "byn",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "ca-AD",
    "language": {
      "name": "Catalan",
      "name_local": "català",
      "iso_639_1": "ca",
      "iso_639_2": "cat",
      "iso_639_3": "cat",
      "countries": [
        {
          "name": "Andorra",
          "name_local": "",
          "code": "AD"
        }
      ]
    },
    "country": {
      "name": "Andorra",
      "name_local": "",
      "code": "AD",
      "area_sq_km": 468,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Andorra la Vella",
      "capital_latitude": 42.50779,
      "capital_longitude": 1.52109,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Catalan",
          "name_local": "català",
          "iso_639_1": "ca",
          "iso_639_2": "cat",
          "iso_639_3": "cat"
        }
      ],
      "flag": "🇦🇩",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FR",
        "ES"
      ],
      "is_landlocked": true,
      "postal_code_format": "AD###",
      "postal_code_regex": "^(?:AD)*(\\d{3})$",
      "iso_3166_1_numeric": 20,
      "iso_3166_1_alpha2": "AD",
      "iso_3166_1_alpha3": "AND",
      "tld": "ad",
      "vehicle_code": "AND",
      "fips10": "AN",
      "un_locode": "AD",
      "stanag_1059": "AND",
      "ioc": "AND",
      "fifa": "AND",
      "itu": "AND",
      "uic": "",
      "maritime": 202,
      "mmc": 213
    }
  },
  {
    "locale": "cs-CZ",
    "language": {
      "name": "Czech",
      "name_local": "čeština",
      "iso_639_1": "cs",
      "iso_639_2": "ces",
      "iso_639_3": "ces",
      "countries": [
        {
          "name": "Czechia",
          "name_local": "Česko, Česká republika",
          "code": "CZ"
        }
      ]
    },
    "country": {
      "name": "Czechia",
      "name_local": "Česko, Česká republika",
      "code": "CZ",
      "area_sq_km": 78865,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Prague",
      "capital_latitude": 50.08804,
      "capital_longitude": 14.42076,
      "currency": "Czech Krone",
      "currency_local": "Czech koruna",
      "currency_code": "CZK",
      "currency_symbol": "Kč",
      "currency_numeric": 203,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Haleru",
      "languages": [
        {
          "name": "Czech",
          "name_local": "čeština",
          "iso_639_1": "cs",
          "iso_639_2": "ces",
          "iso_639_3": "ces"
        },
        {
          "name": "Slovak",
          "name_local": "slovenčina",
          "iso_639_1": "sk",
          "iso_639_2": "slk",
          "iso_639_3": "slk"
        }
      ],
      "flag": "🇨🇿",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "DE",
        "PL",
        "SK"
      ],
      "is_landlocked": true,
      "postal_code_format": "### ##",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 203,
      "iso_3166_1_alpha2": "CZ",
      "iso_3166_1_alpha3": "CZE",
      "tld": "cz",
      "vehicle_code": "CZ",
      "fips10": "EZ",
      "un_locode": "CZ",
      "stanag_1059": "CZE",
      "ioc": "CZE",
      "fifa": "CZE",
      "itu": "CZE",
      "uic": "54 CZ",
      "maritime": 270,
      "mmc": 230
    }
  },
  {
    "locale": "ch-GU",
    "language": {
      "name": "Chamorro",
      "name_local": "Chamoru",
      "iso_639_1": "ch",
      "iso_639_2": "cha",
      "iso_639_3": "cha",
      "countries": [
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        }
      ]
    },
    "country": {
      "name": "Guam",
      "name_local": "Guam",
      "code": "GU",
      "area_sq_km": 549,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Hagåtña",
      "capital_latitude": 13.47567,
      "capital_longitude": 144.74886,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chamorro",
          "name_local": "Chamoru",
          "iso_639_1": "ch",
          "iso_639_2": "cha",
          "iso_639_3": "cha"
        },
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇬🇺",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "969##",
      "postal_code_regex": "^(969\\d{2})$",
      "iso_3166_1_numeric": 316,
      "iso_3166_1_alpha2": "GU",
      "iso_3166_1_alpha3": "GUM",
      "tld": "gu",
      "vehicle_code": "",
      "fips10": "GQ",
      "un_locode": "GU",
      "stanag_1059": "GUM",
      "ioc": "GUM",
      "fifa": "GUM",
      "itu": "GUM",
      "uic": "",
      "maritime": "",
      "mmc": 535
    }
  },
  {
    "locale": "ch-MP",
    "language": {
      "name": "Chamorro",
      "name_local": "Chamoru",
      "iso_639_1": "ch",
      "iso_639_2": "cha",
      "iso_639_3": "cha",
      "countries": [
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        }
      ]
    },
    "country": {
      "name": "Northern Mariana Islands",
      "name_local": "Northern Mariana Islands",
      "code": "MP",
      "area_sq_km": 464,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Saipan",
      "capital_latitude": 15.21233,
      "capital_longitude": 145.7545,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chamorro",
          "name_local": "Chamoru",
          "iso_639_1": "ch",
          "iso_639_2": "cha",
          "iso_639_3": "cha"
        }
      ],
      "flag": "🇲🇵",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 580,
      "iso_3166_1_alpha2": "MP",
      "iso_3166_1_alpha3": "MNP",
      "tld": "mp",
      "vehicle_code": "",
      "fips10": "CQ",
      "un_locode": "MP",
      "stanag_1059": "MNP",
      "ioc": "",
      "fifa": "NMI",
      "itu": "MRA",
      "uic": "",
      "maritime": 536,
      "mmc": 534
    }
  },
  {
    "locale": "da-DK",
    "language": {
      "name": "Danish",
      "name_local": "dansk",
      "iso_639_1": "da",
      "iso_639_2": "dan",
      "iso_639_3": "dan",
      "countries": [
        {
          "name": "Denmark",
          "name_local": "Danmark",
          "code": "DK"
        }
      ]
    },
    "country": {
      "name": "Denmark",
      "name_local": "Danmark",
      "code": "DK",
      "area_sq_km": 43094,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Copenhagen",
      "capital_latitude": 55.67594,
      "capital_longitude": 12.56553,
      "currency": "Danish Krone",
      "currency_local": "Danish krone",
      "currency_code": "DKK",
      "currency_symbol": "kr",
      "currency_numeric": 208,
      "currency_subunit_value": 100,
      "currency_subunit_name": "øre",
      "languages": [
        {
          "name": "Danish",
          "name_local": "dansk",
          "iso_639_1": "da",
          "iso_639_2": "dan",
          "iso_639_3": "dan"
        }
      ],
      "flag": "🇩🇰",
      "timezones": [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC",
        "UTC+01:00"
      ],
      "borders": [
        "DE"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 208,
      "iso_3166_1_alpha2": "DK",
      "iso_3166_1_alpha3": "DNK",
      "tld": "dk",
      "vehicle_code": "DK",
      "fips10": "DA",
      "un_locode": "DK",
      "stanag_1059": "DNK",
      "ioc": "DEN",
      "fifa": "DEN",
      "itu": "DNK",
      "uic": "86 DK",
      "maritime": "219, 220",
      "mmc": 238
    }
  },
  {
    "locale": "de-BE",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Belgium",
      "name_local": "België / Belgique",
      "code": "BE",
      "area_sq_km": 30528,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Brussels",
      "capital_latitude": 50.85045,
      "capital_longitude": 4.34878,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇧🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FR",
        "DE",
        "LU",
        "NL"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 56,
      "iso_3166_1_alpha2": "BE",
      "iso_3166_1_alpha3": "BEL",
      "tld": "be",
      "vehicle_code": "B",
      "fips10": "BE",
      "un_locode": "BE",
      "stanag_1059": "BEL",
      "ioc": "BEL",
      "fifa": "BEL",
      "itu": "BEL",
      "uic": "88 B",
      "maritime": 205,
      "mmc": 206
    }
  },
  {
    "locale": "de-DE",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Germany",
      "name_local": "Deutschland",
      "code": "DE",
      "area_sq_km": 357114,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Berlin",
      "capital_latitude": 52.51767,
      "capital_longitude": 13.405538,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇩🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "BE",
        "CZ",
        "DK",
        "FR",
        "LU",
        "NL",
        "PL",
        "CH"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 276,
      "iso_3166_1_alpha2": "DE",
      "iso_3166_1_alpha3": "DEU",
      "tld": "de",
      "vehicle_code": "D",
      "fips10": "GM",
      "un_locode": "DE",
      "stanag_1059": "DEU",
      "ioc": "GER",
      "fifa": "GER",
      "itu": "D",
      "uic": "80 D",
      "maritime": "211, 218",
      "mmc": 262
    }
  },
  {
    "locale": "de-LI",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Liechtenstein",
      "name_local": "Liechtenstein",
      "code": "LI",
      "area_sq_km": 160,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Vaduz",
      "capital_latitude": 47.14151,
      "capital_longitude": 9.52154,
      "currency": "Swiss Franc",
      "currency_local": "Swiss franc",
      "currency_code": "CHF",
      "currency_symbol": "Fr",
      "currency_numeric": 756,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Rappen",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇱🇮",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "CH"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 438,
      "iso_3166_1_alpha2": "LI",
      "iso_3166_1_alpha3": "LIE",
      "tld": "li",
      "vehicle_code": "FL",
      "fips10": "LS",
      "un_locode": "LI",
      "stanag_1059": "LIE",
      "ioc": "LIE",
      "fifa": "LIE",
      "itu": "LIE",
      "uic": "",
      "maritime": 252,
      "mmc": 295
    }
  },
  {
    "locale": "de-LU",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Luxembourg",
      "name_local": "Luxembourg/Lëtzebuerg",
      "code": "LU",
      "area_sq_km": 2586,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Luxembourg",
      "capital_latitude": 49.61167,
      "capital_longitude": 6.13,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "Luxembourgish",
          "name_local": "Lëtzebuergesch",
          "iso_639_1": "lb",
          "iso_639_2": "ltz",
          "iso_639_3": "ltz"
        }
      ],
      "flag": "🇱🇺",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BE",
        "FR",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 442,
      "iso_3166_1_alpha2": "LU",
      "iso_3166_1_alpha3": "LUX",
      "tld": "lu",
      "vehicle_code": "L",
      "fips10": "LU",
      "un_locode": "LU",
      "stanag_1059": "LUX",
      "ioc": "LUX",
      "fifa": "LUX",
      "itu": "LUX",
      "uic": "82 L",
      "maritime": 253,
      "mmc": 270
    }
  },
  {
    "locale": "de-AT",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Austria",
      "name_local": "Österreich",
      "code": "AT",
      "area_sq_km": 83871,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Vienna",
      "capital_latitude": 48.20849,
      "capital_longitude": 16.37208,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇦🇹",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CZ",
        "DE",
        "HU",
        "IT",
        "LI",
        "SK",
        "SI",
        "CH"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 40,
      "iso_3166_1_alpha2": "AT",
      "iso_3166_1_alpha3": "AUT",
      "tld": "at",
      "vehicle_code": "A",
      "fips10": "AU",
      "un_locode": "AT",
      "stanag_1059": "AUT",
      "ioc": "AUT",
      "fifa": "AUT",
      "itu": "AUT",
      "uic": "81 A",
      "maritime": 203,
      "mmc": 232
    }
  },
  {
    "locale": "de-CH",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Switzerland",
      "name_local": "Schweiz / Suisse / Svizzera / Svizra",
      "code": "CH",
      "area_sq_km": 41284,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Bern",
      "capital_latitude": 46.94809,
      "capital_longitude": 7.44744,
      "currency": "Swiss Franc",
      "currency_local": "Swiss franc",
      "currency_code": "CHF",
      "currency_symbol": "Fr.",
      "currency_numeric": 756,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Rappen",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "Romansh",
          "name_local": "Rumantsch",
          "iso_639_1": "rm",
          "iso_639_2": "roh",
          "iso_639_3": "roh"
        }
      ],
      "flag": "🇨🇭",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "FR",
        "IT",
        "LI",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 756,
      "iso_3166_1_alpha2": "CH",
      "iso_3166_1_alpha3": "CHE",
      "tld": "ch",
      "vehicle_code": "CH",
      "fips10": "SZ",
      "un_locode": "CH",
      "stanag_1059": "CHE",
      "ioc": "SUI",
      "fifa": "SUI",
      "itu": "SUI",
      "uic": "85 CH",
      "maritime": 269,
      "mmc": 228
    }
  },
  {
    "locale": "de-VA",
    "language": {
      "name": "German",
      "name_local": "Deutsch",
      "iso_639_1": "de",
      "iso_639_2": "deu",
      "iso_639_3": "deu",
      "countries": [
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Germany",
          "name_local": "Deutschland",
          "code": "DE"
        },
        {
          "name": "Liechtenstein",
          "name_local": "Liechtenstein",
          "code": "LI"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Austria",
          "name_local": "Österreich",
          "code": "AT"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Vatican City",
      "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
      "code": "VA",
      "area_sq_km": 0.44,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Vatican City",
      "capital_latitude": 41.902226,
      "capital_longitude": 12.450713,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Latin",
          "name_local": "latine",
          "iso_639_1": "la",
          "iso_639_2": "lat",
          "iso_639_3": "lat"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "French",
          "name_local": "Français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇻🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "IT"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 336,
      "iso_3166_1_alpha2": "VA",
      "iso_3166_1_alpha3": "VAT",
      "tld": "va",
      "vehicle_code": "V",
      "fips10": "VT",
      "un_locode": "VA",
      "stanag_1059": "VAT",
      "ioc": "",
      "fifa": "",
      "itu": "CVA",
      "uic": "",
      "maritime": 208,
      "mmc": 225
    }
  },
  {
    "locale": "dv-MV",
    "language": {
      "name": "Divehi",
      "name_local": "ދިވެހި",
      "iso_639_1": "dv",
      "iso_639_2": "div",
      "iso_639_3": "div",
      "countries": [
        {
          "name": "Maldives",
          "name_local": "Dhivehi Raajje/Maldives",
          "code": "MV"
        }
      ]
    },
    "country": {
      "name": "Maldives",
      "name_local": "Dhivehi Raajje/Maldives",
      "code": "MV",
      "area_sq_km": 300,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Malé",
      "capital_latitude": 4.1748,
      "capital_longitude": 73.50888,
      "currency": "Maldivian Rufiyaa",
      "currency_local": "Maldivian rufiyaa",
      "currency_code": "MVR",
      "currency_symbol": ".ރ",
      "currency_numeric": 462,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Laari",
      "languages": [
        {
          "name": "Divehi",
          "name_local": "ދިވެހި",
          "iso_639_1": "dv",
          "iso_639_2": "div",
          "iso_639_3": "div"
        }
      ],
      "flag": "🇲🇻",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 462,
      "iso_3166_1_alpha2": "MV",
      "iso_3166_1_alpha3": "MDV",
      "tld": "mv",
      "vehicle_code": "MV",
      "fips10": "MV",
      "un_locode": "MV",
      "stanag_1059": "MDV",
      "ioc": "MDV",
      "fifa": "MDV",
      "itu": "MLD",
      "uic": "",
      "maritime": 455,
      "mmc": 472
    }
  },
  {
    "locale": "dz-BT",
    "language": {
      "name": "Dzongkha",
      "name_local": "རྫོང་ཁ",
      "iso_639_1": "dz",
      "iso_639_2": "dzo",
      "iso_639_3": "dzo",
      "countries": [
        {
          "name": "Bhutan",
          "name_local": "འབྲུག་ཡུལ་ Dzongkha",
          "code": "BT"
        }
      ]
    },
    "country": {
      "name": "Bhutan",
      "name_local": "འབྲུག་ཡུལ་ Dzongkha",
      "code": "BT",
      "area_sq_km": 38394,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Thimphu",
      "capital_latitude": 27.46609,
      "capital_longitude": 89.64191,
      "currency": "Ngultrum",
      "currency_local": "Bhutanese ngultrum",
      "currency_code": "BTN",
      "currency_symbol": "Nu.",
      "currency_numeric": 64,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Chetrum",
      "languages": [
        {
          "name": "Dzongkha",
          "name_local": "རྫོང་ཁ",
          "iso_639_1": "dz",
          "iso_639_2": "dzo",
          "iso_639_3": "dzo"
        }
      ],
      "flag": "🇧🇹",
      "timezones": [
        "UTC+06:00"
      ],
      "borders": [
        "CN",
        "IN"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 64,
      "iso_3166_1_alpha2": "BT",
      "iso_3166_1_alpha3": "BTN",
      "tld": "bt",
      "vehicle_code": "BHT",
      "fips10": "BT",
      "un_locode": "BT",
      "stanag_1059": "BTN",
      "ioc": "BHU",
      "fifa": "BHU",
      "itu": "BTN",
      "uic": "",
      "maritime": 410,
      "mmc": 402
    }
  },
  {
    "locale": "el-GR",
    "language": {
      "name": "Greek (modern)",
      "name_local": "ελληνικά",
      "iso_639_1": "el",
      "iso_639_2": "ell",
      "iso_639_3": "ell",
      "countries": [
        {
          "name": "Greece",
          "name_local": "Ελλάδα / Elláda",
          "code": "GR"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Greece",
      "name_local": "Ελλάδα / Elláda",
      "code": "GR",
      "area_sq_km": 131990,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Athens",
      "capital_latitude": 37.97945,
      "capital_longitude": 23.71622,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Greek (modern)",
          "name_local": "ελληνικά",
          "iso_639_1": "el",
          "iso_639_2": "ell",
          "iso_639_3": "ell"
        }
      ],
      "flag": "🇬🇷",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "AL",
        "BG",
        "TR",
        "MK"
      ],
      "is_landlocked": false,
      "postal_code_format": "### ##",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 300,
      "iso_3166_1_alpha2": "GR",
      "iso_3166_1_alpha3": "GRC",
      "tld": "gr",
      "vehicle_code": "GR",
      "fips10": "GR",
      "un_locode": "GR",
      "stanag_1059": "GRC",
      "ioc": "GRE",
      "fifa": "GRE",
      "itu": "GRC",
      "uic": "73 GR",
      "maritime": "237, 239, 240, 241",
      "mmc": 202
    }
  },
  {
    "locale": "el-CY",
    "language": {
      "name": "Greek (modern)",
      "name_local": "ελληνικά",
      "iso_639_1": "el",
      "iso_639_2": "ell",
      "iso_639_3": "ell",
      "countries": [
        {
          "name": "Greece",
          "name_local": "Ελλάδα / Elláda",
          "code": "GR"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Cyprus",
      "name_local": "Κύπρος / Kypros / Kıbrıs",
      "code": "CY",
      "area_sq_km": 9251,
      "continent": "Asia",
      "region": "Southern Europe",
      "capital_name": "Nicosia",
      "capital_latitude": 35.17531,
      "capital_longitude": 33.3642,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Greek (modern)",
          "name_local": "ελληνικά",
          "iso_639_1": "el",
          "iso_639_2": "ell",
          "iso_639_3": "ell"
        },
        {
          "name": "Turkish",
          "name_local": "Türkçe",
          "iso_639_1": "tr",
          "iso_639_2": "tur",
          "iso_639_3": "tur"
        },
        {
          "name": "Armenian",
          "name_local": "Հայերեն",
          "iso_639_1": "hy",
          "iso_639_2": "hye",
          "iso_639_3": "hye"
        }
      ],
      "flag": "🇨🇾",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 196,
      "iso_3166_1_alpha2": "CY",
      "iso_3166_1_alpha3": "CYP",
      "tld": "cy",
      "vehicle_code": "CY",
      "fips10": "CY",
      "un_locode": "CY",
      "stanag_1059": "CYP",
      "ioc": "CYP",
      "fifa": "CYP",
      "itu": "CYP",
      "uic": "",
      "maritime": "209, 210, 212",
      "mmc": 280
    }
  },
  {
    "locale": "en-AS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "American Samoa",
      "name_local": "Sāmoa Amelika",
      "code": "AS",
      "area_sq_km": 199,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Pago Pago",
      "capital_latitude": -14.27806,
      "capital_longitude": -170.7025,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Samoan",
          "name_local": "gagana fa'a Samoa",
          "iso_639_1": "sm",
          "iso_639_2": "smo",
          "iso_639_3": "smo"
        }
      ],
      "flag": "🇦🇸",
      "timezones": [
        "UTC-11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 16,
      "iso_3166_1_alpha2": "AS",
      "iso_3166_1_alpha3": "ASM",
      "tld": "as",
      "vehicle_code": "USA",
      "fips10": "AQ",
      "un_locode": "AS",
      "stanag_1059": "ASM",
      "ioc": "ASA",
      "fifa": "ASA",
      "itu": "SMA",
      "uic": "",
      "maritime": 559,
      "mmc": 544
    }
  },
  {
    "locale": "en-AI",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Anguilla",
      "name_local": "Anguilla",
      "code": "AI",
      "area_sq_km": 91,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "The Valley",
      "capital_latitude": 18.21704,
      "capital_longitude": -63.05783,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇦🇮",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 660,
      "iso_3166_1_alpha2": "AI",
      "iso_3166_1_alpha3": "AIA",
      "tld": "ai",
      "vehicle_code": "AXA",
      "fips10": "AV",
      "un_locode": "AI",
      "stanag_1059": "AIA",
      "ioc": "",
      "fifa": "AIA",
      "itu": "AIA",
      "uic": "",
      "maritime": 301,
      "mmc": 365
    }
  },
  {
    "locale": "en-AQ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Antarctica",
      "name_local": "",
      "code": "AQ",
      "area_sq_km": 14000000,
      "continent": "Oceania",
      "region": "",
      "capital_name": "",
      "currency": "",
      "currency_local": "",
      "currency_code": "",
      "currency_symbol": "",
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇦🇶",
      "timezones": [
        "UTC-03:00",
        "UTC+03:00",
        "UTC+05:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 10,
      "iso_3166_1_alpha2": "AQ",
      "iso_3166_1_alpha3": "ATA",
      "tld": "aq",
      "vehicle_code": "",
      "fips10": "AY",
      "un_locode": "AQ",
      "stanag_1059": "ATA",
      "ioc": "",
      "fifa": "",
      "itu": "ATA",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-AG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Antigua and Barbuda",
      "name_local": "Antigua and Barbuda",
      "code": "AG",
      "area_sq_km": 442,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Saint John’s",
      "capital_latitude": 17.11717,
      "capital_longitude": -61.84573,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇦🇬",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 28,
      "iso_3166_1_alpha2": "AG",
      "iso_3166_1_alpha3": "ATG",
      "tld": "ag",
      "vehicle_code": "AG",
      "fips10": "AC",
      "un_locode": "AG",
      "stanag_1059": "ATG",
      "ioc": "ANT",
      "fifa": "ATG",
      "itu": "ATG",
      "uic": "",
      "maritime": "304, 305",
      "mmc": 344
    }
  },
  {
    "locale": "en-AU",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Australia",
      "name_local": "Australia",
      "code": "AU",
      "area_sq_km": 7692024,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "Canberra",
      "capital_latitude": -35.28346,
      "capital_longitude": 149.12807,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇦🇺",
      "timezones": [
        "UTC+05:00",
        "UTC+06:30",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:30",
        "UTC+10:00",
        "UTC+10:30",
        "UTC+11:30"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 36,
      "iso_3166_1_alpha2": "AU",
      "iso_3166_1_alpha3": "AUS",
      "tld": "au",
      "vehicle_code": "AUS",
      "fips10": "AS",
      "un_locode": "AU",
      "stanag_1059": "AUS",
      "ioc": "AUS",
      "fifa": "AUS",
      "itu": "AUS",
      "uic": "61 AU",
      "maritime": 503,
      "mmc": 505
    }
  },
  {
    "locale": "en-BS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Bahamas",
      "name_local": "The Bahamas",
      "code": "BS",
      "area_sq_km": 13943,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Nassau",
      "capital_latitude": 25.05823,
      "capital_longitude": -77.34306,
      "currency": "Bahamian Dollar",
      "currency_local": "Bahamian dollar",
      "currency_code": "BSD",
      "currency_symbol": "$",
      "currency_numeric": 44,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇧🇸",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 44,
      "iso_3166_1_alpha2": "BS",
      "iso_3166_1_alpha3": "BHS",
      "tld": "bs",
      "vehicle_code": "BS",
      "fips10": "BF",
      "un_locode": "BS",
      "stanag_1059": "BHS",
      "ioc": "BAH",
      "fifa": "BAH",
      "itu": "BAH",
      "uic": "",
      "maritime": "308, 309, 311",
      "mmc": 364
    }
  },
  {
    "locale": "en-BB",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Barbados",
      "name_local": "Barbados",
      "code": "BB",
      "area_sq_km": 430,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Bridgetown",
      "capital_latitude": 13.1,
      "capital_longitude": -59.61667,
      "currency": "Barbadian Dollar",
      "currency_local": "Barbadian dollar",
      "currency_code": "BBD",
      "currency_symbol": "$",
      "currency_numeric": 52,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇧🇧",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "BB#####",
      "postal_code_regex": "^(?:BB)*(\\d{5})$",
      "iso_3166_1_numeric": 52,
      "iso_3166_1_alpha2": "BB",
      "iso_3166_1_alpha3": "BRB",
      "tld": "bb",
      "vehicle_code": "BDS",
      "fips10": "BB",
      "un_locode": "BB",
      "stanag_1059": "BRB",
      "ioc": "BAR",
      "fifa": "BRB",
      "itu": "BRB",
      "uic": "",
      "maritime": 314,
      "mmc": 342
    }
  },
  {
    "locale": "en-BZ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Belize",
      "name_local": "Belize",
      "code": "BZ",
      "area_sq_km": 22966,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Belmopan",
      "capital_latitude": 17.25,
      "capital_longitude": -88.76667,
      "currency": "Belize Dollar",
      "currency_local": "Belize dollar",
      "currency_code": "BZD",
      "currency_symbol": "$",
      "currency_numeric": 84,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇧🇿",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "GT",
        "MX"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 84,
      "iso_3166_1_alpha2": "BZ",
      "iso_3166_1_alpha3": "BLZ",
      "tld": "bz",
      "vehicle_code": "BZ",
      "fips10": "BH",
      "un_locode": "BZ",
      "stanag_1059": "BLZ",
      "ioc": "BIZ",
      "fifa": "BLZ",
      "itu": "BLZ",
      "uic": "",
      "maritime": 312,
      "mmc": 702
    }
  },
  {
    "locale": "en-BM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Bermuda",
      "name_local": "Bermuda",
      "code": "BM",
      "area_sq_km": 54,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Hamilton",
      "capital_latitude": 32.2949,
      "capital_longitude": -64.78303,
      "currency": "Bermudian Dollar",
      "currency_local": "Bermudian dollar",
      "currency_code": "BMD",
      "currency_symbol": "$",
      "currency_numeric": 60,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇧🇲",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@@ ##",
      "postal_code_regex": "^([A-Z]{2}\\d{2})$",
      "iso_3166_1_numeric": 60,
      "iso_3166_1_alpha2": "BM",
      "iso_3166_1_alpha3": "BMU",
      "tld": "bm",
      "vehicle_code": "",
      "fips10": "BD",
      "un_locode": "BM",
      "stanag_1059": "BMU",
      "ioc": "BER",
      "fifa": "BER",
      "itu": "BER",
      "uic": "",
      "maritime": 310,
      "mmc": 350
    }
  },
  {
    "locale": "en-BW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Botswana",
      "name_local": "Botswana",
      "code": "BW",
      "area_sq_km": 582000,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Gaborone",
      "capital_latitude": -24.65451,
      "capital_longitude": 25.90859,
      "currency": "Pula",
      "currency_local": "Botswana pula",
      "currency_code": "BWP",
      "currency_symbol": "P",
      "currency_numeric": 72,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Thebe",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        }
      ],
      "flag": "🇧🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "NA",
        "ZA",
        "ZM",
        "ZW"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 72,
      "iso_3166_1_alpha2": "BW",
      "iso_3166_1_alpha3": "BWA",
      "tld": "bw",
      "vehicle_code": "RB",
      "fips10": "BC",
      "un_locode": "BW",
      "stanag_1059": "BWA",
      "ioc": "BOT",
      "fifa": "BOT",
      "itu": "BOT",
      "uic": "",
      "maritime": 611,
      "mmc": 652
    }
  },
  {
    "locale": "en-IO",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "British Indian Ocean Territory",
      "name_local": "British Indian Ocean Territory",
      "code": "IO",
      "area_sq_km": 60,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "",
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇮🇴",
      "timezones": [
        "UTC+06:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 86,
      "iso_3166_1_alpha2": "IO",
      "iso_3166_1_alpha3": "IOT",
      "tld": "io",
      "vehicle_code": "",
      "fips10": "IO",
      "un_locode": "IO",
      "stanag_1059": "IOT",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-CK",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Cook Islands",
      "name_local": "Cook Islands / Kūki 'Āirani",
      "code": "CK",
      "area_sq_km": 236,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Avarua",
      "capital_latitude": -21.20778,
      "capital_longitude": -159.775,
      "currency": "Cook Dollar",
      "currency_local": "Cook Islands dollar",
      "currency_code": "CKD",
      "currency_symbol": "$",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Cook Islands Māori",
          "name_local": "Māori",
          "iso_639_1": "",
          "iso_639_2": "rar",
          "iso_639_3": ""
        }
      ],
      "flag": "🇨🇰",
      "timezones": [
        "UTC-10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 184,
      "iso_3166_1_alpha2": "CK",
      "iso_3166_1_alpha3": "COK",
      "tld": "ck",
      "vehicle_code": "",
      "fips10": "CW",
      "un_locode": "CK",
      "stanag_1059": "COK",
      "ioc": "COK",
      "fifa": "COK",
      "itu": "CKH",
      "uic": "",
      "maritime": 518,
      "mmc": 548
    }
  },
  {
    "locale": "en-CW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Curacao",
      "name_local": "Kòrsou",
      "code": "CW",
      "area_sq_km": 444,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Willemstad",
      "capital_latitude": 12.133649,
      "capital_longitude": -68.930873,
      "currency": "Caribbean guilder",
      "currency_local": "Caribische gulden",
      "currency_code": "XCG",
      "currency_symbol": "Cg",
      "currency_numeric": 532,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "(Eastern) Punjabi",
          "name_local": "ਪੰਜਾਬੀ",
          "iso_639_1": "pa",
          "iso_639_2": "pan",
          "iso_639_3": "pan"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇨🇼",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 531,
      "iso_3166_1_alpha2": "CW",
      "iso_3166_1_alpha3": "CUW",
      "tld": "cw",
      "vehicle_code": "",
      "fips10": "UC",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "CUW",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": ""
    }
  },
  {
    "locale": "en-DM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Dominica",
      "name_local": "Dominica",
      "code": "DM",
      "area_sq_km": 751,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Roseau",
      "capital_latitude": 15.30174,
      "capital_longitude": -61.38808,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇩🇲",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 212,
      "iso_3166_1_alpha2": "DM",
      "iso_3166_1_alpha3": "DMA",
      "tld": "dm",
      "vehicle_code": "WD",
      "fips10": "DO",
      "un_locode": "DM",
      "stanag_1059": "DMA",
      "ioc": "DMA",
      "fifa": "DMA",
      "itu": "DMA",
      "uic": "",
      "maritime": 325,
      "mmc": 366
    }
  },
  {
    "locale": "en-ER",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "en-SZ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Eswatini",
      "name_local": "Umbuso weSwatini",
      "code": "SZ",
      "area_sq_km": 17364,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Mbabane",
      "capital_latitude": -26.31667,
      "capital_longitude": 31.13333,
      "currency": "Swazi Lilangeni",
      "currency_local": "Swazi lilangeni",
      "currency_code": "SZL",
      "currency_symbol": "L",
      "currency_numeric": 748,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        }
      ],
      "flag": "🇸🇿",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "MZ",
        "ZA"
      ],
      "is_landlocked": true,
      "postal_code_format": "@###",
      "postal_code_regex": "^([A-Z]\\d{3})$",
      "iso_3166_1_numeric": 748,
      "iso_3166_1_alpha2": "SZ",
      "iso_3166_1_alpha3": "SWZ",
      "tld": "sz",
      "vehicle_code": "SD",
      "fips10": "WZ",
      "un_locode": "SZ",
      "stanag_1059": "SWZ",
      "ioc": "SWZ",
      "fifa": "SWZ",
      "itu": "SWZ",
      "uic": "",
      "maritime": 669,
      "mmc": 653
    }
  },
  {
    "locale": "en-FK",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Falkland Islands",
      "name_local": "Falkland Islands",
      "code": "FK",
      "area_sq_km": 12173,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Stanley",
      "capital_latitude": -51.7,
      "capital_longitude": -57.85,
      "currency": "Falklands Pound",
      "currency_local": "Falkland Islands pound",
      "currency_code": "FKP",
      "currency_symbol": "£",
      "currency_numeric": 238,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇫🇰",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 238,
      "iso_3166_1_alpha2": "FK",
      "iso_3166_1_alpha3": "FLK",
      "tld": "fk",
      "vehicle_code": "",
      "fips10": "FK",
      "un_locode": "FK",
      "stanag_1059": "FLK",
      "ioc": "",
      "fifa": "",
      "itu": "FLK",
      "uic": "",
      "maritime": 740,
      "mmc": ""
    }
  },
  {
    "locale": "en-FJ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Fiji",
      "name_local": "Viti / फ़िजी गणराज्य / Fiji",
      "code": "FJ",
      "area_sq_km": 18272,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Suva",
      "capital_latitude": -18.14161,
      "capital_longitude": 178.44149,
      "currency": "Fiji Dollar",
      "currency_local": "Fijian dollar",
      "currency_code": "FJD",
      "currency_symbol": "$",
      "currency_numeric": 242,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Fijian",
          "name_local": "vosa Vakaviti",
          "iso_639_1": "fj",
          "iso_639_2": "fij",
          "iso_639_3": "fij"
        },
        {
          "name": "Fiji Hindi",
          "name_local": "फ़िजी बात",
          "iso_639_1": "",
          "iso_639_2": "hif",
          "iso_639_3": ""
        },
        {
          "name": "Rotuman",
          "name_local": "Fäeag Rotuma",
          "iso_639_1": "",
          "iso_639_2": "rtm",
          "iso_639_3": ""
        }
      ],
      "flag": "🇫🇯",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 242,
      "iso_3166_1_alpha2": "FJ",
      "iso_3166_1_alpha3": "FJI",
      "tld": "fj",
      "vehicle_code": "FJI",
      "fips10": "FJ",
      "un_locode": "FJ",
      "stanag_1059": "FJI",
      "ioc": "FIJ",
      "fifa": "FIJ",
      "itu": "FJI",
      "uic": "",
      "maritime": 520,
      "mmc": 542
    }
  },
  {
    "locale": "en-FM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Federated States of Micronesia",
      "name_local": "",
      "code": "FM",
      "area_sq_km": 702,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "",
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇫🇲",
      "timezones": [
        "UTC+10:00",
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 583,
      "iso_3166_1_alpha2": "FM",
      "iso_3166_1_alpha3": "FSM",
      "tld": "fm",
      "vehicle_code": "FSM",
      "fips10": "FM",
      "un_locode": "FM",
      "stanag_1059": "FSM",
      "ioc": "FSM",
      "fifa": "FSM",
      "itu": "FSM",
      "uic": "",
      "maritime": 510,
      "mmc": 550
    }
  },
  {
    "locale": "en-GM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Gambia",
      "name_local": "The Gambia",
      "code": "GM",
      "area_sq_km": 10689,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Banjul",
      "capital_latitude": 13.45274,
      "capital_longitude": -16.57803,
      "currency": "Dalasi",
      "currency_local": "dalasi",
      "currency_code": "GMD",
      "currency_symbol": "D",
      "currency_numeric": 270,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Bututs",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇲",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [
        "SN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 270,
      "iso_3166_1_alpha2": "GM",
      "iso_3166_1_alpha3": "GMB",
      "tld": "gm",
      "vehicle_code": "WAG",
      "fips10": "GA",
      "un_locode": "GM",
      "stanag_1059": "GMB",
      "ioc": "GAM",
      "fifa": "GAM",
      "itu": "GMB",
      "uic": "",
      "maritime": 629,
      "mmc": 607
    }
  },
  {
    "locale": "en-GH",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Ghana",
      "name_local": "Ghana",
      "code": "GH",
      "area_sq_km": 238533,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Accra",
      "capital_latitude": 5.55602,
      "capital_longitude": -0.1969,
      "currency": "Ghana Cedi",
      "currency_local": "Ghanaian cedi",
      "currency_code": "GHS",
      "currency_symbol": "₵",
      "currency_numeric": 936,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pesewas",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇭",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "BF",
        "CI",
        "TG"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 288,
      "iso_3166_1_alpha2": "GH",
      "iso_3166_1_alpha3": "GHA",
      "tld": "gh",
      "vehicle_code": "GH",
      "fips10": "GH",
      "un_locode": "GH",
      "stanag_1059": "GHA",
      "ioc": "GHA",
      "fifa": "GHA",
      "itu": "GHA",
      "uic": "",
      "maritime": 627,
      "mmc": 620
    }
  },
  {
    "locale": "en-GI",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Gibraltar",
      "name_local": "Gibraltar",
      "code": "GI",
      "area_sq_km": 6,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Gibraltar",
      "capital_latitude": 36.14474,
      "capital_longitude": -5.35257,
      "currency": "Gibraltar Pound",
      "currency_local": "Gibraltar pound",
      "currency_code": "GIP",
      "currency_symbol": "£",
      "currency_numeric": 292,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇮",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "ES"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 292,
      "iso_3166_1_alpha2": "GI",
      "iso_3166_1_alpha3": "GIB",
      "tld": "gi",
      "vehicle_code": "GBZ",
      "fips10": "GI",
      "un_locode": "GI",
      "stanag_1059": "GIB",
      "ioc": "",
      "fifa": "GIB",
      "itu": "GIB",
      "uic": "",
      "maritime": 236,
      "mmc": 266
    }
  },
  {
    "locale": "en-GD",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Grenada",
      "name_local": "Grenada",
      "code": "GD",
      "area_sq_km": 344,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Saint George's",
      "capital_latitude": 12.05644,
      "capital_longitude": -61.74849,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇩",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 308,
      "iso_3166_1_alpha2": "GD",
      "iso_3166_1_alpha3": "GRD",
      "tld": "gd",
      "vehicle_code": "WG",
      "fips10": "GJ",
      "un_locode": "GD",
      "stanag_1059": "GRD",
      "ioc": "GRN",
      "fifa": "GRN",
      "itu": "GRD",
      "uic": "",
      "maritime": 330,
      "mmc": 352
    }
  },
  {
    "locale": "en-GU",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Guam",
      "name_local": "Guam",
      "code": "GU",
      "area_sq_km": 549,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Hagåtña",
      "capital_latitude": 13.47567,
      "capital_longitude": 144.74886,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chamorro",
          "name_local": "Chamoru",
          "iso_639_1": "ch",
          "iso_639_2": "cha",
          "iso_639_3": "cha"
        },
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇬🇺",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "969##",
      "postal_code_regex": "^(969\\d{2})$",
      "iso_3166_1_numeric": 316,
      "iso_3166_1_alpha2": "GU",
      "iso_3166_1_alpha3": "GUM",
      "tld": "gu",
      "vehicle_code": "",
      "fips10": "GQ",
      "un_locode": "GU",
      "stanag_1059": "GUM",
      "ioc": "GUM",
      "fifa": "GUM",
      "itu": "GUM",
      "uic": "",
      "maritime": "",
      "mmc": 535
    }
  },
  {
    "locale": "en-GG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Guernsey",
      "name_local": "Bailiwick of Guernsey",
      "code": "GG",
      "area_sq_km": 78,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Saint Peter Port",
      "capital_latitude": 49.45981,
      "capital_longitude": -2.53527,
      "currency": "Guernsey Pound",
      "currency_local": "Guernsey pound",
      "currency_code": "GGP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇬🇬",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 831,
      "iso_3166_1_alpha2": "GG",
      "iso_3166_1_alpha3": "GGY",
      "tld": "gg",
      "vehicle_code": "GBG",
      "fips10": "GK",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-GY",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Guyana",
      "name_local": "Guyana",
      "code": "GY",
      "area_sq_km": 214969,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Georgetown",
      "capital_latitude": 6.80448,
      "capital_longitude": -58.15527,
      "currency": "Guyana Dollar",
      "currency_local": "Guyanese dollar",
      "currency_code": "GYD",
      "currency_symbol": "$",
      "currency_numeric": 328,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇾",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "BR",
        "SR",
        "VE"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 328,
      "iso_3166_1_alpha2": "GY",
      "iso_3166_1_alpha3": "GUY",
      "tld": "gy",
      "vehicle_code": "GUY",
      "fips10": "GY",
      "un_locode": "GY",
      "stanag_1059": "GUY",
      "ioc": "GUY",
      "fifa": "GUY",
      "itu": "GUY",
      "uic": "",
      "maritime": 750,
      "mmc": 738
    }
  },
  {
    "locale": "en-HM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Heard Island and McDonald Islands",
      "name_local": "Heard and McDonald Islands",
      "code": "HM",
      "area_sq_km": 412,
      "continent": "Australia",
      "region": "",
      "capital_name": "",
      "currency": "Australian Dollar",
      "currency_local": "",
      "currency_code": "AUD",
      "currency_symbol": "",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇭🇲",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 334,
      "iso_3166_1_alpha2": "HM",
      "iso_3166_1_alpha3": "HMD",
      "tld": "hm",
      "vehicle_code": "",
      "fips10": "HM",
      "un_locode": "HM",
      "stanag_1059": "HMD",
      "ioc": "",
      "fifa": "",
      "itu": "HMD",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-HK",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Hong Kong",
      "name_local": "香港 / Xiānggǎng",
      "code": "HK",
      "area_sq_km": 1104,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Hong Kong",
      "capital_latitude": 22.28552,
      "capital_longitude": 114.15769,
      "currency": "Hong Kong Dollar",
      "currency_local": "Hong Kong dollar",
      "currency_code": "HKD",
      "currency_symbol": "$",
      "currency_numeric": 344,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇭🇰",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "CN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 344,
      "iso_3166_1_alpha2": "HK",
      "iso_3166_1_alpha3": "HKG",
      "tld": "hk",
      "vehicle_code": "HK",
      "fips10": "HK",
      "un_locode": "HK",
      "stanag_1059": "HKG",
      "ioc": "HKG",
      "fifa": "HKG",
      "itu": "HKG",
      "uic": "",
      "maritime": 477,
      "mmc": 454
    }
  },
  {
    "locale": "en-IN",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "India",
      "name_local": "Bharat  / भारत गणराज्य",
      "code": "IN",
      "area_sq_km": 3287590,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "New Delhi",
      "capital_latitude": 28.63576,
      "capital_longitude": 77.22445,
      "currency": "Indian Rupee",
      "currency_local": "Indian rupee",
      "currency_code": "INR",
      "currency_symbol": "₹",
      "currency_numeric": 356,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Paise",
      "languages": [
        {
          "name": "Hindi",
          "name_local": "हिन्दी",
          "iso_639_1": "hi",
          "iso_639_2": "hin",
          "iso_639_3": "hin"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇮🇳",
      "timezones": [
        "UTC+05:30"
      ],
      "borders": [
        "BD",
        "BT",
        "MM",
        "CN",
        "NP",
        "PK"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 356,
      "iso_3166_1_alpha2": "IN",
      "iso_3166_1_alpha3": "IND",
      "tld": "in",
      "vehicle_code": "IND",
      "fips10": "IN",
      "un_locode": "IN",
      "stanag_1059": "IND",
      "ioc": "IND",
      "fifa": "IND",
      "itu": "IND",
      "uic": "",
      "maritime": 419,
      "mmc": "404, 405"
    }
  },
  {
    "locale": "en-IM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Isle of Man",
      "name_local": "Isle of Man / Mannin / Ellan Vannin",
      "code": "IM",
      "area_sq_km": 572,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Douglas",
      "capital_latitude": 54.15,
      "capital_longitude": -4.48333,
      "currency": "Manx Pound",
      "currency_local": "Manx pound",
      "currency_code": "IMP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Manx",
          "name_local": "Gaelg",
          "iso_639_1": "gv",
          "iso_639_2": "glv",
          "iso_639_3": "glv"
        }
      ],
      "flag": "🇮🇲",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 833,
      "iso_3166_1_alpha2": "IM",
      "iso_3166_1_alpha3": "IMN",
      "tld": "im",
      "vehicle_code": "",
      "fips10": "",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-IE",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Ireland",
      "name_local": "Éire / Airlann",
      "code": "IE",
      "area_sq_km": 70273,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Dublin",
      "capital_latitude": 53.33306,
      "capital_longitude": -6.24889,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Irish",
          "name_local": "Gaeilge",
          "iso_639_1": "ga",
          "iso_639_2": "gle",
          "iso_639_3": "gle"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇮🇪",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GB"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 372,
      "iso_3166_1_alpha2": "IE",
      "iso_3166_1_alpha3": "IRL",
      "tld": "ie",
      "vehicle_code": "IRL",
      "fips10": "EI",
      "un_locode": "IE",
      "stanag_1059": "IRL",
      "ioc": "IRL",
      "fifa": "IRL",
      "itu": "IRL",
      "uic": "60 IRL",
      "maritime": 250,
      "mmc": 272
    }
  },
  {
    "locale": "en-JM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Jamaica",
      "name_local": "Jamaica",
      "code": "JM",
      "area_sq_km": 10991,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Kingston",
      "capital_latitude": 17.99702,
      "capital_longitude": -76.79358,
      "currency": "Jamaica Dollar",
      "currency_local": "Jamaican dollar",
      "currency_code": "JMD",
      "currency_symbol": "$",
      "currency_numeric": 388,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇯🇲",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 388,
      "iso_3166_1_alpha2": "JM",
      "iso_3166_1_alpha3": "JAM",
      "tld": "jm",
      "vehicle_code": "JA",
      "fips10": "JM",
      "un_locode": "JM",
      "stanag_1059": "JAM",
      "ioc": "JAM",
      "fifa": "JAM",
      "itu": "JMC",
      "uic": "",
      "maritime": 339,
      "mmc": 338
    }
  },
  {
    "locale": "en-JE",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Jersey",
      "name_local": "Bailiwick of Jersey",
      "code": "JE",
      "area_sq_km": 116,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Saint Helier",
      "capital_latitude": 49.18804,
      "capital_longitude": -2.10491,
      "currency": "Jersey Sterling Pound",
      "currency_local": "Jersey pound",
      "currency_code": "JEP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Penny",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇯🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 832,
      "iso_3166_1_alpha2": "JE",
      "iso_3166_1_alpha3": "JEY",
      "tld": "je",
      "vehicle_code": "GBJ",
      "fips10": "JE",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-VG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "British Virgin Islands",
      "name_local": "British Virgin Islands",
      "code": "VG",
      "area_sq_km": 151,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Road Town",
      "capital_latitude": 18.42693,
      "capital_longitude": -64.62079,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇻🇬",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 92,
      "iso_3166_1_alpha2": "VG",
      "iso_3166_1_alpha3": "VGB",
      "tld": "vg",
      "vehicle_code": "VG",
      "fips10": "VI",
      "un_locode": "VG",
      "stanag_1059": "VGB",
      "ioc": "IVB",
      "fifa": "VGB",
      "itu": "VRG",
      "uic": "",
      "maritime": 378,
      "mmc": 348
    }
  },
  {
    "locale": "en-VI",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Virgin Islands",
      "name_local": "Virgin Islands of the United States",
      "code": "VI",
      "area_sq_km": 347,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Charlotte Amalie",
      "capital_latitude": 18.3419,
      "capital_longitude": -64.9307,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇻🇮",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 850,
      "iso_3166_1_alpha2": "VI",
      "iso_3166_1_alpha3": "VIR",
      "tld": "vi",
      "vehicle_code": "",
      "fips10": "VQ",
      "un_locode": "VI",
      "stanag_1059": "VIR",
      "ioc": "ISV",
      "fifa": "VIR",
      "itu": "VIR",
      "uic": "",
      "maritime": 379,
      "mmc": 332
    }
  },
  {
    "locale": "en-KY",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Cayman Islands",
      "name_local": "Cayman Islands",
      "code": "KY",
      "area_sq_km": 264,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "George Town",
      "capital_latitude": 19.2866,
      "capital_longitude": -81.37436,
      "currency": "Cayman Dollar",
      "currency_local": "Cayman Islands dollar",
      "currency_code": "KYD",
      "currency_symbol": "$",
      "currency_numeric": 136,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇰🇾",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 136,
      "iso_3166_1_alpha2": "KY",
      "iso_3166_1_alpha3": "CYM",
      "tld": "ky",
      "vehicle_code": "",
      "fips10": "CJ",
      "un_locode": "KY",
      "stanag_1059": "CYM",
      "ioc": "CAY",
      "fifa": "CAY",
      "itu": "CYM",
      "uic": "",
      "maritime": 319,
      "mmc": 346
    }
  },
  {
    "locale": "en-CM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Cameroon",
      "name_local": "Cameroun / Cameroon",
      "code": "CM",
      "area_sq_km": 475442,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Yaounde",
      "capital_latitude": 3.86667,
      "capital_longitude": 11.51667,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇨🇲",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CF",
        "TD",
        "CG",
        "GQ",
        "GA",
        "NG"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 120,
      "iso_3166_1_alpha2": "CM",
      "iso_3166_1_alpha3": "CMR",
      "tld": "cm",
      "vehicle_code": "CAM",
      "fips10": "CM",
      "un_locode": "CM",
      "stanag_1059": "CMR",
      "ioc": "CMR",
      "fifa": "CMR",
      "itu": "CME",
      "uic": "",
      "maritime": 613,
      "mmc": 624
    }
  },
  {
    "locale": "en-CA",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Canada",
      "name_local": "Canada",
      "code": "CA",
      "area_sq_km": 9984670,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Ottawa",
      "capital_latitude": 45.41117,
      "capital_longitude": -75.69812,
      "currency": "Canadian Dollar",
      "currency_local": "Canadian dollar",
      "currency_code": "CAD",
      "currency_symbol": "$",
      "currency_numeric": 124,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇨🇦",
      "timezones": [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:30"
      ],
      "borders": [
        "US"
      ],
      "is_landlocked": false,
      "postal_code_format": "@#@ #@#",
      "postal_code_regex": "^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$ ",
      "iso_3166_1_numeric": 124,
      "iso_3166_1_alpha2": "CA",
      "iso_3166_1_alpha3": "CAN",
      "tld": "ca",
      "vehicle_code": "CDN",
      "fips10": "CA",
      "un_locode": "CA",
      "stanag_1059": "CAN",
      "ioc": "CAN",
      "fifa": "CAN",
      "itu": "CAN",
      "uic": "CA",
      "maritime": 316,
      "mmc": 302
    }
  },
  {
    "locale": "en-KE",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Kenya",
      "name_local": "Kenya",
      "code": "KE",
      "area_sq_km": 580367,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Nairobi",
      "capital_latitude": -1.28333,
      "capital_longitude": 36.81667,
      "currency": "Kenian Schilling",
      "currency_local": "Kenyan shilling",
      "currency_code": "KES",
      "currency_symbol": "Sh",
      "currency_numeric": 404,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        }
      ],
      "flag": "🇰🇪",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "ET",
        "SO",
        "SS",
        "TZ",
        "UG"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 404,
      "iso_3166_1_alpha2": "KE",
      "iso_3166_1_alpha3": "KEN",
      "tld": "ke",
      "vehicle_code": "EAK",
      "fips10": "KE",
      "un_locode": "KE",
      "stanag_1059": "KEN",
      "ioc": "KEN",
      "fifa": "KEN",
      "itu": "KEN",
      "uic": "",
      "maritime": 634,
      "mmc": 639
    }
  },
  {
    "locale": "en-KI",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Kiribati",
      "name_local": "Kiribati",
      "code": "KI",
      "area_sq_km": 811,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Tarawa",
      "capital_latitude": 1.3278,
      "capital_longitude": 172.97696,
      "currency": "Kiribati Dollar",
      "currency_local": "Kiribati dollar",
      "currency_code": "KID",
      "currency_symbol": "$",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇰🇮",
      "timezones": [
        "UTC+12:00",
        "UTC+13:00",
        "UTC+14:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 296,
      "iso_3166_1_alpha2": "KI",
      "iso_3166_1_alpha3": "KIR",
      "tld": "ki",
      "vehicle_code": "KIR",
      "fips10": "KR",
      "un_locode": "KI",
      "stanag_1059": "KIR",
      "ioc": "KIR",
      "fifa": "KIR",
      "itu": "KIR",
      "uic": "",
      "maritime": 529,
      "mmc": 545
    }
  },
  {
    "locale": "en-UM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "United States Minor Outlying Islands",
      "name_local": "United States Minor Outlying Islands",
      "code": "UM",
      "area_sq_km": 34.2,
      "continent": "Oceania",
      "region": "North America",
      "capital_name": "",
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇺🇲",
      "timezones": [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 581,
      "iso_3166_1_alpha2": "UM",
      "iso_3166_1_alpha3": "UMI",
      "tld": "us",
      "vehicle_code": "",
      "fips10": "UM",
      "un_locode": "UM",
      "stanag_1059": "UMI",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-CC",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Cocos (Keeling) Islands",
      "name_local": "",
      "code": "CC",
      "area_sq_km": 14,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "West Island",
      "capital_latitude": -12.14603,
      "capital_longitude": 96.822424,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇨🇨",
      "timezones": [
        "UTC+06:30"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 166,
      "iso_3166_1_alpha2": "CC",
      "iso_3166_1_alpha3": "CCK",
      "tld": "cc",
      "vehicle_code": "",
      "fips10": "CK",
      "un_locode": "CC",
      "stanag_1059": "AUS",
      "ioc": "",
      "fifa": "",
      "itu": "ICO",
      "uic": "",
      "maritime": 523,
      "mmc": ""
    }
  },
  {
    "locale": "en-LS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Lesotho",
      "name_local": "Lesotho",
      "code": "LS",
      "area_sq_km": 30355,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Maseru",
      "capital_latitude": -29.31667,
      "capital_longitude": 27.48333,
      "currency": "Lesotho Loti",
      "currency_local": "Lesotho loti",
      "currency_code": "LSL",
      "currency_symbol": "L",
      "currency_numeric": 426,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Lisente",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        }
      ],
      "flag": "🇱🇸",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "ZA"
      ],
      "is_landlocked": true,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 426,
      "iso_3166_1_alpha2": "LS",
      "iso_3166_1_alpha3": "LSO",
      "tld": "ls",
      "vehicle_code": "LS",
      "fips10": "LT",
      "un_locode": "LS",
      "stanag_1059": "LSO",
      "ioc": "LES",
      "fifa": "LES",
      "itu": "LSO",
      "uic": "",
      "maritime": 644,
      "mmc": 651
    }
  },
  {
    "locale": "en-LR",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Liberia",
      "name_local": "Liberia",
      "code": "LR",
      "area_sq_km": 111369,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Monrovia",
      "capital_latitude": 6.30054,
      "capital_longitude": -10.7969,
      "currency": "Liberian Dollar",
      "currency_local": "Liberian dollar",
      "currency_code": "LRD",
      "currency_symbol": "$",
      "currency_numeric": 430,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇱🇷",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GN",
        "CI",
        "SL"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 430,
      "iso_3166_1_alpha2": "LR",
      "iso_3166_1_alpha3": "LBR",
      "tld": "lr",
      "vehicle_code": "LB",
      "fips10": "LI",
      "un_locode": "LR",
      "stanag_1059": "LBR",
      "ioc": "LBR",
      "fifa": "LBR",
      "itu": "LBR",
      "uic": "",
      "maritime": "636, 637",
      "mmc": 618
    }
  },
  {
    "locale": "en-MW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Malawi",
      "name_local": "Malawi",
      "code": "MW",
      "area_sq_km": 118484,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Lilongwe",
      "capital_latitude": -13.96692,
      "capital_longitude": 33.78725,
      "currency": "Malawian Kwacha",
      "currency_local": "Malawian kwacha",
      "currency_code": "MWK",
      "currency_symbol": "MK",
      "currency_numeric": 454,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tambala",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chichewa",
          "name_local": "chiCheŵa",
          "iso_639_1": "ny",
          "iso_639_2": "nya",
          "iso_639_3": "nya"
        }
      ],
      "flag": "🇲🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "MZ",
        "TZ",
        "ZM"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 454,
      "iso_3166_1_alpha2": "MW",
      "iso_3166_1_alpha3": "MWI",
      "tld": "mw",
      "vehicle_code": "MW",
      "fips10": "MI",
      "un_locode": "MW",
      "stanag_1059": "MWI",
      "ioc": "MAW",
      "fifa": "MWI",
      "itu": "MWI",
      "uic": "",
      "maritime": 655,
      "mmc": 650
    }
  },
  {
    "locale": "en-MT",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Malta",
      "name_local": "Malta",
      "code": "MT",
      "area_sq_km": 316,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Valletta",
      "capital_latitude": 35.89972,
      "capital_longitude": 14.51472,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Maltese",
          "name_local": "Malti",
          "iso_639_1": "mt",
          "iso_639_2": "mlt",
          "iso_639_3": "mlt"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇲🇹",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@@@ ###|@@@ ##",
      "postal_code_regex": "^([A-Z]{3}\\d{2}\\d?)$",
      "iso_3166_1_numeric": 470,
      "iso_3166_1_alpha2": "MT",
      "iso_3166_1_alpha3": "MLT",
      "tld": "mt",
      "vehicle_code": "M",
      "fips10": "MT",
      "un_locode": "MT",
      "stanag_1059": "MLT",
      "ioc": "MLT",
      "fifa": "MLT",
      "itu": "MLT",
      "uic": "",
      "maritime": "215, 229, 248, 249, 256",
      "mmc": 278
    }
  },
  {
    "locale": "en-MH",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Marshall Islands",
      "name_local": "Marshall Islands/Majol",
      "code": "MH",
      "area_sq_km": 181,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Majuro",
      "capital_latitude": 7.08971,
      "capital_longitude": 171.38027,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Marshallese",
          "name_local": "Kajin M̧ajeļ",
          "iso_639_1": "mh",
          "iso_639_2": "mah",
          "iso_639_3": "mah"
        }
      ],
      "flag": "🇲🇭",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 584,
      "iso_3166_1_alpha2": "MH",
      "iso_3166_1_alpha3": "MHL",
      "tld": "mh",
      "vehicle_code": "MH",
      "fips10": "RM",
      "un_locode": "MH",
      "stanag_1059": "MHL",
      "ioc": "MHL",
      "fifa": "",
      "itu": "MHL",
      "uic": "",
      "maritime": 538,
      "mmc": 551
    }
  },
  {
    "locale": "en-MU",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Mauritius",
      "name_local": "Maurice",
      "code": "MU",
      "area_sq_km": 2040,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Port Louis",
      "capital_latitude": -20.16194,
      "capital_longitude": 57.49889,
      "currency": "Mauritian Rupee",
      "currency_local": "Mauritian rupee",
      "currency_code": "MUR",
      "currency_symbol": "₨",
      "currency_numeric": 480,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇲🇺",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 480,
      "iso_3166_1_alpha2": "MU",
      "iso_3166_1_alpha3": "MUS",
      "tld": "mu",
      "vehicle_code": "MS",
      "fips10": "MP",
      "un_locode": "MU",
      "stanag_1059": "MUS",
      "ioc": "MRI",
      "fifa": "MRI",
      "itu": "MAU",
      "uic": "",
      "maritime": 645,
      "mmc": 617
    }
  },
  {
    "locale": "en-MS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Montserrat",
      "name_local": "Montserrat",
      "code": "MS",
      "area_sq_km": 102,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Brades",
      "capital_latitude": 16.79183,
      "capital_longitude": -62.21058,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇲🇸",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 500,
      "iso_3166_1_alpha2": "MS",
      "iso_3166_1_alpha3": "MSR",
      "tld": "ms",
      "vehicle_code": "",
      "fips10": "MH",
      "un_locode": "MS",
      "stanag_1059": "MSR",
      "ioc": "",
      "fifa": "MSR",
      "itu": "MSR",
      "uic": "",
      "maritime": 348,
      "mmc": 354
    }
  },
  {
    "locale": "en-NA",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Namibia",
      "name_local": "Namibia",
      "code": "NA",
      "area_sq_km": 825615,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Windhoek",
      "capital_latitude": -22.55941,
      "capital_longitude": 17.08323,
      "currency": "Namibian Dollar",
      "currency_local": "Namibian dollar",
      "currency_code": "NAD",
      "currency_symbol": "$",
      "currency_numeric": 516,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        }
      ],
      "flag": "🇳🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AO",
        "BW",
        "ZA",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 516,
      "iso_3166_1_alpha2": "NA",
      "iso_3166_1_alpha3": "NAM",
      "tld": "na",
      "vehicle_code": "NAM",
      "fips10": "WA",
      "un_locode": "NA",
      "stanag_1059": "NAM",
      "ioc": "NAM",
      "fifa": "NAM",
      "itu": "NMB",
      "uic": "",
      "maritime": 659,
      "mmc": 649
    }
  },
  {
    "locale": "en-NR",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Nauru",
      "name_local": "Naoero/Nauru",
      "code": "NR",
      "area_sq_km": 21,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Yaren",
      "capital_latitude": -0.55085,
      "capital_longitude": 166.9252,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Nauruan",
          "name_local": "Dorerin Naoero",
          "iso_639_1": "na",
          "iso_639_2": "nau",
          "iso_639_3": "nau"
        }
      ],
      "flag": "🇳🇷",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 520,
      "iso_3166_1_alpha2": "NR",
      "iso_3166_1_alpha3": "NRU",
      "tld": "nr",
      "vehicle_code": "NAU",
      "fips10": "NR",
      "un_locode": "NR",
      "stanag_1059": "NRU",
      "ioc": "NRU",
      "fifa": "",
      "itu": "NRU",
      "uic": "",
      "maritime": 544,
      "mmc": 536
    }
  },
  {
    "locale": "en-NZ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "New Zealand",
      "name_local": "New Zealand/Aotearoa",
      "code": "NZ",
      "area_sq_km": 270467,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "Wellington",
      "capital_latitude": -41.28664,
      "capital_longitude": 174.77557,
      "currency": "New Zealand Dollar",
      "currency_local": "New Zealand dollar",
      "currency_code": "NZD",
      "currency_symbol": "$",
      "currency_numeric": 554,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Māori",
          "name_local": "te reo Māori",
          "iso_639_1": "mi",
          "iso_639_2": "mri",
          "iso_639_3": "mri"
        }
      ],
      "flag": "🇳🇿",
      "timezones": [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00",
        "UTC+12:45",
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 554,
      "iso_3166_1_alpha2": "NZ",
      "iso_3166_1_alpha3": "NZL",
      "tld": "nz",
      "vehicle_code": "NZ",
      "fips10": "NZ",
      "un_locode": "NZ",
      "stanag_1059": "NZL",
      "ioc": "NZL",
      "fifa": "NZL",
      "itu": "NZL",
      "uic": "64 NZ",
      "maritime": 512,
      "mmc": 530
    }
  },
  {
    "locale": "en-NG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Nigeria",
      "name_local": "Nigeria",
      "code": "NG",
      "area_sq_km": 923768,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Abuja",
      "capital_latitude": 9.05785,
      "capital_longitude": 7.49508,
      "currency": "Naira",
      "currency_local": "Nigerian naira",
      "currency_code": "NGN",
      "currency_symbol": "₦",
      "currency_numeric": 566,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kobo",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇳🇬",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BJ",
        "CM",
        "TD",
        "NE"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 566,
      "iso_3166_1_alpha2": "NG",
      "iso_3166_1_alpha3": "NGA",
      "tld": "ng",
      "vehicle_code": "NGR",
      "fips10": "NI",
      "un_locode": "NG",
      "stanag_1059": "NGA",
      "ioc": "NGR",
      "fifa": "NGR",
      "itu": "NIG",
      "uic": "",
      "maritime": 657,
      "mmc": 621
    }
  },
  {
    "locale": "en-NU",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Niue",
      "name_local": "Niue",
      "code": "NU",
      "area_sq_km": 260,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Alofi",
      "capital_latitude": -19.05952,
      "capital_longitude": -169.91867,
      "currency": "New Zealand Dollar",
      "currency_local": "New Zealand dollar",
      "currency_code": "NZD",
      "currency_symbol": "$",
      "currency_numeric": 554,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇳🇺",
      "timezones": [
        "UTC-11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 570,
      "iso_3166_1_alpha2": "NU",
      "iso_3166_1_alpha3": "NIU",
      "tld": "nu",
      "vehicle_code": "",
      "fips10": "NE",
      "un_locode": "NU",
      "stanag_1059": "NIU",
      "ioc": "",
      "fifa": "NIU",
      "itu": "NIU",
      "uic": "",
      "maritime": 542,
      "mmc": ""
    }
  },
  {
    "locale": "en-MP",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Northern Mariana Islands",
      "name_local": "Northern Mariana Islands",
      "code": "MP",
      "area_sq_km": 464,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Saipan",
      "capital_latitude": 15.21233,
      "capital_longitude": 145.7545,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chamorro",
          "name_local": "Chamoru",
          "iso_639_1": "ch",
          "iso_639_2": "cha",
          "iso_639_3": "cha"
        }
      ],
      "flag": "🇲🇵",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 580,
      "iso_3166_1_alpha2": "MP",
      "iso_3166_1_alpha3": "MNP",
      "tld": "mp",
      "vehicle_code": "",
      "fips10": "CQ",
      "un_locode": "MP",
      "stanag_1059": "MNP",
      "ioc": "",
      "fifa": "NMI",
      "itu": "MRA",
      "uic": "",
      "maritime": 536,
      "mmc": 534
    }
  },
  {
    "locale": "en-NF",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Norfolk Island",
      "name_local": "Norfolk Island",
      "code": "NF",
      "area_sq_km": 36,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "Kingston",
      "capital_latitude": -29.05459,
      "capital_longitude": 167.96628,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇳🇫",
      "timezones": [
        "UTC+11:30"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 574,
      "iso_3166_1_alpha2": "NF",
      "iso_3166_1_alpha3": "NFK",
      "tld": "nf",
      "vehicle_code": "",
      "fips10": "NF",
      "un_locode": "NF",
      "stanag_1059": "NFK",
      "ioc": "",
      "fifa": "",
      "itu": "NFK",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-PK",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Pakistan",
      "name_local": "Pakistan",
      "code": "PK",
      "area_sq_km": 881912,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Islamabad",
      "capital_latitude": 33.72148,
      "capital_longitude": 73.04329,
      "currency": "Pakistanian Rupee",
      "currency_local": "Pakistani rupee",
      "currency_code": "PKR",
      "currency_symbol": "₨",
      "currency_numeric": 586,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Paisa",
      "languages": [
        {
          "name": "Urdu",
          "name_local": "اردو",
          "iso_639_1": "ur",
          "iso_639_2": "urd",
          "iso_639_3": "urd"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇰",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "CN",
        "IN",
        "IR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 586,
      "iso_3166_1_alpha2": "PK",
      "iso_3166_1_alpha3": "PAK",
      "tld": "pk",
      "vehicle_code": "PK",
      "fips10": "PK",
      "un_locode": "PK",
      "stanag_1059": "PAK",
      "ioc": "PAK",
      "fifa": "PAK",
      "itu": "PAK",
      "uic": "",
      "maritime": 463,
      "mmc": 410
    }
  },
  {
    "locale": "en-PW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Palau",
      "name_local": "Belau/Palau",
      "code": "PW",
      "area_sq_km": 459,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "",
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇼",
      "timezones": [
        "UTC+09:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "96940",
      "postal_code_regex": "^(96940)$",
      "iso_3166_1_numeric": 585,
      "iso_3166_1_alpha2": "PW",
      "iso_3166_1_alpha3": "PLW",
      "tld": "pw",
      "vehicle_code": "PAL",
      "fips10": "PS",
      "un_locode": "PW",
      "stanag_1059": "PLW",
      "ioc": "PLW",
      "fifa": "PLW",
      "itu": "PLW",
      "uic": "",
      "maritime": 511,
      "mmc": 552
    }
  },
  {
    "locale": "en-PG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Papua New Guinea",
      "name_local": "Papua New Guinea/Papua Niugini",
      "code": "PG",
      "area_sq_km": 462840,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Port Moresby",
      "capital_latitude": -9.44314,
      "capital_longitude": 147.17972,
      "currency": "Kina",
      "currency_local": "Papua New Guinean kina",
      "currency_code": "PGK",
      "currency_symbol": "K",
      "currency_numeric": 598,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Toea",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇬",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [
        "ID"
      ],
      "is_landlocked": false,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 598,
      "iso_3166_1_alpha2": "PG",
      "iso_3166_1_alpha3": "PNG",
      "tld": "pg",
      "vehicle_code": "PNG",
      "fips10": "PP",
      "un_locode": "PG",
      "stanag_1059": "PNG",
      "ioc": "PNG",
      "fifa": "PNG",
      "itu": "PNG",
      "uic": "",
      "maritime": 553,
      "mmc": 537
    }
  },
  {
    "locale": "en-PH",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Philippines",
      "name_local": "Pilipinas",
      "code": "PH",
      "area_sq_km": 342353,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Manila",
      "capital_latitude": 14.6042,
      "capital_longitude": 120.9822,
      "currency": "Philippine Peso",
      "currency_local": "Philippine peso",
      "currency_code": "PHP",
      "currency_symbol": "₱",
      "currency_numeric": 608,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇭",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 608,
      "iso_3166_1_alpha2": "PH",
      "iso_3166_1_alpha3": "PHL",
      "tld": "ph",
      "vehicle_code": "RP",
      "fips10": "RP",
      "un_locode": "PH",
      "stanag_1059": "PHL",
      "ioc": "PHI",
      "fifa": "PHI",
      "itu": "PHL",
      "uic": "",
      "maritime": 548,
      "mmc": 515
    }
  },
  {
    "locale": "en-PN",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Pitcairn Islands",
      "name_local": "",
      "code": "PN",
      "area_sq_km": 47,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Adamstown",
      "capital_latitude": -25.066397,
      "capital_longitude": -130.100197,
      "currency": "New Zealand Dollar",
      "currency_local": "New Zealand dollar",
      "currency_code": "NZD",
      "currency_symbol": "$",
      "currency_numeric": 554,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇳",
      "timezones": [
        "UTC-08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 612,
      "iso_3166_1_alpha2": "PN",
      "iso_3166_1_alpha3": "PCN",
      "tld": "pn",
      "vehicle_code": "",
      "fips10": "PC",
      "un_locode": "PN",
      "stanag_1059": "PCN",
      "ioc": "",
      "fifa": "",
      "itu": "PTC",
      "uic": "",
      "maritime": 555,
      "mmc": ""
    }
  },
  {
    "locale": "en-PR",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Puerto Rico",
      "name_local": "Puerto Rico",
      "code": "PR",
      "area_sq_km": 8870,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "San Juan",
      "capital_latitude": 18.46633,
      "capital_longitude": -66.10572,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇷",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####-####",
      "postal_code_regex": "^(\\d{9})$",
      "iso_3166_1_numeric": 630,
      "iso_3166_1_alpha2": "PR",
      "iso_3166_1_alpha3": "PRI",
      "tld": "pr",
      "vehicle_code": "PRI",
      "fips10": "RQ",
      "un_locode": "PR",
      "stanag_1059": "PRI",
      "ioc": "PUR",
      "fifa": "PUR",
      "itu": "PTR",
      "uic": "",
      "maritime": 358,
      "mmc": 330
    }
  },
  {
    "locale": "en-RW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Rwanda",
      "name_local": "Rwanda / Urwanda",
      "code": "RW",
      "area_sq_km": 26338,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Kigali",
      "capital_latitude": -1.94995,
      "capital_longitude": 30.05885,
      "currency": "Rwandan Franc",
      "currency_local": "Rwandan franc",
      "currency_code": "RWF",
      "currency_symbol": "Fr",
      "currency_numeric": 646,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Kinyarwanda",
          "name_local": "Ikinyarwanda",
          "iso_639_1": "rw",
          "iso_639_2": "kin",
          "iso_639_3": "kin"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇷🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BI",
        "CD",
        "TZ",
        "UG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 646,
      "iso_3166_1_alpha2": "RW",
      "iso_3166_1_alpha3": "RWA",
      "tld": "rw",
      "vehicle_code": "RWA",
      "fips10": "RW",
      "un_locode": "RW",
      "stanag_1059": "RWA",
      "ioc": "RWA",
      "fifa": "RWA",
      "itu": "RRW",
      "uic": "",
      "maritime": 661,
      "mmc": 635
    }
  },
  {
    "locale": "en-MF",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Saint Martin",
      "name_local": "Saint Martin",
      "code": "MF",
      "area_sq_km": 53,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Marigot",
      "capital_latitude": 18.06667,
      "capital_longitude": -63.08333,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇲🇫",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "SX"
      ],
      "is_landlocked": false,
      "postal_code_format": "### ###",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 663,
      "iso_3166_1_alpha2": "MF",
      "iso_3166_1_alpha3": "MAF",
      "tld": "mf",
      "vehicle_code": "F",
      "fips10": "RN",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "SMT",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-SB",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Solomon Islands",
      "name_local": "Solomon Islands",
      "code": "SB",
      "area_sq_km": 28896,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Honiara",
      "capital_latitude": -9.43333,
      "capital_longitude": 159.95,
      "currency": "Salomon Dollar",
      "currency_local": "Solomon Islands dollar",
      "currency_code": "SBD",
      "currency_symbol": "$",
      "currency_numeric": 90,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇧",
      "timezones": [
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 90,
      "iso_3166_1_alpha2": "SB",
      "iso_3166_1_alpha3": "SLB",
      "tld": "sb",
      "vehicle_code": "SOL",
      "fips10": "BP",
      "un_locode": "SB",
      "stanag_1059": "SLB",
      "ioc": "SOL",
      "fifa": "SOL",
      "itu": "SLM",
      "uic": "",
      "maritime": 557,
      "mmc": 540
    }
  },
  {
    "locale": "en-ZM",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Zambia",
      "name_local": "Zambia",
      "code": "ZM",
      "area_sq_km": 752612,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Lusaka",
      "capital_latitude": -15.40669,
      "capital_longitude": 28.28713,
      "currency": "Zambian Kwacha",
      "currency_local": "Zambian kwacha",
      "currency_code": "ZMW",
      "currency_symbol": "ZK",
      "currency_numeric": 967,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Ngwee",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇿🇲",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BW",
        "CD",
        "MW",
        "MZ",
        "NA",
        "TZ",
        "ZW"
      ],
      "is_landlocked": true,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 894,
      "iso_3166_1_alpha2": "ZM",
      "iso_3166_1_alpha3": "ZMB",
      "tld": "zm",
      "vehicle_code": "Z",
      "fips10": "ZA",
      "un_locode": "ZM",
      "stanag_1059": "ZMB",
      "ioc": "ZAM",
      "fifa": "ZAM",
      "itu": "ZMB",
      "uic": "",
      "maritime": 678,
      "mmc": 645
    }
  },
  {
    "locale": "en-WS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Samoa",
      "name_local": "Sāmoa",
      "code": "WS",
      "area_sq_km": 2842,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Apia",
      "capital_latitude": -13.83333,
      "capital_longitude": -171.76666,
      "currency": "Tala",
      "currency_local": "Samoan tālā",
      "currency_code": "WST",
      "currency_symbol": "T",
      "currency_numeric": 882,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Sene",
      "languages": [
        {
          "name": "Samoan",
          "name_local": "gagana fa'a Samoa",
          "iso_639_1": "sm",
          "iso_639_2": "smo",
          "iso_639_3": "smo"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇼🇸",
      "timezones": [
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 882,
      "iso_3166_1_alpha2": "WS",
      "iso_3166_1_alpha3": "WSM",
      "tld": "ws",
      "vehicle_code": "WS",
      "fips10": "WS",
      "un_locode": "WS",
      "stanag_1059": "WSM",
      "ioc": "SAM",
      "fifa": "SAM",
      "itu": "SMO",
      "uic": "",
      "maritime": 561,
      "mmc": 549
    }
  },
  {
    "locale": "en-SC",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Seychelles",
      "name_local": "Sese l /Seychelles",
      "code": "SC",
      "area_sq_km": 452,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Victoria",
      "capital_latitude": -4.61667,
      "capital_longitude": 55.45,
      "currency": "Seychelles Rupee",
      "currency_local": "Seychellois rupee",
      "currency_code": "SCR",
      "currency_symbol": "₨",
      "currency_numeric": 690,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇨",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 690,
      "iso_3166_1_alpha2": "SC",
      "iso_3166_1_alpha3": "SYC",
      "tld": "sc",
      "vehicle_code": "SY",
      "fips10": "SE",
      "un_locode": "SC",
      "stanag_1059": "SYC",
      "ioc": "SEY",
      "fifa": "SEY",
      "itu": "SEY",
      "uic": "",
      "maritime": 664,
      "mmc": 633
    }
  },
  {
    "locale": "en-SL",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Sierra Leone",
      "name_local": "Sierra Leone",
      "code": "SL",
      "area_sq_km": 71740,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Freetown",
      "capital_latitude": 8.484,
      "capital_longitude": -13.22994,
      "currency": "Leone",
      "currency_local": "Sierra Leonean leone",
      "currency_code": "SLL",
      "currency_symbol": "Le",
      "currency_numeric": 694,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇱",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GN",
        "LR"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 694,
      "iso_3166_1_alpha2": "SL",
      "iso_3166_1_alpha3": "SLE",
      "tld": "sl",
      "vehicle_code": "WAL",
      "fips10": "SL",
      "un_locode": "SL",
      "stanag_1059": "SLE",
      "ioc": "SLE",
      "fifa": "SLE",
      "itu": "SRL",
      "uic": "",
      "maritime": 667,
      "mmc": 619
    }
  },
  {
    "locale": "en-ZW",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Zimbabwe",
      "name_local": "Zimbabwe",
      "code": "ZW",
      "area_sq_km": 390757,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Harare",
      "capital_latitude": -17.82772,
      "capital_longitude": 31.05337,
      "currency": "Zimbabwe Dollar",
      "currency_local": "Zimbabwean dollar",
      "currency_code": "ZWL",
      "currency_symbol": "$",
      "currency_numeric": 932,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Shona",
          "name_local": "chiShona",
          "iso_639_1": "sn",
          "iso_639_2": "sna",
          "iso_639_3": "sna"
        },
        {
          "name": "Northern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nd",
          "iso_639_2": "nde",
          "iso_639_3": "nde"
        }
      ],
      "flag": "🇿🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "MZ",
        "ZA",
        "ZM"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 716,
      "iso_3166_1_alpha2": "ZW",
      "iso_3166_1_alpha3": "ZWE",
      "tld": "zw",
      "vehicle_code": "ZW",
      "fips10": "ZI",
      "un_locode": "ZW",
      "stanag_1059": "ZWE",
      "ioc": "ZIM",
      "fifa": "ZIM",
      "itu": "ZWE",
      "uic": "",
      "maritime": 679,
      "mmc": 648
    }
  },
  {
    "locale": "en-SG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Singapore",
      "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
      "code": "SG",
      "area_sq_km": 710,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Singapore",
      "capital_latitude": 1.28967,
      "capital_longitude": 103.85007,
      "currency": "Singapore Dollar",
      "currency_local": "Singapore dollar",
      "currency_code": "SGD",
      "currency_symbol": "$",
      "currency_numeric": 702,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Malay",
          "name_local": "bahasa Melayu",
          "iso_639_1": "ms",
          "iso_639_2": "msa",
          "iso_639_3": "msa"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇸🇬",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 702,
      "iso_3166_1_alpha2": "SG",
      "iso_3166_1_alpha3": "SGP",
      "tld": "sg",
      "vehicle_code": "SGP",
      "fips10": "SN",
      "un_locode": "SG",
      "stanag_1059": "SGP",
      "ioc": "SGP",
      "fifa": "SIN",
      "itu": "SNG",
      "uic": "",
      "maritime": "563, 564, 565, 566",
      "mmc": 525
    }
  },
  {
    "locale": "en-SX",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Sint Maarten",
      "name_local": "Sint Maarten",
      "code": "SX",
      "area_sq_km": 34,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Philipsburg",
      "capital_latitude": 18.025415,
      "capital_longitude": -63.050516,
      "currency": "Caribbean guilder",
      "currency_local": "Caribische gulden",
      "currency_code": "XCG",
      "currency_symbol": "Cg",
      "currency_numeric": 532,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇽",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "MF"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 534,
      "iso_3166_1_alpha2": "SX",
      "iso_3166_1_alpha3": "SXM",
      "tld": "sx",
      "vehicle_code": "",
      "fips10": "NN",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": ""
    }
  },
  {
    "locale": "en-SH",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Saint Helena, Ascension and Tristan da Cunha",
      "name_local": "Saint Helena",
      "code": "SH",
      "area_sq_km": 394,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Jamestown",
      "capital_latitude": -15.93872,
      "capital_longitude": -5.71675,
      "currency": "St.-Helena Pound",
      "currency_local": "Saint Helena pound",
      "currency_code": "SHP",
      "currency_symbol": "£",
      "currency_numeric": 654,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇭",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "STHL 1ZZ",
      "postal_code_regex": "^(STHL1ZZ)$",
      "iso_3166_1_numeric": 654,
      "iso_3166_1_alpha2": "SH",
      "iso_3166_1_alpha3": "SHN",
      "tld": "sh",
      "vehicle_code": "",
      "fips10": "SH",
      "un_locode": "SH",
      "stanag_1059": "SHN",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "608, 665",
      "mmc": ""
    }
  },
  {
    "locale": "en-KN",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Saint Kitts and Nevis",
      "name_local": "Saint Kitts and Nevis",
      "code": "KN",
      "area_sq_km": 261,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Basseterre",
      "capital_latitude": 17.29484,
      "capital_longitude": -62.7261,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇰🇳",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 659,
      "iso_3166_1_alpha2": "KN",
      "iso_3166_1_alpha3": "KNA",
      "tld": "kn",
      "vehicle_code": "KAN",
      "fips10": "SC",
      "un_locode": "KN",
      "stanag_1059": "KNA",
      "ioc": "SKN",
      "fifa": "SKN",
      "itu": "KNA",
      "uic": "",
      "maritime": 341,
      "mmc": 356
    }
  },
  {
    "locale": "en-LC",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Saint Lucia",
      "name_local": "Saint Lucia",
      "code": "LC",
      "area_sq_km": 616,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Castries",
      "capital_latitude": 13.9957,
      "capital_longitude": -61.00614,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇱🇨",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 662,
      "iso_3166_1_alpha2": "LC",
      "iso_3166_1_alpha3": "LCA",
      "tld": "lc",
      "vehicle_code": "WL",
      "fips10": "ST",
      "un_locode": "LC",
      "stanag_1059": "LCA",
      "ioc": "LCA",
      "fifa": "LCA",
      "itu": "LCA",
      "uic": "",
      "maritime": 343,
      "mmc": 358
    }
  },
  {
    "locale": "en-VC",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Saint Vincent and the Grenadines",
      "name_local": "Saint Vincent and the Grenadines",
      "code": "VC",
      "area_sq_km": 389,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Kingstown",
      "capital_latitude": 13.15872,
      "capital_longitude": -61.22475,
      "currency": "East Caribbean Dollar",
      "currency_local": "Eastern Caribbean dollar",
      "currency_code": "XCD",
      "currency_symbol": "$",
      "currency_numeric": 951,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇻🇨",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 670,
      "iso_3166_1_alpha2": "VC",
      "iso_3166_1_alpha3": "VCT",
      "tld": "vc",
      "vehicle_code": "WV",
      "fips10": "VC",
      "un_locode": "VC",
      "stanag_1059": "VCT",
      "ioc": "VIN",
      "fifa": "VIN",
      "itu": "VCT",
      "uic": "",
      "maritime": "375, 376, 377",
      "mmc": 360
    }
  },
  {
    "locale": "en-ZA",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "en-SD",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Sudan",
      "name_local": "جمهورية السودان / As-Sūdān",
      "code": "SD",
      "area_sq_km": 1886068,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "Khartoum",
      "capital_latitude": 15.55177,
      "capital_longitude": 32.53241,
      "currency": "Sudanese Pound",
      "currency_local": "Sudanese pound",
      "currency_code": "SDG",
      "currency_symbol": "",
      "currency_numeric": 938,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piaster",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇩",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "CF",
        "TD",
        "EG",
        "ER",
        "ET",
        "LY",
        "SS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 729,
      "iso_3166_1_alpha2": "SD",
      "iso_3166_1_alpha3": "SDN",
      "tld": "sd",
      "vehicle_code": "SUD",
      "fips10": "SU",
      "un_locode": "SD",
      "stanag_1059": "SDN",
      "ioc": "SUD",
      "fifa": "SDN",
      "itu": "SDN",
      "uic": "",
      "maritime": 662,
      "mmc": 634
    }
  },
  {
    "locale": "en-GS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "South Georgia and South Sandwich Islands",
      "name_local": "South Georgia and the South Sandwich Islands",
      "code": "GS",
      "area_sq_km": 3903,
      "continent": "South America",
      "region": "",
      "capital_name": "King Edward Point",
      "capital_latitude": -54.283349,
      "capital_longitude": -36.494533,
      "currency": "Sterling Pound",
      "currency_local": "",
      "currency_code": "GBP",
      "currency_symbol": "",
      "currency_numeric": 826,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇸",
      "timezones": [
        "UTC-02:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 239,
      "iso_3166_1_alpha2": "GS",
      "iso_3166_1_alpha3": "SGS",
      "tld": "gs",
      "vehicle_code": "",
      "fips10": "SX",
      "un_locode": "GS",
      "stanag_1059": "SGS",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-SS",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "South Sudan",
      "name_local": "",
      "code": "SS",
      "area_sq_km": 619745,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Juba",
      "capital_latitude": 4.85165,
      "capital_longitude": 31.58247,
      "currency": "South Sudanese Pound",
      "currency_local": "South Sudanese pound",
      "currency_code": "SSP",
      "currency_symbol": "£",
      "currency_numeric": 728,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piaster",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇸",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "CF",
        "CD",
        "ET",
        "KE",
        "SD",
        "UG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 728,
      "iso_3166_1_alpha2": "SS",
      "iso_3166_1_alpha3": "SSD",
      "tld": "ss",
      "vehicle_code": "SSD",
      "fips10": "",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "SSD",
      "uic": "",
      "maritime": 638,
      "mmc": ""
    }
  },
  {
    "locale": "en-TZ",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Tanzania",
      "name_local": "Tanzania",
      "code": "TZ",
      "area_sq_km": 945087,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Dodoma",
      "capital_latitude": -6.17221,
      "capital_longitude": 35.73947,
      "currency": "Tansanian Shilling",
      "currency_local": "Tanzanian shilling",
      "currency_code": "TZS",
      "currency_symbol": "Sh",
      "currency_numeric": 834,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇿",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "BI",
        "CD",
        "KE",
        "MW",
        "MZ",
        "RW",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 834,
      "iso_3166_1_alpha2": "TZ",
      "iso_3166_1_alpha3": "TZA",
      "tld": "tz",
      "vehicle_code": "EAT",
      "fips10": "TZ",
      "un_locode": "TZ",
      "stanag_1059": "TZA",
      "ioc": "TAN",
      "fifa": "TAN",
      "itu": "TZA",
      "uic": "",
      "maritime": "674, 677",
      "mmc": 640
    }
  },
  {
    "locale": "en-TK",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Tokelau",
      "name_local": "Tokelau",
      "code": "TK",
      "area_sq_km": 12,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "",
      "currency": "New Zealand Dollar",
      "currency_local": "New Zealand dollar",
      "currency_code": "NZD",
      "currency_symbol": "$",
      "currency_numeric": 554,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇰",
      "timezones": [
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 772,
      "iso_3166_1_alpha2": "TK",
      "iso_3166_1_alpha3": "TKL",
      "tld": "tk",
      "vehicle_code": "",
      "fips10": "TL",
      "un_locode": "TK",
      "stanag_1059": "TKL",
      "ioc": "",
      "fifa": "",
      "itu": "TKL",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "en-TO",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Tonga",
      "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
      "code": "TO",
      "area_sq_km": 747,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Nuku‘alofa",
      "capital_latitude": -21.13938,
      "capital_longitude": -175.2018,
      "currency": "Pa'anga",
      "currency_local": "Tongan paʻanga",
      "currency_code": "TOP",
      "currency_symbol": "T$",
      "currency_numeric": 776,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Seniti",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tonga (Tonga Islands)",
          "name_local": "faka Tonga",
          "iso_639_1": "to",
          "iso_639_2": "ton",
          "iso_639_3": "ton"
        }
      ],
      "flag": "🇹🇴",
      "timezones": [
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 776,
      "iso_3166_1_alpha2": "TO",
      "iso_3166_1_alpha3": "TON",
      "tld": "to",
      "vehicle_code": "TON",
      "fips10": "TN",
      "un_locode": "TO",
      "stanag_1059": "TON",
      "ioc": "TGA",
      "fifa": "TGA",
      "itu": "TON",
      "uic": "",
      "maritime": 570,
      "mmc": 539
    }
  },
  {
    "locale": "en-TT",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Trinidad and Tobago",
      "name_local": "Trinidad and Tobago",
      "code": "TT",
      "area_sq_km": 5130,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Port-of-Spain",
      "capital_latitude": 10.66668,
      "capital_longitude": -61.51889,
      "currency": "Trinidad and Tobago Dollar",
      "currency_local": "Trinidad and Tobago dollar",
      "currency_code": "TTD",
      "currency_symbol": "$",
      "currency_numeric": 780,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇹",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 780,
      "iso_3166_1_alpha2": "TT",
      "iso_3166_1_alpha3": "TTO",
      "tld": "tt",
      "vehicle_code": "TT",
      "fips10": "TD",
      "un_locode": "TT",
      "stanag_1059": "TTO",
      "ioc": "TTO",
      "fifa": "TRI",
      "itu": "TRD",
      "uic": "",
      "maritime": 362,
      "mmc": 374
    }
  },
  {
    "locale": "en-TC",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Turks and Caicos Islands",
      "name_local": "The Turks and Caicos Islands",
      "code": "TC",
      "area_sq_km": 948,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Cockburn Town",
      "capital_latitude": 21.46122,
      "capital_longitude": -71.14188,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇨",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "TKCA 1ZZ",
      "postal_code_regex": "^(TKCA 1ZZ)$",
      "iso_3166_1_numeric": 796,
      "iso_3166_1_alpha2": "TC",
      "iso_3166_1_alpha3": "TCA",
      "tld": "tc",
      "vehicle_code": "",
      "fips10": "TK",
      "un_locode": "TC",
      "stanag_1059": "TCA",
      "ioc": "",
      "fifa": "TCA",
      "itu": "TCA",
      "uic": "",
      "maritime": 364,
      "mmc": 376
    }
  },
  {
    "locale": "en-TV",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Tuvalu",
      "name_local": "Tuvalu / Fakavae Aliki-Malo",
      "code": "TV",
      "area_sq_km": 26,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Funafuti",
      "capital_latitude": -8.52425,
      "capital_longitude": 179.19417,
      "currency": "Tuvaluan Dollar",
      "currency_local": "Tuvaluan dollar",
      "currency_code": "TVD",
      "currency_symbol": "$",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇻",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 798,
      "iso_3166_1_alpha2": "TV",
      "iso_3166_1_alpha3": "TUV",
      "tld": "tv",
      "vehicle_code": "TUV",
      "fips10": "TV",
      "un_locode": "TV",
      "stanag_1059": "TUV",
      "ioc": "TUV",
      "fifa": "TUV",
      "itu": "TUV",
      "uic": "",
      "maritime": 572,
      "mmc": ""
    }
  },
  {
    "locale": "en-UG",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Uganda",
      "name_local": "Uganda",
      "code": "UG",
      "area_sq_km": 241550,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Kampala",
      "capital_latitude": 0.31628,
      "capital_longitude": 32.58219,
      "currency": "Ugandan Schilling",
      "currency_local": "Ugandan shilling",
      "currency_code": "UGX",
      "currency_symbol": "Sh",
      "currency_numeric": 800,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        }
      ],
      "flag": "🇺🇬",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "CD",
        "KE",
        "RW",
        "SS",
        "TZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 800,
      "iso_3166_1_alpha2": "UG",
      "iso_3166_1_alpha3": "UGA",
      "tld": "ug",
      "vehicle_code": "EAU",
      "fips10": "UG",
      "un_locode": "UG",
      "stanag_1059": "UGA",
      "ioc": "UGA",
      "fifa": "UGA",
      "itu": "UGA",
      "uic": "",
      "maritime": 675,
      "mmc": 641
    }
  },
  {
    "locale": "en-VU",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Vanuatu",
      "name_local": "Vanuatu",
      "code": "VU",
      "area_sq_km": 12189,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Port-Vila",
      "capital_latitude": -17.73381,
      "capital_longitude": 168.32188,
      "currency": "Vatu",
      "currency_local": "Vanuatu vatu",
      "currency_code": "VUV",
      "currency_symbol": "Vt",
      "currency_numeric": 548,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Bislama",
          "name_local": "Bislama",
          "iso_639_1": "bi",
          "iso_639_2": "bis",
          "iso_639_3": "bis"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇻🇺",
      "timezones": [
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 548,
      "iso_3166_1_alpha2": "VU",
      "iso_3166_1_alpha3": "VUT",
      "tld": "vu",
      "vehicle_code": "VAN",
      "fips10": "NH",
      "un_locode": "VU",
      "stanag_1059": "VUT",
      "ioc": "VAN",
      "fifa": "VAN",
      "itu": "VUT",
      "uic": "",
      "maritime": "576, 577",
      "mmc": 541
    }
  },
  {
    "locale": "en-US",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "United States of America",
      "name_local": "",
      "code": "US",
      "area_sq_km": 9372610,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Washington, D.C.",
      "capital_latitude": 38.89511,
      "capital_longitude": -77.03637,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇺🇸",
      "timezones": [
        "UTC-12:00",
        "UTC-11:00",
        "UTC-10:00",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      "borders": [
        "CA",
        "MX"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####-####",
      "postal_code_regex": "^\\d{5}(-\\d{4})?$",
      "iso_3166_1_numeric": 840,
      "iso_3166_1_alpha2": "US",
      "iso_3166_1_alpha3": "USA",
      "tld": "us",
      "vehicle_code": "USA",
      "fips10": "US",
      "un_locode": "US",
      "stanag_1059": "USA",
      "ioc": "USA",
      "fifa": "USA",
      "itu": "USA",
      "uic": "001 US",
      "maritime": "303, 338, 366, 367, 368, 369",
      "mmc": "310, 311, 312, 313, 314, 315, 316"
    }
  },
  {
    "locale": "en-GB",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "United Kingdom",
      "name_local": "United Kingdom",
      "code": "GB",
      "area_sq_km": 242900,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "London",
      "capital_latitude": 51.50853,
      "capital_longitude": -0.12574,
      "currency": "Sterling Pound",
      "currency_local": "British pound",
      "currency_code": "GBP",
      "currency_symbol": "£",
      "currency_numeric": 826,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇬🇧",
      "timezones": [
        "UTC-08:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00",
        "UTC",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+06:00"
      ],
      "borders": [
        "IE"
      ],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 826,
      "iso_3166_1_alpha2": "GB",
      "iso_3166_1_alpha3": "GBR",
      "tld": "uk",
      "vehicle_code": "GBM",
      "fips10": "UK",
      "un_locode": "GB",
      "stanag_1059": "GBR",
      "ioc": "GBR",
      "fifa": "GBR",
      "itu": "G",
      "uic": "70 GB",
      "maritime": "232, 233, 234, 235",
      "mmc": "234, 235"
    }
  },
  {
    "locale": "en-CX",
    "language": {
      "name": "English",
      "name_local": "English",
      "iso_639_1": "en",
      "iso_639_2": "eng",
      "iso_639_3": "eng",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Anguilla",
          "name_local": "Anguilla",
          "code": "AI"
        },
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Antigua and Barbuda",
          "name_local": "Antigua and Barbuda",
          "code": "AG"
        },
        {
          "name": "Australia",
          "name_local": "Australia",
          "code": "AU"
        },
        {
          "name": "Bahamas",
          "name_local": "The Bahamas",
          "code": "BS"
        },
        {
          "name": "Barbados",
          "name_local": "Barbados",
          "code": "BB"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bermuda",
          "name_local": "Bermuda",
          "code": "BM"
        },
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "British Indian Ocean Territory",
          "name_local": "British Indian Ocean Territory",
          "code": "IO"
        },
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Dominica",
          "name_local": "Dominica",
          "code": "DM"
        },
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        },
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "Falkland Islands",
          "name_local": "Falkland Islands",
          "code": "FK"
        },
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        },
        {
          "name": "Federated States of Micronesia",
          "name_local": "",
          "code": "FM"
        },
        {
          "name": "Gambia",
          "name_local": "The Gambia",
          "code": "GM"
        },
        {
          "name": "Ghana",
          "name_local": "Ghana",
          "code": "GH"
        },
        {
          "name": "Gibraltar",
          "name_local": "Gibraltar",
          "code": "GI"
        },
        {
          "name": "Grenada",
          "name_local": "Grenada",
          "code": "GD"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guyana",
          "name_local": "Guyana",
          "code": "GY"
        },
        {
          "name": "Heard Island and McDonald Islands",
          "name_local": "Heard and McDonald Islands",
          "code": "HM"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        },
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        },
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        },
        {
          "name": "Jamaica",
          "name_local": "Jamaica",
          "code": "JM"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "British Virgin Islands",
          "name_local": "British Virgin Islands",
          "code": "VG"
        },
        {
          "name": "Virgin Islands",
          "name_local": "Virgin Islands of the United States",
          "code": "VI"
        },
        {
          "name": "Cayman Islands",
          "name_local": "Cayman Islands",
          "code": "KY"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Kiribati",
          "name_local": "Kiribati",
          "code": "KI"
        },
        {
          "name": "United States Minor Outlying Islands",
          "name_local": "United States Minor Outlying Islands",
          "code": "UM"
        },
        {
          "name": "Cocos (Keeling) Islands",
          "name_local": "",
          "code": "CC"
        },
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "Liberia",
          "name_local": "Liberia",
          "code": "LR"
        },
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        },
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        },
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        },
        {
          "name": "Mauritius",
          "name_local": "Maurice",
          "code": "MU"
        },
        {
          "name": "Montserrat",
          "name_local": "Montserrat",
          "code": "MS"
        },
        {
          "name": "Namibia",
          "name_local": "Namibia",
          "code": "NA"
        },
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        },
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        },
        {
          "name": "Nigeria",
          "name_local": "Nigeria",
          "code": "NG"
        },
        {
          "name": "Niue",
          "name_local": "Niue",
          "code": "NU"
        },
        {
          "name": "Northern Mariana Islands",
          "name_local": "Northern Mariana Islands",
          "code": "MP"
        },
        {
          "name": "Norfolk Island",
          "name_local": "Norfolk Island",
          "code": "NF"
        },
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        },
        {
          "name": "Palau",
          "name_local": "Belau/Palau",
          "code": "PW"
        },
        {
          "name": "Papua New Guinea",
          "name_local": "Papua New Guinea/Papua Niugini",
          "code": "PG"
        },
        {
          "name": "Philippines",
          "name_local": "Pilipinas",
          "code": "PH"
        },
        {
          "name": "Pitcairn Islands",
          "name_local": "",
          "code": "PN"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Solomon Islands",
          "name_local": "Solomon Islands",
          "code": "SB"
        },
        {
          "name": "Zambia",
          "name_local": "Zambia",
          "code": "ZM"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Sierra Leone",
          "name_local": "Sierra Leone",
          "code": "SL"
        },
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Saint Helena, Ascension and Tristan da Cunha",
          "name_local": "Saint Helena",
          "code": "SH"
        },
        {
          "name": "Saint Kitts and Nevis",
          "name_local": "Saint Kitts and Nevis",
          "code": "KN"
        },
        {
          "name": "Saint Lucia",
          "name_local": "Saint Lucia",
          "code": "LC"
        },
        {
          "name": "Saint Vincent and the Grenadines",
          "name_local": "Saint Vincent and the Grenadines",
          "code": "VC"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        },
        {
          "name": "Sudan",
          "name_local": "جمهورية السودان / As-Sūdān",
          "code": "SD"
        },
        {
          "name": "South Georgia and South Sandwich Islands",
          "name_local": "South Georgia and the South Sandwich Islands",
          "code": "GS"
        },
        {
          "name": "South Sudan",
          "name_local": "",
          "code": "SS"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Tokelau",
          "name_local": "Tokelau",
          "code": "TK"
        },
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        },
        {
          "name": "Trinidad and Tobago",
          "name_local": "Trinidad and Tobago",
          "code": "TT"
        },
        {
          "name": "Turks and Caicos Islands",
          "name_local": "The Turks and Caicos Islands",
          "code": "TC"
        },
        {
          "name": "Tuvalu",
          "name_local": "Tuvalu / Fakavae Aliki-Malo",
          "code": "TV"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "United States of America",
          "name_local": "",
          "code": "US"
        },
        {
          "name": "United Kingdom",
          "name_local": "United Kingdom",
          "code": "GB"
        },
        {
          "name": "Christmas Island",
          "name_local": "Christmas Island",
          "code": "CX"
        }
      ]
    },
    "country": {
      "name": "Christmas Island",
      "name_local": "Christmas Island",
      "code": "CX",
      "area_sq_km": 135,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "Flying Fish Cove",
      "capital_latitude": -10.42172,
      "capital_longitude": 105.67912,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇨🇽",
      "timezones": [
        "UTC+07:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 162,
      "iso_3166_1_alpha2": "CX",
      "iso_3166_1_alpha3": "CXR",
      "tld": "cx",
      "vehicle_code": "",
      "fips10": "KT",
      "un_locode": "CX",
      "stanag_1059": "CXR",
      "ioc": "",
      "fifa": "",
      "itu": "CHR",
      "uic": "",
      "maritime": 516,
      "mmc": ""
    }
  },
  {
    "locale": "et-EE",
    "language": {
      "name": "Estonian",
      "name_local": "eesti",
      "iso_639_1": "et",
      "iso_639_2": "est",
      "iso_639_3": "est",
      "countries": [
        {
          "name": "Estonia",
          "name_local": "Eesti",
          "code": "EE"
        }
      ]
    },
    "country": {
      "name": "Estonia",
      "name_local": "Eesti",
      "code": "EE",
      "area_sq_km": 45227,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Tallinn",
      "capital_latitude": 59.43696,
      "capital_longitude": 24.75353,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Estonian",
          "name_local": "eesti",
          "iso_639_1": "et",
          "iso_639_2": "est",
          "iso_639_3": "est"
        }
      ],
      "flag": "🇪🇪",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "LV",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 233,
      "iso_3166_1_alpha2": "EE",
      "iso_3166_1_alpha3": "EST",
      "tld": "ee",
      "vehicle_code": "EST",
      "fips10": "EN",
      "un_locode": "EE",
      "stanag_1059": "EST",
      "ioc": "EST",
      "fifa": "EST",
      "itu": "EST",
      "uic": "26 EST",
      "maritime": 276,
      "mmc": 248
    }
  },
  {
    "locale": "fan-GQ",
    "language": {
      "name": "Fang",
      "name_local": "Fang",
      "iso_639_1": "",
      "iso_639_2": "fan",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        }
      ]
    },
    "country": {
      "name": "Equatorial Guinea",
      "name_local": "Guinea Ecuatorial",
      "code": "GQ",
      "area_sq_km": 28051,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Malabo",
      "capital_latitude": 3.75,
      "capital_longitude": 8.78333,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        },
        {
          "name": "Fang",
          "name_local": "Fang",
          "iso_639_1": "",
          "iso_639_2": "fan",
          "iso_639_3": ""
        }
      ],
      "flag": "🇬🇶",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 226,
      "iso_3166_1_alpha2": "GQ",
      "iso_3166_1_alpha3": "GNQ",
      "tld": "gq",
      "vehicle_code": "GQ",
      "fips10": "EK",
      "un_locode": "GQ",
      "stanag_1059": "GNQ",
      "ioc": "GEQ",
      "fifa": "EQG",
      "itu": "GNE",
      "uic": "",
      "maritime": 631,
      "mmc": 627
    }
  },
  {
    "locale": "fo-FO",
    "language": {
      "name": "Faroese",
      "name_local": "føroyskt",
      "iso_639_1": "fo",
      "iso_639_2": "fao",
      "iso_639_3": "fao",
      "countries": [
        {
          "name": "Faroe Islands",
          "name_local": "Føroyar / Færøerne",
          "code": "FO"
        }
      ]
    },
    "country": {
      "name": "Faroe Islands",
      "name_local": "Føroyar / Færøerne",
      "code": "FO",
      "area_sq_km": 1393,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Tórshavn",
      "capital_latitude": 62.00973,
      "capital_longitude": -6.77164,
      "currency": "Faroese Krona",
      "currency_local": "Faroese króna",
      "currency_code": "FOK",
      "currency_symbol": "kr",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Oyra",
      "languages": [
        {
          "name": "Faroese",
          "name_local": "føroyskt",
          "iso_639_1": "fo",
          "iso_639_2": "fao",
          "iso_639_3": "fao"
        }
      ],
      "flag": "🇫🇴",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "FO-###",
      "postal_code_regex": "^(?:FO)*(\\d{3})$",
      "iso_3166_1_numeric": 234,
      "iso_3166_1_alpha2": "FO",
      "iso_3166_1_alpha3": "FRO",
      "tld": "fo",
      "vehicle_code": "FO",
      "fips10": "FO",
      "un_locode": "FO",
      "stanag_1059": "FRO",
      "ioc": "",
      "fifa": "FRO",
      "itu": "FRO",
      "uic": "",
      "maritime": 231,
      "mmc": 288
    }
  },
  {
    "locale": "fa-IR",
    "language": {
      "name": "Persian (Farsi)",
      "name_local": "فارسی",
      "iso_639_1": "fa",
      "iso_639_2": "fas",
      "iso_639_3": "fas",
      "countries": [
        {
          "name": "Iran",
          "name_local": "ايران / Īrān",
          "code": "IR"
        }
      ]
    },
    "country": {
      "name": "Iran",
      "name_local": "ايران / Īrān",
      "code": "IR",
      "area_sq_km": 1648195,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Tehran",
      "capital_latitude": 35.69439,
      "capital_longitude": 51.42151,
      "currency": "Iranian Rial",
      "currency_local": "Iranian rial",
      "currency_code": "IRR",
      "currency_symbol": "﷼",
      "currency_numeric": 364,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Dinars",
      "languages": [
        {
          "name": "Persian (Farsi)",
          "name_local": "فارسی",
          "iso_639_1": "fa",
          "iso_639_2": "fas",
          "iso_639_3": "fas"
        }
      ],
      "flag": "🇮🇷",
      "timezones": [
        "UTC+03:30"
      ],
      "borders": [
        "AF",
        "AM",
        "AZ",
        "IQ",
        "PK",
        "TR",
        "TM"
      ],
      "is_landlocked": false,
      "postal_code_format": "##########",
      "postal_code_regex": "^(\\d{10})$",
      "iso_3166_1_numeric": 364,
      "iso_3166_1_alpha2": "IR",
      "iso_3166_1_alpha3": "IRN",
      "tld": "ir",
      "vehicle_code": "IR",
      "fips10": "IR",
      "un_locode": "IR",
      "stanag_1059": "IRN",
      "ioc": "IRI",
      "fifa": "IRN",
      "itu": "IRN",
      "uic": "98 IR",
      "maritime": 422,
      "mmc": 432
    }
  },
  {
    "locale": "fj-FJ",
    "language": {
      "name": "Fijian",
      "name_local": "vosa Vakaviti",
      "iso_639_1": "fj",
      "iso_639_2": "fij",
      "iso_639_3": "fij",
      "countries": [
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        }
      ]
    },
    "country": {
      "name": "Fiji",
      "name_local": "Viti / फ़िजी गणराज्य / Fiji",
      "code": "FJ",
      "area_sq_km": 18272,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Suva",
      "capital_latitude": -18.14161,
      "capital_longitude": 178.44149,
      "currency": "Fiji Dollar",
      "currency_local": "Fijian dollar",
      "currency_code": "FJD",
      "currency_symbol": "$",
      "currency_numeric": 242,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Fijian",
          "name_local": "vosa Vakaviti",
          "iso_639_1": "fj",
          "iso_639_2": "fij",
          "iso_639_3": "fij"
        },
        {
          "name": "Fiji Hindi",
          "name_local": "फ़िजी बात",
          "iso_639_1": "",
          "iso_639_2": "hif",
          "iso_639_3": ""
        },
        {
          "name": "Rotuman",
          "name_local": "Fäeag Rotuma",
          "iso_639_1": "",
          "iso_639_2": "rtm",
          "iso_639_3": ""
        }
      ],
      "flag": "🇫🇯",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 242,
      "iso_3166_1_alpha2": "FJ",
      "iso_3166_1_alpha3": "FJI",
      "tld": "fj",
      "vehicle_code": "FJI",
      "fips10": "FJ",
      "un_locode": "FJ",
      "stanag_1059": "FJI",
      "ioc": "FIJ",
      "fifa": "FIJ",
      "itu": "FJI",
      "uic": "",
      "maritime": 520,
      "mmc": 542
    }
  },
  {
    "locale": "fi-FI",
    "language": {
      "name": "Finnish",
      "name_local": "suomi",
      "iso_639_1": "fi",
      "iso_639_2": "fin",
      "iso_639_3": "fin",
      "countries": [
        {
          "name": "Finland",
          "name_local": "Suomi",
          "code": "FI"
        }
      ]
    },
    "country": {
      "name": "Finland",
      "name_local": "Suomi",
      "code": "FI",
      "area_sq_km": 338424,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Helsinki",
      "capital_latitude": 60.16952,
      "capital_longitude": 24.93545,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Finnish",
          "name_local": "suomi",
          "iso_639_1": "fi",
          "iso_639_2": "fin",
          "iso_639_3": "fin"
        },
        {
          "name": "Swedish",
          "name_local": "svenska",
          "iso_639_1": "sv",
          "iso_639_2": "swe",
          "iso_639_3": "swe"
        }
      ],
      "flag": "🇫🇮",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "NO",
        "SE",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(?:FI)*(\\d{5})$",
      "iso_3166_1_numeric": 246,
      "iso_3166_1_alpha2": "FI",
      "iso_3166_1_alpha3": "FIN",
      "tld": "fi",
      "vehicle_code": "FIN",
      "fips10": "FI",
      "un_locode": "FI",
      "stanag_1059": "FIN",
      "ioc": "FIN",
      "fifa": "FIN",
      "itu": "FIN",
      "uic": "10 FIN",
      "maritime": 230,
      "mmc": 244
    }
  },
  {
    "locale": "fr-GQ",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Equatorial Guinea",
      "name_local": "Guinea Ecuatorial",
      "code": "GQ",
      "area_sq_km": 28051,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Malabo",
      "capital_latitude": 3.75,
      "capital_longitude": 8.78333,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        },
        {
          "name": "Fang",
          "name_local": "Fang",
          "iso_639_1": "",
          "iso_639_2": "fan",
          "iso_639_3": ""
        }
      ],
      "flag": "🇬🇶",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 226,
      "iso_3166_1_alpha2": "GQ",
      "iso_3166_1_alpha3": "GNQ",
      "tld": "gq",
      "vehicle_code": "GQ",
      "fips10": "EK",
      "un_locode": "GQ",
      "stanag_1059": "GNQ",
      "ioc": "GEQ",
      "fifa": "EQG",
      "itu": "GNE",
      "uic": "",
      "maritime": 631,
      "mmc": 627
    }
  },
  {
    "locale": "fr-BE",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Belgium",
      "name_local": "België / Belgique",
      "code": "BE",
      "area_sq_km": 30528,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Brussels",
      "capital_latitude": 50.85045,
      "capital_longitude": 4.34878,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇧🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FR",
        "DE",
        "LU",
        "NL"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 56,
      "iso_3166_1_alpha2": "BE",
      "iso_3166_1_alpha3": "BEL",
      "tld": "be",
      "vehicle_code": "B",
      "fips10": "BE",
      "un_locode": "BE",
      "stanag_1059": "BEL",
      "ioc": "BEL",
      "fifa": "BEL",
      "itu": "BEL",
      "uic": "88 B",
      "maritime": 205,
      "mmc": 206
    }
  },
  {
    "locale": "fr-BJ",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Benin",
      "name_local": "Bénin",
      "code": "BJ",
      "area_sq_km": 112622,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Porto-Novo",
      "capital_latitude": 6.49646,
      "capital_longitude": 2.60359,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇧🇯",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BF",
        "NE",
        "NG",
        "TG"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 204,
      "iso_3166_1_alpha2": "BJ",
      "iso_3166_1_alpha3": "BEN",
      "tld": "bj",
      "vehicle_code": "BJ",
      "fips10": "BN",
      "un_locode": "BJ",
      "stanag_1059": "BEN",
      "ioc": "BEN",
      "fifa": "BEN",
      "itu": "BEN",
      "uic": "",
      "maritime": 610,
      "mmc": 616
    }
  },
  {
    "locale": "fr-BF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Burkina Faso",
      "name_local": "Burkina Faso",
      "code": "BF",
      "area_sq_km": 272967,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Ouagadougou",
      "capital_latitude": 12.36566,
      "capital_longitude": -1.53388,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Fula",
          "name_local": "Fulfulde",
          "iso_639_1": "ff",
          "iso_639_2": "ful",
          "iso_639_3": "ful"
        }
      ],
      "flag": "🇧🇫",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "BJ",
        "CI",
        "GH",
        "ML",
        "NE",
        "TG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 854,
      "iso_3166_1_alpha2": "BF",
      "iso_3166_1_alpha3": "BFA",
      "tld": "bf",
      "vehicle_code": "BF",
      "fips10": "UV",
      "un_locode": "BF",
      "stanag_1059": "BFA",
      "ioc": "BUR",
      "fifa": "BFA",
      "itu": "BFA",
      "uic": "",
      "maritime": 633,
      "mmc": 613
    }
  },
  {
    "locale": "fr-BI",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Burundi",
      "name_local": "Burundi / Uburundi",
      "code": "BI",
      "area_sq_km": 27834,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Bujumbura",
      "capital_latitude": -3.3822,
      "capital_longitude": 29.3644,
      "currency": "Burundi Franc",
      "currency_local": "Burundian franc",
      "currency_code": "BIF",
      "currency_symbol": "Fr",
      "currency_numeric": 108,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Kirundi",
          "name_local": "Ikirundi",
          "iso_639_1": "rn",
          "iso_639_2": "run",
          "iso_639_3": "run"
        }
      ],
      "flag": "🇧🇮",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "CD",
        "RW",
        "TZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 108,
      "iso_3166_1_alpha2": "BI",
      "iso_3166_1_alpha3": "BDI",
      "tld": "bi",
      "vehicle_code": "RU",
      "fips10": "BY",
      "un_locode": "BI",
      "stanag_1059": "BDI",
      "ioc": "BDI",
      "fifa": "BDI",
      "itu": "BDI",
      "uic": "",
      "maritime": 609,
      "mmc": 642
    }
  },
  {
    "locale": "fr-CD",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Democratic Republic of the Congo",
      "name_local": "République Démocratique du Congo",
      "code": "CD",
      "area_sq_km": 2344858,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Kinshasa",
      "capital_latitude": -4.32758,
      "capital_longitude": 15.31357,
      "currency": "Congolais Franc",
      "currency_local": "Congolese franc",
      "currency_code": "CDF",
      "currency_symbol": "FC",
      "currency_numeric": 976,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        },
        {
          "name": "Kongo",
          "name_local": "Kikongo",
          "iso_639_1": "kg",
          "iso_639_2": "kon",
          "iso_639_3": "kon"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "Luba-Katanga",
          "name_local": "Tshiluba",
          "iso_639_1": "lu",
          "iso_639_2": "lub",
          "iso_639_3": "lub"
        }
      ],
      "flag": "🇨🇩",
      "timezones": [
        "UTC+01:00",
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BI",
        "CF",
        "CG",
        "RW",
        "SS",
        "TZ",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 180,
      "iso_3166_1_alpha2": "CD",
      "iso_3166_1_alpha3": "COD",
      "tld": "cd",
      "vehicle_code": "CGO",
      "fips10": "CG",
      "un_locode": "CD",
      "stanag_1059": "COD",
      "ioc": "COD",
      "fifa": "COD",
      "itu": "COD",
      "uic": "CD",
      "maritime": 676,
      "mmc": 630
    }
  },
  {
    "locale": "fr-DJ",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Djibouti",
      "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
      "code": "DJ",
      "area_sq_km": 23200,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Djibouti",
      "capital_latitude": 11.58901,
      "capital_longitude": 43.14503,
      "currency": "Djibouti Franc",
      "currency_local": "Djiboutian franc",
      "currency_code": "DJF",
      "currency_symbol": "Fr",
      "currency_numeric": 262,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇩🇯",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "ER",
        "ET",
        "SO"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 262,
      "iso_3166_1_alpha2": "DJ",
      "iso_3166_1_alpha3": "DJI",
      "tld": "dj",
      "vehicle_code": "DJI",
      "fips10": "DJ",
      "un_locode": "DJ",
      "stanag_1059": "DJI",
      "ioc": "DJI",
      "fifa": "DJI",
      "itu": "DJI",
      "uic": "",
      "maritime": 621,
      "mmc": 638
    }
  },
  {
    "locale": "fr-CI",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Ivory Coast",
      "name_local": "Côte d’Ivoire",
      "code": "CI",
      "area_sq_km": 322463,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Yamoussoukro",
      "capital_latitude": 6.82055,
      "capital_longitude": -5.27674,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇨🇮",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "BF",
        "GH",
        "GN",
        "LR",
        "ML"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 384,
      "iso_3166_1_alpha2": "CI",
      "iso_3166_1_alpha3": "CIV",
      "tld": "ci",
      "vehicle_code": "CI",
      "fips10": "IV",
      "un_locode": "CI",
      "stanag_1059": "CIV",
      "ioc": "CIV",
      "fifa": "CIV",
      "itu": "CTI",
      "uic": "",
      "maritime": 619,
      "mmc": 612
    }
  },
  {
    "locale": "fr-FR",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "France",
      "name_local": "France",
      "code": "FR",
      "area_sq_km": 551695,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Paris",
      "capital_latitude": 48.85341,
      "capital_longitude": 2.3488,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇫🇷",
      "timezones": [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00",
        "UTC-08:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC+01:00",
        "UTC+02:00",
        "UTC+03:00",
        "UTC+04:00",
        "UTC+05:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      "borders": [
        "AD",
        "BE",
        "DE",
        "IT",
        "LU",
        "MC",
        "ES",
        "CH"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 250,
      "iso_3166_1_alpha2": "FR",
      "iso_3166_1_alpha3": "FRA",
      "tld": "fr",
      "vehicle_code": "F",
      "fips10": "FR",
      "un_locode": "FR",
      "stanag_1059": "FRA",
      "ioc": "FRA",
      "fifa": "FRA",
      "itu": "F",
      "uic": "87 F",
      "maritime": "226, 227, 228",
      "mmc": 208
    }
  },
  {
    "locale": "fr-GF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "French Guiana",
      "name_local": "Guyane française",
      "code": "GF",
      "area_sq_km": 83534,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Cayenne",
      "capital_latitude": 4.93333,
      "capital_longitude": -52.33333,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇬🇫",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [
        "BR",
        "SR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^((97|98)3\\d{2})$",
      "iso_3166_1_numeric": 254,
      "iso_3166_1_alpha2": "GF",
      "iso_3166_1_alpha3": "GUF",
      "tld": "gf",
      "vehicle_code": "",
      "fips10": "FG",
      "un_locode": "GF",
      "stanag_1059": "GUF",
      "ioc": "",
      "fifa": "GUF",
      "itu": "GUF",
      "uic": "",
      "maritime": 745,
      "mmc": 742
    }
  },
  {
    "locale": "fr-PF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "French Polynesia",
      "name_local": "Polynésie française",
      "code": "PF",
      "area_sq_km": 4167,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Papeete",
      "capital_latitude": -17.53733,
      "capital_longitude": -149.5665,
      "currency": "Pacific Franc",
      "currency_local": "CFP franc",
      "currency_code": "XPF",
      "currency_symbol": "₣",
      "currency_numeric": 953,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇵🇫",
      "timezones": [
        "UTC-10:00",
        "UTC-09:30",
        "UTC-09:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^((97|98)7\\d{2})$",
      "iso_3166_1_numeric": 258,
      "iso_3166_1_alpha2": "PF",
      "iso_3166_1_alpha3": "PYF",
      "tld": "pf",
      "vehicle_code": "",
      "fips10": "FP",
      "un_locode": "PF",
      "stanag_1059": "PYF",
      "ioc": "",
      "fifa": "TAH",
      "itu": "OCE",
      "uic": "",
      "maritime": 546,
      "mmc": 547
    }
  },
  {
    "locale": "fr-TF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "French Southern and Antarctic Lands",
      "name_local": "Terres australes françaises",
      "code": "TF",
      "area_sq_km": 7747,
      "continent": "Oceania",
      "region": "",
      "capital_name": "Port-aux-Français",
      "capital_latitude": -49.35,
      "capital_longitude": 70.21667,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇹🇫",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 260,
      "iso_3166_1_alpha2": "TF",
      "iso_3166_1_alpha3": "ATF",
      "tld": "tf",
      "vehicle_code": "",
      "fips10": "FS",
      "un_locode": "",
      "stanag_1059": "ATF",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": 635,
      "mmc": ""
    }
  },
  {
    "locale": "fr-MC",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Principality of Monaco",
      "name_local": "Monaco",
      "code": "MC",
      "area_sq_km": 2.02,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Monaco",
      "capital_latitude": 43.73333,
      "capital_longitude": 7.41667,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇲🇨",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 492,
      "iso_3166_1_alpha2": "MC",
      "iso_3166_1_alpha3": "MCO",
      "tld": "mc",
      "vehicle_code": "MC",
      "fips10": "MN",
      "un_locode": "MC",
      "stanag_1059": "MCO",
      "ioc": "MON",
      "fifa": "",
      "itu": "MCO",
      "uic": "",
      "maritime": 254,
      "mmc": 212
    }
  },
  {
    "locale": "fr-GA",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Gabon",
      "name_local": "Le Gabon",
      "code": "GA",
      "area_sq_km": 267668,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Libreville",
      "capital_latitude": 0.39241,
      "capital_longitude": 9.45356,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇬🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "CG",
        "GQ"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 266,
      "iso_3166_1_alpha2": "GA",
      "iso_3166_1_alpha3": "GAB",
      "tld": "ga",
      "vehicle_code": "G",
      "fips10": "GB",
      "un_locode": "GA",
      "stanag_1059": "GAB",
      "ioc": "GAB",
      "fifa": "GAB",
      "itu": "GAB",
      "uic": "",
      "maritime": 626,
      "mmc": 628
    }
  },
  {
    "locale": "fr-GP",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Guadeloupe",
      "name_local": "Guadeloupe / Gwadloup",
      "code": "GP",
      "area_sq_km": 1628,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Basse-Terre",
      "capital_latitude": 15.99854,
      "capital_longitude": -61.72548,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇬🇵",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^((97|98)\\d{3})$",
      "iso_3166_1_numeric": 312,
      "iso_3166_1_alpha2": "GP",
      "iso_3166_1_alpha3": "GLP",
      "tld": "gp",
      "vehicle_code": "",
      "fips10": "GP",
      "un_locode": "GP",
      "stanag_1059": "GLP",
      "ioc": "",
      "fifa": "GPE",
      "itu": "",
      "uic": "",
      "maritime": 329,
      "mmc": 340
    }
  },
  {
    "locale": "fr-GG",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Guernsey",
      "name_local": "Bailiwick of Guernsey",
      "code": "GG",
      "area_sq_km": 78,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Saint Peter Port",
      "capital_latitude": 49.45981,
      "capital_longitude": -2.53527,
      "currency": "Guernsey Pound",
      "currency_local": "Guernsey pound",
      "currency_code": "GGP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇬🇬",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 831,
      "iso_3166_1_alpha2": "GG",
      "iso_3166_1_alpha3": "GGY",
      "tld": "gg",
      "vehicle_code": "GBG",
      "fips10": "GK",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "fr-GN",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Guinea",
      "name_local": "La Guinée",
      "code": "GN",
      "area_sq_km": 245857,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Conakry",
      "capital_latitude": 9.53795,
      "capital_longitude": -13.67729,
      "currency": "Guinea Franc",
      "currency_local": "Guinean franc",
      "currency_code": "GNF",
      "currency_symbol": "Fr",
      "currency_numeric": 324,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Fula",
          "name_local": "Fulfulde",
          "iso_639_1": "ff",
          "iso_639_2": "ful",
          "iso_639_3": "ful"
        }
      ],
      "flag": "🇬🇳",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "CI",
        "GW",
        "LR",
        "ML",
        "SN",
        "SL"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 324,
      "iso_3166_1_alpha2": "GN",
      "iso_3166_1_alpha3": "GIN",
      "tld": "gn",
      "vehicle_code": "RG",
      "fips10": "GV",
      "un_locode": "GN",
      "stanag_1059": "GIN",
      "ioc": "GUI",
      "fifa": "GUI",
      "itu": "GUI",
      "uic": "",
      "maritime": 632,
      "mmc": 611
    }
  },
  {
    "locale": "fr-HT",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Haiti",
      "name_local": "Ayiti / Haïti",
      "code": "HT",
      "area_sq_km": 27750,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Port-au-Prince",
      "capital_latitude": 18.53917,
      "capital_longitude": -72.335,
      "currency": "Gourde",
      "currency_local": "Haitian gourde",
      "currency_code": "HTG",
      "currency_symbol": "G",
      "currency_numeric": 332,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Haitian",
          "name_local": "Kreyòl ayisyen",
          "iso_639_1": "ht",
          "iso_639_2": "hat",
          "iso_639_3": "hat"
        }
      ],
      "flag": "🇭🇹",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [
        "DO"
      ],
      "is_landlocked": false,
      "postal_code_format": "HT####",
      "postal_code_regex": "^(?:HT)*(\\d{4})$",
      "iso_3166_1_numeric": 332,
      "iso_3166_1_alpha2": "HT",
      "iso_3166_1_alpha3": "HTI",
      "tld": "ht",
      "vehicle_code": "RH",
      "fips10": "HA",
      "un_locode": "HT",
      "stanag_1059": "HTI",
      "ioc": "HAI",
      "fifa": "HAI",
      "itu": "HTI",
      "uic": "",
      "maritime": 336,
      "mmc": 372
    }
  },
  {
    "locale": "fr-JE",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Jersey",
      "name_local": "Bailiwick of Jersey",
      "code": "JE",
      "area_sq_km": 116,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Saint Helier",
      "capital_latitude": 49.18804,
      "capital_longitude": -2.10491,
      "currency": "Jersey Sterling Pound",
      "currency_local": "Jersey pound",
      "currency_code": "JEP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Penny",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇯🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 832,
      "iso_3166_1_alpha2": "JE",
      "iso_3166_1_alpha3": "JEY",
      "tld": "je",
      "vehicle_code": "GBJ",
      "fips10": "JE",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "fr-CM",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Cameroon",
      "name_local": "Cameroun / Cameroon",
      "code": "CM",
      "area_sq_km": 475442,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Yaounde",
      "capital_latitude": 3.86667,
      "capital_longitude": 11.51667,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇨🇲",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CF",
        "TD",
        "CG",
        "GQ",
        "GA",
        "NG"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 120,
      "iso_3166_1_alpha2": "CM",
      "iso_3166_1_alpha3": "CMR",
      "tld": "cm",
      "vehicle_code": "CAM",
      "fips10": "CM",
      "un_locode": "CM",
      "stanag_1059": "CMR",
      "ioc": "CMR",
      "fifa": "CMR",
      "itu": "CME",
      "uic": "",
      "maritime": 613,
      "mmc": 624
    }
  },
  {
    "locale": "fr-CA",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Canada",
      "name_local": "Canada",
      "code": "CA",
      "area_sq_km": 9984670,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Ottawa",
      "capital_latitude": 45.41117,
      "capital_longitude": -75.69812,
      "currency": "Canadian Dollar",
      "currency_local": "Canadian dollar",
      "currency_code": "CAD",
      "currency_symbol": "$",
      "currency_numeric": 124,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇨🇦",
      "timezones": [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00",
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:30"
      ],
      "borders": [
        "US"
      ],
      "is_landlocked": false,
      "postal_code_format": "@#@ #@#",
      "postal_code_regex": "^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$ ",
      "iso_3166_1_numeric": 124,
      "iso_3166_1_alpha2": "CA",
      "iso_3166_1_alpha3": "CAN",
      "tld": "ca",
      "vehicle_code": "CDN",
      "fips10": "CA",
      "un_locode": "CA",
      "stanag_1059": "CAN",
      "ioc": "CAN",
      "fifa": "CAN",
      "itu": "CAN",
      "uic": "CA",
      "maritime": 316,
      "mmc": 302
    }
  },
  {
    "locale": "fr-KM",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Comoros",
      "name_local": "القمر جزر / قمر / Comores",
      "code": "KM",
      "area_sq_km": 1862,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Moroni",
      "capital_latitude": -11.70216,
      "capital_longitude": 43.25506,
      "currency": "Comorian Franc",
      "currency_local": "Comorian franc",
      "currency_code": "KMF",
      "currency_symbol": "Fr",
      "currency_numeric": 174,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇰🇲",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 174,
      "iso_3166_1_alpha2": "KM",
      "iso_3166_1_alpha3": "COM",
      "tld": "km",
      "vehicle_code": "COM",
      "fips10": "CN",
      "un_locode": "KM",
      "stanag_1059": "COM",
      "ioc": "COM",
      "fifa": "COM",
      "itu": "COM",
      "uic": "",
      "maritime": "616, 620",
      "mmc": 654
    }
  },
  {
    "locale": "fr-LB",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Lebanon",
      "name_local": "Lubnan",
      "code": "LB",
      "area_sq_km": 10452,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Beirut",
      "capital_latitude": 33.88894,
      "capital_longitude": 35.49442,
      "currency": "Lebanese Pound",
      "currency_local": "Lebanese pound",
      "currency_code": "LBP",
      "currency_symbol": "ل.ل",
      "currency_numeric": 422,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Piastres",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇱🇧",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "IL",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#### ####|####",
      "postal_code_regex": "^(\\d{4}(\\d{4})?)$",
      "iso_3166_1_numeric": 422,
      "iso_3166_1_alpha2": "LB",
      "iso_3166_1_alpha3": "LBN",
      "tld": "lb",
      "vehicle_code": "RL",
      "fips10": "LE",
      "un_locode": "LB",
      "stanag_1059": "LBN",
      "ioc": "LBN",
      "fifa": "LIB",
      "itu": "LBN",
      "uic": "",
      "maritime": 450,
      "mmc": 415
    }
  },
  {
    "locale": "fr-LU",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Luxembourg",
      "name_local": "Luxembourg/Lëtzebuerg",
      "code": "LU",
      "area_sq_km": 2586,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Luxembourg",
      "capital_latitude": 49.61167,
      "capital_longitude": 6.13,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "Luxembourgish",
          "name_local": "Lëtzebuergesch",
          "iso_639_1": "lb",
          "iso_639_2": "ltz",
          "iso_639_3": "ltz"
        }
      ],
      "flag": "🇱🇺",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BE",
        "FR",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 442,
      "iso_3166_1_alpha2": "LU",
      "iso_3166_1_alpha3": "LUX",
      "tld": "lu",
      "vehicle_code": "L",
      "fips10": "LU",
      "un_locode": "LU",
      "stanag_1059": "LUX",
      "ioc": "LUX",
      "fifa": "LUX",
      "itu": "LUX",
      "uic": "82 L",
      "maritime": 253,
      "mmc": 270
    }
  },
  {
    "locale": "fr-MG",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Madagascar",
      "name_local": "Madagasikara/Madagascar",
      "code": "MG",
      "area_sq_km": 587041,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Antananarivo",
      "capital_latitude": -18.91368,
      "capital_longitude": 47.53613,
      "currency": "Malagasy Ariary",
      "currency_local": "Malagasy ariary",
      "currency_code": "MGA",
      "currency_symbol": "Ar",
      "currency_numeric": "",
      "currency_subunit_value": 5,
      "currency_subunit_name": "Iraimbilanja",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Malagasy",
          "name_local": "fiteny malagasy",
          "iso_639_1": "mg",
          "iso_639_2": "mlg",
          "iso_639_3": "mlg"
        }
      ],
      "flag": "🇲🇬",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 450,
      "iso_3166_1_alpha2": "MG",
      "iso_3166_1_alpha3": "MDG",
      "tld": "mg",
      "vehicle_code": "RM",
      "fips10": "MA",
      "un_locode": "MG",
      "stanag_1059": "MDG",
      "ioc": "MAD",
      "fifa": "MAD",
      "itu": "MDG",
      "uic": "",
      "maritime": 647,
      "mmc": 646
    }
  },
  {
    "locale": "fr-ML",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Mali",
      "name_local": "Mali",
      "code": "ML",
      "area_sq_km": 1240192,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Bamako",
      "capital_latitude": 12.65,
      "capital_longitude": -8,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇲🇱",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "DZ",
        "BF",
        "GN",
        "CI",
        "MR",
        "NE",
        "SN"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 466,
      "iso_3166_1_alpha2": "ML",
      "iso_3166_1_alpha3": "MLI",
      "tld": "ml",
      "vehicle_code": "RMM",
      "fips10": "ML",
      "un_locode": "ML",
      "stanag_1059": "MLI",
      "ioc": "MLI",
      "fifa": "MLI",
      "itu": "MLI",
      "uic": "",
      "maritime": 649,
      "mmc": 610
    }
  },
  {
    "locale": "fr-MQ",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Martinique",
      "name_local": "Martinique / Matinik / Matnik",
      "code": "MQ",
      "area_sq_km": 1128,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Fort-de-France",
      "capital_latitude": 14.60892,
      "capital_longitude": -61.07334,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇲🇶",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 474,
      "iso_3166_1_alpha2": "MQ",
      "iso_3166_1_alpha3": "MTQ",
      "tld": "mq",
      "vehicle_code": "",
      "fips10": "MB",
      "un_locode": "MQ",
      "stanag_1059": "MTQ",
      "ioc": "",
      "fifa": "MTQ",
      "itu": "MRT",
      "uic": "",
      "maritime": 347,
      "mmc": 340
    }
  },
  {
    "locale": "fr-YT",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Mayotte",
      "name_local": "Mayotte",
      "code": "YT",
      "area_sq_km": 374,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Mamoudzou",
      "capital_latitude": -12.78234,
      "capital_longitude": 45.22878,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇾🇹",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 175,
      "iso_3166_1_alpha2": "YT",
      "iso_3166_1_alpha3": "MYT",
      "tld": "yt",
      "vehicle_code": "",
      "fips10": "MF",
      "un_locode": "YT",
      "stanag_1059": "FRA",
      "ioc": "",
      "fifa": "",
      "itu": "MYT",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "fr-NC",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "New Caledonia",
      "name_local": "Nouvelle-Calédonie",
      "code": "NC",
      "area_sq_km": 18575,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Nouméa",
      "capital_latitude": -22.27631,
      "capital_longitude": 166.4572,
      "currency": "Pacific Franc",
      "currency_local": "CFP franc",
      "currency_code": "XPF",
      "currency_symbol": "₣",
      "currency_numeric": 953,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇳🇨",
      "timezones": [
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 540,
      "iso_3166_1_alpha2": "NC",
      "iso_3166_1_alpha3": "NCL",
      "tld": "nc",
      "vehicle_code": "NCL",
      "fips10": "NC",
      "un_locode": "NC",
      "stanag_1059": "NCL",
      "ioc": "",
      "fifa": "NCL",
      "itu": "NCL",
      "uic": "",
      "maritime": 540,
      "mmc": 546
    }
  },
  {
    "locale": "fr-NE",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Niger",
      "name_local": "Niger",
      "code": "NE",
      "area_sq_km": 1267000,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Niamey",
      "capital_latitude": 13.51366,
      "capital_longitude": 2.1098,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇳🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "DZ",
        "BJ",
        "BF",
        "TD",
        "LY",
        "ML",
        "NG"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 562,
      "iso_3166_1_alpha2": "NE",
      "iso_3166_1_alpha3": "NER",
      "tld": "ne",
      "vehicle_code": "RN",
      "fips10": "NG",
      "un_locode": "NE",
      "stanag_1059": "NER",
      "ioc": "NIG",
      "fifa": "NIG",
      "itu": "NGR",
      "uic": "",
      "maritime": 656,
      "mmc": 614
    }
  },
  {
    "locale": "fr-CG",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Republic of the Congo",
      "name_local": "Congo",
      "code": "CG",
      "area_sq_km": 342000,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Brazzaville",
      "capital_latitude": -4.26613,
      "capital_longitude": 15.28318,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        }
      ],
      "flag": "🇨🇬",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AO",
        "CM",
        "CF",
        "CD",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 178,
      "iso_3166_1_alpha2": "CG",
      "iso_3166_1_alpha3": "COG",
      "tld": "cg",
      "vehicle_code": "RCB",
      "fips10": "CF",
      "un_locode": "CG",
      "stanag_1059": "COG",
      "ioc": "CGO",
      "fifa": "CGO",
      "itu": "COG",
      "uic": "",
      "maritime": 615,
      "mmc": 629
    }
  },
  {
    "locale": "fr-RE",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Reunion",
      "name_local": "Réunion",
      "code": "RE",
      "area_sq_km": 2511,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Saint-Denis",
      "capital_latitude": -20.88231,
      "capital_longitude": 55.4504,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇷🇪",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^((97|98)(4|7|8)\\d{2})$",
      "iso_3166_1_numeric": 638,
      "iso_3166_1_alpha2": "RE",
      "iso_3166_1_alpha3": "REU",
      "tld": "re",
      "vehicle_code": "",
      "fips10": "RE",
      "un_locode": "RE",
      "stanag_1059": "REU",
      "ioc": "",
      "fifa": "REU",
      "itu": "REU",
      "uic": "",
      "maritime": 660,
      "mmc": 647
    }
  },
  {
    "locale": "fr-RW",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Rwanda",
      "name_local": "Rwanda / Urwanda",
      "code": "RW",
      "area_sq_km": 26338,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Kigali",
      "capital_latitude": -1.94995,
      "capital_longitude": 30.05885,
      "currency": "Rwandan Franc",
      "currency_local": "Rwandan franc",
      "currency_code": "RWF",
      "currency_symbol": "Fr",
      "currency_numeric": 646,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Kinyarwanda",
          "name_local": "Ikinyarwanda",
          "iso_639_1": "rw",
          "iso_639_2": "kin",
          "iso_639_3": "kin"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇷🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BI",
        "CD",
        "TZ",
        "UG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 646,
      "iso_3166_1_alpha2": "RW",
      "iso_3166_1_alpha3": "RWA",
      "tld": "rw",
      "vehicle_code": "RWA",
      "fips10": "RW",
      "un_locode": "RW",
      "stanag_1059": "RWA",
      "ioc": "RWA",
      "fifa": "RWA",
      "itu": "RRW",
      "uic": "",
      "maritime": 661,
      "mmc": 635
    }
  },
  {
    "locale": "fr-MF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Saint Martin",
      "name_local": "Saint Martin",
      "code": "MF",
      "area_sq_km": 53,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Marigot",
      "capital_latitude": 18.06667,
      "capital_longitude": -63.08333,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇲🇫",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "SX"
      ],
      "is_landlocked": false,
      "postal_code_format": "### ###",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 663,
      "iso_3166_1_alpha2": "MF",
      "iso_3166_1_alpha3": "MAF",
      "tld": "mf",
      "vehicle_code": "F",
      "fips10": "RN",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "SMT",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "fr-BL",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Saint Barthelemy",
      "name_local": "Saint-Barthélemy",
      "code": "BL",
      "area_sq_km": 21,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Gustavia",
      "capital_latitude": 17.89618,
      "capital_longitude": -62.84978,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇧🇱",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "### ###",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 652,
      "iso_3166_1_alpha2": "BL",
      "iso_3166_1_alpha3": "BLM",
      "tld": "bl",
      "vehicle_code": "",
      "fips10": "TB",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "fr-CH",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Switzerland",
      "name_local": "Schweiz / Suisse / Svizzera / Svizra",
      "code": "CH",
      "area_sq_km": 41284,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Bern",
      "capital_latitude": 46.94809,
      "capital_longitude": 7.44744,
      "currency": "Swiss Franc",
      "currency_local": "Swiss franc",
      "currency_code": "CHF",
      "currency_symbol": "Fr.",
      "currency_numeric": 756,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Rappen",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "Romansh",
          "name_local": "Rumantsch",
          "iso_639_1": "rm",
          "iso_639_2": "roh",
          "iso_639_3": "roh"
        }
      ],
      "flag": "🇨🇭",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "FR",
        "IT",
        "LI",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 756,
      "iso_3166_1_alpha2": "CH",
      "iso_3166_1_alpha3": "CHE",
      "tld": "ch",
      "vehicle_code": "CH",
      "fips10": "SZ",
      "un_locode": "CH",
      "stanag_1059": "CHE",
      "ioc": "SUI",
      "fifa": "SUI",
      "itu": "SUI",
      "uic": "85 CH",
      "maritime": 269,
      "mmc": 228
    }
  },
  {
    "locale": "fr-SN",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Senegal",
      "name_local": "Sénégal / Sounougal",
      "code": "SN",
      "area_sq_km": 196722,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Dakar",
      "capital_latitude": 14.6937,
      "capital_longitude": -17.44406,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇸🇳",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GM",
        "GN",
        "GW",
        "ML",
        "MR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 686,
      "iso_3166_1_alpha2": "SN",
      "iso_3166_1_alpha3": "SEN",
      "tld": "sn",
      "vehicle_code": "SN",
      "fips10": "SG",
      "un_locode": "SN",
      "stanag_1059": "SEN",
      "ioc": "SEN",
      "fifa": "SEN",
      "itu": "SEN",
      "uic": "",
      "maritime": 663,
      "mmc": 608
    }
  },
  {
    "locale": "fr-SC",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Seychelles",
      "name_local": "Sese l /Seychelles",
      "code": "SC",
      "area_sq_km": 452,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Victoria",
      "capital_latitude": -4.61667,
      "capital_longitude": 55.45,
      "currency": "Seychelles Rupee",
      "currency_local": "Seychellois rupee",
      "currency_code": "SCR",
      "currency_symbol": "₨",
      "currency_numeric": 690,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇨",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 690,
      "iso_3166_1_alpha2": "SC",
      "iso_3166_1_alpha3": "SYC",
      "tld": "sc",
      "vehicle_code": "SY",
      "fips10": "SE",
      "un_locode": "SC",
      "stanag_1059": "SYC",
      "ioc": "SEY",
      "fifa": "SEY",
      "itu": "SEY",
      "uic": "",
      "maritime": 664,
      "mmc": 633
    }
  },
  {
    "locale": "fr-PM",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Saint Pierre and Miquelon",
      "name_local": "Saint-Pierre-et-Miquelon",
      "code": "PM",
      "area_sq_km": 242,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Saint-Pierre",
      "capital_latitude": 46.77914,
      "capital_longitude": -56.1773,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇵🇲",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(97500)$",
      "iso_3166_1_numeric": 666,
      "iso_3166_1_alpha2": "PM",
      "iso_3166_1_alpha3": "SPM",
      "tld": "pm",
      "vehicle_code": "",
      "fips10": "SB",
      "un_locode": "PM",
      "stanag_1059": "SPM",
      "ioc": "",
      "fifa": "",
      "itu": "SPM",
      "uic": "",
      "maritime": 361,
      "mmc": 308
    }
  },
  {
    "locale": "fr-TG",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Togo",
      "name_local": "Togo",
      "code": "TG",
      "area_sq_km": 56785,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Lomé",
      "capital_latitude": 6.13748,
      "capital_longitude": 1.21227,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇹🇬",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "BJ",
        "BF",
        "GH"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 768,
      "iso_3166_1_alpha2": "TG",
      "iso_3166_1_alpha3": "TGO",
      "tld": "tg",
      "vehicle_code": "TG",
      "fips10": "TO",
      "un_locode": "TG",
      "stanag_1059": "TGO",
      "ioc": "TOG",
      "fifa": "TOG",
      "itu": "TGO",
      "uic": "",
      "maritime": 671,
      "mmc": 615
    }
  },
  {
    "locale": "fr-TD",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Chad",
      "name_local": "جمهوريّة تشاد / Tchad",
      "code": "TD",
      "area_sq_km": 1284000,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "N'Djamena",
      "capital_latitude": 12.10672,
      "capital_longitude": 15.0444,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇹🇩",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "CF",
        "LY",
        "NE",
        "NG",
        "SD"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 148,
      "iso_3166_1_alpha2": "TD",
      "iso_3166_1_alpha3": "TCD",
      "tld": "td",
      "vehicle_code": "TD",
      "fips10": "CD",
      "un_locode": "TD",
      "stanag_1059": "TCD",
      "ioc": "CHA",
      "fifa": "CHA",
      "itu": "TCD",
      "uic": "",
      "maritime": 670,
      "mmc": 622
    }
  },
  {
    "locale": "fr-VU",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Vanuatu",
      "name_local": "Vanuatu",
      "code": "VU",
      "area_sq_km": 12189,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Port-Vila",
      "capital_latitude": -17.73381,
      "capital_longitude": 168.32188,
      "currency": "Vatu",
      "currency_local": "Vanuatu vatu",
      "currency_code": "VUV",
      "currency_symbol": "Vt",
      "currency_numeric": 548,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Bislama",
          "name_local": "Bislama",
          "iso_639_1": "bi",
          "iso_639_2": "bis",
          "iso_639_3": "bis"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇻🇺",
      "timezones": [
        "UTC+11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 548,
      "iso_3166_1_alpha2": "VU",
      "iso_3166_1_alpha3": "VUT",
      "tld": "vu",
      "vehicle_code": "VAN",
      "fips10": "NH",
      "un_locode": "VU",
      "stanag_1059": "VUT",
      "ioc": "VAN",
      "fifa": "VAN",
      "itu": "VUT",
      "uic": "",
      "maritime": "576, 577",
      "mmc": 541
    }
  },
  {
    "locale": "fr-VA",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Vatican City",
      "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
      "code": "VA",
      "area_sq_km": 0.44,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Vatican City",
      "capital_latitude": 41.902226,
      "capital_longitude": 12.450713,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Latin",
          "name_local": "latine",
          "iso_639_1": "la",
          "iso_639_2": "lat",
          "iso_639_3": "lat"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "French",
          "name_local": "Français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇻🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "IT"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 336,
      "iso_3166_1_alpha2": "VA",
      "iso_3166_1_alpha3": "VAT",
      "tld": "va",
      "vehicle_code": "V",
      "fips10": "VT",
      "un_locode": "VA",
      "stanag_1059": "VAT",
      "ioc": "",
      "fifa": "",
      "itu": "CVA",
      "uic": "",
      "maritime": 208,
      "mmc": 225
    }
  },
  {
    "locale": "fr-WF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Wallis and Futuna",
      "name_local": "Wallis-et-Futuna",
      "code": "WF",
      "area_sq_km": 142,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Mata-Utu",
      "capital_latitude": -13.28163,
      "capital_longitude": -176.17453,
      "currency": "Pacific Franc",
      "currency_local": "CFP franc",
      "currency_code": "XPF",
      "currency_symbol": "₣",
      "currency_numeric": 953,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇼🇫",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(986\\d{2})$",
      "iso_3166_1_numeric": 876,
      "iso_3166_1_alpha2": "WF",
      "iso_3166_1_alpha3": "WLF",
      "tld": "wf",
      "vehicle_code": "",
      "fips10": "WF",
      "un_locode": "WF",
      "stanag_1059": "WLF",
      "ioc": "",
      "fifa": "",
      "itu": "WAL",
      "uic": "",
      "maritime": 578,
      "mmc": 543
    }
  },
  {
    "locale": "fr-CF",
    "language": {
      "name": "French",
      "name_local": "français",
      "iso_639_1": "fr",
      "iso_639_2": "fra",
      "iso_639_3": "fra",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Benin",
          "name_local": "Bénin",
          "code": "BJ"
        },
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        },
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Djibouti",
          "name_local": "جيبوتي / Dschībūtī / Djibouti / Jabuuti / Gab",
          "code": "DJ"
        },
        {
          "name": "Ivory Coast",
          "name_local": "Côte d’Ivoire",
          "code": "CI"
        },
        {
          "name": "France",
          "name_local": "France",
          "code": "FR"
        },
        {
          "name": "French Guiana",
          "name_local": "Guyane française",
          "code": "GF"
        },
        {
          "name": "French Polynesia",
          "name_local": "Polynésie française",
          "code": "PF"
        },
        {
          "name": "French Southern and Antarctic Lands",
          "name_local": "Terres australes françaises",
          "code": "TF"
        },
        {
          "name": "Principality of Monaco",
          "name_local": "Monaco",
          "code": "MC"
        },
        {
          "name": "Gabon",
          "name_local": "Le Gabon",
          "code": "GA"
        },
        {
          "name": "Guadeloupe",
          "name_local": "Guadeloupe / Gwadloup",
          "code": "GP"
        },
        {
          "name": "Guernsey",
          "name_local": "Bailiwick of Guernsey",
          "code": "GG"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        },
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        },
        {
          "name": "Jersey",
          "name_local": "Bailiwick of Jersey",
          "code": "JE"
        },
        {
          "name": "Cameroon",
          "name_local": "Cameroun / Cameroon",
          "code": "CM"
        },
        {
          "name": "Canada",
          "name_local": "Canada",
          "code": "CA"
        },
        {
          "name": "Comoros",
          "name_local": "القمر جزر / قمر / Comores",
          "code": "KM"
        },
        {
          "name": "Lebanon",
          "name_local": "Lubnan",
          "code": "LB"
        },
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        },
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        },
        {
          "name": "Mali",
          "name_local": "Mali",
          "code": "ML"
        },
        {
          "name": "Martinique",
          "name_local": "Martinique / Matinik / Matnik",
          "code": "MQ"
        },
        {
          "name": "Mayotte",
          "name_local": "Mayotte",
          "code": "YT"
        },
        {
          "name": "New Caledonia",
          "name_local": "Nouvelle-Calédonie",
          "code": "NC"
        },
        {
          "name": "Niger",
          "name_local": "Niger",
          "code": "NE"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        },
        {
          "name": "Reunion",
          "name_local": "Réunion",
          "code": "RE"
        },
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Saint Barthelemy",
          "name_local": "Saint-Barthélemy",
          "code": "BL"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Senegal",
          "name_local": "Sénégal / Sounougal",
          "code": "SN"
        },
        {
          "name": "Seychelles",
          "name_local": "Sese l /Seychelles",
          "code": "SC"
        },
        {
          "name": "Saint Pierre and Miquelon",
          "name_local": "Saint-Pierre-et-Miquelon",
          "code": "PM"
        },
        {
          "name": "Togo",
          "name_local": "Togo",
          "code": "TG"
        },
        {
          "name": "Chad",
          "name_local": "جمهوريّة تشاد / Tchad",
          "code": "TD"
        },
        {
          "name": "Vanuatu",
          "name_local": "Vanuatu",
          "code": "VU"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        },
        {
          "name": "Wallis and Futuna",
          "name_local": "Wallis-et-Futuna",
          "code": "WF"
        },
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Central African Republic",
      "name_local": "Centrafrique / Bê-Afrîka",
      "code": "CF",
      "area_sq_km": 622984,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Bangui",
      "capital_latitude": 4.36122,
      "capital_longitude": 18.55496,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Sango",
          "name_local": "yângâ tî sängö",
          "iso_639_1": "sg",
          "iso_639_2": "sag",
          "iso_639_3": "sag"
        }
      ],
      "flag": "🇨🇫",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "TD",
        "CD",
        "CG",
        "SS",
        "SD"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 140,
      "iso_3166_1_alpha2": "CF",
      "iso_3166_1_alpha3": "CAF",
      "tld": "cf",
      "vehicle_code": "RCA",
      "fips10": "CT",
      "un_locode": "CF",
      "stanag_1059": "CAF",
      "ioc": "CAF",
      "fifa": "CTA",
      "itu": "CAF",
      "uic": "",
      "maritime": 612,
      "mmc": 623
    }
  },
  {
    "locale": "ff-BF",
    "language": {
      "name": "Fula",
      "name_local": "Fulfulde",
      "iso_639_1": "ff",
      "iso_639_2": "ful",
      "iso_639_3": "ful",
      "countries": [
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        }
      ]
    },
    "country": {
      "name": "Burkina Faso",
      "name_local": "Burkina Faso",
      "code": "BF",
      "area_sq_km": 272967,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Ouagadougou",
      "capital_latitude": 12.36566,
      "capital_longitude": -1.53388,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Fula",
          "name_local": "Fulfulde",
          "iso_639_1": "ff",
          "iso_639_2": "ful",
          "iso_639_3": "ful"
        }
      ],
      "flag": "🇧🇫",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "BJ",
        "CI",
        "GH",
        "ML",
        "NE",
        "TG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 854,
      "iso_3166_1_alpha2": "BF",
      "iso_3166_1_alpha3": "BFA",
      "tld": "bf",
      "vehicle_code": "BF",
      "fips10": "UV",
      "un_locode": "BF",
      "stanag_1059": "BFA",
      "ioc": "BUR",
      "fifa": "BFA",
      "itu": "BFA",
      "uic": "",
      "maritime": 633,
      "mmc": 613
    }
  },
  {
    "locale": "ff-GN",
    "language": {
      "name": "Fula",
      "name_local": "Fulfulde",
      "iso_639_1": "ff",
      "iso_639_2": "ful",
      "iso_639_3": "ful",
      "countries": [
        {
          "name": "Burkina Faso",
          "name_local": "Burkina Faso",
          "code": "BF"
        },
        {
          "name": "Guinea",
          "name_local": "La Guinée",
          "code": "GN"
        }
      ]
    },
    "country": {
      "name": "Guinea",
      "name_local": "La Guinée",
      "code": "GN",
      "area_sq_km": 245857,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Conakry",
      "capital_latitude": 9.53795,
      "capital_longitude": -13.67729,
      "currency": "Guinea Franc",
      "currency_local": "Guinean franc",
      "currency_code": "GNF",
      "currency_symbol": "Fr",
      "currency_numeric": 324,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Fula",
          "name_local": "Fulfulde",
          "iso_639_1": "ff",
          "iso_639_2": "ful",
          "iso_639_3": "ful"
        }
      ],
      "flag": "🇬🇳",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "CI",
        "GW",
        "LR",
        "ML",
        "SN",
        "SL"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 324,
      "iso_3166_1_alpha2": "GN",
      "iso_3166_1_alpha3": "GIN",
      "tld": "gn",
      "vehicle_code": "RG",
      "fips10": "GV",
      "un_locode": "GN",
      "stanag_1059": "GIN",
      "ioc": "GUI",
      "fifa": "GUI",
      "itu": "GUI",
      "uic": "",
      "maritime": 632,
      "mmc": 611
    }
  },
  {
    "locale": "ga-IE",
    "language": {
      "name": "Irish",
      "name_local": "Gaeilge",
      "iso_639_1": "ga",
      "iso_639_2": "gle",
      "iso_639_3": "gle",
      "countries": [
        {
          "name": "Ireland",
          "name_local": "Éire / Airlann",
          "code": "IE"
        }
      ]
    },
    "country": {
      "name": "Ireland",
      "name_local": "Éire / Airlann",
      "code": "IE",
      "area_sq_km": 70273,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Dublin",
      "capital_latitude": 53.33306,
      "capital_longitude": -6.24889,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Irish",
          "name_local": "Gaeilge",
          "iso_639_1": "ga",
          "iso_639_2": "gle",
          "iso_639_3": "gle"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇮🇪",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GB"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 372,
      "iso_3166_1_alpha2": "IE",
      "iso_3166_1_alpha3": "IRL",
      "tld": "ie",
      "vehicle_code": "IRL",
      "fips10": "EI",
      "un_locode": "IE",
      "stanag_1059": "IRL",
      "ioc": "IRL",
      "fifa": "IRL",
      "itu": "IRL",
      "uic": "60 IRL",
      "maritime": 250,
      "mmc": 272
    }
  },
  {
    "locale": "gv-IM",
    "language": {
      "name": "Manx",
      "name_local": "Gaelg",
      "iso_639_1": "gv",
      "iso_639_2": "glv",
      "iso_639_3": "glv",
      "countries": [
        {
          "name": "Isle of Man",
          "name_local": "Isle of Man / Mannin / Ellan Vannin",
          "code": "IM"
        }
      ]
    },
    "country": {
      "name": "Isle of Man",
      "name_local": "Isle of Man / Mannin / Ellan Vannin",
      "code": "IM",
      "area_sq_km": 572,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Douglas",
      "capital_latitude": 54.15,
      "capital_longitude": -4.48333,
      "currency": "Manx Pound",
      "currency_local": "Manx pound",
      "currency_code": "IMP",
      "currency_symbol": "£",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pence",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Manx",
          "name_local": "Gaelg",
          "iso_639_1": "gv",
          "iso_639_2": "glv",
          "iso_639_3": "glv"
        }
      ],
      "flag": "🇮🇲",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@# #@@|@## #@@|@@# #@@|@@## #@@|@#@ #@@|@@#@ #@@|GIR0AA",
      "postal_code_regex": "^(([A-Z]\\d{2}[A-Z]{2})|([A-Z]\\d{3}[A-Z]{2})|([A-Z]{2}\\d{2}[A-Z]{2})|([A-Z]{2}\\d{3}[A-Z]{2})|([A-Z]\\d[A-Z]\\d[A-Z]{2})|([A-Z]{2}\\d[A-Z]\\d[A-Z]{2})|(GIR0AA))$",
      "iso_3166_1_numeric": 833,
      "iso_3166_1_alpha2": "IM",
      "iso_3166_1_alpha3": "IMN",
      "tld": "im",
      "vehicle_code": "",
      "fips10": "",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "gn-AR",
    "language": {
      "name": "Guaraní",
      "name_local": "Avañe'ẽ",
      "iso_639_1": "gn",
      "iso_639_2": "grn",
      "iso_639_3": "grn",
      "countries": [
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        }
      ]
    },
    "country": {
      "name": "Argentina",
      "name_local": "Argentina",
      "code": "AR",
      "area_sq_km": 2780400,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Buenos Aires",
      "capital_latitude": -34.61315,
      "capital_longitude": -58.37723,
      "currency": "Argentine Peso",
      "currency_local": "Argentine peso",
      "currency_code": "ARS",
      "currency_symbol": "$",
      "currency_numeric": 32,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Guaraní",
          "name_local": "Avañe'ẽ",
          "iso_639_1": "gn",
          "iso_639_2": "grn",
          "iso_639_3": "grn"
        }
      ],
      "flag": "🇦🇷",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [
        "BO",
        "BR",
        "CL",
        "PY",
        "UY"
      ],
      "is_landlocked": false,
      "postal_code_format": "@####@@@",
      "postal_code_regex": "^([A-Z]\\d{4}[A-Z]{3})$",
      "iso_3166_1_numeric": 32,
      "iso_3166_1_alpha2": "AR",
      "iso_3166_1_alpha3": "ARG",
      "tld": "ar",
      "vehicle_code": "RA",
      "fips10": "AR",
      "un_locode": "AR",
      "stanag_1059": "ARG",
      "ioc": "ARG",
      "fifa": "ARG",
      "itu": "ARG",
      "uic": "",
      "maritime": 701,
      "mmc": 722
    }
  },
  {
    "locale": "gn-PY",
    "language": {
      "name": "Guaraní",
      "name_local": "Avañe'ẽ",
      "iso_639_1": "gn",
      "iso_639_2": "grn",
      "iso_639_3": "grn",
      "countries": [
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        }
      ]
    },
    "country": {
      "name": "Paraguay",
      "name_local": "Paraguay",
      "code": "PY",
      "area_sq_km": 406752,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Asunción",
      "capital_latitude": -25.30066,
      "capital_longitude": -57.63591,
      "currency": "Guaraní",
      "currency_local": "Paraguayan guaraní",
      "currency_code": "PYG",
      "currency_symbol": "₲",
      "currency_numeric": 600,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Guaraní",
          "name_local": "Avañe'ẽ",
          "iso_639_1": "gn",
          "iso_639_2": "grn",
          "iso_639_3": "grn"
        }
      ],
      "flag": "🇵🇾",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BO",
        "BR"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 600,
      "iso_3166_1_alpha2": "PY",
      "iso_3166_1_alpha3": "PRY",
      "tld": "py",
      "vehicle_code": "PY",
      "fips10": "PA",
      "un_locode": "PY",
      "stanag_1059": "PRY",
      "ioc": "PAR",
      "fifa": "PAR",
      "itu": "PRG",
      "uic": "",
      "maritime": 755,
      "mmc": 744
    }
  },
  {
    "locale": "ht-HT",
    "language": {
      "name": "Haitian",
      "name_local": "Kreyòl ayisyen",
      "iso_639_1": "ht",
      "iso_639_2": "hat",
      "iso_639_3": "hat",
      "countries": [
        {
          "name": "Haiti",
          "name_local": "Ayiti / Haïti",
          "code": "HT"
        }
      ]
    },
    "country": {
      "name": "Haiti",
      "name_local": "Ayiti / Haïti",
      "code": "HT",
      "area_sq_km": 27750,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Port-au-Prince",
      "capital_latitude": 18.53917,
      "capital_longitude": -72.335,
      "currency": "Gourde",
      "currency_local": "Haitian gourde",
      "currency_code": "HTG",
      "currency_symbol": "G",
      "currency_numeric": 332,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Haitian",
          "name_local": "Kreyòl ayisyen",
          "iso_639_1": "ht",
          "iso_639_2": "hat",
          "iso_639_3": "hat"
        }
      ],
      "flag": "🇭🇹",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [
        "DO"
      ],
      "is_landlocked": false,
      "postal_code_format": "HT####",
      "postal_code_regex": "^(?:HT)*(\\d{4})$",
      "iso_3166_1_numeric": 332,
      "iso_3166_1_alpha2": "HT",
      "iso_3166_1_alpha3": "HTI",
      "tld": "ht",
      "vehicle_code": "RH",
      "fips10": "HA",
      "un_locode": "HT",
      "stanag_1059": "HTI",
      "ioc": "HAI",
      "fifa": "HAI",
      "itu": "HTI",
      "uic": "",
      "maritime": 336,
      "mmc": 372
    }
  },
  {
    "locale": "he-IL",
    "language": {
      "name": "Hebrew (modern)",
      "name_local": "עברית",
      "iso_639_1": "he",
      "iso_639_2": "heb",
      "iso_639_3": "heb",
      "countries": [
        {
          "name": "Israel",
          "name_local": "ישראל / Yisra’el / Isra’il",
          "code": "IL"
        }
      ]
    },
    "country": {
      "name": "Israel",
      "name_local": "ישראל / Yisra’el / Isra’il",
      "code": "IL",
      "area_sq_km": 20770,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Jerusalem",
      "capital_latitude": 31.76904,
      "capital_longitude": 35.21633,
      "currency": "New Israeli Sheqel",
      "currency_local": "Israeli new shekel",
      "currency_code": "ILS",
      "currency_symbol": "₪",
      "currency_numeric": 376,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Agorot",
      "languages": [
        {
          "name": "Hebrew (modern)",
          "name_local": "עברית",
          "iso_639_1": "he",
          "iso_639_2": "heb",
          "iso_639_3": "heb"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇮🇱",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "EG",
        "JO",
        "LB",
        "PS",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 376,
      "iso_3166_1_alpha2": "IL",
      "iso_3166_1_alpha3": "ISR",
      "tld": "il",
      "vehicle_code": "IL",
      "fips10": "IS",
      "un_locode": "IL",
      "stanag_1059": "ISR",
      "ioc": "ISR",
      "fifa": "ISR",
      "itu": "ISR",
      "uic": "95 IL",
      "maritime": 428,
      "mmc": 425
    }
  },
  {
    "locale": "hif-FJ",
    "language": {
      "name": "Fiji Hindi",
      "name_local": "फ़िजी बात",
      "iso_639_1": "",
      "iso_639_2": "hif",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        }
      ]
    },
    "country": {
      "name": "Fiji",
      "name_local": "Viti / फ़िजी गणराज्य / Fiji",
      "code": "FJ",
      "area_sq_km": 18272,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Suva",
      "capital_latitude": -18.14161,
      "capital_longitude": 178.44149,
      "currency": "Fiji Dollar",
      "currency_local": "Fijian dollar",
      "currency_code": "FJD",
      "currency_symbol": "$",
      "currency_numeric": 242,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Fijian",
          "name_local": "vosa Vakaviti",
          "iso_639_1": "fj",
          "iso_639_2": "fij",
          "iso_639_3": "fij"
        },
        {
          "name": "Fiji Hindi",
          "name_local": "फ़िजी बात",
          "iso_639_1": "",
          "iso_639_2": "hif",
          "iso_639_3": ""
        },
        {
          "name": "Rotuman",
          "name_local": "Fäeag Rotuma",
          "iso_639_1": "",
          "iso_639_2": "rtm",
          "iso_639_3": ""
        }
      ],
      "flag": "🇫🇯",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 242,
      "iso_3166_1_alpha2": "FJ",
      "iso_3166_1_alpha3": "FJI",
      "tld": "fj",
      "vehicle_code": "FJI",
      "fips10": "FJ",
      "un_locode": "FJ",
      "stanag_1059": "FJI",
      "ioc": "FIJ",
      "fifa": "FIJ",
      "itu": "FJI",
      "uic": "",
      "maritime": 520,
      "mmc": 542
    }
  },
  {
    "locale": "hi-IN",
    "language": {
      "name": "Hindi",
      "name_local": "हिन्दी",
      "iso_639_1": "hi",
      "iso_639_2": "hin",
      "iso_639_3": "hin",
      "countries": [
        {
          "name": "India",
          "name_local": "Bharat  / भारत गणराज्य",
          "code": "IN"
        }
      ]
    },
    "country": {
      "name": "India",
      "name_local": "Bharat  / भारत गणराज्य",
      "code": "IN",
      "area_sq_km": 3287590,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "New Delhi",
      "capital_latitude": 28.63576,
      "capital_longitude": 77.22445,
      "currency": "Indian Rupee",
      "currency_local": "Indian rupee",
      "currency_code": "INR",
      "currency_symbol": "₹",
      "currency_numeric": 356,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Paise",
      "languages": [
        {
          "name": "Hindi",
          "name_local": "हिन्दी",
          "iso_639_1": "hi",
          "iso_639_2": "hin",
          "iso_639_3": "hin"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇮🇳",
      "timezones": [
        "UTC+05:30"
      ],
      "borders": [
        "BD",
        "BT",
        "MM",
        "CN",
        "NP",
        "PK"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 356,
      "iso_3166_1_alpha2": "IN",
      "iso_3166_1_alpha3": "IND",
      "tld": "in",
      "vehicle_code": "IND",
      "fips10": "IN",
      "un_locode": "IN",
      "stanag_1059": "IND",
      "ioc": "IND",
      "fifa": "IND",
      "itu": "IND",
      "uic": "",
      "maritime": 419,
      "mmc": "404, 405"
    }
  },
  {
    "locale": "hr-BA",
    "language": {
      "name": "Croatian",
      "name_local": "hrvatski jezik",
      "iso_639_1": "hr",
      "iso_639_2": "hrv",
      "iso_639_3": "hrv",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Croatia",
          "name_local": "Hrvatska",
          "code": "HR"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Bosnia and Herzegovina",
      "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
      "code": "BA",
      "area_sq_km": 51209,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Sarajevo",
      "capital_latitude": 43.84864,
      "capital_longitude": 18.35644,
      "currency": "Convertible Mark",
      "currency_local": "Bosnia and Herzegovina convertible mark",
      "currency_code": "BAM",
      "currency_symbol": "",
      "currency_numeric": 977,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fening",
      "languages": [
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        },
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇧🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "HR",
        "ME",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 70,
      "iso_3166_1_alpha2": "BA",
      "iso_3166_1_alpha3": "BIH",
      "tld": "ba",
      "vehicle_code": "BIH",
      "fips10": "BK",
      "un_locode": "BA",
      "stanag_1059": "BIH",
      "ioc": "BIH",
      "fifa": "BIH",
      "itu": "BIH",
      "uic": "44-50 BIH",
      "maritime": 478,
      "mmc": 218
    }
  },
  {
    "locale": "hr-HR",
    "language": {
      "name": "Croatian",
      "name_local": "hrvatski jezik",
      "iso_639_1": "hr",
      "iso_639_2": "hrv",
      "iso_639_3": "hrv",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Croatia",
          "name_local": "Hrvatska",
          "code": "HR"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Croatia",
      "name_local": "Hrvatska",
      "code": "HR",
      "area_sq_km": 56594,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Zagreb",
      "capital_latitude": 45.81444,
      "capital_longitude": 15.97798,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        }
      ],
      "flag": "🇭🇷",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BA",
        "HU",
        "ME",
        "RS",
        "SI"
      ],
      "is_landlocked": false,
      "postal_code_format": "HR-#####",
      "postal_code_regex": "^(?:HR)*(\\d{5})$",
      "iso_3166_1_numeric": 191,
      "iso_3166_1_alpha2": "HR",
      "iso_3166_1_alpha3": "HRV",
      "tld": "hr",
      "vehicle_code": "HR",
      "fips10": "HR",
      "un_locode": "HR",
      "stanag_1059": "HRV",
      "ioc": "CRO",
      "fifa": "CRO",
      "itu": "HRV",
      "uic": "78 HR",
      "maritime": 238,
      "mmc": 219
    }
  },
  {
    "locale": "hr-ME",
    "language": {
      "name": "Croatian",
      "name_local": "hrvatski jezik",
      "iso_639_1": "hr",
      "iso_639_2": "hrv",
      "iso_639_3": "hrv",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Croatia",
          "name_local": "Hrvatska",
          "code": "HR"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Montenegro",
      "name_local": "Црна Гора / Crna Gora / Mali i Zi",
      "code": "ME",
      "area_sq_km": 13812,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Podgorica",
      "capital_latitude": 42.44111,
      "capital_longitude": 19.26361,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        },
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        }
      ],
      "flag": "🇲🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "BA",
        "HR",
        "XK",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 499,
      "iso_3166_1_alpha2": "ME",
      "iso_3166_1_alpha3": "MNE",
      "tld": "me",
      "vehicle_code": "MNE",
      "fips10": "MJ",
      "un_locode": "ME",
      "stanag_1059": "",
      "ioc": "MNE",
      "fifa": "MNE",
      "itu": "MNE",
      "uic": "62 CG",
      "maritime": 262,
      "mmc": 297
    }
  },
  {
    "locale": "hu-HU",
    "language": {
      "name": "Hungarian",
      "name_local": "magyar",
      "iso_639_1": "hu",
      "iso_639_2": "hun",
      "iso_639_3": "hun",
      "countries": [
        {
          "name": "Hungary",
          "name_local": "Magyarország",
          "code": "HU"
        }
      ]
    },
    "country": {
      "name": "Hungary",
      "name_local": "Magyarország",
      "code": "HU",
      "area_sq_km": 93028,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Budapest",
      "capital_latitude": 47.49801,
      "capital_longitude": 19.03991,
      "currency": "Hungarian Forint",
      "currency_local": "Hungarian forint",
      "currency_code": "HUF",
      "currency_symbol": "Ft",
      "currency_numeric": 348,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fillér",
      "languages": [
        {
          "name": "Hungarian",
          "name_local": "magyar",
          "iso_639_1": "hu",
          "iso_639_2": "hun",
          "iso_639_3": "hun"
        }
      ],
      "flag": "🇭🇺",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "HR",
        "RO",
        "RS",
        "SK",
        "SI",
        "UA"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 348,
      "iso_3166_1_alpha2": "HU",
      "iso_3166_1_alpha3": "HUN",
      "tld": "hu",
      "vehicle_code": "H",
      "fips10": "HU",
      "un_locode": "HU",
      "stanag_1059": "HUN",
      "ioc": "HUN",
      "fifa": "HUN",
      "itu": "HNG",
      "uic": "55 H",
      "maritime": 243,
      "mmc": 216
    }
  },
  {
    "locale": "hy-AM",
    "language": {
      "name": "Armenian",
      "name_local": "Հայերեն",
      "iso_639_1": "hy",
      "iso_639_2": "hye",
      "iso_639_3": "hye",
      "countries": [
        {
          "name": "Armenia",
          "name_local": "Հայաստան Hajastan",
          "code": "AM"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Armenia",
      "name_local": "Հայաստան Hajastan",
      "code": "AM",
      "area_sq_km": 29743,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Yerevan",
      "capital_latitude": 40.18111,
      "capital_longitude": 44.51361,
      "currency": "Dram",
      "currency_local": "Armenian dram",
      "currency_code": "AMD",
      "currency_symbol": "֏",
      "currency_numeric": 51,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Lumma",
      "languages": [
        {
          "name": "Armenian",
          "name_local": "Հայերեն",
          "iso_639_1": "hy",
          "iso_639_2": "hye",
          "iso_639_3": "hye"
        }
      ],
      "flag": "🇦🇲",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [
        "AZ",
        "GE",
        "IR",
        "TR"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 51,
      "iso_3166_1_alpha2": "AM",
      "iso_3166_1_alpha3": "ARM",
      "tld": "am",
      "vehicle_code": "AM",
      "fips10": "AM",
      "un_locode": "AM",
      "stanag_1059": "ARM",
      "ioc": "ARM",
      "fifa": "ARM",
      "itu": "ARM",
      "uic": "58 ARM",
      "maritime": 216,
      "mmc": 283
    }
  },
  {
    "locale": "hy-CY",
    "language": {
      "name": "Armenian",
      "name_local": "Հայերեն",
      "iso_639_1": "hy",
      "iso_639_2": "hye",
      "iso_639_3": "hye",
      "countries": [
        {
          "name": "Armenia",
          "name_local": "Հայաստան Hajastan",
          "code": "AM"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Cyprus",
      "name_local": "Κύπρος / Kypros / Kıbrıs",
      "code": "CY",
      "area_sq_km": 9251,
      "continent": "Asia",
      "region": "Southern Europe",
      "capital_name": "Nicosia",
      "capital_latitude": 35.17531,
      "capital_longitude": 33.3642,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Greek (modern)",
          "name_local": "ελληνικά",
          "iso_639_1": "el",
          "iso_639_2": "ell",
          "iso_639_3": "ell"
        },
        {
          "name": "Turkish",
          "name_local": "Türkçe",
          "iso_639_1": "tr",
          "iso_639_2": "tur",
          "iso_639_3": "tur"
        },
        {
          "name": "Armenian",
          "name_local": "Հայերեն",
          "iso_639_1": "hy",
          "iso_639_2": "hye",
          "iso_639_3": "hye"
        }
      ],
      "flag": "🇨🇾",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 196,
      "iso_3166_1_alpha2": "CY",
      "iso_3166_1_alpha3": "CYP",
      "tld": "cy",
      "vehicle_code": "CY",
      "fips10": "CY",
      "un_locode": "CY",
      "stanag_1059": "CYP",
      "ioc": "CYP",
      "fifa": "CYP",
      "itu": "CYP",
      "uic": "",
      "maritime": "209, 210, 212",
      "mmc": 280
    }
  },
  {
    "locale": "id-ID",
    "language": {
      "name": "Indonesian",
      "name_local": "Bahasa Indonesia",
      "iso_639_1": "id",
      "iso_639_2": "ind",
      "iso_639_3": "ind",
      "countries": [
        {
          "name": "Indonesia",
          "name_local": "Indonesia",
          "code": "ID"
        }
      ]
    },
    "country": {
      "name": "Indonesia",
      "name_local": "Indonesia",
      "code": "ID",
      "area_sq_km": 1904569,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Jakarta",
      "capital_latitude": -6.21462,
      "capital_longitude": 106.84513,
      "currency": "Indonesian Rupiah",
      "currency_local": "Indonesian rupiah",
      "currency_code": "IDR",
      "currency_symbol": "Rp",
      "currency_numeric": 360,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Sen",
      "languages": [
        {
          "name": "Indonesian",
          "name_local": "Bahasa Indonesia",
          "iso_639_1": "id",
          "iso_639_2": "ind",
          "iso_639_3": "ind"
        }
      ],
      "flag": "🇮🇩",
      "timezones": [
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00"
      ],
      "borders": [
        "TL",
        "MY",
        "PG"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 360,
      "iso_3166_1_alpha2": "ID",
      "iso_3166_1_alpha3": "IDN",
      "tld": "id",
      "vehicle_code": "RI",
      "fips10": "ID",
      "un_locode": "ID",
      "stanag_1059": "IDN",
      "ioc": "INA",
      "fifa": "IDN",
      "itu": "INS",
      "uic": "",
      "maritime": 525,
      "mmc": 510
    }
  },
  {
    "locale": "is-IS",
    "language": {
      "name": "Icelandic",
      "name_local": "Íslenska",
      "iso_639_1": "is",
      "iso_639_2": "isl",
      "iso_639_3": "isl",
      "countries": [
        {
          "name": "Iceland",
          "name_local": "Ísland",
          "code": "IS"
        }
      ]
    },
    "country": {
      "name": "Iceland",
      "name_local": "Ísland",
      "code": "IS",
      "area_sq_km": 103000,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Reykjavík",
      "capital_latitude": 64.13548,
      "capital_longitude": -21.89541,
      "currency": "Icelandic Krone",
      "currency_local": "Icelandic króna",
      "currency_code": "ISK",
      "currency_symbol": "kr",
      "currency_numeric": 352,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Aurar",
      "languages": [
        {
          "name": "Icelandic",
          "name_local": "Íslenska",
          "iso_639_1": "is",
          "iso_639_2": "isl",
          "iso_639_3": "isl"
        }
      ],
      "flag": "🇮🇸",
      "timezones": [
        "UTC"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 352,
      "iso_3166_1_alpha2": "IS",
      "iso_3166_1_alpha3": "ISL",
      "tld": "is",
      "vehicle_code": "IS",
      "fips10": "IC",
      "un_locode": "IS",
      "stanag_1059": "ISL",
      "ioc": "ISL",
      "fifa": "ISL",
      "itu": "ISL",
      "uic": "",
      "maritime": 251,
      "mmc": 274
    }
  },
  {
    "locale": "it-IT",
    "language": {
      "name": "Italian",
      "name_local": "Italiano",
      "iso_639_1": "it",
      "iso_639_2": "ita",
      "iso_639_3": "ita",
      "countries": [
        {
          "name": "Italy",
          "name_local": "Italia",
          "code": "IT"
        },
        {
          "name": "San Marino",
          "name_local": "San Marino",
          "code": "SM"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Italy",
      "name_local": "Italia",
      "code": "IT",
      "area_sq_km": 301336,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Rome",
      "capital_latitude": 41.89193,
      "capital_longitude": 12.51133,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        }
      ],
      "flag": "🇮🇹",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "FR",
        "SM",
        "SI",
        "CH",
        "VA"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 380,
      "iso_3166_1_alpha2": "IT",
      "iso_3166_1_alpha3": "ITA",
      "tld": "it",
      "vehicle_code": "I",
      "fips10": "IT",
      "un_locode": "IT",
      "stanag_1059": "ITA",
      "ioc": "ITA",
      "fifa": "ITA",
      "itu": "I",
      "uic": "83 I",
      "maritime": 247,
      "mmc": 222
    }
  },
  {
    "locale": "it-SM",
    "language": {
      "name": "Italian",
      "name_local": "Italiano",
      "iso_639_1": "it",
      "iso_639_2": "ita",
      "iso_639_3": "ita",
      "countries": [
        {
          "name": "Italy",
          "name_local": "Italia",
          "code": "IT"
        },
        {
          "name": "San Marino",
          "name_local": "San Marino",
          "code": "SM"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "San Marino",
      "name_local": "San Marino",
      "code": "SM",
      "area_sq_km": 61,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "San Marino",
      "capital_latitude": 43.93667,
      "capital_longitude": 12.44639,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        }
      ],
      "flag": "🇸🇲",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "IT"
      ],
      "is_landlocked": true,
      "postal_code_format": "4789#",
      "postal_code_regex": "^(4789\\d)$",
      "iso_3166_1_numeric": 674,
      "iso_3166_1_alpha2": "SM",
      "iso_3166_1_alpha3": "SMR",
      "tld": "sm",
      "vehicle_code": "RSM",
      "fips10": "SM",
      "un_locode": "SM",
      "stanag_1059": "SMR",
      "ioc": "SMR",
      "fifa": "SMR",
      "itu": "SMR",
      "uic": "",
      "maritime": 268,
      "mmc": 292
    }
  },
  {
    "locale": "it-CH",
    "language": {
      "name": "Italian",
      "name_local": "Italiano",
      "iso_639_1": "it",
      "iso_639_2": "ita",
      "iso_639_3": "ita",
      "countries": [
        {
          "name": "Italy",
          "name_local": "Italia",
          "code": "IT"
        },
        {
          "name": "San Marino",
          "name_local": "San Marino",
          "code": "SM"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Switzerland",
      "name_local": "Schweiz / Suisse / Svizzera / Svizra",
      "code": "CH",
      "area_sq_km": 41284,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Bern",
      "capital_latitude": 46.94809,
      "capital_longitude": 7.44744,
      "currency": "Swiss Franc",
      "currency_local": "Swiss franc",
      "currency_code": "CHF",
      "currency_symbol": "Fr.",
      "currency_numeric": 756,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Rappen",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "Romansh",
          "name_local": "Rumantsch",
          "iso_639_1": "rm",
          "iso_639_2": "roh",
          "iso_639_3": "roh"
        }
      ],
      "flag": "🇨🇭",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "FR",
        "IT",
        "LI",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 756,
      "iso_3166_1_alpha2": "CH",
      "iso_3166_1_alpha3": "CHE",
      "tld": "ch",
      "vehicle_code": "CH",
      "fips10": "SZ",
      "un_locode": "CH",
      "stanag_1059": "CHE",
      "ioc": "SUI",
      "fifa": "SUI",
      "itu": "SUI",
      "uic": "85 CH",
      "maritime": 269,
      "mmc": 228
    }
  },
  {
    "locale": "it-VA",
    "language": {
      "name": "Italian",
      "name_local": "Italiano",
      "iso_639_1": "it",
      "iso_639_2": "ita",
      "iso_639_3": "ita",
      "countries": [
        {
          "name": "Italy",
          "name_local": "Italia",
          "code": "IT"
        },
        {
          "name": "San Marino",
          "name_local": "San Marino",
          "code": "SM"
        },
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        },
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Vatican City",
      "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
      "code": "VA",
      "area_sq_km": 0.44,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Vatican City",
      "capital_latitude": 41.902226,
      "capital_longitude": 12.450713,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Latin",
          "name_local": "latine",
          "iso_639_1": "la",
          "iso_639_2": "lat",
          "iso_639_3": "lat"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "French",
          "name_local": "Français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇻🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "IT"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 336,
      "iso_3166_1_alpha2": "VA",
      "iso_3166_1_alpha3": "VAT",
      "tld": "va",
      "vehicle_code": "V",
      "fips10": "VT",
      "un_locode": "VA",
      "stanag_1059": "VAT",
      "ioc": "",
      "fifa": "",
      "itu": "CVA",
      "uic": "",
      "maritime": 208,
      "mmc": 225
    }
  },
  {
    "locale": "ja-JP",
    "language": {
      "name": "Japanese",
      "name_local": "日本語 (にほんご)",
      "iso_639_1": "ja",
      "iso_639_2": "jpn",
      "iso_639_3": "jpn",
      "countries": [
        {
          "name": "Japan",
          "name_local": "日本国",
          "code": "JP"
        }
      ]
    },
    "country": {
      "name": "Japan",
      "name_local": "日本国",
      "code": "JP",
      "area_sq_km": 377930,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Tokyo",
      "capital_latitude": 35.6895,
      "capital_longitude": 139.69171,
      "currency": "Japanese Yen",
      "currency_local": "Japanese yen",
      "currency_code": "JPY",
      "currency_symbol": "¥",
      "currency_numeric": 392,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Sen",
      "languages": [
        {
          "name": "Japanese",
          "name_local": "日本語 (にほんご)",
          "iso_639_1": "ja",
          "iso_639_2": "jpn",
          "iso_639_3": "jpn"
        }
      ],
      "flag": "🇯🇵",
      "timezones": [
        "UTC+09:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "###-####",
      "postal_code_regex": "^(\\d{7})$",
      "iso_3166_1_numeric": 392,
      "iso_3166_1_alpha2": "JP",
      "iso_3166_1_alpha3": "JPN",
      "tld": "jp",
      "vehicle_code": "J",
      "fips10": "JA",
      "un_locode": "JP",
      "stanag_1059": "JPN",
      "ioc": "JPN",
      "fifa": "JPN",
      "itu": "J",
      "uic": "42 J",
      "maritime": "431, 432",
      "mmc": "440, 441"
    }
  },
  {
    "locale": "kl-GL",
    "language": {
      "name": "Greenlandic",
      "name_local": "kalaallisut",
      "iso_639_1": "kl",
      "iso_639_2": "kal",
      "iso_639_3": "kal",
      "countries": [
        {
          "name": "Greenland",
          "name_local": "Kalaallit Nunaat / Grønland",
          "code": "GL"
        }
      ]
    },
    "country": {
      "name": "Greenland",
      "name_local": "Kalaallit Nunaat / Grønland",
      "code": "GL",
      "area_sq_km": 2166086,
      "continent": "North America",
      "region": "North America",
      "capital_name": "Nuuk",
      "capital_latitude": 64.18347,
      "capital_longitude": -51.72157,
      "currency": "Danish Krone",
      "currency_local": "krone",
      "currency_code": "DKK",
      "currency_symbol": "kr.",
      "currency_numeric": 208,
      "currency_subunit_value": 100,
      "currency_subunit_name": "øre",
      "languages": [
        {
          "name": "Greenlandic",
          "name_local": "kalaallisut",
          "iso_639_1": "kl",
          "iso_639_2": "kal",
          "iso_639_3": "kal"
        }
      ],
      "flag": "🇬🇱",
      "timezones": [
        "UTC-04:00",
        "UTC-03:00",
        "UTC-01:00",
        "UTC+00:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 304,
      "iso_3166_1_alpha2": "GL",
      "iso_3166_1_alpha3": "GRL",
      "tld": "gl",
      "vehicle_code": "KN",
      "fips10": "GL",
      "un_locode": "GL",
      "stanag_1059": "GRL",
      "ioc": "",
      "fifa": "",
      "itu": "GRL",
      "uic": "",
      "maritime": 331,
      "mmc": 290
    }
  },
  {
    "locale": "ka-GE",
    "language": {
      "name": "Georgian",
      "name_local": "ქართული",
      "iso_639_1": "ka",
      "iso_639_2": "kat",
      "iso_639_3": "kat",
      "countries": [
        {
          "name": "Georgia",
          "name_local": "საქართველო / Sakartwelo",
          "code": "GE"
        }
      ]
    },
    "country": {
      "name": "Georgia",
      "name_local": "საქართველო / Sakartwelo",
      "code": "GE",
      "area_sq_km": 69700,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Tbilisi",
      "capital_latitude": 41.69411,
      "capital_longitude": 44.83368,
      "currency": "Georgian Lari",
      "currency_local": "lari",
      "currency_code": "GEL",
      "currency_symbol": "₾",
      "currency_numeric": 981,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tetri",
      "languages": [
        {
          "name": "Georgian",
          "name_local": "ქართული",
          "iso_639_1": "ka",
          "iso_639_2": "kat",
          "iso_639_3": "kat"
        }
      ],
      "flag": "🇬🇪",
      "timezones": [
        "UTC+04:00"
      ],
      "borders": [
        "AM",
        "AZ",
        "RU",
        "TR"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 268,
      "iso_3166_1_alpha2": "GE",
      "iso_3166_1_alpha3": "GEO",
      "tld": "ge",
      "vehicle_code": "GE",
      "fips10": "GG",
      "un_locode": "GE",
      "stanag_1059": "GEO",
      "ioc": "GEO",
      "fifa": "GEO",
      "itu": "GEO",
      "uic": "28 GE",
      "maritime": 213,
      "mmc": 282
    }
  },
  {
    "locale": "kk-KZ",
    "language": {
      "name": "Kazakh",
      "name_local": "қазақ тілі",
      "iso_639_1": "kk",
      "iso_639_2": "kaz",
      "iso_639_3": "kaz",
      "countries": [
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        }
      ]
    },
    "country": {
      "name": "Kazakhstan",
      "name_local": "Қазақстан /  Qazaqstan",
      "code": "KZ",
      "area_sq_km": 2724900,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Nursultan",
      "capital_latitude": 51.1801,
      "capital_longitude": 71.44598,
      "currency": "Tenge",
      "currency_local": "Kazakhstani tenge",
      "currency_code": "KZT",
      "currency_symbol": "₸",
      "currency_numeric": 398,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tyin",
      "languages": [
        {
          "name": "Kazakh",
          "name_local": "қазақ тілі",
          "iso_639_1": "kk",
          "iso_639_2": "kaz",
          "iso_639_3": "kaz"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇰🇿",
      "timezones": [
        "UTC+05:00",
        "UTC+06:00"
      ],
      "borders": [
        "CN",
        "KG",
        "RU",
        "TM",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 398,
      "iso_3166_1_alpha2": "KZ",
      "iso_3166_1_alpha3": "KAZ",
      "tld": "kz",
      "vehicle_code": "KZ",
      "fips10": "KZ",
      "un_locode": "KZ",
      "stanag_1059": "KAZ",
      "ioc": "KAZ",
      "fifa": "KAZ",
      "itu": "KAZ",
      "uic": "27 KZ",
      "maritime": 436,
      "mmc": 401
    }
  },
  {
    "locale": "km-KH",
    "language": {
      "name": "Khmer",
      "name_local": "ខ្មែរ",
      "iso_639_1": "km",
      "iso_639_2": "khm",
      "iso_639_3": "khm",
      "countries": [
        {
          "name": "Cambodia",
          "name_local": "ព្រះរាជាណាចក្រកម្ពុជា / Preăh Réachéanachâk K",
          "code": "KH"
        }
      ]
    },
    "country": {
      "name": "Cambodia",
      "name_local": "ព្រះរាជាណាចក្រកម្ពុជា / Preăh Réachéanachâk K",
      "code": "KH",
      "area_sq_km": 181035,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Phnom Penh",
      "capital_latitude": 11.56245,
      "capital_longitude": 104.91601,
      "currency": "Cambodian Riel",
      "currency_local": "Cambodian riel",
      "currency_code": "KHR",
      "currency_symbol": "៛",
      "currency_numeric": 116,
      "currency_subunit_value": 10,
      "currency_subunit_name": "Karak",
      "languages": [
        {
          "name": "Khmer",
          "name_local": "ខ្មែរ",
          "iso_639_1": "km",
          "iso_639_2": "khm",
          "iso_639_3": "khm"
        }
      ],
      "flag": "🇰🇭",
      "timezones": [
        "UTC+07:00"
      ],
      "borders": [
        "LA",
        "TH",
        "VN"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 116,
      "iso_3166_1_alpha2": "KH",
      "iso_3166_1_alpha3": "KHM",
      "tld": "kh",
      "vehicle_code": "K",
      "fips10": "CB",
      "un_locode": "KH",
      "stanag_1059": "KHM",
      "ioc": "CAM",
      "fifa": "CAM",
      "itu": "CBG",
      "uic": "",
      "maritime": "514, 515",
      "mmc": 456
    }
  },
  {
    "locale": "rw-RW",
    "language": {
      "name": "Kinyarwanda",
      "name_local": "Ikinyarwanda",
      "iso_639_1": "rw",
      "iso_639_2": "kin",
      "iso_639_3": "kin",
      "countries": [
        {
          "name": "Rwanda",
          "name_local": "Rwanda / Urwanda",
          "code": "RW"
        }
      ]
    },
    "country": {
      "name": "Rwanda",
      "name_local": "Rwanda / Urwanda",
      "code": "RW",
      "area_sq_km": 26338,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Kigali",
      "capital_latitude": -1.94995,
      "capital_longitude": 30.05885,
      "currency": "Rwandan Franc",
      "currency_local": "Rwandan franc",
      "currency_code": "RWF",
      "currency_symbol": "Fr",
      "currency_numeric": 646,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Kinyarwanda",
          "name_local": "Ikinyarwanda",
          "iso_639_1": "rw",
          "iso_639_2": "kin",
          "iso_639_3": "kin"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        }
      ],
      "flag": "🇷🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BI",
        "CD",
        "TZ",
        "UG"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 646,
      "iso_3166_1_alpha2": "RW",
      "iso_3166_1_alpha3": "RWA",
      "tld": "rw",
      "vehicle_code": "RWA",
      "fips10": "RW",
      "un_locode": "RW",
      "stanag_1059": "RWA",
      "ioc": "RWA",
      "fifa": "RWA",
      "itu": "RRW",
      "uic": "",
      "maritime": 661,
      "mmc": 635
    }
  },
  {
    "locale": "ky-KG",
    "language": {
      "name": "Kyrgyz",
      "name_local": "Кыргызча",
      "iso_639_1": "ky",
      "iso_639_2": "kir",
      "iso_639_3": "kir",
      "countries": [
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        }
      ]
    },
    "country": {
      "name": "Kyrgyzstan",
      "name_local": "Кыргызстан / Kyrgyzstan",
      "code": "KG",
      "area_sq_km": 199951,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Bishkek",
      "capital_latitude": 42.87,
      "capital_longitude": 74.59,
      "currency": "Som",
      "currency_local": "Kyrgyzstani som",
      "currency_code": "KGS",
      "currency_symbol": "с",
      "currency_numeric": 417,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tyiyn",
      "languages": [
        {
          "name": "Kyrgyz",
          "name_local": "Кыргызча",
          "iso_639_1": "ky",
          "iso_639_2": "kir",
          "iso_639_3": "kir"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇰🇬",
      "timezones": [
        "UTC+06:00"
      ],
      "borders": [
        "CN",
        "KZ",
        "TJ",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 417,
      "iso_3166_1_alpha2": "KG",
      "iso_3166_1_alpha3": "KGZ",
      "tld": "kg",
      "vehicle_code": "KS",
      "fips10": "KG",
      "un_locode": "KG",
      "stanag_1059": "KGZ",
      "ioc": "KGZ",
      "fifa": "KGZ",
      "itu": "KGZ",
      "uic": "59 KS",
      "maritime": 451,
      "mmc": 437
    }
  },
  {
    "locale": "kg-CD",
    "language": {
      "name": "Kongo",
      "name_local": "Kikongo",
      "iso_639_1": "kg",
      "iso_639_2": "kon",
      "iso_639_3": "kon",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        }
      ]
    },
    "country": {
      "name": "Democratic Republic of the Congo",
      "name_local": "République Démocratique du Congo",
      "code": "CD",
      "area_sq_km": 2344858,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Kinshasa",
      "capital_latitude": -4.32758,
      "capital_longitude": 15.31357,
      "currency": "Congolais Franc",
      "currency_local": "Congolese franc",
      "currency_code": "CDF",
      "currency_symbol": "FC",
      "currency_numeric": 976,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        },
        {
          "name": "Kongo",
          "name_local": "Kikongo",
          "iso_639_1": "kg",
          "iso_639_2": "kon",
          "iso_639_3": "kon"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "Luba-Katanga",
          "name_local": "Tshiluba",
          "iso_639_1": "lu",
          "iso_639_2": "lub",
          "iso_639_3": "lub"
        }
      ],
      "flag": "🇨🇩",
      "timezones": [
        "UTC+01:00",
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BI",
        "CF",
        "CG",
        "RW",
        "SS",
        "TZ",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 180,
      "iso_3166_1_alpha2": "CD",
      "iso_3166_1_alpha3": "COD",
      "tld": "cd",
      "vehicle_code": "CGO",
      "fips10": "CG",
      "un_locode": "CD",
      "stanag_1059": "COD",
      "ioc": "COD",
      "fifa": "COD",
      "itu": "COD",
      "uic": "CD",
      "maritime": 676,
      "mmc": 630
    }
  },
  {
    "locale": "ko-KP",
    "language": {
      "name": "Korean",
      "name_local": "한국어",
      "iso_639_1": "ko",
      "iso_639_2": "kor",
      "iso_639_3": "kor",
      "countries": [
        {
          "name": "North Korea",
          "name_local": "Choson Minjujuui In´min Konghwaguk (Bukhan)",
          "code": "KP"
        },
        {
          "name": "South Korea",
          "name_local": "대한민국 / 大韓民國",
          "code": "KR"
        }
      ]
    },
    "country": {
      "name": "North Korea",
      "name_local": "Choson Minjujuui In´min Konghwaguk (Bukhan)",
      "code": "KP",
      "area_sq_km": 120538,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Pyongyang",
      "capital_latitude": 39.03385,
      "capital_longitude": 125.75432,
      "currency": "North Korean Won",
      "currency_local": "North Korean won",
      "currency_code": "KPW",
      "currency_symbol": "₩",
      "currency_numeric": 408,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Chon",
      "languages": [
        {
          "name": "Korean",
          "name_local": "한국어",
          "iso_639_1": "ko",
          "iso_639_2": "kor",
          "iso_639_3": "kor"
        }
      ],
      "flag": "🇰🇵",
      "timezones": [
        "UTC+09:00"
      ],
      "borders": [
        "CN",
        "KR",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "###-###",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 408,
      "iso_3166_1_alpha2": "KP",
      "iso_3166_1_alpha3": "PRK",
      "tld": "kp",
      "vehicle_code": "KP",
      "fips10": "KN",
      "un_locode": "KP",
      "stanag_1059": "PRK",
      "ioc": "PRK",
      "fifa": "PRK",
      "itu": "KRE",
      "uic": "30 PRK",
      "maritime": 445,
      "mmc": 467
    }
  },
  {
    "locale": "ko-KR",
    "language": {
      "name": "Korean",
      "name_local": "한국어",
      "iso_639_1": "ko",
      "iso_639_2": "kor",
      "iso_639_3": "kor",
      "countries": [
        {
          "name": "North Korea",
          "name_local": "Choson Minjujuui In´min Konghwaguk (Bukhan)",
          "code": "KP"
        },
        {
          "name": "South Korea",
          "name_local": "대한민국 / 大韓民國",
          "code": "KR"
        }
      ]
    },
    "country": {
      "name": "South Korea",
      "name_local": "대한민국 / 大韓民國",
      "code": "KR",
      "area_sq_km": 100210,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Seoul",
      "capital_latitude": 37.566,
      "capital_longitude": 126.9784,
      "currency": "South Korean Won",
      "currency_local": "South Korean won",
      "currency_code": "KRW",
      "currency_symbol": "₩",
      "currency_numeric": 410,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Chon",
      "languages": [
        {
          "name": "Korean",
          "name_local": "한국어",
          "iso_639_1": "ko",
          "iso_639_2": "kor",
          "iso_639_3": "kor"
        }
      ],
      "flag": "🇰🇷",
      "timezones": [
        "UTC+09:00"
      ],
      "borders": [
        "KP"
      ],
      "is_landlocked": false,
      "postal_code_format": "SEOUL ###-###",
      "postal_code_regex": "^(?:SEOUL)*(\\d{6})$",
      "iso_3166_1_numeric": 410,
      "iso_3166_1_alpha2": "KR",
      "iso_3166_1_alpha3": "KOR",
      "tld": "kr",
      "vehicle_code": "ROK",
      "fips10": "KS",
      "un_locode": "KR",
      "stanag_1059": "KOR",
      "ioc": "KOR",
      "fifa": "KOR",
      "itu": "KOR",
      "uic": "61 ROK",
      "maritime": "440, 441",
      "mmc": 450
    }
  },
  {
    "locale": "kun-ER",
    "language": {
      "name": "Kunama",
      "name_local": "Kunama",
      "iso_639_1": "",
      "iso_639_2": "kun",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "ku-IQ",
    "language": {
      "name": "Kurdish",
      "name_local": "Kurdî",
      "iso_639_1": "ku",
      "iso_639_2": "kur",
      "iso_639_3": "kur",
      "countries": [
        {
          "name": "Iraq",
          "name_local": "جمهورية العراق / Al-´Iraq",
          "code": "IQ"
        }
      ]
    },
    "country": {
      "name": "Iraq",
      "name_local": "جمهورية العراق / Al-´Iraq",
      "code": "IQ",
      "area_sq_km": 438317,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Baghdad",
      "capital_latitude": 33.34058,
      "capital_longitude": 44.40088,
      "currency": "Iraqi Dinar",
      "currency_local": "Iraqi dinar",
      "currency_code": "IQD",
      "currency_symbol": "ع.د",
      "currency_numeric": 368,
      "currency_subunit_value": 1000,
      "currency_subunit_name": "Fils",
      "languages": [
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "Kurdish",
          "name_local": "Kurdî",
          "iso_639_1": "ku",
          "iso_639_2": "kur",
          "iso_639_3": "kur"
        }
      ],
      "flag": "🇮🇶",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "IR",
        "JO",
        "KW",
        "SA",
        "SY",
        "TR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 368,
      "iso_3166_1_alpha2": "IQ",
      "iso_3166_1_alpha3": "IRQ",
      "tld": "iq",
      "vehicle_code": "IRQ",
      "fips10": "IZ",
      "un_locode": "IQ",
      "stanag_1059": "IRQ",
      "ioc": "IRQ",
      "fifa": "IRQ",
      "itu": "IRQ",
      "uic": "99 IRQ",
      "maritime": 425,
      "mmc": 418
    }
  },
  {
    "locale": "lo-LA",
    "language": {
      "name": "Lao",
      "name_local": "ພາສາລາວ",
      "iso_639_1": "lo",
      "iso_639_2": "lao",
      "iso_639_3": "lao",
      "countries": [
        {
          "name": "Laos",
          "name_local": "Lao",
          "code": "LA"
        }
      ]
    },
    "country": {
      "name": "Laos",
      "name_local": "Lao",
      "code": "LA",
      "area_sq_km": 236800,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Vientiane",
      "capital_latitude": 17.96667,
      "capital_longitude": 102.6,
      "currency": "Kip",
      "currency_local": "Lao kip",
      "currency_code": "LAK",
      "currency_symbol": "₭",
      "currency_numeric": 418,
      "currency_subunit_value": 100,
      "currency_subunit_name": "At",
      "languages": [
        {
          "name": "Lao",
          "name_local": "ພາສາລາວ",
          "iso_639_1": "lo",
          "iso_639_2": "lao",
          "iso_639_3": "lao"
        }
      ],
      "flag": "🇱🇦",
      "timezones": [
        "UTC+07:00"
      ],
      "borders": [
        "MM",
        "KH",
        "CN",
        "TH",
        "VN"
      ],
      "is_landlocked": true,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 418,
      "iso_3166_1_alpha2": "LA",
      "iso_3166_1_alpha3": "LAO",
      "tld": "la",
      "vehicle_code": "LAO",
      "fips10": "LA",
      "un_locode": "LA",
      "stanag_1059": "LAO",
      "ioc": "LAO",
      "fifa": "LAO",
      "itu": "LAO",
      "uic": "",
      "maritime": 531,
      "mmc": 457
    }
  },
  {
    "locale": "la-VA",
    "language": {
      "name": "Latin",
      "name_local": "latine",
      "iso_639_1": "la",
      "iso_639_2": "lat",
      "iso_639_3": "lat",
      "countries": [
        {
          "name": "Vatican City",
          "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
          "code": "VA"
        }
      ]
    },
    "country": {
      "name": "Vatican City",
      "name_local": "Vaticanæ / Santa Sede / Città del Vaticano",
      "code": "VA",
      "area_sq_km": 0.44,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Vatican City",
      "capital_latitude": 41.902226,
      "capital_longitude": 12.450713,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Latin",
          "name_local": "latine",
          "iso_639_1": "la",
          "iso_639_2": "lat",
          "iso_639_3": "lat"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "French",
          "name_local": "Français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇻🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "IT"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 336,
      "iso_3166_1_alpha2": "VA",
      "iso_3166_1_alpha3": "VAT",
      "tld": "va",
      "vehicle_code": "V",
      "fips10": "VT",
      "un_locode": "VA",
      "stanag_1059": "VAT",
      "ioc": "",
      "fifa": "",
      "itu": "CVA",
      "uic": "",
      "maritime": 208,
      "mmc": 225
    }
  },
  {
    "locale": "lv-LV",
    "language": {
      "name": "Latvian",
      "name_local": "latviešu valoda",
      "iso_639_1": "lv",
      "iso_639_2": "lav",
      "iso_639_3": "lav",
      "countries": [
        {
          "name": "Latvia",
          "name_local": "Latvija",
          "code": "LV"
        }
      ]
    },
    "country": {
      "name": "Latvia",
      "name_local": "Latvija",
      "code": "LV",
      "area_sq_km": 64559,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Riga",
      "capital_latitude": 56.946,
      "capital_longitude": 24.10589,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Latvian",
          "name_local": "latviešu valoda",
          "iso_639_1": "lv",
          "iso_639_2": "lav",
          "iso_639_3": "lav"
        }
      ],
      "flag": "🇱🇻",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BY",
        "EE",
        "LT",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "LV-####",
      "postal_code_regex": "^(?:LV)*(\\d{4})$",
      "iso_3166_1_numeric": 428,
      "iso_3166_1_alpha2": "LV",
      "iso_3166_1_alpha3": "LVA",
      "tld": "lv",
      "vehicle_code": "LV",
      "fips10": "LG",
      "un_locode": "LV",
      "stanag_1059": "LVA",
      "ioc": "LAT",
      "fifa": "LVA",
      "itu": "LVA",
      "uic": "25 LV",
      "maritime": 275,
      "mmc": 247
    }
  },
  {
    "locale": "ln-CD",
    "language": {
      "name": "Lingala",
      "name_local": "Lingála",
      "iso_639_1": "ln",
      "iso_639_2": "lin",
      "iso_639_3": "lin",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        }
      ]
    },
    "country": {
      "name": "Democratic Republic of the Congo",
      "name_local": "République Démocratique du Congo",
      "code": "CD",
      "area_sq_km": 2344858,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Kinshasa",
      "capital_latitude": -4.32758,
      "capital_longitude": 15.31357,
      "currency": "Congolais Franc",
      "currency_local": "Congolese franc",
      "currency_code": "CDF",
      "currency_symbol": "FC",
      "currency_numeric": 976,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        },
        {
          "name": "Kongo",
          "name_local": "Kikongo",
          "iso_639_1": "kg",
          "iso_639_2": "kon",
          "iso_639_3": "kon"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "Luba-Katanga",
          "name_local": "Tshiluba",
          "iso_639_1": "lu",
          "iso_639_2": "lub",
          "iso_639_3": "lub"
        }
      ],
      "flag": "🇨🇩",
      "timezones": [
        "UTC+01:00",
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BI",
        "CF",
        "CG",
        "RW",
        "SS",
        "TZ",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 180,
      "iso_3166_1_alpha2": "CD",
      "iso_3166_1_alpha3": "COD",
      "tld": "cd",
      "vehicle_code": "CGO",
      "fips10": "CG",
      "un_locode": "CD",
      "stanag_1059": "COD",
      "ioc": "COD",
      "fifa": "COD",
      "itu": "COD",
      "uic": "CD",
      "maritime": 676,
      "mmc": 630
    }
  },
  {
    "locale": "ln-CG",
    "language": {
      "name": "Lingala",
      "name_local": "Lingála",
      "iso_639_1": "ln",
      "iso_639_2": "lin",
      "iso_639_3": "lin",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Republic of the Congo",
          "name_local": "Congo",
          "code": "CG"
        }
      ]
    },
    "country": {
      "name": "Republic of the Congo",
      "name_local": "Congo",
      "code": "CG",
      "area_sq_km": 342000,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Brazzaville",
      "capital_latitude": -4.26613,
      "capital_longitude": 15.28318,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        }
      ],
      "flag": "🇨🇬",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AO",
        "CM",
        "CF",
        "CD",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 178,
      "iso_3166_1_alpha2": "CG",
      "iso_3166_1_alpha3": "COG",
      "tld": "cg",
      "vehicle_code": "RCB",
      "fips10": "CF",
      "un_locode": "CG",
      "stanag_1059": "COG",
      "ioc": "CGO",
      "fifa": "CGO",
      "itu": "COG",
      "uic": "",
      "maritime": 615,
      "mmc": 629
    }
  },
  {
    "locale": "lt-LT",
    "language": {
      "name": "Lithuanian",
      "name_local": "lietuvių kalba",
      "iso_639_1": "lt",
      "iso_639_2": "lit",
      "iso_639_3": "lit",
      "countries": [
        {
          "name": "Lithuania",
          "name_local": "Lietuva",
          "code": "LT"
        }
      ]
    },
    "country": {
      "name": "Lithuania",
      "name_local": "Lietuva",
      "code": "LT",
      "area_sq_km": 65300,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Vilnius",
      "capital_latitude": 54.68916,
      "capital_longitude": 25.2798,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Lithuanian",
          "name_local": "lietuvių kalba",
          "iso_639_1": "lt",
          "iso_639_2": "lit",
          "iso_639_3": "lit"
        }
      ],
      "flag": "🇱🇹",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BY",
        "LV",
        "PL",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "LT-#####",
      "postal_code_regex": "^(?:LT)*(\\d{5})$",
      "iso_3166_1_numeric": 440,
      "iso_3166_1_alpha2": "LT",
      "iso_3166_1_alpha3": "LTU",
      "tld": "lt",
      "vehicle_code": "LT",
      "fips10": "LH",
      "un_locode": "LT",
      "stanag_1059": "LTU",
      "ioc": "LTU",
      "fifa": "LTU",
      "itu": "LTU",
      "uic": "24 LT",
      "maritime": 277,
      "mmc": 246
    }
  },
  {
    "locale": "lb-LU",
    "language": {
      "name": "Luxembourgish",
      "name_local": "Lëtzebuergesch",
      "iso_639_1": "lb",
      "iso_639_2": "ltz",
      "iso_639_3": "ltz",
      "countries": [
        {
          "name": "Luxembourg",
          "name_local": "Luxembourg/Lëtzebuerg",
          "code": "LU"
        }
      ]
    },
    "country": {
      "name": "Luxembourg",
      "name_local": "Luxembourg/Lëtzebuerg",
      "code": "LU",
      "area_sq_km": 2586,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Luxembourg",
      "capital_latitude": 49.61167,
      "capital_longitude": 6.13,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "Luxembourgish",
          "name_local": "Lëtzebuergesch",
          "iso_639_1": "lb",
          "iso_639_2": "ltz",
          "iso_639_3": "ltz"
        }
      ],
      "flag": "🇱🇺",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BE",
        "FR",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 442,
      "iso_3166_1_alpha2": "LU",
      "iso_3166_1_alpha3": "LUX",
      "tld": "lu",
      "vehicle_code": "L",
      "fips10": "LU",
      "un_locode": "LU",
      "stanag_1059": "LUX",
      "ioc": "LUX",
      "fifa": "LUX",
      "itu": "LUX",
      "uic": "82 L",
      "maritime": 253,
      "mmc": 270
    }
  },
  {
    "locale": "lu-CD",
    "language": {
      "name": "Luba-Katanga",
      "name_local": "Tshiluba",
      "iso_639_1": "lu",
      "iso_639_2": "lub",
      "iso_639_3": "lub",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        }
      ]
    },
    "country": {
      "name": "Democratic Republic of the Congo",
      "name_local": "République Démocratique du Congo",
      "code": "CD",
      "area_sq_km": 2344858,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Kinshasa",
      "capital_latitude": -4.32758,
      "capital_longitude": 15.31357,
      "currency": "Congolais Franc",
      "currency_local": "Congolese franc",
      "currency_code": "CDF",
      "currency_symbol": "FC",
      "currency_numeric": 976,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        },
        {
          "name": "Kongo",
          "name_local": "Kikongo",
          "iso_639_1": "kg",
          "iso_639_2": "kon",
          "iso_639_3": "kon"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "Luba-Katanga",
          "name_local": "Tshiluba",
          "iso_639_1": "lu",
          "iso_639_2": "lub",
          "iso_639_3": "lub"
        }
      ],
      "flag": "🇨🇩",
      "timezones": [
        "UTC+01:00",
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BI",
        "CF",
        "CG",
        "RW",
        "SS",
        "TZ",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 180,
      "iso_3166_1_alpha2": "CD",
      "iso_3166_1_alpha3": "COD",
      "tld": "cd",
      "vehicle_code": "CGO",
      "fips10": "CG",
      "un_locode": "CD",
      "stanag_1059": "COD",
      "ioc": "COD",
      "fifa": "COD",
      "itu": "COD",
      "uic": "CD",
      "maritime": 676,
      "mmc": 630
    }
  },
  {
    "locale": "mh-MH",
    "language": {
      "name": "Marshallese",
      "name_local": "Kajin M̧ajeļ",
      "iso_639_1": "mh",
      "iso_639_2": "mah",
      "iso_639_3": "mah",
      "countries": [
        {
          "name": "Marshall Islands",
          "name_local": "Marshall Islands/Majol",
          "code": "MH"
        }
      ]
    },
    "country": {
      "name": "Marshall Islands",
      "name_local": "Marshall Islands/Majol",
      "code": "MH",
      "area_sq_km": 181,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Majuro",
      "capital_latitude": 7.08971,
      "capital_longitude": 171.38027,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Marshallese",
          "name_local": "Kajin M̧ajeļ",
          "iso_639_1": "mh",
          "iso_639_2": "mah",
          "iso_639_3": "mah"
        }
      ],
      "flag": "🇲🇭",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 584,
      "iso_3166_1_alpha2": "MH",
      "iso_3166_1_alpha3": "MHL",
      "tld": "mh",
      "vehicle_code": "MH",
      "fips10": "RM",
      "un_locode": "MH",
      "stanag_1059": "MHL",
      "ioc": "MHL",
      "fifa": "",
      "itu": "MHL",
      "uic": "",
      "maritime": 538,
      "mmc": 551
    }
  },
  {
    "locale": "mk-MK",
    "language": {
      "name": "Macedonian",
      "name_local": "македонски јазик",
      "iso_639_1": "mk",
      "iso_639_2": "mkd",
      "iso_639_3": "mkd",
      "countries": [
        {
          "name": "North Macedonia",
          "name_local": "Северна Македонија / Maqedonisë së Veriut",
          "code": "MK"
        }
      ]
    },
    "country": {
      "name": "North Macedonia",
      "name_local": "Северна Македонија / Maqedonisë së Veriut",
      "code": "MK",
      "area_sq_km": 25713,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Skopje",
      "capital_latitude": 41.99646,
      "capital_longitude": 21.43141,
      "currency": "Denar",
      "currency_local": "denar",
      "currency_code": "MKD",
      "currency_symbol": "den",
      "currency_numeric": 807,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Deni",
      "languages": [
        {
          "name": "Macedonian",
          "name_local": "македонски јазик",
          "iso_639_1": "mk",
          "iso_639_2": "mkd",
          "iso_639_3": "mkd"
        }
      ],
      "flag": "🇲🇰",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "BG",
        "GR",
        "XK",
        "RS"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 807,
      "iso_3166_1_alpha2": "MK",
      "iso_3166_1_alpha3": "MKD",
      "tld": "mk",
      "vehicle_code": "MK",
      "fips10": "MK",
      "un_locode": "MK",
      "stanag_1059": "FYR",
      "ioc": "MKD",
      "fifa": "MKD",
      "itu": "MKD",
      "uic": "65 MK",
      "maritime": 274,
      "mmc": 294
    }
  },
  {
    "locale": "mg-MG",
    "language": {
      "name": "Malagasy",
      "name_local": "fiteny malagasy",
      "iso_639_1": "mg",
      "iso_639_2": "mlg",
      "iso_639_3": "mlg",
      "countries": [
        {
          "name": "Madagascar",
          "name_local": "Madagasikara/Madagascar",
          "code": "MG"
        }
      ]
    },
    "country": {
      "name": "Madagascar",
      "name_local": "Madagasikara/Madagascar",
      "code": "MG",
      "area_sq_km": 587041,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Antananarivo",
      "capital_latitude": -18.91368,
      "capital_longitude": 47.53613,
      "currency": "Malagasy Ariary",
      "currency_local": "Malagasy ariary",
      "currency_code": "MGA",
      "currency_symbol": "Ar",
      "currency_numeric": "",
      "currency_subunit_value": 5,
      "currency_subunit_name": "Iraimbilanja",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Malagasy",
          "name_local": "fiteny malagasy",
          "iso_639_1": "mg",
          "iso_639_2": "mlg",
          "iso_639_3": "mlg"
        }
      ],
      "flag": "🇲🇬",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 450,
      "iso_3166_1_alpha2": "MG",
      "iso_3166_1_alpha3": "MDG",
      "tld": "mg",
      "vehicle_code": "RM",
      "fips10": "MA",
      "un_locode": "MG",
      "stanag_1059": "MDG",
      "ioc": "MAD",
      "fifa": "MAD",
      "itu": "MDG",
      "uic": "",
      "maritime": 647,
      "mmc": 646
    }
  },
  {
    "locale": "mt-MT",
    "language": {
      "name": "Maltese",
      "name_local": "Malti",
      "iso_639_1": "mt",
      "iso_639_2": "mlt",
      "iso_639_3": "mlt",
      "countries": [
        {
          "name": "Malta",
          "name_local": "Malta",
          "code": "MT"
        }
      ]
    },
    "country": {
      "name": "Malta",
      "name_local": "Malta",
      "code": "MT",
      "area_sq_km": 316,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Valletta",
      "capital_latitude": 35.89972,
      "capital_longitude": 14.51472,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Maltese",
          "name_local": "Malti",
          "iso_639_1": "mt",
          "iso_639_2": "mlt",
          "iso_639_3": "mlt"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇲🇹",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "@@@ ###|@@@ ##",
      "postal_code_regex": "^([A-Z]{3}\\d{2}\\d?)$",
      "iso_3166_1_numeric": 470,
      "iso_3166_1_alpha2": "MT",
      "iso_3166_1_alpha3": "MLT",
      "tld": "mt",
      "vehicle_code": "M",
      "fips10": "MT",
      "un_locode": "MT",
      "stanag_1059": "MLT",
      "ioc": "MLT",
      "fifa": "MLT",
      "itu": "MLT",
      "uic": "",
      "maritime": "215, 229, 248, 249, 256",
      "mmc": 278
    }
  },
  {
    "locale": "mn-MN",
    "language": {
      "name": "Mongolian",
      "name_local": "Монгол хэл",
      "iso_639_1": "mn",
      "iso_639_2": "mon",
      "iso_639_3": "mon",
      "countries": [
        {
          "name": "Mongolia",
          "name_local": "Mongol Uls",
          "code": "MN"
        }
      ]
    },
    "country": {
      "name": "Mongolia",
      "name_local": "Mongol Uls",
      "code": "MN",
      "area_sq_km": 1564110,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Ulaanbaatar",
      "capital_latitude": 47.90771,
      "capital_longitude": 106.88324,
      "currency": "Tugrik",
      "currency_local": "Mongolian tögrög",
      "currency_code": "MNT",
      "currency_symbol": "₮",
      "currency_numeric": 496,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Möngö",
      "languages": [
        {
          "name": "Mongolian",
          "name_local": "Монгол хэл",
          "iso_639_1": "mn",
          "iso_639_2": "mon",
          "iso_639_3": "mon"
        }
      ],
      "flag": "🇲🇳",
      "timezones": [
        "UTC+07:00",
        "UTC+08:00"
      ],
      "borders": [
        "CN",
        "RU"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 496,
      "iso_3166_1_alpha2": "MN",
      "iso_3166_1_alpha3": "MNG",
      "tld": "mn",
      "vehicle_code": "MGL",
      "fips10": "MG",
      "un_locode": "MN",
      "stanag_1059": "MNG",
      "ioc": "MGL",
      "fifa": "MNG",
      "itu": "MNG",
      "uic": "31 MGL",
      "maritime": 457,
      "mmc": 428
    }
  },
  {
    "locale": "mi-NZ",
    "language": {
      "name": "Māori",
      "name_local": "te reo Māori",
      "iso_639_1": "mi",
      "iso_639_2": "mri",
      "iso_639_3": "mri",
      "countries": [
        {
          "name": "New Zealand",
          "name_local": "New Zealand/Aotearoa",
          "code": "NZ"
        }
      ]
    },
    "country": {
      "name": "New Zealand",
      "name_local": "New Zealand/Aotearoa",
      "code": "NZ",
      "area_sq_km": 270467,
      "continent": "Australia",
      "region": "Australia and New Zealand",
      "capital_name": "Wellington",
      "capital_latitude": -41.28664,
      "capital_longitude": 174.77557,
      "currency": "New Zealand Dollar",
      "currency_local": "New Zealand dollar",
      "currency_code": "NZD",
      "currency_symbol": "$",
      "currency_numeric": 554,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Māori",
          "name_local": "te reo Māori",
          "iso_639_1": "mi",
          "iso_639_2": "mri",
          "iso_639_3": "mri"
        }
      ],
      "flag": "🇳🇿",
      "timezones": [
        "UTC-11:00",
        "UTC-10:00",
        "UTC+12:00",
        "UTC+12:45",
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 554,
      "iso_3166_1_alpha2": "NZ",
      "iso_3166_1_alpha3": "NZL",
      "tld": "nz",
      "vehicle_code": "NZ",
      "fips10": "NZ",
      "un_locode": "NZ",
      "stanag_1059": "NZL",
      "ioc": "NZL",
      "fifa": "NZL",
      "itu": "NZL",
      "uic": "64 NZ",
      "maritime": 512,
      "mmc": 530
    }
  },
  {
    "locale": "ms-BN",
    "language": {
      "name": "Malay",
      "name_local": "bahasa Melayu",
      "iso_639_1": "ms",
      "iso_639_2": "msa",
      "iso_639_3": "msa",
      "countries": [
        {
          "name": "Brunei",
          "name_local": "نݢارا بروني دار السلام",
          "code": "BN"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        }
      ]
    },
    "country": {
      "name": "Brunei",
      "name_local": "نݢارا بروني دار السلام",
      "code": "BN",
      "area_sq_km": 5765,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Bandar Seri Begawan",
      "capital_latitude": 4.94029,
      "capital_longitude": 114.94806,
      "currency": "Brunei Dollar",
      "currency_local": "Brunei dollar",
      "currency_code": "BND",
      "currency_symbol": "$",
      "currency_numeric": 96,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Malay",
          "name_local": "bahasa Melayu",
          "iso_639_1": "ms",
          "iso_639_2": "msa",
          "iso_639_3": "msa"
        }
      ],
      "flag": "🇧🇳",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "MY"
      ],
      "is_landlocked": false,
      "postal_code_format": "@@####",
      "postal_code_regex": "^([A-Z]{2}\\d{4})$",
      "iso_3166_1_numeric": 96,
      "iso_3166_1_alpha2": "BN",
      "iso_3166_1_alpha3": "BRN",
      "tld": "bn",
      "vehicle_code": "BRU",
      "fips10": "BX",
      "un_locode": "BN",
      "stanag_1059": "BRN",
      "ioc": "BRU",
      "fifa": "BRU",
      "itu": "BRU",
      "uic": "",
      "maritime": 508,
      "mmc": 528
    }
  },
  {
    "locale": "ms-SG",
    "language": {
      "name": "Malay",
      "name_local": "bahasa Melayu",
      "iso_639_1": "ms",
      "iso_639_2": "msa",
      "iso_639_3": "msa",
      "countries": [
        {
          "name": "Brunei",
          "name_local": "نݢارا بروني دار السلام",
          "code": "BN"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        }
      ]
    },
    "country": {
      "name": "Singapore",
      "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
      "code": "SG",
      "area_sq_km": 710,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Singapore",
      "capital_latitude": 1.28967,
      "capital_longitude": 103.85007,
      "currency": "Singapore Dollar",
      "currency_local": "Singapore dollar",
      "currency_code": "SGD",
      "currency_symbol": "$",
      "currency_numeric": 702,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Malay",
          "name_local": "bahasa Melayu",
          "iso_639_1": "ms",
          "iso_639_2": "msa",
          "iso_639_3": "msa"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇸🇬",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 702,
      "iso_3166_1_alpha2": "SG",
      "iso_3166_1_alpha3": "SGP",
      "tld": "sg",
      "vehicle_code": "SGP",
      "fips10": "SN",
      "un_locode": "SG",
      "stanag_1059": "SGP",
      "ioc": "SGP",
      "fifa": "SIN",
      "itu": "SNG",
      "uic": "",
      "maritime": "563, 564, 565, 566",
      "mmc": 525
    }
  },
  {
    "locale": "my-MM",
    "language": {
      "name": "Burmese",
      "name_local": "ဗမာစာ",
      "iso_639_1": "my",
      "iso_639_2": "mya",
      "iso_639_3": "mya",
      "countries": [
        {
          "name": "Myanmar",
          "name_local": "Myanma Pye",
          "code": "MM"
        }
      ]
    },
    "country": {
      "name": "Myanmar",
      "name_local": "Myanma Pye",
      "code": "MM",
      "area_sq_km": 676578,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Nay Pyi Taw",
      "capital_latitude": 19.745,
      "capital_longitude": 96.12972,
      "currency": "Kyat",
      "currency_local": "Burmese kyat",
      "currency_code": "MMK",
      "currency_symbol": "Ks",
      "currency_numeric": 104,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Pyas",
      "languages": [
        {
          "name": "Burmese",
          "name_local": "ဗမာစာ",
          "iso_639_1": "my",
          "iso_639_2": "mya",
          "iso_639_3": "mya"
        }
      ],
      "flag": "🇲🇲",
      "timezones": [
        "UTC+06:30"
      ],
      "borders": [
        "BD",
        "CN",
        "IN",
        "LA",
        "TH"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 104,
      "iso_3166_1_alpha2": "MM",
      "iso_3166_1_alpha3": "MMR",
      "tld": "mm",
      "vehicle_code": "MYA",
      "fips10": "BM",
      "un_locode": "MM",
      "stanag_1059": "MMR",
      "ioc": "MYA",
      "fifa": "MYA",
      "itu": "BRM",
      "uic": "",
      "maritime": 506,
      "mmc": 414
    }
  },
  {
    "locale": "na-NR",
    "language": {
      "name": "Nauruan",
      "name_local": "Dorerin Naoero",
      "iso_639_1": "na",
      "iso_639_2": "nau",
      "iso_639_3": "nau",
      "countries": [
        {
          "name": "Nauru",
          "name_local": "Naoero/Nauru",
          "code": "NR"
        }
      ]
    },
    "country": {
      "name": "Nauru",
      "name_local": "Naoero/Nauru",
      "code": "NR",
      "area_sq_km": 21,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Yaren",
      "capital_latitude": -0.55085,
      "capital_longitude": 166.9252,
      "currency": "Australian Dollar",
      "currency_local": "Australian dollar",
      "currency_code": "AUD",
      "currency_symbol": "$",
      "currency_numeric": 36,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Nauruan",
          "name_local": "Dorerin Naoero",
          "iso_639_1": "na",
          "iso_639_2": "nau",
          "iso_639_3": "nau"
        }
      ],
      "flag": "🇳🇷",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 520,
      "iso_3166_1_alpha2": "NR",
      "iso_3166_1_alpha3": "NRU",
      "tld": "nr",
      "vehicle_code": "NAU",
      "fips10": "NR",
      "un_locode": "NR",
      "stanag_1059": "NRU",
      "ioc": "NRU",
      "fifa": "",
      "itu": "NRU",
      "uic": "",
      "maritime": 544,
      "mmc": 536
    }
  },
  {
    "locale": "nr-ZA",
    "language": {
      "name": "Southern Ndebele",
      "name_local": "isiNdebele",
      "iso_639_1": "nr",
      "iso_639_2": "nbl",
      "iso_639_3": "nbl",
      "countries": [
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "nd-ZW",
    "language": {
      "name": "Northern Ndebele",
      "name_local": "isiNdebele",
      "iso_639_1": "nd",
      "iso_639_2": "nde",
      "iso_639_3": "nde",
      "countries": [
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        }
      ]
    },
    "country": {
      "name": "Zimbabwe",
      "name_local": "Zimbabwe",
      "code": "ZW",
      "area_sq_km": 390757,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Harare",
      "capital_latitude": -17.82772,
      "capital_longitude": 31.05337,
      "currency": "Zimbabwe Dollar",
      "currency_local": "Zimbabwean dollar",
      "currency_code": "ZWL",
      "currency_symbol": "$",
      "currency_numeric": 932,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Shona",
          "name_local": "chiShona",
          "iso_639_1": "sn",
          "iso_639_2": "sna",
          "iso_639_3": "sna"
        },
        {
          "name": "Northern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nd",
          "iso_639_2": "nde",
          "iso_639_3": "nde"
        }
      ],
      "flag": "🇿🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "MZ",
        "ZA",
        "ZM"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 716,
      "iso_3166_1_alpha2": "ZW",
      "iso_3166_1_alpha3": "ZWE",
      "tld": "zw",
      "vehicle_code": "ZW",
      "fips10": "ZI",
      "un_locode": "ZW",
      "stanag_1059": "ZWE",
      "ioc": "ZIM",
      "fifa": "ZIM",
      "itu": "ZWE",
      "uic": "",
      "maritime": 679,
      "mmc": 648
    }
  },
  {
    "locale": "ne-NP",
    "language": {
      "name": "Nepali",
      "name_local": "नेपाली",
      "iso_639_1": "ne",
      "iso_639_2": "nep",
      "iso_639_3": "nep",
      "countries": [
        {
          "name": "Nepal",
          "name_local": "Nepal",
          "code": "NP"
        }
      ]
    },
    "country": {
      "name": "Nepal",
      "name_local": "Nepal",
      "code": "NP",
      "area_sq_km": 147181,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Kathmandu",
      "capital_latitude": 27.70169,
      "capital_longitude": 85.3206,
      "currency": "Nepalese Rupee",
      "currency_local": "Nepalese rupee",
      "currency_code": "NPR",
      "currency_symbol": "₨",
      "currency_numeric": 524,
      "currency_subunit_value": 2,
      "currency_subunit_name": "Mohur",
      "languages": [
        {
          "name": "Nepali",
          "name_local": "नेपाली",
          "iso_639_1": "ne",
          "iso_639_2": "nep",
          "iso_639_3": "nep"
        }
      ],
      "flag": "🇳🇵",
      "timezones": [
        "UTC+05:45"
      ],
      "borders": [
        "CN",
        "IN"
      ],
      "is_landlocked": true,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 524,
      "iso_3166_1_alpha2": "NP",
      "iso_3166_1_alpha3": "NPL",
      "tld": "np",
      "vehicle_code": "NEP",
      "fips10": "NP",
      "un_locode": "NP",
      "stanag_1059": "NPL",
      "ioc": "NEP",
      "fifa": "NEP",
      "itu": "NPL",
      "uic": "",
      "maritime": 459,
      "mmc": 429
    }
  },
  {
    "locale": "nl-AW",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Aruba",
      "name_local": "Aruba",
      "code": "AW",
      "area_sq_km": 180,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Oranjestad",
      "capital_latitude": 12.52398,
      "capital_longitude": -70.02703,
      "currency": "Guilder",
      "currency_local": "Aruban florin",
      "currency_code": "AWG",
      "currency_symbol": "ƒ",
      "currency_numeric": 533,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "(Eastern) Punjabi",
          "name_local": "ਪੰਜਾਬੀ",
          "iso_639_1": "pa",
          "iso_639_2": "pan",
          "iso_639_3": "pan"
        }
      ],
      "flag": "🇦🇼",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 533,
      "iso_3166_1_alpha2": "AW",
      "iso_3166_1_alpha3": "ABW",
      "tld": "aw",
      "vehicle_code": "ARU",
      "fips10": "AA",
      "un_locode": "AW",
      "stanag_1059": "ABW",
      "ioc": "ARU",
      "fifa": "ARU",
      "itu": "ABW",
      "uic": "",
      "maritime": 307,
      "mmc": 363
    }
  },
  {
    "locale": "nl-BE",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Belgium",
      "name_local": "België / Belgique",
      "code": "BE",
      "area_sq_km": 30528,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Brussels",
      "capital_latitude": 50.85045,
      "capital_longitude": 4.34878,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        }
      ],
      "flag": "🇧🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FR",
        "DE",
        "LU",
        "NL"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 56,
      "iso_3166_1_alpha2": "BE",
      "iso_3166_1_alpha3": "BEL",
      "tld": "be",
      "vehicle_code": "B",
      "fips10": "BE",
      "un_locode": "BE",
      "stanag_1059": "BEL",
      "ioc": "BEL",
      "fifa": "BEL",
      "itu": "BEL",
      "uic": "88 B",
      "maritime": 205,
      "mmc": 206
    }
  },
  {
    "locale": "nl-CW",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Curacao",
      "name_local": "Kòrsou",
      "code": "CW",
      "area_sq_km": 444,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Willemstad",
      "capital_latitude": 12.133649,
      "capital_longitude": -68.930873,
      "currency": "Caribbean guilder",
      "currency_local": "Caribische gulden",
      "currency_code": "XCG",
      "currency_symbol": "Cg",
      "currency_numeric": 532,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "(Eastern) Punjabi",
          "name_local": "ਪੰਜਾਬੀ",
          "iso_639_1": "pa",
          "iso_639_2": "pan",
          "iso_639_3": "pan"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇨🇼",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 531,
      "iso_3166_1_alpha2": "CW",
      "iso_3166_1_alpha3": "CUW",
      "tld": "cw",
      "vehicle_code": "",
      "fips10": "UC",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "CUW",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": ""
    }
  },
  {
    "locale": "nl-BQ",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Caribbean Netherlands",
      "name_local": "Caribisch Nederland",
      "code": "BQ",
      "area_sq_km": 328,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "",
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇧🇶",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 535,
      "iso_3166_1_alpha2": "BQ",
      "iso_3166_1_alpha3": "BES",
      "tld": "bq",
      "vehicle_code": "NL",
      "fips10": "",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": 362
    }
  },
  {
    "locale": "nl-NL",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Netherlands",
      "name_local": "Nederland",
      "code": "NL",
      "area_sq_km": 41850,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Amsterdam",
      "capital_latitude": 52.37403,
      "capital_longitude": 4.88969,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇳🇱",
      "timezones": [
        "UTC-04:00",
        "UTC+01:00"
      ],
      "borders": [
        "BE",
        "DE"
      ],
      "is_landlocked": false,
      "postal_code_format": "#### @@",
      "postal_code_regex": "^(\\d{4}[A-Z]{2})$",
      "iso_3166_1_numeric": 528,
      "iso_3166_1_alpha2": "NL",
      "iso_3166_1_alpha3": "NLD",
      "tld": "nl",
      "vehicle_code": "NL",
      "fips10": "NL",
      "un_locode": "NL",
      "stanag_1059": "NLD",
      "ioc": "NED",
      "fifa": "NED",
      "itu": "HOL",
      "uic": "84 NL",
      "maritime": "244, 245, 246",
      "mmc": 204
    }
  },
  {
    "locale": "nl-MF",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Saint Martin",
      "name_local": "Saint Martin",
      "code": "MF",
      "area_sq_km": 53,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Marigot",
      "capital_latitude": 18.06667,
      "capital_longitude": -63.08333,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇲🇫",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "SX"
      ],
      "is_landlocked": false,
      "postal_code_format": "### ###",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 663,
      "iso_3166_1_alpha2": "MF",
      "iso_3166_1_alpha3": "MAF",
      "tld": "mf",
      "vehicle_code": "F",
      "fips10": "RN",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "SMT",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "nl-SX",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Sint Maarten",
      "name_local": "Sint Maarten",
      "code": "SX",
      "area_sq_km": 34,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Philipsburg",
      "capital_latitude": 18.025415,
      "capital_longitude": -63.050516,
      "currency": "Caribbean guilder",
      "currency_local": "Caribische gulden",
      "currency_code": "XCG",
      "currency_symbol": "Cg",
      "currency_numeric": 532,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇸🇽",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "MF"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 534,
      "iso_3166_1_alpha2": "SX",
      "iso_3166_1_alpha3": "SXM",
      "tld": "sx",
      "vehicle_code": "",
      "fips10": "NN",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": ""
    }
  },
  {
    "locale": "nl-SR",
    "language": {
      "name": "Dutch",
      "name_local": "Nederlands",
      "iso_639_1": "nl",
      "iso_639_2": "nld",
      "iso_639_3": "nld",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Belgium",
          "name_local": "België / Belgique",
          "code": "BE"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        },
        {
          "name": "Caribbean Netherlands",
          "name_local": "Caribisch Nederland",
          "code": "BQ"
        },
        {
          "name": "Netherlands",
          "name_local": "Nederland",
          "code": "NL"
        },
        {
          "name": "Saint Martin",
          "name_local": "Saint Martin",
          "code": "MF"
        },
        {
          "name": "Sint Maarten",
          "name_local": "Sint Maarten",
          "code": "SX"
        },
        {
          "name": "Suriname",
          "name_local": "Suriname",
          "code": "SR"
        }
      ]
    },
    "country": {
      "name": "Suriname",
      "name_local": "Suriname",
      "code": "SR",
      "area_sq_km": 163820,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Paramaribo",
      "capital_latitude": 5.86638,
      "capital_longitude": -55.16682,
      "currency": "Surinam Dollar",
      "currency_local": "Surinamese dollar",
      "currency_code": "SRD",
      "currency_symbol": "$",
      "currency_numeric": 968,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        }
      ],
      "flag": "🇸🇷",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [
        "BR",
        "GF",
        "GY"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 740,
      "iso_3166_1_alpha2": "SR",
      "iso_3166_1_alpha3": "SUR",
      "tld": "sr",
      "vehicle_code": "SME",
      "fips10": "NS",
      "un_locode": "SR",
      "stanag_1059": "SUR",
      "ioc": "SUR",
      "fifa": "SUR",
      "itu": "SUR",
      "uic": "",
      "maritime": 765,
      "mmc": 746
    }
  },
  {
    "locale": "nn-BV",
    "language": {
      "name": "Norwegian Nynorsk",
      "name_local": "Norsk nynorsk",
      "iso_639_1": "nn",
      "iso_639_2": "nno",
      "iso_639_3": "nno",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        }
      ]
    },
    "country": {
      "name": "Bouvet Island",
      "name_local": "Bouvetøya",
      "code": "BV",
      "area_sq_km": 49,
      "continent": "South America",
      "region": "",
      "capital_name": "",
      "currency": "Norwegian Krone",
      "currency_local": "",
      "currency_code": "NOK",
      "currency_symbol": "",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇧🇻",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 74,
      "iso_3166_1_alpha2": "BV",
      "iso_3166_1_alpha3": "BVT",
      "tld": "bv",
      "vehicle_code": "",
      "fips10": "BV",
      "un_locode": "",
      "stanag_1059": "BVT",
      "ioc": "",
      "fifa": "",
      "itu": "BVT",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "nn-NO",
    "language": {
      "name": "Norwegian Nynorsk",
      "name_local": "Norsk nynorsk",
      "iso_639_1": "nn",
      "iso_639_2": "nno",
      "iso_639_3": "nno",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        }
      ]
    },
    "country": {
      "name": "Norway",
      "name_local": "Norge",
      "code": "NO",
      "area_sq_km": 323802,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Oslo",
      "capital_latitude": 59.91273,
      "capital_longitude": 10.74609,
      "currency": "Norwegian Krone",
      "currency_local": "Norwegian krone",
      "currency_code": "NOK",
      "currency_symbol": "kr",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇳🇴",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FI",
        "SE",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 578,
      "iso_3166_1_alpha2": "NO",
      "iso_3166_1_alpha3": "NOR",
      "tld": "no",
      "vehicle_code": "N",
      "fips10": "NO",
      "un_locode": "NO",
      "stanag_1059": "NOR",
      "ioc": "NOR",
      "fifa": "NOR",
      "itu": "NOR",
      "uic": "76 N",
      "maritime": "257, 258, 259",
      "mmc": 242
    }
  },
  {
    "locale": "nb-BV",
    "language": {
      "name": "Norwegian Bokmål",
      "name_local": "Norsk bokmål",
      "iso_639_1": "nb",
      "iso_639_2": "nob",
      "iso_639_3": "nob",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        }
      ]
    },
    "country": {
      "name": "Bouvet Island",
      "name_local": "Bouvetøya",
      "code": "BV",
      "area_sq_km": 49,
      "continent": "South America",
      "region": "",
      "capital_name": "",
      "currency": "Norwegian Krone",
      "currency_local": "",
      "currency_code": "NOK",
      "currency_symbol": "",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇧🇻",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 74,
      "iso_3166_1_alpha2": "BV",
      "iso_3166_1_alpha3": "BVT",
      "tld": "bv",
      "vehicle_code": "",
      "fips10": "BV",
      "un_locode": "",
      "stanag_1059": "BVT",
      "ioc": "",
      "fifa": "",
      "itu": "BVT",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "nb-NO",
    "language": {
      "name": "Norwegian Bokmål",
      "name_local": "Norsk bokmål",
      "iso_639_1": "nb",
      "iso_639_2": "nob",
      "iso_639_3": "nob",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        }
      ]
    },
    "country": {
      "name": "Norway",
      "name_local": "Norge",
      "code": "NO",
      "area_sq_km": 323802,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Oslo",
      "capital_latitude": 59.91273,
      "capital_longitude": 10.74609,
      "currency": "Norwegian Krone",
      "currency_local": "Norwegian krone",
      "currency_code": "NOK",
      "currency_symbol": "kr",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇳🇴",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FI",
        "SE",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 578,
      "iso_3166_1_alpha2": "NO",
      "iso_3166_1_alpha3": "NOR",
      "tld": "no",
      "vehicle_code": "N",
      "fips10": "NO",
      "un_locode": "NO",
      "stanag_1059": "NOR",
      "ioc": "NOR",
      "fifa": "NOR",
      "itu": "NOR",
      "uic": "76 N",
      "maritime": "257, 258, 259",
      "mmc": 242
    }
  },
  {
    "locale": "no-BV",
    "language": {
      "name": "Norwegian",
      "name_local": "Norsk",
      "iso_639_1": "no",
      "iso_639_2": "nor",
      "iso_639_3": "nor",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        },
        {
          "name": "Svalbard",
          "name_local": "Svalbard og Jan Mayen",
          "code": "SJ"
        }
      ]
    },
    "country": {
      "name": "Bouvet Island",
      "name_local": "Bouvetøya",
      "code": "BV",
      "area_sq_km": 49,
      "continent": "South America",
      "region": "",
      "capital_name": "",
      "currency": "Norwegian Krone",
      "currency_local": "",
      "currency_code": "NOK",
      "currency_symbol": "",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇧🇻",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 74,
      "iso_3166_1_alpha2": "BV",
      "iso_3166_1_alpha3": "BVT",
      "tld": "bv",
      "vehicle_code": "",
      "fips10": "BV",
      "un_locode": "",
      "stanag_1059": "BVT",
      "ioc": "",
      "fifa": "",
      "itu": "BVT",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "no-NO",
    "language": {
      "name": "Norwegian",
      "name_local": "Norsk",
      "iso_639_1": "no",
      "iso_639_2": "nor",
      "iso_639_3": "nor",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        },
        {
          "name": "Svalbard",
          "name_local": "Svalbard og Jan Mayen",
          "code": "SJ"
        }
      ]
    },
    "country": {
      "name": "Norway",
      "name_local": "Norge",
      "code": "NO",
      "area_sq_km": 323802,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Oslo",
      "capital_latitude": 59.91273,
      "capital_longitude": 10.74609,
      "currency": "Norwegian Krone",
      "currency_local": "Norwegian krone",
      "currency_code": "NOK",
      "currency_symbol": "kr",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        },
        {
          "name": "Norwegian Bokmål",
          "name_local": "Norsk bokmål",
          "iso_639_1": "nb",
          "iso_639_2": "nob",
          "iso_639_3": "nob"
        },
        {
          "name": "Norwegian Nynorsk",
          "name_local": "Norsk nynorsk",
          "iso_639_1": "nn",
          "iso_639_2": "nno",
          "iso_639_3": "nno"
        }
      ],
      "flag": "🇳🇴",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FI",
        "SE",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 578,
      "iso_3166_1_alpha2": "NO",
      "iso_3166_1_alpha3": "NOR",
      "tld": "no",
      "vehicle_code": "N",
      "fips10": "NO",
      "un_locode": "NO",
      "stanag_1059": "NOR",
      "ioc": "NOR",
      "fifa": "NOR",
      "itu": "NOR",
      "uic": "76 N",
      "maritime": "257, 258, 259",
      "mmc": 242
    }
  },
  {
    "locale": "no-SJ",
    "language": {
      "name": "Norwegian",
      "name_local": "Norsk",
      "iso_639_1": "no",
      "iso_639_2": "nor",
      "iso_639_3": "nor",
      "countries": [
        {
          "name": "Bouvet Island",
          "name_local": "Bouvetøya",
          "code": "BV"
        },
        {
          "name": "Norway",
          "name_local": "Norge",
          "code": "NO"
        },
        {
          "name": "Svalbard",
          "name_local": "Svalbard og Jan Mayen",
          "code": "SJ"
        }
      ]
    },
    "country": {
      "name": "Svalbard",
      "name_local": "Svalbard og Jan Mayen",
      "code": "SJ",
      "area_sq_km": -1,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Longyearbyen",
      "capital_latitude": 78.22334,
      "capital_longitude": 15.64689,
      "currency": "Norwegian Krone",
      "currency_local": "krone",
      "currency_code": "NOK",
      "currency_symbol": "kr",
      "currency_numeric": 578,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Øre",
      "languages": [
        {
          "name": "Norwegian",
          "name_local": "Norsk",
          "iso_639_1": "no",
          "iso_639_2": "nor",
          "iso_639_3": "nor"
        }
      ],
      "flag": "🇸🇯",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 744,
      "iso_3166_1_alpha2": "SJ",
      "iso_3166_1_alpha3": "SJM",
      "tld": "sj",
      "vehicle_code": "",
      "fips10": "SV",
      "un_locode": "SJ",
      "stanag_1059": "SJM",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "nrb-ER",
    "language": {
      "name": "Nara",
      "name_local": "Nara",
      "iso_639_1": "",
      "iso_639_2": "nrb",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "ny-MW",
    "language": {
      "name": "Chichewa",
      "name_local": "chiCheŵa",
      "iso_639_1": "ny",
      "iso_639_2": "nya",
      "iso_639_3": "nya",
      "countries": [
        {
          "name": "Malawi",
          "name_local": "Malawi",
          "code": "MW"
        }
      ]
    },
    "country": {
      "name": "Malawi",
      "name_local": "Malawi",
      "code": "MW",
      "area_sq_km": 118484,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Lilongwe",
      "capital_latitude": -13.96692,
      "capital_longitude": 33.78725,
      "currency": "Malawian Kwacha",
      "currency_local": "Malawian kwacha",
      "currency_code": "MWK",
      "currency_symbol": "MK",
      "currency_numeric": 454,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tambala",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chichewa",
          "name_local": "chiCheŵa",
          "iso_639_1": "ny",
          "iso_639_2": "nya",
          "iso_639_3": "nya"
        }
      ],
      "flag": "🇲🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "MZ",
        "TZ",
        "ZM"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 454,
      "iso_3166_1_alpha2": "MW",
      "iso_3166_1_alpha3": "MWI",
      "tld": "mw",
      "vehicle_code": "MW",
      "fips10": "MI",
      "un_locode": "MW",
      "stanag_1059": "MWI",
      "ioc": "MAW",
      "fifa": "MWI",
      "itu": "MWI",
      "uic": "",
      "maritime": 655,
      "mmc": 650
    }
  },
  {
    "locale": "pa-AW",
    "language": {
      "name": "(Eastern) Punjabi",
      "name_local": "ਪੰਜਾਬੀ",
      "iso_639_1": "pa",
      "iso_639_2": "pan",
      "iso_639_3": "pan",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        }
      ]
    },
    "country": {
      "name": "Aruba",
      "name_local": "Aruba",
      "code": "AW",
      "area_sq_km": 180,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Oranjestad",
      "capital_latitude": 12.52398,
      "capital_longitude": -70.02703,
      "currency": "Guilder",
      "currency_local": "Aruban florin",
      "currency_code": "AWG",
      "currency_symbol": "ƒ",
      "currency_numeric": 533,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "(Eastern) Punjabi",
          "name_local": "ਪੰਜਾਬੀ",
          "iso_639_1": "pa",
          "iso_639_2": "pan",
          "iso_639_3": "pan"
        }
      ],
      "flag": "🇦🇼",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 533,
      "iso_3166_1_alpha2": "AW",
      "iso_3166_1_alpha3": "ABW",
      "tld": "aw",
      "vehicle_code": "ARU",
      "fips10": "AA",
      "un_locode": "AW",
      "stanag_1059": "ABW",
      "ioc": "ARU",
      "fifa": "ARU",
      "itu": "ABW",
      "uic": "",
      "maritime": 307,
      "mmc": 363
    }
  },
  {
    "locale": "pa-CW",
    "language": {
      "name": "(Eastern) Punjabi",
      "name_local": "ਪੰਜਾਬੀ",
      "iso_639_1": "pa",
      "iso_639_2": "pan",
      "iso_639_3": "pan",
      "countries": [
        {
          "name": "Aruba",
          "name_local": "Aruba",
          "code": "AW"
        },
        {
          "name": "Curacao",
          "name_local": "Kòrsou",
          "code": "CW"
        }
      ]
    },
    "country": {
      "name": "Curacao",
      "name_local": "Kòrsou",
      "code": "CW",
      "area_sq_km": 444,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Willemstad",
      "capital_latitude": 12.133649,
      "capital_longitude": -68.930873,
      "currency": "Caribbean guilder",
      "currency_local": "Caribische gulden",
      "currency_code": "XCG",
      "currency_symbol": "Cg",
      "currency_numeric": 532,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Dutch",
          "name_local": "Nederlands",
          "iso_639_1": "nl",
          "iso_639_2": "nld",
          "iso_639_3": "nld"
        },
        {
          "name": "(Eastern) Punjabi",
          "name_local": "ਪੰਜਾਬੀ",
          "iso_639_1": "pa",
          "iso_639_2": "pan",
          "iso_639_3": "pan"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇨🇼",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 531,
      "iso_3166_1_alpha2": "CW",
      "iso_3166_1_alpha3": "CUW",
      "tld": "cw",
      "vehicle_code": "",
      "fips10": "UC",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "CUW",
      "itu": "",
      "uic": "",
      "maritime": 306,
      "mmc": ""
    }
  },
  {
    "locale": "pl-PL",
    "language": {
      "name": "Polish",
      "name_local": "polski",
      "iso_639_1": "pl",
      "iso_639_2": "pol",
      "iso_639_3": "pol",
      "countries": [
        {
          "name": "Poland",
          "name_local": "Polska",
          "code": "PL"
        }
      ]
    },
    "country": {
      "name": "Poland",
      "name_local": "Polska",
      "code": "PL",
      "area_sq_km": 312679,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Warsaw",
      "capital_latitude": 52.22977,
      "capital_longitude": 21.01178,
      "currency": "Zloty",
      "currency_local": "Polish złoty",
      "currency_code": "PLN",
      "currency_symbol": "zł",
      "currency_numeric": 985,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Groszy",
      "languages": [
        {
          "name": "Polish",
          "name_local": "polski",
          "iso_639_1": "pl",
          "iso_639_2": "pol",
          "iso_639_3": "pol"
        }
      ],
      "flag": "🇵🇱",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BY",
        "CZ",
        "DE",
        "LT",
        "RU",
        "SK",
        "UA"
      ],
      "is_landlocked": false,
      "postal_code_format": "##-###",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 616,
      "iso_3166_1_alpha2": "PL",
      "iso_3166_1_alpha3": "POL",
      "tld": "pl",
      "vehicle_code": "PL",
      "fips10": "PL",
      "un_locode": "PL",
      "stanag_1059": "POL",
      "ioc": "POL",
      "fifa": "POL",
      "itu": "POL",
      "uic": "51 PL",
      "maritime": 261,
      "mmc": 260
    }
  },
  {
    "locale": "pt-AO",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Angola",
      "name_local": "Ngola",
      "code": "AO",
      "area_sq_km": 1246700,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Luanda",
      "capital_latitude": -8.83682,
      "capital_longitude": 13.23432,
      "currency": "Kwanza",
      "currency_local": "Angolan kwanza",
      "currency_code": "AOA",
      "currency_symbol": "Kz",
      "currency_numeric": 973,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Lwei",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇦🇴",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CG",
        "CD",
        "ZM",
        "NA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 24,
      "iso_3166_1_alpha2": "AO",
      "iso_3166_1_alpha3": "AGO",
      "tld": "ao",
      "vehicle_code": "ANG",
      "fips10": "AO",
      "un_locode": "AO",
      "stanag_1059": "AGO",
      "ioc": "ANG",
      "fifa": "ANG",
      "itu": "AGL",
      "uic": "",
      "maritime": 603,
      "mmc": 631
    }
  },
  {
    "locale": "pt-GQ",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Equatorial Guinea",
      "name_local": "Guinea Ecuatorial",
      "code": "GQ",
      "area_sq_km": 28051,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Malabo",
      "capital_latitude": 3.75,
      "capital_longitude": 8.78333,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        },
        {
          "name": "Fang",
          "name_local": "Fang",
          "iso_639_1": "",
          "iso_639_2": "fan",
          "iso_639_3": ""
        }
      ],
      "flag": "🇬🇶",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 226,
      "iso_3166_1_alpha2": "GQ",
      "iso_3166_1_alpha3": "GNQ",
      "tld": "gq",
      "vehicle_code": "GQ",
      "fips10": "EK",
      "un_locode": "GQ",
      "stanag_1059": "GNQ",
      "ioc": "GEQ",
      "fifa": "EQG",
      "itu": "GNE",
      "uic": "",
      "maritime": 631,
      "mmc": 627
    }
  },
  {
    "locale": "pt-BR",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Brazil",
      "name_local": "Brasil",
      "code": "BR",
      "area_sq_km": 8515767,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Brasilia",
      "capital_latitude": -15.77972,
      "capital_longitude": -47.92972,
      "currency": "Brazilian Real",
      "currency_local": "Brazilian real",
      "currency_code": "BRL",
      "currency_symbol": "R$",
      "currency_numeric": 986,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇧🇷",
      "timezones": [
        "UTC-05:00",
        "UTC-04:00",
        "UTC-03:00",
        "UTC-02:00"
      ],
      "borders": [
        "AR",
        "BO",
        "CO",
        "GF",
        "GY",
        "PY",
        "PE",
        "SR",
        "UY",
        "VE"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####-###",
      "postal_code_regex": "^(\\d{8})$",
      "iso_3166_1_numeric": 76,
      "iso_3166_1_alpha2": "BR",
      "iso_3166_1_alpha3": "BRA",
      "tld": "br",
      "vehicle_code": "BR",
      "fips10": "BR",
      "un_locode": "BR",
      "stanag_1059": "BRA",
      "ioc": "BRA",
      "fifa": "BRA",
      "itu": "B",
      "uic": "",
      "maritime": 710,
      "mmc": 724
    }
  },
  {
    "locale": "pt-GW",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Guinea-Bissau",
      "name_local": "Guiné-Bissau",
      "code": "GW",
      "area_sq_km": 36125,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Bissau",
      "capital_latitude": 11.86357,
      "capital_longitude": -15.59767,
      "currency": "West African Franc",
      "currency_local": "West African CFA franc",
      "currency_code": "XOF",
      "currency_symbol": "Fr",
      "currency_numeric": 952,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇬🇼",
      "timezones": [
        "UTC"
      ],
      "borders": [
        "GN",
        "SN"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 624,
      "iso_3166_1_alpha2": "GW",
      "iso_3166_1_alpha3": "GNB",
      "tld": "gw",
      "vehicle_code": "GUB",
      "fips10": "PU",
      "un_locode": "GW",
      "stanag_1059": "GNB",
      "ioc": "GBS",
      "fifa": "GNB",
      "itu": "GNB",
      "uic": "",
      "maritime": 630,
      "mmc": 632
    }
  },
  {
    "locale": "pt-CV",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Cape Verde",
      "name_local": "Cabo Verde",
      "code": "CV",
      "area_sq_km": 4033,
      "continent": "Africa",
      "region": "Western Africa",
      "capital_name": "Praia",
      "capital_latitude": 14.93152,
      "capital_longitude": -23.51254,
      "currency": "Cape Verdean Escudo",
      "currency_local": "Cape Verdean escudo",
      "currency_code": "CVE",
      "currency_symbol": "Esc",
      "currency_numeric": 132,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇨🇻",
      "timezones": [
        "UTC-01:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 132,
      "iso_3166_1_alpha2": "CV",
      "iso_3166_1_alpha3": "CPV",
      "tld": "cv",
      "vehicle_code": "CV",
      "fips10": "CV",
      "un_locode": "CV",
      "stanag_1059": "CPV",
      "ioc": "CPV",
      "fifa": "CPV",
      "itu": "CPV",
      "uic": "",
      "maritime": 617,
      "mmc": 625
    }
  },
  {
    "locale": "pt-MO",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Macao",
      "name_local": "Macau, Aomen",
      "code": "MO",
      "area_sq_km": 30,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Concelho de Macau",
      "capital_latitude": 22.20056,
      "capital_longitude": 113.54611,
      "currency": "Macanese Pataca",
      "currency_local": "Macanese pataca",
      "currency_code": "MOP",
      "currency_symbol": "P",
      "currency_numeric": 446,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Avos",
      "languages": [
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇲🇴",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "CN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 446,
      "iso_3166_1_alpha2": "MO",
      "iso_3166_1_alpha3": "MAC",
      "tld": "mo",
      "vehicle_code": "",
      "fips10": "MC",
      "un_locode": "MO",
      "stanag_1059": "MAC",
      "ioc": "",
      "fifa": "MAC",
      "itu": "MAC",
      "uic": "",
      "maritime": 453,
      "mmc": 455
    }
  },
  {
    "locale": "pt-MZ",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Mozambique",
      "name_local": "Moçambique",
      "code": "MZ",
      "area_sq_km": 801590,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Maputo",
      "capital_latitude": -25.96553,
      "capital_longitude": 32.58322,
      "currency": "Metical",
      "currency_local": "Mozambican metical",
      "currency_code": "MZN",
      "currency_symbol": "MT",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇲🇿",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "MW",
        "ZA",
        "SZ",
        "TZ",
        "ZM",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 508,
      "iso_3166_1_alpha2": "MZ",
      "iso_3166_1_alpha3": "MOZ",
      "tld": "mz",
      "vehicle_code": "MOC",
      "fips10": "MZ",
      "un_locode": "MZ",
      "stanag_1059": "MOZ",
      "ioc": "MOZ",
      "fifa": "MOZ",
      "itu": "MOZ",
      "uic": "",
      "maritime": 650,
      "mmc": 643
    }
  },
  {
    "locale": "pt-TL",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "East Timor",
      "name_local": "Timor Timur",
      "code": "TL",
      "area_sq_km": 14874,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Dili",
      "capital_latitude": -8.55861,
      "capital_longitude": 125.57361,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇹🇱",
      "timezones": [
        "UTC+09:00"
      ],
      "borders": [
        "ID"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 626,
      "iso_3166_1_alpha2": "TL",
      "iso_3166_1_alpha3": "TLS",
      "tld": "tl",
      "vehicle_code": "TL",
      "fips10": "TT",
      "un_locode": "TL",
      "stanag_1059": "TLS",
      "ioc": "TLS",
      "fifa": "TLS",
      "itu": "TLS",
      "uic": "",
      "maritime": "",
      "mmc": 514
    }
  },
  {
    "locale": "pt-PT",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Portugal",
      "name_local": "Portugal",
      "code": "PT",
      "area_sq_km": 92090,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Lisbon",
      "capital_latitude": 38.71667,
      "capital_longitude": -9.13333,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇵🇹",
      "timezones": [
        "UTC-01:00",
        "UTC"
      ],
      "borders": [
        "ES"
      ],
      "is_landlocked": false,
      "postal_code_format": "####-###",
      "postal_code_regex": "^(\\d{7})$",
      "iso_3166_1_numeric": 620,
      "iso_3166_1_alpha2": "PT",
      "iso_3166_1_alpha3": "PRT",
      "tld": "pt",
      "vehicle_code": "P",
      "fips10": "PO",
      "un_locode": "PT",
      "stanag_1059": "PRT",
      "ioc": "POR",
      "fifa": "POR",
      "itu": "POR",
      "uic": "94 P",
      "maritime": "255, 263",
      "mmc": 268
    }
  },
  {
    "locale": "pt-ST",
    "language": {
      "name": "Portuguese",
      "name_local": "Português",
      "iso_639_1": "pt",
      "iso_639_2": "por",
      "iso_639_3": "por",
      "countries": [
        {
          "name": "Angola",
          "name_local": "Ngola",
          "code": "AO"
        },
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Brazil",
          "name_local": "Brasil",
          "code": "BR"
        },
        {
          "name": "Guinea-Bissau",
          "name_local": "Guiné-Bissau",
          "code": "GW"
        },
        {
          "name": "Cape Verde",
          "name_local": "Cabo Verde",
          "code": "CV"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Mozambique",
          "name_local": "Moçambique",
          "code": "MZ"
        },
        {
          "name": "East Timor",
          "name_local": "Timor Timur",
          "code": "TL"
        },
        {
          "name": "Portugal",
          "name_local": "Portugal",
          "code": "PT"
        },
        {
          "name": "Sao Tome and Principe",
          "name_local": "São Tomé e Príncipe",
          "code": "ST"
        }
      ]
    },
    "country": {
      "name": "Sao Tome and Principe",
      "name_local": "São Tomé e Príncipe",
      "code": "ST",
      "area_sq_km": 964,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "São Tomé",
      "capital_latitude": 0.33654,
      "capital_longitude": 6.72732,
      "currency": "Dobra",
      "currency_local": "",
      "currency_code": "STD",
      "currency_symbol": "",
      "currency_numeric": 678,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇸🇹",
      "timezones": [
        "UTC"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 678,
      "iso_3166_1_alpha2": "ST",
      "iso_3166_1_alpha3": "STP",
      "tld": "st",
      "vehicle_code": "STP",
      "fips10": "TP",
      "un_locode": "ST",
      "stanag_1059": "STP",
      "ioc": "STP",
      "fifa": "STP",
      "itu": "STP",
      "uic": "",
      "maritime": 668,
      "mmc": 626
    }
  },
  {
    "locale": "ps-AF",
    "language": {
      "name": "Pashto",
      "name_local": "پښتو",
      "iso_639_1": "ps",
      "iso_639_2": "pus",
      "iso_639_3": "pus",
      "countries": [
        {
          "name": "Afghanistan",
          "name_local": "افغانستان Afghānestān",
          "code": "AF"
        }
      ]
    },
    "country": {
      "name": "Afghanistan",
      "name_local": "افغانستان Afghānestān",
      "code": "AF",
      "area_sq_km": 652230,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Kabul",
      "capital_latitude": 34.52813,
      "capital_longitude": 69.17233,
      "currency": "Afghani",
      "currency_local": "Afghan afghani",
      "currency_code": "AFN",
      "currency_symbol": "؋",
      "currency_numeric": 971,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Puls",
      "languages": [
        {
          "name": "Pashto",
          "name_local": "پښتو",
          "iso_639_1": "ps",
          "iso_639_2": "pus",
          "iso_639_3": "pus"
        },
        {
          "name": "Uzbek",
          "name_local": "Oʻzbek",
          "iso_639_1": "uz",
          "iso_639_2": "uzb",
          "iso_639_3": "uzb"
        },
        {
          "name": "Turkmen",
          "name_local": "Türkmen",
          "iso_639_1": "tk",
          "iso_639_2": "tuk",
          "iso_639_3": "tuk"
        }
      ],
      "flag": "🇦🇫",
      "timezones": [
        "UTC+04:30"
      ],
      "borders": [
        "IR",
        "PK",
        "TM",
        "UZ",
        "TJ",
        "CN"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 4,
      "iso_3166_1_alpha2": "AF",
      "iso_3166_1_alpha3": "AFG",
      "tld": "af",
      "vehicle_code": "AFG",
      "fips10": "AF",
      "un_locode": "AF",
      "stanag_1059": "AFG",
      "ioc": "AFG",
      "fifa": "AFG",
      "itu": "AFG",
      "uic": "68 AF",
      "maritime": 401,
      "mmc": 412
    }
  },
  {
    "locale": "qu-BO",
    "language": {
      "name": "Quechua",
      "name_local": "Runa Simi",
      "iso_639_1": "qu",
      "iso_639_2": "que",
      "iso_639_3": "que",
      "countries": [
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        }
      ]
    },
    "country": {
      "name": "Bolivia",
      "name_local": "Bolivia",
      "code": "BO",
      "area_sq_km": 1098581,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Sucre",
      "capital_latitude": -19.03332,
      "capital_longitude": -65.26274,
      "currency": "Boliviano",
      "currency_local": "Bolivian boliviano",
      "currency_code": "BOB",
      "currency_symbol": "Bs.",
      "currency_numeric": 68,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Aymara",
          "name_local": "aymar aru",
          "iso_639_1": "ay",
          "iso_639_2": "aym",
          "iso_639_3": "aym"
        },
        {
          "name": "Quechua",
          "name_local": "Runa Simi",
          "iso_639_1": "qu",
          "iso_639_2": "que",
          "iso_639_3": "que"
        }
      ],
      "flag": "🇧🇴",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BR",
        "CL",
        "PY",
        "PE"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 68,
      "iso_3166_1_alpha2": "BO",
      "iso_3166_1_alpha3": "BOL",
      "tld": "bo",
      "vehicle_code": "BOL",
      "fips10": "BL",
      "un_locode": "BO",
      "stanag_1059": "BOL",
      "ioc": "BOL",
      "fifa": "BOL",
      "itu": "BOL",
      "uic": "",
      "maritime": 720,
      "mmc": 736
    }
  },
  {
    "locale": "rar-CK",
    "language": {
      "name": "Cook Islands Māori",
      "name_local": "Māori",
      "iso_639_1": "",
      "iso_639_2": "rar",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Cook Islands",
          "name_local": "Cook Islands / Kūki 'Āirani",
          "code": "CK"
        }
      ]
    },
    "country": {
      "name": "Cook Islands",
      "name_local": "Cook Islands / Kūki 'Āirani",
      "code": "CK",
      "area_sq_km": 236,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Avarua",
      "capital_latitude": -21.20778,
      "capital_longitude": -159.775,
      "currency": "Cook Dollar",
      "currency_local": "Cook Islands dollar",
      "currency_code": "CKD",
      "currency_symbol": "$",
      "currency_numeric": "",
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Cook Islands Māori",
          "name_local": "Māori",
          "iso_639_1": "",
          "iso_639_2": "rar",
          "iso_639_3": ""
        }
      ],
      "flag": "🇨🇰",
      "timezones": [
        "UTC-10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 184,
      "iso_3166_1_alpha2": "CK",
      "iso_3166_1_alpha3": "COK",
      "tld": "ck",
      "vehicle_code": "",
      "fips10": "CW",
      "un_locode": "CK",
      "stanag_1059": "COK",
      "ioc": "COK",
      "fifa": "COK",
      "itu": "CKH",
      "uic": "",
      "maritime": 518,
      "mmc": 548
    }
  },
  {
    "locale": "rm-CH",
    "language": {
      "name": "Romansh",
      "name_local": "Rumantsch",
      "iso_639_1": "rm",
      "iso_639_2": "roh",
      "iso_639_3": "roh",
      "countries": [
        {
          "name": "Switzerland",
          "name_local": "Schweiz / Suisse / Svizzera / Svizra",
          "code": "CH"
        }
      ]
    },
    "country": {
      "name": "Switzerland",
      "name_local": "Schweiz / Suisse / Svizzera / Svizra",
      "code": "CH",
      "area_sq_km": 41284,
      "continent": "Europe",
      "region": "Western Europe",
      "capital_name": "Bern",
      "capital_latitude": 46.94809,
      "capital_longitude": 7.44744,
      "currency": "Swiss Franc",
      "currency_local": "Swiss franc",
      "currency_code": "CHF",
      "currency_symbol": "Fr.",
      "currency_numeric": 756,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Rappen",
      "languages": [
        {
          "name": "German",
          "name_local": "Deutsch",
          "iso_639_1": "de",
          "iso_639_2": "deu",
          "iso_639_3": "deu"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Italian",
          "name_local": "Italiano",
          "iso_639_1": "it",
          "iso_639_2": "ita",
          "iso_639_3": "ita"
        },
        {
          "name": "Romansh",
          "name_local": "Rumantsch",
          "iso_639_1": "rm",
          "iso_639_2": "roh",
          "iso_639_3": "roh"
        }
      ],
      "flag": "🇨🇭",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "FR",
        "IT",
        "LI",
        "DE"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 756,
      "iso_3166_1_alpha2": "CH",
      "iso_3166_1_alpha3": "CHE",
      "tld": "ch",
      "vehicle_code": "CH",
      "fips10": "SZ",
      "un_locode": "CH",
      "stanag_1059": "CHE",
      "ioc": "SUI",
      "fifa": "SUI",
      "itu": "SUI",
      "uic": "85 CH",
      "maritime": 269,
      "mmc": 228
    }
  },
  {
    "locale": "ro-MD",
    "language": {
      "name": "Romanian",
      "name_local": "Română",
      "iso_639_1": "ro",
      "iso_639_2": "ron",
      "iso_639_3": "ron",
      "countries": [
        {
          "name": "Moldova",
          "name_local": "Moldova",
          "code": "MD"
        },
        {
          "name": "Romania",
          "name_local": "România",
          "code": "RO"
        }
      ]
    },
    "country": {
      "name": "Moldova",
      "name_local": "Moldova",
      "code": "MD",
      "area_sq_km": 33846,
      "continent": "Europe",
      "region": "Eastern Europe",
      "capital_name": "Chisinau",
      "capital_latitude": 47.00556,
      "capital_longitude": 28.8575,
      "currency": "Moldovan Leu",
      "currency_local": "Moldovan leu",
      "currency_code": "MDL",
      "currency_symbol": "L",
      "currency_numeric": 498,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Bani",
      "languages": [
        {
          "name": "Romanian",
          "name_local": "Română",
          "iso_639_1": "ro",
          "iso_639_2": "ron",
          "iso_639_3": "ron"
        }
      ],
      "flag": "🇲🇩",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "RO",
        "UA"
      ],
      "is_landlocked": true,
      "postal_code_format": "MD-####",
      "postal_code_regex": "^(?:MD)*(\\d{4})$",
      "iso_3166_1_numeric": 498,
      "iso_3166_1_alpha2": "MD",
      "iso_3166_1_alpha3": "MDA",
      "tld": "md",
      "vehicle_code": "MD",
      "fips10": "MD",
      "un_locode": "MD",
      "stanag_1059": "MDA",
      "ioc": "MDA",
      "fifa": "MDA",
      "itu": "MDA",
      "uic": "23 MD",
      "maritime": 214,
      "mmc": 259
    }
  },
  {
    "locale": "ro-RO",
    "language": {
      "name": "Romanian",
      "name_local": "Română",
      "iso_639_1": "ro",
      "iso_639_2": "ron",
      "iso_639_3": "ron",
      "countries": [
        {
          "name": "Moldova",
          "name_local": "Moldova",
          "code": "MD"
        },
        {
          "name": "Romania",
          "name_local": "România",
          "code": "RO"
        }
      ]
    },
    "country": {
      "name": "Romania",
      "name_local": "România",
      "code": "RO",
      "area_sq_km": 238391,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Bucharest",
      "capital_latitude": 44.43225,
      "capital_longitude": 26.10626,
      "currency": "Romanian Leu",
      "currency_local": "Romanian leu",
      "currency_code": "RON",
      "currency_symbol": "lei",
      "currency_numeric": 946,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Bani",
      "languages": [
        {
          "name": "Romanian",
          "name_local": "Română",
          "iso_639_1": "ro",
          "iso_639_2": "ron",
          "iso_639_3": "ron"
        }
      ],
      "flag": "🇷🇴",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BG",
        "HU",
        "MD",
        "RS",
        "UA"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 642,
      "iso_3166_1_alpha2": "RO",
      "iso_3166_1_alpha3": "ROU",
      "tld": "ro",
      "vehicle_code": "RO",
      "fips10": "RO",
      "un_locode": "RO",
      "stanag_1059": "ROU",
      "ioc": "ROU",
      "fifa": "ROU",
      "itu": "ROU",
      "uic": "53 RO",
      "maritime": 264,
      "mmc": 226
    }
  },
  {
    "locale": "rtm-FJ",
    "language": {
      "name": "Rotuman",
      "name_local": "Fäeag Rotuma",
      "iso_639_1": "",
      "iso_639_2": "rtm",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Fiji",
          "name_local": "Viti / फ़िजी गणराज्य / Fiji",
          "code": "FJ"
        }
      ]
    },
    "country": {
      "name": "Fiji",
      "name_local": "Viti / फ़िजी गणराज्य / Fiji",
      "code": "FJ",
      "area_sq_km": 18272,
      "continent": "Oceania",
      "region": "Melanesia",
      "capital_name": "Suva",
      "capital_latitude": -18.14161,
      "capital_longitude": 178.44149,
      "currency": "Fiji Dollar",
      "currency_local": "Fijian dollar",
      "currency_code": "FJD",
      "currency_symbol": "$",
      "currency_numeric": 242,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Fijian",
          "name_local": "vosa Vakaviti",
          "iso_639_1": "fj",
          "iso_639_2": "fij",
          "iso_639_3": "fij"
        },
        {
          "name": "Fiji Hindi",
          "name_local": "फ़िजी बात",
          "iso_639_1": "",
          "iso_639_2": "hif",
          "iso_639_3": ""
        },
        {
          "name": "Rotuman",
          "name_local": "Fäeag Rotuma",
          "iso_639_1": "",
          "iso_639_2": "rtm",
          "iso_639_3": ""
        }
      ],
      "flag": "🇫🇯",
      "timezones": [
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 242,
      "iso_3166_1_alpha2": "FJ",
      "iso_3166_1_alpha3": "FJI",
      "tld": "fj",
      "vehicle_code": "FJI",
      "fips10": "FJ",
      "un_locode": "FJ",
      "stanag_1059": "FJI",
      "ioc": "FIJ",
      "fifa": "FIJ",
      "itu": "FJI",
      "uic": "",
      "maritime": 520,
      "mmc": 542
    }
  },
  {
    "locale": "rn-BI",
    "language": {
      "name": "Kirundi",
      "name_local": "Ikirundi",
      "iso_639_1": "rn",
      "iso_639_2": "run",
      "iso_639_3": "run",
      "countries": [
        {
          "name": "Burundi",
          "name_local": "Burundi / Uburundi",
          "code": "BI"
        }
      ]
    },
    "country": {
      "name": "Burundi",
      "name_local": "Burundi / Uburundi",
      "code": "BI",
      "area_sq_km": 27834,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Bujumbura",
      "capital_latitude": -3.3822,
      "capital_longitude": 29.3644,
      "currency": "Burundi Franc",
      "currency_local": "Burundian franc",
      "currency_code": "BIF",
      "currency_symbol": "Fr",
      "currency_numeric": 108,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Kirundi",
          "name_local": "Ikirundi",
          "iso_639_1": "rn",
          "iso_639_2": "run",
          "iso_639_3": "run"
        }
      ],
      "flag": "🇧🇮",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "CD",
        "RW",
        "TZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 108,
      "iso_3166_1_alpha2": "BI",
      "iso_3166_1_alpha3": "BDI",
      "tld": "bi",
      "vehicle_code": "RU",
      "fips10": "BY",
      "un_locode": "BI",
      "stanag_1059": "BDI",
      "ioc": "BDI",
      "fifa": "BDI",
      "itu": "BDI",
      "uic": "",
      "maritime": 609,
      "mmc": 642
    }
  },
  {
    "locale": "ru-AQ",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Antarctica",
      "name_local": "",
      "code": "AQ",
      "area_sq_km": 14000000,
      "continent": "Oceania",
      "region": "",
      "capital_name": "",
      "currency": "",
      "currency_local": "",
      "currency_code": "",
      "currency_symbol": "",
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇦🇶",
      "timezones": [
        "UTC-03:00",
        "UTC+03:00",
        "UTC+05:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+10:00",
        "UTC+12:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 10,
      "iso_3166_1_alpha2": "AQ",
      "iso_3166_1_alpha3": "ATA",
      "tld": "aq",
      "vehicle_code": "",
      "fips10": "AY",
      "un_locode": "AQ",
      "stanag_1059": "ATA",
      "ioc": "",
      "fifa": "",
      "itu": "ATA",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "ru-BY",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Belarus",
      "name_local": "Беларусь",
      "code": "BY",
      "area_sq_km": 207600,
      "continent": "Europe",
      "region": "Eastern Europe",
      "capital_name": "Minsk",
      "capital_latitude": 53.9,
      "capital_longitude": 27.56667,
      "currency": "Belarus Rubel",
      "currency_local": "",
      "currency_code": "BYR",
      "currency_symbol": "",
      "currency_numeric": 933,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kapejek",
      "languages": [
        {
          "name": "Belarusian",
          "name_local": "беларуская мова",
          "iso_639_1": "be",
          "iso_639_2": "bel",
          "iso_639_3": "bel"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇧🇾",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "LV",
        "LT",
        "PL",
        "RU",
        "UA"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 112,
      "iso_3166_1_alpha2": "BY",
      "iso_3166_1_alpha3": "BLR",
      "tld": "by",
      "vehicle_code": "BY",
      "fips10": "BO",
      "un_locode": "BY",
      "stanag_1059": "BLR",
      "ioc": "BLR",
      "fifa": "BLR",
      "itu": "BLR",
      "uic": "21 BLR",
      "maritime": 206,
      "mmc": 257
    }
  },
  {
    "locale": "ru-KZ",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Kazakhstan",
      "name_local": "Қазақстан /  Qazaqstan",
      "code": "KZ",
      "area_sq_km": 2724900,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Nursultan",
      "capital_latitude": 51.1801,
      "capital_longitude": 71.44598,
      "currency": "Tenge",
      "currency_local": "Kazakhstani tenge",
      "currency_code": "KZT",
      "currency_symbol": "₸",
      "currency_numeric": 398,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tyin",
      "languages": [
        {
          "name": "Kazakh",
          "name_local": "қазақ тілі",
          "iso_639_1": "kk",
          "iso_639_2": "kaz",
          "iso_639_3": "kaz"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇰🇿",
      "timezones": [
        "UTC+05:00",
        "UTC+06:00"
      ],
      "borders": [
        "CN",
        "KG",
        "RU",
        "TM",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 398,
      "iso_3166_1_alpha2": "KZ",
      "iso_3166_1_alpha3": "KAZ",
      "tld": "kz",
      "vehicle_code": "KZ",
      "fips10": "KZ",
      "un_locode": "KZ",
      "stanag_1059": "KAZ",
      "ioc": "KAZ",
      "fifa": "KAZ",
      "itu": "KAZ",
      "uic": "27 KZ",
      "maritime": 436,
      "mmc": 401
    }
  },
  {
    "locale": "ru-KG",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Kyrgyzstan",
      "name_local": "Кыргызстан / Kyrgyzstan",
      "code": "KG",
      "area_sq_km": 199951,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Bishkek",
      "capital_latitude": 42.87,
      "capital_longitude": 74.59,
      "currency": "Som",
      "currency_local": "Kyrgyzstani som",
      "currency_code": "KGS",
      "currency_symbol": "с",
      "currency_numeric": 417,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tyiyn",
      "languages": [
        {
          "name": "Kyrgyz",
          "name_local": "Кыргызча",
          "iso_639_1": "ky",
          "iso_639_2": "kir",
          "iso_639_3": "kir"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇰🇬",
      "timezones": [
        "UTC+06:00"
      ],
      "borders": [
        "CN",
        "KZ",
        "TJ",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 417,
      "iso_3166_1_alpha2": "KG",
      "iso_3166_1_alpha3": "KGZ",
      "tld": "kg",
      "vehicle_code": "KS",
      "fips10": "KG",
      "un_locode": "KG",
      "stanag_1059": "KGZ",
      "ioc": "KGZ",
      "fifa": "KGZ",
      "itu": "KGZ",
      "uic": "59 KS",
      "maritime": 451,
      "mmc": 437
    }
  },
  {
    "locale": "ru-RU",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Russia",
      "name_local": "Россия / Rossija",
      "code": "RU",
      "area_sq_km": 17098242,
      "continent": "Europe",
      "region": "Eastern Europe",
      "capital_name": "Moscow",
      "capital_latitude": 55.75222,
      "capital_longitude": 37.61556,
      "currency": "Russian Rubel",
      "currency_local": "Russian ruble",
      "currency_code": "RUB",
      "currency_symbol": "₽",
      "currency_numeric": 643,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kopeken",
      "languages": [
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇷🇺",
      "timezones": [
        "UTC+03:00",
        "UTC+04:00",
        "UTC+06:00",
        "UTC+07:00",
        "UTC+08:00",
        "UTC+09:00",
        "UTC+10:00",
        "UTC+11:00",
        "UTC+12:00"
      ],
      "borders": [
        "AZ",
        "BY",
        "CN",
        "EE",
        "FI",
        "GE",
        "KZ",
        "KP",
        "LV",
        "LT",
        "MN",
        "NO",
        "PL",
        "UA"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 643,
      "iso_3166_1_alpha2": "RU",
      "iso_3166_1_alpha3": "RUS",
      "tld": "ru",
      "vehicle_code": "RUS",
      "fips10": "RS",
      "un_locode": "RU",
      "stanag_1059": "RUS",
      "ioc": "RUS",
      "fifa": "RUS",
      "itu": "RUS",
      "uic": "20 RUS",
      "maritime": 273,
      "mmc": 250
    }
  },
  {
    "locale": "ru-TJ",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Tajikistan",
      "name_local": "Toçikiston / Тоҷикистон",
      "code": "TJ",
      "area_sq_km": 143100,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Dushanbe",
      "capital_latitude": 38.53575,
      "capital_longitude": 68.77905,
      "currency": "Somoni",
      "currency_local": "Tajikistani somoni",
      "currency_code": "TJS",
      "currency_symbol": "ЅМ",
      "currency_numeric": 972,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Dirham",
      "languages": [
        {
          "name": "Tajik",
          "name_local": "тоҷикӣ",
          "iso_639_1": "tg",
          "iso_639_2": "tgk",
          "iso_639_3": "tgk"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇹🇯",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "CN",
        "KG",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 762,
      "iso_3166_1_alpha2": "TJ",
      "iso_3166_1_alpha3": "TJK",
      "tld": "tj",
      "vehicle_code": "TJ",
      "fips10": "TI",
      "un_locode": "TJ",
      "stanag_1059": "TJK",
      "ioc": "TJK",
      "fifa": "TJK",
      "itu": "TJK",
      "uic": "66 TJ",
      "maritime": 472,
      "mmc": 436
    }
  },
  {
    "locale": "ru-TM",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Turkmenistan",
      "name_local": "Türkmenostan",
      "code": "TM",
      "area_sq_km": 488100,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Ashgabat",
      "capital_latitude": 37.95,
      "capital_longitude": 58.38333,
      "currency": "Turkmen Manat",
      "currency_local": "Turkmenistan manat",
      "currency_code": "TMT",
      "currency_symbol": "m",
      "currency_numeric": 934,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tenge",
      "languages": [
        {
          "name": "Turkmen",
          "name_local": "Türkmen",
          "iso_639_1": "tk",
          "iso_639_2": "tuk",
          "iso_639_3": "tuk"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇹🇲",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "IR",
        "KZ",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 795,
      "iso_3166_1_alpha2": "TM",
      "iso_3166_1_alpha3": "TKM",
      "tld": "tm",
      "vehicle_code": "TM",
      "fips10": "TX",
      "un_locode": "TM",
      "stanag_1059": "TKM",
      "ioc": "TKM",
      "fifa": "TKM",
      "itu": "TKM",
      "uic": "67 TM",
      "maritime": 434,
      "mmc": 438
    }
  },
  {
    "locale": "ru-UZ",
    "language": {
      "name": "Russian",
      "name_local": "Русский",
      "iso_639_1": "ru",
      "iso_639_2": "rus",
      "iso_639_3": "rus",
      "countries": [
        {
          "name": "Antarctica",
          "name_local": "",
          "code": "AQ"
        },
        {
          "name": "Belarus",
          "name_local": "Беларусь",
          "code": "BY"
        },
        {
          "name": "Kazakhstan",
          "name_local": "Қазақстан /  Qazaqstan",
          "code": "KZ"
        },
        {
          "name": "Kyrgyzstan",
          "name_local": "Кыргызстан / Kyrgyzstan",
          "code": "KG"
        },
        {
          "name": "Russia",
          "name_local": "Россия / Rossija",
          "code": "RU"
        },
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Uzbekistan",
      "name_local": "Oʻzbekiston",
      "code": "UZ",
      "area_sq_km": 447400,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Tashkent",
      "capital_latitude": 41.26465,
      "capital_longitude": 69.21627,
      "currency": "Uzbekistan Sum",
      "currency_local": "Uzbekistani soʻm",
      "currency_code": "UZS",
      "currency_symbol": "so'm",
      "currency_numeric": 860,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tiyin",
      "languages": [
        {
          "name": "Uzbek",
          "name_local": "Oʻzbek",
          "iso_639_1": "uz",
          "iso_639_2": "uzb",
          "iso_639_3": "uzb"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇺🇿",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "KZ",
        "KG",
        "TJ",
        "TM"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 860,
      "iso_3166_1_alpha2": "UZ",
      "iso_3166_1_alpha3": "UZB",
      "tld": "uz",
      "vehicle_code": "UZ",
      "fips10": "UZ",
      "un_locode": "UZ",
      "stanag_1059": "UZB",
      "ioc": "UZB",
      "fifa": "UZB",
      "itu": "UZB",
      "uic": "29 UZ",
      "maritime": 437,
      "mmc": 434
    }
  },
  {
    "locale": "sg-CF",
    "language": {
      "name": "Sango",
      "name_local": "yângâ tî sängö",
      "iso_639_1": "sg",
      "iso_639_2": "sag",
      "iso_639_3": "sag",
      "countries": [
        {
          "name": "Central African Republic",
          "name_local": "Centrafrique / Bê-Afrîka",
          "code": "CF"
        }
      ]
    },
    "country": {
      "name": "Central African Republic",
      "name_local": "Centrafrique / Bê-Afrîka",
      "code": "CF",
      "area_sq_km": 622984,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Bangui",
      "capital_latitude": 4.36122,
      "capital_longitude": 18.55496,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Sango",
          "name_local": "yângâ tî sängö",
          "iso_639_1": "sg",
          "iso_639_2": "sag",
          "iso_639_3": "sag"
        }
      ],
      "flag": "🇨🇫",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "TD",
        "CD",
        "CG",
        "SS",
        "SD"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 140,
      "iso_3166_1_alpha2": "CF",
      "iso_3166_1_alpha3": "CAF",
      "tld": "cf",
      "vehicle_code": "RCA",
      "fips10": "CT",
      "un_locode": "CF",
      "stanag_1059": "CAF",
      "ioc": "CAF",
      "fifa": "CTA",
      "itu": "CAF",
      "uic": "",
      "maritime": 612,
      "mmc": 623
    }
  },
  {
    "locale": "si-LK",
    "language": {
      "name": "Sinhalese",
      "name_local": "සිංහල",
      "iso_639_1": "si",
      "iso_639_2": "sin",
      "iso_639_3": "sin",
      "countries": [
        {
          "name": "Sri Lanka",
          "name_local": "ශ්‍රී ලංකා / இலங்கை",
          "code": "LK"
        }
      ]
    },
    "country": {
      "name": "Sri Lanka",
      "name_local": "ශ්‍රී ලංකා / இலங்கை",
      "code": "LK",
      "area_sq_km": 65610,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Colombo",
      "capital_latitude": 6.93194,
      "capital_longitude": 79.84778,
      "currency": "Sri Lanka Rupee",
      "currency_local": "Sri Lankan rupee",
      "currency_code": "LKR",
      "currency_symbol": "Rs  රු",
      "currency_numeric": 144,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Sinhalese",
          "name_local": "සිංහල",
          "iso_639_1": "si",
          "iso_639_2": "sin",
          "iso_639_3": "sin"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        }
      ],
      "flag": "🇱🇰",
      "timezones": [
        "UTC+05:30"
      ],
      "borders": [
        "IN"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 144,
      "iso_3166_1_alpha2": "LK",
      "iso_3166_1_alpha3": "LKA",
      "tld": "lk",
      "vehicle_code": "CL",
      "fips10": "CE",
      "un_locode": "LK",
      "stanag_1059": "LKA",
      "ioc": "SRI",
      "fifa": "SRI",
      "itu": "CLN",
      "uic": "",
      "maritime": 417,
      "mmc": 413
    }
  },
  {
    "locale": "sk-SK",
    "language": {
      "name": "Slovak",
      "name_local": "slovenčina",
      "iso_639_1": "sk",
      "iso_639_2": "slk",
      "iso_639_3": "slk",
      "countries": [
        {
          "name": "Slovakia",
          "name_local": "Slovensko",
          "code": "SK"
        },
        {
          "name": "Czechia",
          "name_local": "Česko, Česká republika",
          "code": "CZ"
        }
      ]
    },
    "country": {
      "name": "Slovakia",
      "name_local": "Slovensko",
      "code": "SK",
      "area_sq_km": 49037,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Bratislava",
      "capital_latitude": 48.14816,
      "capital_longitude": 17.10674,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Slovak",
          "name_local": "slovenčina",
          "iso_639_1": "sk",
          "iso_639_2": "slk",
          "iso_639_3": "slk"
        }
      ],
      "flag": "🇸🇰",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "CZ",
        "HU",
        "PL",
        "UA"
      ],
      "is_landlocked": true,
      "postal_code_format": "###  ##",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 703,
      "iso_3166_1_alpha2": "SK",
      "iso_3166_1_alpha3": "SVK",
      "tld": "sk",
      "vehicle_code": "SK",
      "fips10": "LO",
      "un_locode": "SK",
      "stanag_1059": "SVK",
      "ioc": "SVK",
      "fifa": "SVK",
      "itu": "SVK",
      "uic": "56 SK",
      "maritime": 267,
      "mmc": 231
    }
  },
  {
    "locale": "sk-CZ",
    "language": {
      "name": "Slovak",
      "name_local": "slovenčina",
      "iso_639_1": "sk",
      "iso_639_2": "slk",
      "iso_639_3": "slk",
      "countries": [
        {
          "name": "Slovakia",
          "name_local": "Slovensko",
          "code": "SK"
        },
        {
          "name": "Czechia",
          "name_local": "Česko, Česká republika",
          "code": "CZ"
        }
      ]
    },
    "country": {
      "name": "Czechia",
      "name_local": "Česko, Česká republika",
      "code": "CZ",
      "area_sq_km": 78865,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Prague",
      "capital_latitude": 50.08804,
      "capital_longitude": 14.42076,
      "currency": "Czech Krone",
      "currency_local": "Czech koruna",
      "currency_code": "CZK",
      "currency_symbol": "Kč",
      "currency_numeric": 203,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Haleru",
      "languages": [
        {
          "name": "Czech",
          "name_local": "čeština",
          "iso_639_1": "cs",
          "iso_639_2": "ces",
          "iso_639_3": "ces"
        },
        {
          "name": "Slovak",
          "name_local": "slovenčina",
          "iso_639_1": "sk",
          "iso_639_2": "slk",
          "iso_639_3": "slk"
        }
      ],
      "flag": "🇨🇿",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "DE",
        "PL",
        "SK"
      ],
      "is_landlocked": true,
      "postal_code_format": "### ##",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 203,
      "iso_3166_1_alpha2": "CZ",
      "iso_3166_1_alpha3": "CZE",
      "tld": "cz",
      "vehicle_code": "CZ",
      "fips10": "EZ",
      "un_locode": "CZ",
      "stanag_1059": "CZE",
      "ioc": "CZE",
      "fifa": "CZE",
      "itu": "CZE",
      "uic": "54 CZ",
      "maritime": 270,
      "mmc": 230
    }
  },
  {
    "locale": "sl-SI",
    "language": {
      "name": "Slovene",
      "name_local": "slovenski jezik",
      "iso_639_1": "sl",
      "iso_639_2": "slv",
      "iso_639_3": "slv",
      "countries": [
        {
          "name": "Slovenia",
          "name_local": "Slovenija",
          "code": "SI"
        }
      ]
    },
    "country": {
      "name": "Slovenia",
      "name_local": "Slovenija",
      "code": "SI",
      "area_sq_km": 20273,
      "continent": "Europe",
      "region": "Central Europe",
      "capital_name": "Ljubljana",
      "capital_latitude": 46.05108,
      "capital_longitude": 14.50513,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Slovene",
          "name_local": "slovenski jezik",
          "iso_639_1": "sl",
          "iso_639_2": "slv",
          "iso_639_3": "slv"
        }
      ],
      "flag": "🇸🇮",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AT",
        "HR",
        "IT",
        "HU"
      ],
      "is_landlocked": false,
      "postal_code_format": "SI- ####",
      "postal_code_regex": "^(?:SI)*(\\d{4})$",
      "iso_3166_1_numeric": 705,
      "iso_3166_1_alpha2": "SI",
      "iso_3166_1_alpha3": "SVN",
      "tld": "si",
      "vehicle_code": "SLO",
      "fips10": "SI",
      "un_locode": "SI",
      "stanag_1059": "SVN",
      "ioc": "SLO",
      "fifa": "SVN",
      "itu": "SVN",
      "uic": "79 SLO",
      "maritime": 278,
      "mmc": 293
    }
  },
  {
    "locale": "sm-AS",
    "language": {
      "name": "Samoan",
      "name_local": "gagana fa'a Samoa",
      "iso_639_1": "sm",
      "iso_639_2": "smo",
      "iso_639_3": "smo",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        }
      ]
    },
    "country": {
      "name": "American Samoa",
      "name_local": "Sāmoa Amelika",
      "code": "AS",
      "area_sq_km": 199,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Pago Pago",
      "capital_latitude": -14.27806,
      "capital_longitude": -170.7025,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Samoan",
          "name_local": "gagana fa'a Samoa",
          "iso_639_1": "sm",
          "iso_639_2": "smo",
          "iso_639_3": "smo"
        }
      ],
      "flag": "🇦🇸",
      "timezones": [
        "UTC-11:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 16,
      "iso_3166_1_alpha2": "AS",
      "iso_3166_1_alpha3": "ASM",
      "tld": "as",
      "vehicle_code": "USA",
      "fips10": "AQ",
      "un_locode": "AS",
      "stanag_1059": "ASM",
      "ioc": "ASA",
      "fifa": "ASA",
      "itu": "SMA",
      "uic": "",
      "maritime": 559,
      "mmc": 544
    }
  },
  {
    "locale": "sm-WS",
    "language": {
      "name": "Samoan",
      "name_local": "gagana fa'a Samoa",
      "iso_639_1": "sm",
      "iso_639_2": "smo",
      "iso_639_3": "smo",
      "countries": [
        {
          "name": "American Samoa",
          "name_local": "Sāmoa Amelika",
          "code": "AS"
        },
        {
          "name": "Samoa",
          "name_local": "Sāmoa",
          "code": "WS"
        }
      ]
    },
    "country": {
      "name": "Samoa",
      "name_local": "Sāmoa",
      "code": "WS",
      "area_sq_km": 2842,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Apia",
      "capital_latitude": -13.83333,
      "capital_longitude": -171.76666,
      "currency": "Tala",
      "currency_local": "Samoan tālā",
      "currency_code": "WST",
      "currency_symbol": "T",
      "currency_numeric": 882,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Sene",
      "languages": [
        {
          "name": "Samoan",
          "name_local": "gagana fa'a Samoa",
          "iso_639_1": "sm",
          "iso_639_2": "smo",
          "iso_639_3": "smo"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇼🇸",
      "timezones": [
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 882,
      "iso_3166_1_alpha2": "WS",
      "iso_3166_1_alpha3": "WSM",
      "tld": "ws",
      "vehicle_code": "WS",
      "fips10": "WS",
      "un_locode": "WS",
      "stanag_1059": "WSM",
      "ioc": "SAM",
      "fifa": "SAM",
      "itu": "SMO",
      "uic": "",
      "maritime": 561,
      "mmc": 549
    }
  },
  {
    "locale": "sn-ZW",
    "language": {
      "name": "Shona",
      "name_local": "chiShona",
      "iso_639_1": "sn",
      "iso_639_2": "sna",
      "iso_639_3": "sna",
      "countries": [
        {
          "name": "Zimbabwe",
          "name_local": "Zimbabwe",
          "code": "ZW"
        }
      ]
    },
    "country": {
      "name": "Zimbabwe",
      "name_local": "Zimbabwe",
      "code": "ZW",
      "area_sq_km": 390757,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Harare",
      "capital_latitude": -17.82772,
      "capital_longitude": 31.05337,
      "currency": "Zimbabwe Dollar",
      "currency_local": "Zimbabwean dollar",
      "currency_code": "ZWL",
      "currency_symbol": "$",
      "currency_numeric": 932,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Shona",
          "name_local": "chiShona",
          "iso_639_1": "sn",
          "iso_639_2": "sna",
          "iso_639_3": "sna"
        },
        {
          "name": "Northern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nd",
          "iso_639_2": "nde",
          "iso_639_3": "nde"
        }
      ],
      "flag": "🇿🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "MZ",
        "ZA",
        "ZM"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 716,
      "iso_3166_1_alpha2": "ZW",
      "iso_3166_1_alpha3": "ZWE",
      "tld": "zw",
      "vehicle_code": "ZW",
      "fips10": "ZI",
      "un_locode": "ZW",
      "stanag_1059": "ZWE",
      "ioc": "ZIM",
      "fifa": "ZIM",
      "itu": "ZWE",
      "uic": "",
      "maritime": 679,
      "mmc": 648
    }
  },
  {
    "locale": "so-SO",
    "language": {
      "name": "Somali",
      "name_local": "Soomaaliga",
      "iso_639_1": "so",
      "iso_639_2": "som",
      "iso_639_3": "som",
      "countries": [
        {
          "name": "Somalia",
          "name_local": "Soomaaliya / Somalia / الصومال",
          "code": "SO"
        }
      ]
    },
    "country": {
      "name": "Somalia",
      "name_local": "Soomaaliya / Somalia / الصومال",
      "code": "SO",
      "area_sq_km": 637657,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Mogadishu",
      "capital_latitude": 2.03711,
      "capital_longitude": 45.34375,
      "currency": "Somalian Shilling",
      "currency_local": "Somali shilling",
      "currency_code": "SOS",
      "currency_symbol": "Sh",
      "currency_numeric": 706,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centesimi",
      "languages": [
        {
          "name": "Somali",
          "name_local": "Soomaaliga",
          "iso_639_1": "so",
          "iso_639_2": "som",
          "iso_639_3": "som"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        }
      ],
      "flag": "🇸🇴",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "KE"
      ],
      "is_landlocked": false,
      "postal_code_format": "@@  #####",
      "postal_code_regex": "^([A-Z]{2}\\d{5})$",
      "iso_3166_1_numeric": 706,
      "iso_3166_1_alpha2": "SO",
      "iso_3166_1_alpha3": "SOM",
      "tld": "so",
      "vehicle_code": "SO",
      "fips10": "SO",
      "un_locode": "SO",
      "stanag_1059": "SOM",
      "ioc": "SOM",
      "fifa": "SOM",
      "itu": "SOM",
      "uic": "",
      "maritime": 666,
      "mmc": 637
    }
  },
  {
    "locale": "st-LS",
    "language": {
      "name": "Southern Sotho",
      "name_local": "Sesotho",
      "iso_639_1": "st",
      "iso_639_2": "sot",
      "iso_639_3": "sot",
      "countries": [
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "Lesotho",
      "name_local": "Lesotho",
      "code": "LS",
      "area_sq_km": 30355,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Maseru",
      "capital_latitude": -29.31667,
      "capital_longitude": 27.48333,
      "currency": "Lesotho Loti",
      "currency_local": "Lesotho loti",
      "currency_code": "LSL",
      "currency_symbol": "L",
      "currency_numeric": 426,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Lisente",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        }
      ],
      "flag": "🇱🇸",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "ZA"
      ],
      "is_landlocked": true,
      "postal_code_format": "###",
      "postal_code_regex": "^(\\d{3})$",
      "iso_3166_1_numeric": 426,
      "iso_3166_1_alpha2": "LS",
      "iso_3166_1_alpha3": "LSO",
      "tld": "ls",
      "vehicle_code": "LS",
      "fips10": "LT",
      "un_locode": "LS",
      "stanag_1059": "LSO",
      "ioc": "LES",
      "fifa": "LES",
      "itu": "LSO",
      "uic": "",
      "maritime": 644,
      "mmc": 651
    }
  },
  {
    "locale": "st-ZA",
    "language": {
      "name": "Southern Sotho",
      "name_local": "Sesotho",
      "iso_639_1": "st",
      "iso_639_2": "sot",
      "iso_639_3": "sot",
      "countries": [
        {
          "name": "Lesotho",
          "name_local": "Lesotho",
          "code": "LS"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "es-GQ",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Equatorial Guinea",
      "name_local": "Guinea Ecuatorial",
      "code": "GQ",
      "area_sq_km": 28051,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Malabo",
      "capital_latitude": 3.75,
      "capital_longitude": 8.78333,
      "currency": "Central African Franc",
      "currency_local": "Central African CFA franc",
      "currency_code": "XAF",
      "currency_symbol": "Fr",
      "currency_numeric": 950,
      "currency_subunit_value": 0,
      "currency_subunit_name": "",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        },
        {
          "name": "Fang",
          "name_local": "Fang",
          "iso_639_1": "",
          "iso_639_2": "fan",
          "iso_639_3": ""
        }
      ],
      "flag": "🇬🇶",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "CM",
        "GA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 226,
      "iso_3166_1_alpha2": "GQ",
      "iso_3166_1_alpha3": "GNQ",
      "tld": "gq",
      "vehicle_code": "GQ",
      "fips10": "EK",
      "un_locode": "GQ",
      "stanag_1059": "GNQ",
      "ioc": "GEQ",
      "fifa": "EQG",
      "itu": "GNE",
      "uic": "",
      "maritime": 631,
      "mmc": 627
    }
  },
  {
    "locale": "es-AR",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Argentina",
      "name_local": "Argentina",
      "code": "AR",
      "area_sq_km": 2780400,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Buenos Aires",
      "capital_latitude": -34.61315,
      "capital_longitude": -58.37723,
      "currency": "Argentine Peso",
      "currency_local": "Argentine peso",
      "currency_code": "ARS",
      "currency_symbol": "$",
      "currency_numeric": 32,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Guaraní",
          "name_local": "Avañe'ẽ",
          "iso_639_1": "gn",
          "iso_639_2": "grn",
          "iso_639_3": "grn"
        }
      ],
      "flag": "🇦🇷",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [
        "BO",
        "BR",
        "CL",
        "PY",
        "UY"
      ],
      "is_landlocked": false,
      "postal_code_format": "@####@@@",
      "postal_code_regex": "^([A-Z]\\d{4}[A-Z]{3})$",
      "iso_3166_1_numeric": 32,
      "iso_3166_1_alpha2": "AR",
      "iso_3166_1_alpha3": "ARG",
      "tld": "ar",
      "vehicle_code": "RA",
      "fips10": "AR",
      "un_locode": "AR",
      "stanag_1059": "ARG",
      "ioc": "ARG",
      "fifa": "ARG",
      "itu": "ARG",
      "uic": "",
      "maritime": 701,
      "mmc": 722
    }
  },
  {
    "locale": "es-BZ",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Belize",
      "name_local": "Belize",
      "code": "BZ",
      "area_sq_km": 22966,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Belmopan",
      "capital_latitude": 17.25,
      "capital_longitude": -88.76667,
      "currency": "Belize Dollar",
      "currency_local": "Belize dollar",
      "currency_code": "BZD",
      "currency_symbol": "$",
      "currency_numeric": 84,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇧🇿",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "GT",
        "MX"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 84,
      "iso_3166_1_alpha2": "BZ",
      "iso_3166_1_alpha3": "BLZ",
      "tld": "bz",
      "vehicle_code": "BZ",
      "fips10": "BH",
      "un_locode": "BZ",
      "stanag_1059": "BLZ",
      "ioc": "BIZ",
      "fifa": "BLZ",
      "itu": "BLZ",
      "uic": "",
      "maritime": 312,
      "mmc": 702
    }
  },
  {
    "locale": "es-BO",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Bolivia",
      "name_local": "Bolivia",
      "code": "BO",
      "area_sq_km": 1098581,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Sucre",
      "capital_latitude": -19.03332,
      "capital_longitude": -65.26274,
      "currency": "Boliviano",
      "currency_local": "Bolivian boliviano",
      "currency_code": "BOB",
      "currency_symbol": "Bs.",
      "currency_numeric": 68,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Aymara",
          "name_local": "aymar aru",
          "iso_639_1": "ay",
          "iso_639_2": "aym",
          "iso_639_3": "aym"
        },
        {
          "name": "Quechua",
          "name_local": "Runa Simi",
          "iso_639_1": "qu",
          "iso_639_2": "que",
          "iso_639_3": "que"
        }
      ],
      "flag": "🇧🇴",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BR",
        "CL",
        "PY",
        "PE"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 68,
      "iso_3166_1_alpha2": "BO",
      "iso_3166_1_alpha3": "BOL",
      "tld": "bo",
      "vehicle_code": "BOL",
      "fips10": "BL",
      "un_locode": "BO",
      "stanag_1059": "BOL",
      "ioc": "BOL",
      "fifa": "BOL",
      "itu": "BOL",
      "uic": "",
      "maritime": 720,
      "mmc": 736
    }
  },
  {
    "locale": "es-CL",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Chile",
      "name_local": "Chile",
      "code": "CL",
      "area_sq_km": 756102,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Santiago",
      "capital_latitude": -33.45694,
      "capital_longitude": -70.64827,
      "currency": "Chilean Peso",
      "currency_local": "Chilean peso",
      "currency_code": "CLP",
      "currency_symbol": "$",
      "currency_numeric": 152,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇨🇱",
      "timezones": [
        "UTC-06:00",
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BO",
        "PE"
      ],
      "is_landlocked": false,
      "postal_code_format": "#######",
      "postal_code_regex": "^(\\d{7})$",
      "iso_3166_1_numeric": 152,
      "iso_3166_1_alpha2": "CL",
      "iso_3166_1_alpha3": "CHL",
      "tld": "cl",
      "vehicle_code": "RCH",
      "fips10": "CI",
      "un_locode": "CL",
      "stanag_1059": "CHL",
      "ioc": "CHI",
      "fifa": "CHI",
      "itu": "CHL",
      "uic": "",
      "maritime": 725,
      "mmc": 730
    }
  },
  {
    "locale": "es-CR",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Costa Rica",
      "name_local": "Costa Rica",
      "code": "CR",
      "area_sq_km": 51100,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "San José",
      "capital_latitude": 9.93333,
      "capital_longitude": -84.08333,
      "currency": "Colón",
      "currency_local": "Costa Rican colón",
      "currency_code": "CRC",
      "currency_symbol": "₡",
      "currency_numeric": 188,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Céntimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇨🇷",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "NI",
        "PA"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 188,
      "iso_3166_1_alpha2": "CR",
      "iso_3166_1_alpha3": "CRI",
      "tld": "cr",
      "vehicle_code": "CR",
      "fips10": "CS",
      "un_locode": "CR",
      "stanag_1059": "CRI",
      "ioc": "CRC",
      "fifa": "CRC",
      "itu": "CTR",
      "uic": "",
      "maritime": 321,
      "mmc": 712
    }
  },
  {
    "locale": "es-DO",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Dominican Republic",
      "name_local": "República Dominicana",
      "code": "DO",
      "area_sq_km": 48671,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Santo Domingo",
      "capital_latitude": 18.50012,
      "capital_longitude": -69.98857,
      "currency": "Dominican Peso",
      "currency_local": "Dominican peso",
      "currency_code": "DOP",
      "currency_symbol": "$",
      "currency_numeric": 214,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇩🇴",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "HT"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 214,
      "iso_3166_1_alpha2": "DO",
      "iso_3166_1_alpha3": "DOM",
      "tld": "do",
      "vehicle_code": "DOM",
      "fips10": "DR",
      "un_locode": "DO",
      "stanag_1059": "DOM",
      "ioc": "DOM",
      "fifa": "DOM",
      "itu": "DOM",
      "uic": "",
      "maritime": 327,
      "mmc": 370
    }
  },
  {
    "locale": "es-EC",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Ecuador",
      "name_local": "Ecuador",
      "code": "EC",
      "area_sq_km": 276841,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Quito",
      "capital_latitude": -0.22985,
      "capital_longitude": -78.52495,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇪🇨",
      "timezones": [
        "UTC-06:00",
        "UTC-05:00"
      ],
      "borders": [
        "CO",
        "PE"
      ],
      "is_landlocked": false,
      "postal_code_format": "@####@",
      "postal_code_regex": "^([a-zA-Z]\\d{4}[a-zA-Z])$",
      "iso_3166_1_numeric": 218,
      "iso_3166_1_alpha2": "EC",
      "iso_3166_1_alpha3": "ECU",
      "tld": "ec",
      "vehicle_code": "EC",
      "fips10": "EC",
      "un_locode": "EC",
      "stanag_1059": "ECU",
      "ioc": "ECU",
      "fifa": "ECU",
      "itu": "EQA",
      "uic": "",
      "maritime": 735,
      "mmc": 740
    }
  },
  {
    "locale": "es-SV",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "El Salvador",
      "name_local": "El Salvador",
      "code": "SV",
      "area_sq_km": 21041,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "San Salvador",
      "capital_latitude": 13.68935,
      "capital_longitude": -89.18718,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇸🇻",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "GT",
        "HN"
      ],
      "is_landlocked": false,
      "postal_code_format": "CP ####",
      "postal_code_regex": "^(?:CP)*(\\d{4})$",
      "iso_3166_1_numeric": 222,
      "iso_3166_1_alpha2": "SV",
      "iso_3166_1_alpha3": "SLV",
      "tld": "sv",
      "vehicle_code": "ES",
      "fips10": "ES",
      "un_locode": "SV",
      "stanag_1059": "SLV",
      "ioc": "ESA",
      "fifa": "SLV",
      "itu": "SLV",
      "uic": "",
      "maritime": 359,
      "mmc": 706
    }
  },
  {
    "locale": "es-GU",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Guam",
      "name_local": "Guam",
      "code": "GU",
      "area_sq_km": 549,
      "continent": "Oceania",
      "region": "Micronesia",
      "capital_name": "Hagåtña",
      "capital_latitude": 13.47567,
      "capital_longitude": 144.74886,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chamorro",
          "name_local": "Chamoru",
          "iso_639_1": "ch",
          "iso_639_2": "cha",
          "iso_639_3": "cha"
        },
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇬🇺",
      "timezones": [
        "UTC+10:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "969##",
      "postal_code_regex": "^(969\\d{2})$",
      "iso_3166_1_numeric": 316,
      "iso_3166_1_alpha2": "GU",
      "iso_3166_1_alpha3": "GUM",
      "tld": "gu",
      "vehicle_code": "",
      "fips10": "GQ",
      "un_locode": "GU",
      "stanag_1059": "GUM",
      "ioc": "GUM",
      "fifa": "GUM",
      "itu": "GUM",
      "uic": "",
      "maritime": "",
      "mmc": 535
    }
  },
  {
    "locale": "es-GT",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Guatemala",
      "name_local": "República de Guatemala",
      "code": "GT",
      "area_sq_km": 108889,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Guatemala City",
      "capital_latitude": 14.64072,
      "capital_longitude": -90.51327,
      "currency": "Quetzal",
      "currency_local": "Guatemalan quetzal",
      "currency_code": "GTQ",
      "currency_symbol": "Q",
      "currency_numeric": 320,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇬🇹",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "BZ",
        "SV",
        "HN",
        "MX"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 320,
      "iso_3166_1_alpha2": "GT",
      "iso_3166_1_alpha3": "GTM",
      "tld": "gt",
      "vehicle_code": "GCA",
      "fips10": "GT",
      "un_locode": "GT",
      "stanag_1059": "GTM",
      "ioc": "GUA",
      "fifa": "GUA",
      "itu": "GTM",
      "uic": "",
      "maritime": 332,
      "mmc": 704
    }
  },
  {
    "locale": "es-HN",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Honduras",
      "name_local": "Honduras",
      "code": "HN",
      "area_sq_km": 112492,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Tegucigalpa",
      "capital_latitude": 14.0818,
      "capital_longitude": -87.20681,
      "currency": "Lempira",
      "currency_local": "Honduran lempira",
      "currency_code": "HNL",
      "currency_symbol": "L",
      "currency_numeric": 340,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇭🇳",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "GT",
        "SV",
        "NI"
      ],
      "is_landlocked": false,
      "postal_code_format": "@@####",
      "postal_code_regex": "^([A-Z]{2}\\d{4})$",
      "iso_3166_1_numeric": 340,
      "iso_3166_1_alpha2": "HN",
      "iso_3166_1_alpha3": "HND",
      "tld": "hn",
      "vehicle_code": "HN",
      "fips10": "HO",
      "un_locode": "HN",
      "stanag_1059": "HND",
      "ioc": "HON",
      "fifa": "HON",
      "itu": "HND",
      "uic": "",
      "maritime": 334,
      "mmc": 708
    }
  },
  {
    "locale": "es-CO",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Colombia",
      "name_local": "Colombia",
      "code": "CO",
      "area_sq_km": 1141748,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Bogota",
      "capital_latitude": 4.60971,
      "capital_longitude": -74.08175,
      "currency": "Colombian Peso",
      "currency_local": "Colombian peso",
      "currency_code": "COP",
      "currency_symbol": "$",
      "currency_numeric": 170,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇨🇴",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [
        "BR",
        "EC",
        "PA",
        "PE",
        "VE"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 170,
      "iso_3166_1_alpha2": "CO",
      "iso_3166_1_alpha3": "COL",
      "tld": "co",
      "vehicle_code": "CO",
      "fips10": "CO",
      "un_locode": "CO",
      "stanag_1059": "COL",
      "ioc": "COL",
      "fifa": "COL",
      "itu": "CLM",
      "uic": "",
      "maritime": 730,
      "mmc": 732
    }
  },
  {
    "locale": "es-CU",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Cuba",
      "name_local": "Cuba",
      "code": "CU",
      "area_sq_km": 109884,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "Havana",
      "capital_latitude": 23.13302,
      "capital_longitude": -82.38304,
      "currency": "Cuban Peso",
      "currency_local": "Cuban peso",
      "currency_code": "CUP",
      "currency_symbol": "$",
      "currency_numeric": 192,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇨🇺",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "CP #####",
      "postal_code_regex": "^(?:CP)*(\\d{5})$",
      "iso_3166_1_numeric": 192,
      "iso_3166_1_alpha2": "CU",
      "iso_3166_1_alpha3": "CUB",
      "tld": "cu",
      "vehicle_code": "C",
      "fips10": "CU",
      "un_locode": "CU",
      "stanag_1059": "CUB",
      "ioc": "CUB",
      "fifa": "CUB",
      "itu": "CUB",
      "uic": "40 C",
      "maritime": 323,
      "mmc": 368
    }
  },
  {
    "locale": "es-MX",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Mexico",
      "name_local": "México",
      "code": "MX",
      "area_sq_km": 1964375,
      "continent": "Central America",
      "region": "North America",
      "capital_name": "Mexico City",
      "capital_latitude": 19.42847,
      "capital_longitude": -99.12766,
      "currency": "Mexican Peso",
      "currency_local": "Mexican peso",
      "currency_code": "MXN",
      "currency_symbol": "$",
      "currency_numeric": 484,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇲🇽",
      "timezones": [
        "UTC-08:00",
        "UTC-07:00",
        "UTC-06:00"
      ],
      "borders": [
        "BZ",
        "GT",
        "US"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 484,
      "iso_3166_1_alpha2": "MX",
      "iso_3166_1_alpha3": "MEX",
      "tld": "mx",
      "vehicle_code": "MEX",
      "fips10": "MX",
      "un_locode": "MX",
      "stanag_1059": "MEX",
      "ioc": "MEX",
      "fifa": "MEX",
      "itu": "MEX",
      "uic": "",
      "maritime": 345,
      "mmc": 334
    }
  },
  {
    "locale": "es-NI",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Nicaragua",
      "name_local": "Nicaragua",
      "code": "NI",
      "area_sq_km": 130373,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Managua",
      "capital_latitude": 12.13282,
      "capital_longitude": -86.2504,
      "currency": "Córdoba Oro",
      "currency_local": "Nicaraguan córdoba",
      "currency_code": "NIO",
      "currency_symbol": "C$",
      "currency_numeric": 558,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centavos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇳🇮",
      "timezones": [
        "UTC-06:00"
      ],
      "borders": [
        "CR",
        "HN"
      ],
      "is_landlocked": false,
      "postal_code_format": "###-###-#",
      "postal_code_regex": "^(\\d{7})$",
      "iso_3166_1_numeric": 558,
      "iso_3166_1_alpha2": "NI",
      "iso_3166_1_alpha3": "NIC",
      "tld": "ni",
      "vehicle_code": "NIC",
      "fips10": "NU",
      "un_locode": "NI",
      "stanag_1059": "NIC",
      "ioc": "NCA",
      "fifa": "NCA",
      "itu": "NCG",
      "uic": "",
      "maritime": 350,
      "mmc": 710
    }
  },
  {
    "locale": "es-PA",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Panama",
      "name_local": "Panamá",
      "code": "PA",
      "area_sq_km": 75417,
      "continent": "Central America",
      "region": "Central America",
      "capital_name": "Panama City",
      "capital_latitude": 8.9936,
      "capital_longitude": -79.51973,
      "currency": "Panamanian Balboa",
      "currency_local": "Panamanian balboa",
      "currency_code": "PAB",
      "currency_symbol": "B/.",
      "currency_numeric": 590,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centesimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇵🇦",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [
        "CO",
        "CR"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 591,
      "iso_3166_1_alpha2": "PA",
      "iso_3166_1_alpha3": "PAN",
      "tld": "pa",
      "vehicle_code": "PA",
      "fips10": "PM",
      "un_locode": "PA",
      "stanag_1059": "PAN",
      "ioc": "PAN",
      "fifa": "PAN",
      "itu": "PNR",
      "uic": "",
      "maritime": "351, 352, 353, 354, 355, 356, 3",
      "mmc": 714
    }
  },
  {
    "locale": "es-PY",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Paraguay",
      "name_local": "Paraguay",
      "code": "PY",
      "area_sq_km": 406752,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Asunción",
      "capital_latitude": -25.30066,
      "capital_longitude": -57.63591,
      "currency": "Guaraní",
      "currency_local": "Paraguayan guaraní",
      "currency_code": "PYG",
      "currency_symbol": "₲",
      "currency_numeric": 600,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "Guaraní",
          "name_local": "Avañe'ẽ",
          "iso_639_1": "gn",
          "iso_639_2": "grn",
          "iso_639_3": "grn"
        }
      ],
      "flag": "🇵🇾",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "AR",
        "BO",
        "BR"
      ],
      "is_landlocked": true,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 600,
      "iso_3166_1_alpha2": "PY",
      "iso_3166_1_alpha3": "PRY",
      "tld": "py",
      "vehicle_code": "PY",
      "fips10": "PA",
      "un_locode": "PY",
      "stanag_1059": "PRY",
      "ioc": "PAR",
      "fifa": "PAR",
      "itu": "PRG",
      "uic": "",
      "maritime": 755,
      "mmc": 744
    }
  },
  {
    "locale": "es-PE",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Peru",
      "name_local": "Perú/Piruw",
      "code": "PE",
      "area_sq_km": 1285216,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Lima",
      "capital_latitude": -12.04318,
      "capital_longitude": -77.02824,
      "currency": "Nuevo Sol",
      "currency_local": "Peruvian sol",
      "currency_code": "PEN",
      "currency_symbol": "S/ ",
      "currency_numeric": 604,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Céntimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇵🇪",
      "timezones": [
        "UTC-05:00"
      ],
      "borders": [
        "BO",
        "BR",
        "CL",
        "CO",
        "EC"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 604,
      "iso_3166_1_alpha2": "PE",
      "iso_3166_1_alpha3": "PER",
      "tld": "pe",
      "vehicle_code": "PE",
      "fips10": "PE",
      "un_locode": "PE",
      "stanag_1059": "PER",
      "ioc": "PER",
      "fifa": "PER",
      "itu": "PRU",
      "uic": "",
      "maritime": 760,
      "mmc": 716
    }
  },
  {
    "locale": "es-PR",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Puerto Rico",
      "name_local": "Puerto Rico",
      "code": "PR",
      "area_sq_km": 8870,
      "continent": "Central America",
      "region": "Caribbean",
      "capital_name": "San Juan",
      "capital_latitude": 18.46633,
      "capital_longitude": -66.10572,
      "currency": "US Dollar",
      "currency_local": "United States dollar",
      "currency_code": "USD",
      "currency_symbol": "$",
      "currency_numeric": 840,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇷",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####-####",
      "postal_code_regex": "^(\\d{9})$",
      "iso_3166_1_numeric": 630,
      "iso_3166_1_alpha2": "PR",
      "iso_3166_1_alpha3": "PRI",
      "tld": "pr",
      "vehicle_code": "PRI",
      "fips10": "RQ",
      "un_locode": "PR",
      "stanag_1059": "PRI",
      "ioc": "PUR",
      "fifa": "PUR",
      "itu": "PTR",
      "uic": "",
      "maritime": 358,
      "mmc": 330
    }
  },
  {
    "locale": "es-ES",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Spain",
      "name_local": "España",
      "code": "ES",
      "area_sq_km": 505992,
      "continent": "Europe",
      "region": "Southern Europe",
      "capital_name": "Madrid",
      "capital_latitude": 40.4165,
      "capital_longitude": -3.70256,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇪🇸",
      "timezones": [
        "UTC",
        "UTC+01:00"
      ],
      "borders": [
        "AD",
        "FR",
        "GI",
        "PT",
        "MA"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 724,
      "iso_3166_1_alpha2": "ES",
      "iso_3166_1_alpha3": "ESP",
      "tld": "es",
      "vehicle_code": "E",
      "fips10": "SP",
      "un_locode": "ES",
      "stanag_1059": "ESP",
      "ioc": "ESP",
      "fifa": "ESP",
      "itu": "E",
      "uic": "71 ES",
      "maritime": "224, 225",
      "mmc": 214
    }
  },
  {
    "locale": "es-UY",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Uruguay",
      "name_local": "Uruguay",
      "code": "UY",
      "area_sq_km": 181034,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Montevideo",
      "capital_latitude": -34.90328,
      "capital_longitude": -56.18816,
      "currency": "Uruguay Peso",
      "currency_local": "Uruguayan peso",
      "currency_code": "UYU",
      "currency_symbol": "$",
      "currency_numeric": 858,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centesimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇺🇾",
      "timezones": [
        "UTC-03:00"
      ],
      "borders": [
        "AR",
        "BR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 858,
      "iso_3166_1_alpha2": "UY",
      "iso_3166_1_alpha3": "URY",
      "tld": "uy",
      "vehicle_code": "ROU",
      "fips10": "UY",
      "un_locode": "UY",
      "stanag_1059": "URY",
      "ioc": "URU",
      "fifa": "URU",
      "itu": "URG",
      "uic": "",
      "maritime": 770,
      "mmc": 748
    }
  },
  {
    "locale": "es-VE",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Venezuela",
      "name_local": "Venezuela",
      "code": "VE",
      "area_sq_km": 916445,
      "continent": "South America",
      "region": "South America",
      "capital_name": "Caracas",
      "capital_latitude": 10.48801,
      "capital_longitude": -66.87919,
      "currency": "Bolivar digital",
      "currency_local": "",
      "currency_code": "VED",
      "currency_symbol": "",
      "currency_numeric": 926,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Céntimos",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇻🇪",
      "timezones": [
        "UTC-04:00"
      ],
      "borders": [
        "BR",
        "CO",
        "GY"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 862,
      "iso_3166_1_alpha2": "VE",
      "iso_3166_1_alpha3": "VEN",
      "tld": "ve",
      "vehicle_code": "YV",
      "fips10": "VE",
      "un_locode": "VE",
      "stanag_1059": "VEN",
      "ioc": "VEN",
      "fifa": "VEN",
      "itu": "VEN",
      "uic": "",
      "maritime": 775,
      "mmc": 734
    }
  },
  {
    "locale": "es-EH",
    "language": {
      "name": "Spanish",
      "name_local": "Español",
      "iso_639_1": "es",
      "iso_639_2": "spa",
      "iso_639_3": "spa",
      "countries": [
        {
          "name": "Equatorial Guinea",
          "name_local": "Guinea Ecuatorial",
          "code": "GQ"
        },
        {
          "name": "Argentina",
          "name_local": "Argentina",
          "code": "AR"
        },
        {
          "name": "Belize",
          "name_local": "Belize",
          "code": "BZ"
        },
        {
          "name": "Bolivia",
          "name_local": "Bolivia",
          "code": "BO"
        },
        {
          "name": "Chile",
          "name_local": "Chile",
          "code": "CL"
        },
        {
          "name": "Costa Rica",
          "name_local": "Costa Rica",
          "code": "CR"
        },
        {
          "name": "Dominican Republic",
          "name_local": "República Dominicana",
          "code": "DO"
        },
        {
          "name": "Ecuador",
          "name_local": "Ecuador",
          "code": "EC"
        },
        {
          "name": "El Salvador",
          "name_local": "El Salvador",
          "code": "SV"
        },
        {
          "name": "Guam",
          "name_local": "Guam",
          "code": "GU"
        },
        {
          "name": "Guatemala",
          "name_local": "República de Guatemala",
          "code": "GT"
        },
        {
          "name": "Honduras",
          "name_local": "Honduras",
          "code": "HN"
        },
        {
          "name": "Colombia",
          "name_local": "Colombia",
          "code": "CO"
        },
        {
          "name": "Cuba",
          "name_local": "Cuba",
          "code": "CU"
        },
        {
          "name": "Mexico",
          "name_local": "México",
          "code": "MX"
        },
        {
          "name": "Nicaragua",
          "name_local": "Nicaragua",
          "code": "NI"
        },
        {
          "name": "Panama",
          "name_local": "Panamá",
          "code": "PA"
        },
        {
          "name": "Paraguay",
          "name_local": "Paraguay",
          "code": "PY"
        },
        {
          "name": "Peru",
          "name_local": "Perú/Piruw",
          "code": "PE"
        },
        {
          "name": "Puerto Rico",
          "name_local": "Puerto Rico",
          "code": "PR"
        },
        {
          "name": "Spain",
          "name_local": "España",
          "code": "ES"
        },
        {
          "name": "Uruguay",
          "name_local": "Uruguay",
          "code": "UY"
        },
        {
          "name": "Venezuela",
          "name_local": "Venezuela",
          "code": "VE"
        },
        {
          "name": "Western Sahara",
          "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
          "code": "EH"
        }
      ]
    },
    "country": {
      "name": "Western Sahara",
      "name_local": "الصحراء الغربية / aṣ-Ṣaḥrāʾ al-Ġarbiyya",
      "code": "EH",
      "area_sq_km": 266000,
      "continent": "Africa",
      "region": "Northern Africa",
      "capital_name": "El Aaiún",
      "capital_latitude": 27.1418,
      "capital_longitude": -13.18797,
      "currency": "Moroccan Dirham",
      "currency_local": "Moroccan dirham",
      "currency_code": "MAD",
      "currency_symbol": "DH",
      "currency_numeric": 504,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "Spanish",
          "name_local": "Español",
          "iso_639_1": "es",
          "iso_639_2": "spa",
          "iso_639_3": "spa"
        }
      ],
      "flag": "🇪🇭",
      "timezones": [
        "UTC+00:00"
      ],
      "borders": [
        "DZ",
        "MR",
        "MA"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 732,
      "iso_3166_1_alpha2": "EH",
      "iso_3166_1_alpha3": "ESH",
      "tld": "eh",
      "vehicle_code": "WSA",
      "fips10": "WI",
      "un_locode": "EH",
      "stanag_1059": "ESH",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "sq-AL",
    "language": {
      "name": "Albanian",
      "name_local": "Shqip",
      "iso_639_1": "sq",
      "iso_639_2": "sqi",
      "iso_639_3": "sqi",
      "countries": [
        {
          "name": "Albania",
          "name_local": "Republika e Shqipërisë",
          "code": "AL"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Albania",
      "name_local": "Republika e Shqipërisë",
      "code": "AL",
      "area_sq_km": 28748,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Tirana",
      "capital_latitude": 41.3275,
      "capital_longitude": 19.81889,
      "currency": "Lek",
      "currency_local": "Albanian lek",
      "currency_code": "ALL",
      "currency_symbol": "L",
      "currency_numeric": 8,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Qindarka",
      "languages": [
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        }
      ],
      "flag": "🇦🇱",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "ME",
        "GR",
        "MK",
        "XK"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 8,
      "iso_3166_1_alpha2": "AL",
      "iso_3166_1_alpha3": "ALB",
      "tld": "al",
      "vehicle_code": "AL",
      "fips10": "AL",
      "un_locode": "AL",
      "stanag_1059": "ALB",
      "ioc": "ALB",
      "fifa": "ALB",
      "itu": "ALB",
      "uic": "41 AL",
      "maritime": 201,
      "mmc": 276
    }
  },
  {
    "locale": "sq-XK",
    "language": {
      "name": "Albanian",
      "name_local": "Shqip",
      "iso_639_1": "sq",
      "iso_639_2": "sqi",
      "iso_639_3": "sqi",
      "countries": [
        {
          "name": "Albania",
          "name_local": "Republika e Shqipërisë",
          "code": "AL"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Kosovo",
      "name_local": "Kosova",
      "code": "XK",
      "area_sq_km": 10908,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Pristina",
      "capital_latitude": 42.67272,
      "capital_longitude": 21.16688,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇽🇰",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "MK",
        "ME",
        "RS"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": "",
      "iso_3166_1_alpha2": "XK",
      "iso_3166_1_alpha3": "XKX",
      "tld": "ko",
      "vehicle_code": "RKS",
      "fips10": "KV",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "KOS",
      "fifa": "KVX",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "sq-ME",
    "language": {
      "name": "Albanian",
      "name_local": "Shqip",
      "iso_639_1": "sq",
      "iso_639_2": "sqi",
      "iso_639_3": "sqi",
      "countries": [
        {
          "name": "Albania",
          "name_local": "Republika e Shqipërisë",
          "code": "AL"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        }
      ]
    },
    "country": {
      "name": "Montenegro",
      "name_local": "Црна Гора / Crna Gora / Mali i Zi",
      "code": "ME",
      "area_sq_km": 13812,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Podgorica",
      "capital_latitude": 42.44111,
      "capital_longitude": 19.26361,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        },
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        }
      ],
      "flag": "🇲🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "BA",
        "HR",
        "XK",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 499,
      "iso_3166_1_alpha2": "ME",
      "iso_3166_1_alpha3": "MNE",
      "tld": "me",
      "vehicle_code": "MNE",
      "fips10": "MJ",
      "un_locode": "ME",
      "stanag_1059": "",
      "ioc": "MNE",
      "fifa": "MNE",
      "itu": "MNE",
      "uic": "62 CG",
      "maritime": 262,
      "mmc": 297
    }
  },
  {
    "locale": "sr-BA",
    "language": {
      "name": "Serbian",
      "name_local": "српски језик",
      "iso_639_1": "sr",
      "iso_639_2": "srp",
      "iso_639_3": "srp",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        },
        {
          "name": "Serbia",
          "name_local": "Србија Srbija",
          "code": "RS"
        }
      ]
    },
    "country": {
      "name": "Bosnia and Herzegovina",
      "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
      "code": "BA",
      "area_sq_km": 51209,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Sarajevo",
      "capital_latitude": 43.84864,
      "capital_longitude": 18.35644,
      "currency": "Convertible Mark",
      "currency_local": "Bosnia and Herzegovina convertible mark",
      "currency_code": "BAM",
      "currency_symbol": "",
      "currency_numeric": 977,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fening",
      "languages": [
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        },
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇧🇦",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "HR",
        "ME",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 70,
      "iso_3166_1_alpha2": "BA",
      "iso_3166_1_alpha3": "BIH",
      "tld": "ba",
      "vehicle_code": "BIH",
      "fips10": "BK",
      "un_locode": "BA",
      "stanag_1059": "BIH",
      "ioc": "BIH",
      "fifa": "BIH",
      "itu": "BIH",
      "uic": "44-50 BIH",
      "maritime": 478,
      "mmc": 218
    }
  },
  {
    "locale": "sr-XK",
    "language": {
      "name": "Serbian",
      "name_local": "српски језик",
      "iso_639_1": "sr",
      "iso_639_2": "srp",
      "iso_639_3": "srp",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        },
        {
          "name": "Serbia",
          "name_local": "Србија Srbija",
          "code": "RS"
        }
      ]
    },
    "country": {
      "name": "Kosovo",
      "name_local": "Kosova",
      "code": "XK",
      "area_sq_km": 10908,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Pristina",
      "capital_latitude": 42.67272,
      "capital_longitude": 21.16688,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇽🇰",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "MK",
        "ME",
        "RS"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": "",
      "iso_3166_1_alpha2": "XK",
      "iso_3166_1_alpha3": "XKX",
      "tld": "ko",
      "vehicle_code": "RKS",
      "fips10": "KV",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "KOS",
      "fifa": "KVX",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "sr-ME",
    "language": {
      "name": "Serbian",
      "name_local": "српски језик",
      "iso_639_1": "sr",
      "iso_639_2": "srp",
      "iso_639_3": "srp",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        },
        {
          "name": "Serbia",
          "name_local": "Србија Srbija",
          "code": "RS"
        }
      ]
    },
    "country": {
      "name": "Montenegro",
      "name_local": "Црна Гора / Crna Gora / Mali i Zi",
      "code": "ME",
      "area_sq_km": 13812,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Podgorica",
      "capital_latitude": 42.44111,
      "capital_longitude": 19.26361,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        },
        {
          "name": "Bosnian",
          "name_local": "bosanski jezik",
          "iso_639_1": "bs",
          "iso_639_2": "bos",
          "iso_639_3": "bos"
        },
        {
          "name": "Albanian",
          "name_local": "Shqip",
          "iso_639_1": "sq",
          "iso_639_2": "sqi",
          "iso_639_3": "sqi"
        },
        {
          "name": "Croatian",
          "name_local": "hrvatski jezik",
          "iso_639_1": "hr",
          "iso_639_2": "hrv",
          "iso_639_3": "hrv"
        }
      ],
      "flag": "🇲🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "AL",
        "BA",
        "HR",
        "XK",
        "RS"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 499,
      "iso_3166_1_alpha2": "ME",
      "iso_3166_1_alpha3": "MNE",
      "tld": "me",
      "vehicle_code": "MNE",
      "fips10": "MJ",
      "un_locode": "ME",
      "stanag_1059": "",
      "ioc": "MNE",
      "fifa": "MNE",
      "itu": "MNE",
      "uic": "62 CG",
      "maritime": 262,
      "mmc": 297
    }
  },
  {
    "locale": "sr-RS",
    "language": {
      "name": "Serbian",
      "name_local": "српски језик",
      "iso_639_1": "sr",
      "iso_639_2": "srp",
      "iso_639_3": "srp",
      "countries": [
        {
          "name": "Bosnia and Herzegovina",
          "name_local": "Bosna i Hercegovina / Босна и Херцеговина",
          "code": "BA"
        },
        {
          "name": "Kosovo",
          "name_local": "Kosova",
          "code": "XK"
        },
        {
          "name": "Montenegro",
          "name_local": "Црна Гора / Crna Gora / Mali i Zi",
          "code": "ME"
        },
        {
          "name": "Serbia",
          "name_local": "Србија Srbija",
          "code": "RS"
        }
      ]
    },
    "country": {
      "name": "Serbia",
      "name_local": "Србија Srbija",
      "code": "RS",
      "area_sq_km": 88361,
      "continent": "Europe",
      "region": "Southeast Europe",
      "capital_name": "Belgrade",
      "capital_latitude": 44.80401,
      "capital_longitude": 20.46513,
      "currency": "Serbian Dinar",
      "currency_local": "Serbian dinar",
      "currency_code": "RSD",
      "currency_symbol": "дин.",
      "currency_numeric": 941,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Para",
      "languages": [
        {
          "name": "Serbian",
          "name_local": "српски језик",
          "iso_639_1": "sr",
          "iso_639_2": "srp",
          "iso_639_3": "srp"
        }
      ],
      "flag": "🇷🇸",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "BA",
        "BG",
        "HR",
        "HU",
        "XK",
        "MK",
        "ME",
        "RO"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 688,
      "iso_3166_1_alpha2": "RS",
      "iso_3166_1_alpha3": "SRB",
      "tld": "rs",
      "vehicle_code": "SRB",
      "fips10": "RI",
      "un_locode": "RS",
      "stanag_1059": "",
      "ioc": "SRB",
      "fifa": "SRB",
      "itu": "SRB",
      "uic": "72 SRB",
      "maritime": 279,
      "mmc": 220
    }
  },
  {
    "locale": "ss-SZ",
    "language": {
      "name": "Swati",
      "name_local": "SiSwati",
      "iso_639_1": "ss",
      "iso_639_2": "ssw",
      "iso_639_3": "ssw",
      "countries": [
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "Eswatini",
      "name_local": "Umbuso weSwatini",
      "code": "SZ",
      "area_sq_km": 17364,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Mbabane",
      "capital_latitude": -26.31667,
      "capital_longitude": 31.13333,
      "currency": "Swazi Lilangeni",
      "currency_local": "Swazi lilangeni",
      "currency_code": "SZL",
      "currency_symbol": "L",
      "currency_numeric": 748,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        }
      ],
      "flag": "🇸🇿",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "MZ",
        "ZA"
      ],
      "is_landlocked": true,
      "postal_code_format": "@###",
      "postal_code_regex": "^([A-Z]\\d{3})$",
      "iso_3166_1_numeric": 748,
      "iso_3166_1_alpha2": "SZ",
      "iso_3166_1_alpha3": "SWZ",
      "tld": "sz",
      "vehicle_code": "SD",
      "fips10": "WZ",
      "un_locode": "SZ",
      "stanag_1059": "SWZ",
      "ioc": "SWZ",
      "fifa": "SWZ",
      "itu": "SWZ",
      "uic": "",
      "maritime": 669,
      "mmc": 653
    }
  },
  {
    "locale": "ss-ZA",
    "language": {
      "name": "Swati",
      "name_local": "SiSwati",
      "iso_639_1": "ss",
      "iso_639_2": "ssw",
      "iso_639_3": "ssw",
      "countries": [
        {
          "name": "Eswatini",
          "name_local": "Umbuso weSwatini",
          "code": "SZ"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "ssy-ER",
    "language": {
      "name": "Saho",
      "name_local": "Saho",
      "iso_639_1": "",
      "iso_639_2": "ssy",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "sw-CD",
    "language": {
      "name": "Swahili",
      "name_local": "Kiswahili",
      "iso_639_1": "sw",
      "iso_639_2": "swa",
      "iso_639_3": "swa",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        }
      ]
    },
    "country": {
      "name": "Democratic Republic of the Congo",
      "name_local": "République Démocratique du Congo",
      "code": "CD",
      "area_sq_km": 2344858,
      "continent": "Africa",
      "region": "Middle Africa",
      "capital_name": "Kinshasa",
      "capital_latitude": -4.32758,
      "capital_longitude": 15.31357,
      "currency": "Congolais Franc",
      "currency_local": "Congolese franc",
      "currency_code": "CDF",
      "currency_symbol": "FC",
      "currency_numeric": 976,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Centimes",
      "languages": [
        {
          "name": "French",
          "name_local": "français",
          "iso_639_1": "fr",
          "iso_639_2": "fra",
          "iso_639_3": "fra"
        },
        {
          "name": "Lingala",
          "name_local": "Lingála",
          "iso_639_1": "ln",
          "iso_639_2": "lin",
          "iso_639_3": "lin"
        },
        {
          "name": "Kongo",
          "name_local": "Kikongo",
          "iso_639_1": "kg",
          "iso_639_2": "kon",
          "iso_639_3": "kon"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "Luba-Katanga",
          "name_local": "Tshiluba",
          "iso_639_1": "lu",
          "iso_639_2": "lub",
          "iso_639_3": "lub"
        }
      ],
      "flag": "🇨🇩",
      "timezones": [
        "UTC+01:00",
        "UTC+02:00"
      ],
      "borders": [
        "AO",
        "BI",
        "CF",
        "CG",
        "RW",
        "SS",
        "TZ",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 180,
      "iso_3166_1_alpha2": "CD",
      "iso_3166_1_alpha3": "COD",
      "tld": "cd",
      "vehicle_code": "CGO",
      "fips10": "CG",
      "un_locode": "CD",
      "stanag_1059": "COD",
      "ioc": "COD",
      "fifa": "COD",
      "itu": "COD",
      "uic": "CD",
      "maritime": 676,
      "mmc": 630
    }
  },
  {
    "locale": "sw-KE",
    "language": {
      "name": "Swahili",
      "name_local": "Kiswahili",
      "iso_639_1": "sw",
      "iso_639_2": "swa",
      "iso_639_3": "swa",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        }
      ]
    },
    "country": {
      "name": "Kenya",
      "name_local": "Kenya",
      "code": "KE",
      "area_sq_km": 580367,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Nairobi",
      "capital_latitude": -1.28333,
      "capital_longitude": 36.81667,
      "currency": "Kenian Schilling",
      "currency_local": "Kenyan shilling",
      "currency_code": "KES",
      "currency_symbol": "Sh",
      "currency_numeric": 404,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        }
      ],
      "flag": "🇰🇪",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "ET",
        "SO",
        "SS",
        "TZ",
        "UG"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 404,
      "iso_3166_1_alpha2": "KE",
      "iso_3166_1_alpha3": "KEN",
      "tld": "ke",
      "vehicle_code": "EAK",
      "fips10": "KE",
      "un_locode": "KE",
      "stanag_1059": "KEN",
      "ioc": "KEN",
      "fifa": "KEN",
      "itu": "KEN",
      "uic": "",
      "maritime": 634,
      "mmc": 639
    }
  },
  {
    "locale": "sw-TZ",
    "language": {
      "name": "Swahili",
      "name_local": "Kiswahili",
      "iso_639_1": "sw",
      "iso_639_2": "swa",
      "iso_639_3": "swa",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        }
      ]
    },
    "country": {
      "name": "Tanzania",
      "name_local": "Tanzania",
      "code": "TZ",
      "area_sq_km": 945087,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Dodoma",
      "capital_latitude": -6.17221,
      "capital_longitude": 35.73947,
      "currency": "Tansanian Shilling",
      "currency_local": "Tanzanian shilling",
      "currency_code": "TZS",
      "currency_symbol": "Sh",
      "currency_numeric": 834,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇹🇿",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "BI",
        "CD",
        "KE",
        "MW",
        "MZ",
        "RW",
        "UG",
        "ZM"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 834,
      "iso_3166_1_alpha2": "TZ",
      "iso_3166_1_alpha3": "TZA",
      "tld": "tz",
      "vehicle_code": "EAT",
      "fips10": "TZ",
      "un_locode": "TZ",
      "stanag_1059": "TZA",
      "ioc": "TAN",
      "fifa": "TAN",
      "itu": "TZA",
      "uic": "",
      "maritime": "674, 677",
      "mmc": 640
    }
  },
  {
    "locale": "sw-UG",
    "language": {
      "name": "Swahili",
      "name_local": "Kiswahili",
      "iso_639_1": "sw",
      "iso_639_2": "swa",
      "iso_639_3": "swa",
      "countries": [
        {
          "name": "Democratic Republic of the Congo",
          "name_local": "République Démocratique du Congo",
          "code": "CD"
        },
        {
          "name": "Kenya",
          "name_local": "Kenya",
          "code": "KE"
        },
        {
          "name": "Tanzania",
          "name_local": "Tanzania",
          "code": "TZ"
        },
        {
          "name": "Uganda",
          "name_local": "Uganda",
          "code": "UG"
        }
      ]
    },
    "country": {
      "name": "Uganda",
      "name_local": "Uganda",
      "code": "UG",
      "area_sq_km": 241550,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Kampala",
      "capital_latitude": 0.31628,
      "capital_longitude": 32.58219,
      "currency": "Ugandan Schilling",
      "currency_local": "Ugandan shilling",
      "currency_code": "UGX",
      "currency_symbol": "Sh",
      "currency_numeric": 800,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Swahili",
          "name_local": "Kiswahili",
          "iso_639_1": "sw",
          "iso_639_2": "swa",
          "iso_639_3": "swa"
        }
      ],
      "flag": "🇺🇬",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "CD",
        "KE",
        "RW",
        "SS",
        "TZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 800,
      "iso_3166_1_alpha2": "UG",
      "iso_3166_1_alpha3": "UGA",
      "tld": "ug",
      "vehicle_code": "EAU",
      "fips10": "UG",
      "un_locode": "UG",
      "stanag_1059": "UGA",
      "ioc": "UGA",
      "fifa": "UGA",
      "itu": "UGA",
      "uic": "",
      "maritime": 675,
      "mmc": 641
    }
  },
  {
    "locale": "sv-AX",
    "language": {
      "name": "Swedish",
      "name_local": "svenska",
      "iso_639_1": "sv",
      "iso_639_2": "swe",
      "iso_639_3": "swe",
      "countries": [
        {
          "name": "Åland Islands",
          "name_local": "Ahvenanmaa",
          "code": "AX"
        },
        {
          "name": "Finland",
          "name_local": "Suomi",
          "code": "FI"
        },
        {
          "name": "Sweden",
          "name_local": "Sverige",
          "code": "SE"
        }
      ]
    },
    "country": {
      "name": "Åland Islands",
      "name_local": "Ahvenanmaa",
      "code": "AX",
      "area_sq_km": 1580,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Mariehamn",
      "capital_latitude": 60.09726,
      "capital_longitude": 19.93481,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Swedish",
          "name_local": "svenska",
          "iso_639_1": "sv",
          "iso_639_2": "swe",
          "iso_639_3": "swe"
        }
      ],
      "flag": "🇦🇽",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 248,
      "iso_3166_1_alpha2": "AX",
      "iso_3166_1_alpha3": "ALA",
      "tld": "ax",
      "vehicle_code": "AX",
      "fips10": "",
      "un_locode": "",
      "stanag_1059": "",
      "ioc": "",
      "fifa": "",
      "itu": "",
      "uic": "",
      "maritime": "",
      "mmc": ""
    }
  },
  {
    "locale": "sv-FI",
    "language": {
      "name": "Swedish",
      "name_local": "svenska",
      "iso_639_1": "sv",
      "iso_639_2": "swe",
      "iso_639_3": "swe",
      "countries": [
        {
          "name": "Åland Islands",
          "name_local": "Ahvenanmaa",
          "code": "AX"
        },
        {
          "name": "Finland",
          "name_local": "Suomi",
          "code": "FI"
        },
        {
          "name": "Sweden",
          "name_local": "Sverige",
          "code": "SE"
        }
      ]
    },
    "country": {
      "name": "Finland",
      "name_local": "Suomi",
      "code": "FI",
      "area_sq_km": 338424,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Helsinki",
      "capital_latitude": 60.16952,
      "capital_longitude": 24.93545,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Finnish",
          "name_local": "suomi",
          "iso_639_1": "fi",
          "iso_639_2": "fin",
          "iso_639_3": "fin"
        },
        {
          "name": "Swedish",
          "name_local": "svenska",
          "iso_639_1": "sv",
          "iso_639_2": "swe",
          "iso_639_3": "swe"
        }
      ],
      "flag": "🇫🇮",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "NO",
        "SE",
        "RU"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(?:FI)*(\\d{5})$",
      "iso_3166_1_numeric": 246,
      "iso_3166_1_alpha2": "FI",
      "iso_3166_1_alpha3": "FIN",
      "tld": "fi",
      "vehicle_code": "FIN",
      "fips10": "FI",
      "un_locode": "FI",
      "stanag_1059": "FIN",
      "ioc": "FIN",
      "fifa": "FIN",
      "itu": "FIN",
      "uic": "10 FIN",
      "maritime": 230,
      "mmc": 244
    }
  },
  {
    "locale": "sv-SE",
    "language": {
      "name": "Swedish",
      "name_local": "svenska",
      "iso_639_1": "sv",
      "iso_639_2": "swe",
      "iso_639_3": "swe",
      "countries": [
        {
          "name": "Åland Islands",
          "name_local": "Ahvenanmaa",
          "code": "AX"
        },
        {
          "name": "Finland",
          "name_local": "Suomi",
          "code": "FI"
        },
        {
          "name": "Sweden",
          "name_local": "Sverige",
          "code": "SE"
        }
      ]
    },
    "country": {
      "name": "Sweden",
      "name_local": "Sverige",
      "code": "SE",
      "area_sq_km": 450295,
      "continent": "Europe",
      "region": "Northern Europe",
      "capital_name": "Stockholm",
      "capital_latitude": 59.33258,
      "capital_longitude": 18.0649,
      "currency": "Swedish Krone",
      "currency_local": "Swedish krona",
      "currency_code": "SEK",
      "currency_symbol": "kr",
      "currency_numeric": 752,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Öre",
      "languages": [
        {
          "name": "Swedish",
          "name_local": "svenska",
          "iso_639_1": "sv",
          "iso_639_2": "swe",
          "iso_639_3": "swe"
        }
      ],
      "flag": "🇸🇪",
      "timezones": [
        "UTC+01:00"
      ],
      "borders": [
        "FI",
        "NO"
      ],
      "is_landlocked": false,
      "postal_code_format": "SE-### ##",
      "postal_code_regex": "^(?:SE)*(\\d{5})$",
      "iso_3166_1_numeric": 752,
      "iso_3166_1_alpha2": "SE",
      "iso_3166_1_alpha3": "SWE",
      "tld": "se",
      "vehicle_code": "S",
      "fips10": "SW",
      "un_locode": "SE",
      "stanag_1059": "SWE",
      "ioc": "SWE",
      "fifa": "SWE",
      "itu": "S",
      "uic": "74 S",
      "maritime": "265, 266",
      "mmc": 240
    }
  },
  {
    "locale": "ta-SG",
    "language": {
      "name": "Tamil",
      "name_local": "தமிழ்",
      "iso_639_1": "ta",
      "iso_639_2": "tam",
      "iso_639_3": "tam",
      "countries": [
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sri Lanka",
          "name_local": "ශ්‍රී ලංකා / இலங்கை",
          "code": "LK"
        }
      ]
    },
    "country": {
      "name": "Singapore",
      "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
      "code": "SG",
      "area_sq_km": 710,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Singapore",
      "capital_latitude": 1.28967,
      "capital_longitude": 103.85007,
      "currency": "Singapore Dollar",
      "currency_local": "Singapore dollar",
      "currency_code": "SGD",
      "currency_symbol": "$",
      "currency_numeric": 702,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Malay",
          "name_local": "bahasa Melayu",
          "iso_639_1": "ms",
          "iso_639_2": "msa",
          "iso_639_3": "msa"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇸🇬",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 702,
      "iso_3166_1_alpha2": "SG",
      "iso_3166_1_alpha3": "SGP",
      "tld": "sg",
      "vehicle_code": "SGP",
      "fips10": "SN",
      "un_locode": "SG",
      "stanag_1059": "SGP",
      "ioc": "SGP",
      "fifa": "SIN",
      "itu": "SNG",
      "uic": "",
      "maritime": "563, 564, 565, 566",
      "mmc": 525
    }
  },
  {
    "locale": "ta-LK",
    "language": {
      "name": "Tamil",
      "name_local": "தமிழ்",
      "iso_639_1": "ta",
      "iso_639_2": "tam",
      "iso_639_3": "tam",
      "countries": [
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Sri Lanka",
          "name_local": "ශ්‍රී ලංකා / இலங்கை",
          "code": "LK"
        }
      ]
    },
    "country": {
      "name": "Sri Lanka",
      "name_local": "ශ්‍රී ලංකා / இலங்கை",
      "code": "LK",
      "area_sq_km": 65610,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Colombo",
      "capital_latitude": 6.93194,
      "capital_longitude": 79.84778,
      "currency": "Sri Lanka Rupee",
      "currency_local": "Sri Lankan rupee",
      "currency_code": "LKR",
      "currency_symbol": "Rs  රු",
      "currency_numeric": 144,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Sinhalese",
          "name_local": "සිංහල",
          "iso_639_1": "si",
          "iso_639_2": "sin",
          "iso_639_3": "sin"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        }
      ],
      "flag": "🇱🇰",
      "timezones": [
        "UTC+05:30"
      ],
      "borders": [
        "IN"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 144,
      "iso_3166_1_alpha2": "LK",
      "iso_3166_1_alpha3": "LKA",
      "tld": "lk",
      "vehicle_code": "CL",
      "fips10": "CE",
      "un_locode": "LK",
      "stanag_1059": "LKA",
      "ioc": "SRI",
      "fifa": "SRI",
      "itu": "CLN",
      "uic": "",
      "maritime": 417,
      "mmc": 413
    }
  },
  {
    "locale": "tg-TJ",
    "language": {
      "name": "Tajik",
      "name_local": "тоҷикӣ",
      "iso_639_1": "tg",
      "iso_639_2": "tgk",
      "iso_639_3": "tgk",
      "countries": [
        {
          "name": "Tajikistan",
          "name_local": "Toçikiston / Тоҷикистон",
          "code": "TJ"
        }
      ]
    },
    "country": {
      "name": "Tajikistan",
      "name_local": "Toçikiston / Тоҷикистон",
      "code": "TJ",
      "area_sq_km": 143100,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Dushanbe",
      "capital_latitude": 38.53575,
      "capital_longitude": 68.77905,
      "currency": "Somoni",
      "currency_local": "Tajikistani somoni",
      "currency_code": "TJS",
      "currency_symbol": "ЅМ",
      "currency_numeric": 972,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Dirham",
      "languages": [
        {
          "name": "Tajik",
          "name_local": "тоҷикӣ",
          "iso_639_1": "tg",
          "iso_639_2": "tgk",
          "iso_639_3": "tgk"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇹🇯",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "CN",
        "KG",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 762,
      "iso_3166_1_alpha2": "TJ",
      "iso_3166_1_alpha3": "TJK",
      "tld": "tj",
      "vehicle_code": "TJ",
      "fips10": "TI",
      "un_locode": "TJ",
      "stanag_1059": "TJK",
      "ioc": "TJK",
      "fifa": "TJK",
      "itu": "TJK",
      "uic": "66 TJ",
      "maritime": 472,
      "mmc": 436
    }
  },
  {
    "locale": "th-TH",
    "language": {
      "name": "Thai",
      "name_local": "ไทย",
      "iso_639_1": "th",
      "iso_639_2": "tha",
      "iso_639_3": "tha",
      "countries": [
        {
          "name": "Thailand",
          "name_local": "Prathet Thai / ประเทศไทย",
          "code": "TH"
        }
      ]
    },
    "country": {
      "name": "Thailand",
      "name_local": "Prathet Thai / ประเทศไทย",
      "code": "TH",
      "area_sq_km": 513120,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Bangkok",
      "capital_latitude": 13.75398,
      "capital_longitude": 100.50144,
      "currency": "Thai Baht",
      "currency_local": "Thai baht",
      "currency_code": "THB",
      "currency_symbol": "฿",
      "currency_numeric": 764,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Satang",
      "languages": [
        {
          "name": "Thai",
          "name_local": "ไทย",
          "iso_639_1": "th",
          "iso_639_2": "tha",
          "iso_639_3": "tha"
        }
      ],
      "flag": "🇹🇭",
      "timezones": [
        "UTC+07:00"
      ],
      "borders": [
        "MM",
        "KH",
        "LA",
        "MY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 764,
      "iso_3166_1_alpha2": "TH",
      "iso_3166_1_alpha3": "THA",
      "tld": "th",
      "vehicle_code": "T",
      "fips10": "TH",
      "un_locode": "TH",
      "stanag_1059": "THA",
      "ioc": "THA",
      "fifa": "THA",
      "itu": "THA",
      "uic": "",
      "maritime": 567,
      "mmc": 520
    }
  },
  {
    "locale": "tig-ER",
    "language": {
      "name": "Tigre",
      "name_local": "ትግረ",
      "iso_639_1": "",
      "iso_639_2": "tig",
      "iso_639_3": "",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "ti-ER",
    "language": {
      "name": "Tigrinya",
      "name_local": "ትግርኛ",
      "iso_639_1": "ti",
      "iso_639_2": "tir",
      "iso_639_3": "tir",
      "countries": [
        {
          "name": "Eritrea",
          "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
          "code": "ER"
        }
      ]
    },
    "country": {
      "name": "Eritrea",
      "name_local": "ኤርትራ Ertra / إرتريا Iritriyyā",
      "code": "ER",
      "area_sq_km": 117600,
      "continent": "Africa",
      "region": "Eastern Africa",
      "capital_name": "Asmara",
      "capital_latitude": 15.33805,
      "capital_longitude": 38.93184,
      "currency": "Nakfa",
      "currency_local": "Eritrean nakfa",
      "currency_code": "ERN",
      "currency_symbol": "Nfk",
      "currency_numeric": 232,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Tigrinya",
          "name_local": "ትግርኛ",
          "iso_639_1": "ti",
          "iso_639_2": "tir",
          "iso_639_3": "tir"
        },
        {
          "name": "Arabic",
          "name_local": "العربية",
          "iso_639_1": "ar",
          "iso_639_2": "ara",
          "iso_639_3": "ara"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tigre",
          "name_local": "ትግረ",
          "iso_639_1": "",
          "iso_639_2": "tig",
          "iso_639_3": ""
        },
        {
          "name": "Kunama",
          "name_local": "Kunama",
          "iso_639_1": "",
          "iso_639_2": "kun",
          "iso_639_3": ""
        },
        {
          "name": "Saho",
          "name_local": "Saho",
          "iso_639_1": "",
          "iso_639_2": "ssy",
          "iso_639_3": ""
        },
        {
          "name": "Bilen",
          "name_local": "ብሊና",
          "iso_639_1": "",
          "iso_639_2": "byn",
          "iso_639_3": ""
        },
        {
          "name": "Nara",
          "name_local": "Nara",
          "iso_639_1": "",
          "iso_639_2": "nrb",
          "iso_639_3": ""
        },
        {
          "name": "Afar",
          "name_local": "Afar",
          "iso_639_1": "aa",
          "iso_639_2": "aar",
          "iso_639_3": "aar"
        }
      ],
      "flag": "🇪🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "DJ",
        "ET",
        "SD"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 232,
      "iso_3166_1_alpha2": "ER",
      "iso_3166_1_alpha3": "ERI",
      "tld": "er",
      "vehicle_code": "ER",
      "fips10": "ER",
      "un_locode": "ER",
      "stanag_1059": "ERI",
      "ioc": "ERI",
      "fifa": "ERI",
      "itu": "ERI",
      "uic": "",
      "maritime": 625,
      "mmc": 657
    }
  },
  {
    "locale": "to-TO",
    "language": {
      "name": "Tonga (Tonga Islands)",
      "name_local": "faka Tonga",
      "iso_639_1": "to",
      "iso_639_2": "ton",
      "iso_639_3": "ton",
      "countries": [
        {
          "name": "Tonga",
          "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
          "code": "TO"
        }
      ]
    },
    "country": {
      "name": "Tonga",
      "name_local": "Puleʻanga Fakatuʻi ʻo Tonga",
      "code": "TO",
      "area_sq_km": 747,
      "continent": "Oceania",
      "region": "Polynesia",
      "capital_name": "Nuku‘alofa",
      "capital_latitude": -21.13938,
      "capital_longitude": -175.2018,
      "currency": "Pa'anga",
      "currency_local": "Tongan paʻanga",
      "currency_code": "TOP",
      "currency_symbol": "T$",
      "currency_numeric": 776,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Seniti",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tonga (Tonga Islands)",
          "name_local": "faka Tonga",
          "iso_639_1": "to",
          "iso_639_2": "ton",
          "iso_639_3": "ton"
        }
      ],
      "flag": "🇹🇴",
      "timezones": [
        "UTC+13:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 776,
      "iso_3166_1_alpha2": "TO",
      "iso_3166_1_alpha3": "TON",
      "tld": "to",
      "vehicle_code": "TON",
      "fips10": "TN",
      "un_locode": "TO",
      "stanag_1059": "TON",
      "ioc": "TGA",
      "fifa": "TGA",
      "itu": "TON",
      "uic": "",
      "maritime": 570,
      "mmc": 539
    }
  },
  {
    "locale": "tn-BW",
    "language": {
      "name": "Tswana",
      "name_local": "Setswana",
      "iso_639_1": "tn",
      "iso_639_2": "tsn",
      "iso_639_3": "tsn",
      "countries": [
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "Botswana",
      "name_local": "Botswana",
      "code": "BW",
      "area_sq_km": 582000,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Gaborone",
      "capital_latitude": -24.65451,
      "capital_longitude": 25.90859,
      "currency": "Pula",
      "currency_local": "Botswana pula",
      "currency_code": "BWP",
      "currency_symbol": "P",
      "currency_numeric": 72,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Thebe",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        }
      ],
      "flag": "🇧🇼",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "NA",
        "ZA",
        "ZM",
        "ZW"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 72,
      "iso_3166_1_alpha2": "BW",
      "iso_3166_1_alpha3": "BWA",
      "tld": "bw",
      "vehicle_code": "RB",
      "fips10": "BC",
      "un_locode": "BW",
      "stanag_1059": "BWA",
      "ioc": "BOT",
      "fifa": "BOT",
      "itu": "BOT",
      "uic": "",
      "maritime": 611,
      "mmc": 652
    }
  },
  {
    "locale": "tn-ZA",
    "language": {
      "name": "Tswana",
      "name_local": "Setswana",
      "iso_639_1": "tn",
      "iso_639_2": "tsn",
      "iso_639_3": "tsn",
      "countries": [
        {
          "name": "Botswana",
          "name_local": "Botswana",
          "code": "BW"
        },
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "ts-ZA",
    "language": {
      "name": "Tsonga",
      "name_local": "Xitsonga",
      "iso_639_1": "ts",
      "iso_639_2": "tso",
      "iso_639_3": "tso",
      "countries": [
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "tk-AF",
    "language": {
      "name": "Turkmen",
      "name_local": "Türkmen",
      "iso_639_1": "tk",
      "iso_639_2": "tuk",
      "iso_639_3": "tuk",
      "countries": [
        {
          "name": "Afghanistan",
          "name_local": "افغانستان Afghānestān",
          "code": "AF"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        }
      ]
    },
    "country": {
      "name": "Afghanistan",
      "name_local": "افغانستان Afghānestān",
      "code": "AF",
      "area_sq_km": 652230,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Kabul",
      "capital_latitude": 34.52813,
      "capital_longitude": 69.17233,
      "currency": "Afghani",
      "currency_local": "Afghan afghani",
      "currency_code": "AFN",
      "currency_symbol": "؋",
      "currency_numeric": 971,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Puls",
      "languages": [
        {
          "name": "Pashto",
          "name_local": "پښتو",
          "iso_639_1": "ps",
          "iso_639_2": "pus",
          "iso_639_3": "pus"
        },
        {
          "name": "Uzbek",
          "name_local": "Oʻzbek",
          "iso_639_1": "uz",
          "iso_639_2": "uzb",
          "iso_639_3": "uzb"
        },
        {
          "name": "Turkmen",
          "name_local": "Türkmen",
          "iso_639_1": "tk",
          "iso_639_2": "tuk",
          "iso_639_3": "tuk"
        }
      ],
      "flag": "🇦🇫",
      "timezones": [
        "UTC+04:30"
      ],
      "borders": [
        "IR",
        "PK",
        "TM",
        "UZ",
        "TJ",
        "CN"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 4,
      "iso_3166_1_alpha2": "AF",
      "iso_3166_1_alpha3": "AFG",
      "tld": "af",
      "vehicle_code": "AFG",
      "fips10": "AF",
      "un_locode": "AF",
      "stanag_1059": "AFG",
      "ioc": "AFG",
      "fifa": "AFG",
      "itu": "AFG",
      "uic": "68 AF",
      "maritime": 401,
      "mmc": 412
    }
  },
  {
    "locale": "tk-TM",
    "language": {
      "name": "Turkmen",
      "name_local": "Türkmen",
      "iso_639_1": "tk",
      "iso_639_2": "tuk",
      "iso_639_3": "tuk",
      "countries": [
        {
          "name": "Afghanistan",
          "name_local": "افغانستان Afghānestān",
          "code": "AF"
        },
        {
          "name": "Turkmenistan",
          "name_local": "Türkmenostan",
          "code": "TM"
        }
      ]
    },
    "country": {
      "name": "Turkmenistan",
      "name_local": "Türkmenostan",
      "code": "TM",
      "area_sq_km": 488100,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Ashgabat",
      "capital_latitude": 37.95,
      "capital_longitude": 58.38333,
      "currency": "Turkmen Manat",
      "currency_local": "Turkmenistan manat",
      "currency_code": "TMT",
      "currency_symbol": "m",
      "currency_numeric": 934,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tenge",
      "languages": [
        {
          "name": "Turkmen",
          "name_local": "Türkmen",
          "iso_639_1": "tk",
          "iso_639_2": "tuk",
          "iso_639_3": "tuk"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇹🇲",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "IR",
        "KZ",
        "UZ"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 795,
      "iso_3166_1_alpha2": "TM",
      "iso_3166_1_alpha3": "TKM",
      "tld": "tm",
      "vehicle_code": "TM",
      "fips10": "TX",
      "un_locode": "TM",
      "stanag_1059": "TKM",
      "ioc": "TKM",
      "fifa": "TKM",
      "itu": "TKM",
      "uic": "67 TM",
      "maritime": 434,
      "mmc": 438
    }
  },
  {
    "locale": "tr-TR",
    "language": {
      "name": "Turkish",
      "name_local": "Türkçe",
      "iso_639_1": "tr",
      "iso_639_2": "tur",
      "iso_639_3": "tur",
      "countries": [
        {
          "name": "Turkey",
          "name_local": "Türkiye Cumhuriyeti",
          "code": "TR"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Turkey",
      "name_local": "Türkiye Cumhuriyeti",
      "code": "TR",
      "area_sq_km": 783562,
      "continent": "Asia",
      "region": "Western Asia",
      "capital_name": "Ankara",
      "capital_latitude": 39.91987,
      "capital_longitude": 32.85427,
      "currency": "Turkish Lira",
      "currency_local": "Turkish lira",
      "currency_code": "TRY",
      "currency_symbol": "₺",
      "currency_numeric": 949,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kurus",
      "languages": [
        {
          "name": "Turkish",
          "name_local": "Türkçe",
          "iso_639_1": "tr",
          "iso_639_2": "tur",
          "iso_639_3": "tur"
        }
      ],
      "flag": "🇹🇷",
      "timezones": [
        "UTC+03:00"
      ],
      "borders": [
        "AM",
        "AZ",
        "BG",
        "GE",
        "GR",
        "IR",
        "IQ",
        "SY"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 792,
      "iso_3166_1_alpha2": "TR",
      "iso_3166_1_alpha3": "TUR",
      "tld": "tr",
      "vehicle_code": "TR",
      "fips10": "TU",
      "un_locode": "TR",
      "stanag_1059": "TUR",
      "ioc": "TUR",
      "fifa": "TUR",
      "itu": "TUR",
      "uic": "75 TR",
      "maritime": 271,
      "mmc": 286
    }
  },
  {
    "locale": "tr-CY",
    "language": {
      "name": "Turkish",
      "name_local": "Türkçe",
      "iso_639_1": "tr",
      "iso_639_2": "tur",
      "iso_639_3": "tur",
      "countries": [
        {
          "name": "Turkey",
          "name_local": "Türkiye Cumhuriyeti",
          "code": "TR"
        },
        {
          "name": "Cyprus",
          "name_local": "Κύπρος / Kypros / Kıbrıs",
          "code": "CY"
        }
      ]
    },
    "country": {
      "name": "Cyprus",
      "name_local": "Κύπρος / Kypros / Kıbrıs",
      "code": "CY",
      "area_sq_km": 9251,
      "continent": "Asia",
      "region": "Southern Europe",
      "capital_name": "Nicosia",
      "capital_latitude": 35.17531,
      "capital_longitude": 33.3642,
      "currency": "Euro",
      "currency_local": "Euro",
      "currency_code": "EUR",
      "currency_symbol": "€",
      "currency_numeric": 978,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cent",
      "languages": [
        {
          "name": "Greek (modern)",
          "name_local": "ελληνικά",
          "iso_639_1": "el",
          "iso_639_2": "ell",
          "iso_639_3": "ell"
        },
        {
          "name": "Turkish",
          "name_local": "Türkçe",
          "iso_639_1": "tr",
          "iso_639_2": "tur",
          "iso_639_3": "tur"
        },
        {
          "name": "Armenian",
          "name_local": "Հայերեն",
          "iso_639_1": "hy",
          "iso_639_2": "hye",
          "iso_639_3": "hye"
        }
      ],
      "flag": "🇨🇾",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 196,
      "iso_3166_1_alpha2": "CY",
      "iso_3166_1_alpha3": "CYP",
      "tld": "cy",
      "vehicle_code": "CY",
      "fips10": "CY",
      "un_locode": "CY",
      "stanag_1059": "CYP",
      "ioc": "CYP",
      "fifa": "CYP",
      "itu": "CYP",
      "uic": "",
      "maritime": "209, 210, 212",
      "mmc": 280
    }
  },
  {
    "locale": "uk-UA",
    "language": {
      "name": "Ukrainian",
      "name_local": "Українська",
      "iso_639_1": "uk",
      "iso_639_2": "ukr",
      "iso_639_3": "ukr",
      "countries": [
        {
          "name": "Ukraine",
          "name_local": "Ukrajina / Україна",
          "code": "UA"
        }
      ]
    },
    "country": {
      "name": "Ukraine",
      "name_local": "Ukrajina / Україна",
      "code": "UA",
      "area_sq_km": 603500,
      "continent": "Europe",
      "region": "Eastern Europe",
      "capital_name": "Kyiv",
      "capital_latitude": 50.45466,
      "capital_longitude": 30.5238,
      "currency": "Hrywnja",
      "currency_local": "Ukrainian hryvnia",
      "currency_code": "UAH",
      "currency_symbol": "₴",
      "currency_numeric": 980,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Kopeken",
      "languages": [
        {
          "name": "Ukrainian",
          "name_local": "Українська",
          "iso_639_1": "uk",
          "iso_639_2": "ukr",
          "iso_639_3": "ukr"
        }
      ],
      "flag": "🇺🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BY",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 804,
      "iso_3166_1_alpha2": "UA",
      "iso_3166_1_alpha3": "UKR",
      "tld": "ua",
      "vehicle_code": "UA",
      "fips10": "UP",
      "un_locode": "UA",
      "stanag_1059": "UKR",
      "ioc": "UKR",
      "fifa": "UKR",
      "itu": "UKR",
      "uic": "22 UA",
      "maritime": 272,
      "mmc": 255
    }
  },
  {
    "locale": "ur-PK",
    "language": {
      "name": "Urdu",
      "name_local": "اردو",
      "iso_639_1": "ur",
      "iso_639_2": "urd",
      "iso_639_3": "urd",
      "countries": [
        {
          "name": "Pakistan",
          "name_local": "Pakistan",
          "code": "PK"
        }
      ]
    },
    "country": {
      "name": "Pakistan",
      "name_local": "Pakistan",
      "code": "PK",
      "area_sq_km": 881912,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Islamabad",
      "capital_latitude": 33.72148,
      "capital_longitude": 73.04329,
      "currency": "Pakistanian Rupee",
      "currency_local": "Pakistani rupee",
      "currency_code": "PKR",
      "currency_symbol": "₨",
      "currency_numeric": 586,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Paisa",
      "languages": [
        {
          "name": "Urdu",
          "name_local": "اردو",
          "iso_639_1": "ur",
          "iso_639_2": "urd",
          "iso_639_3": "urd"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        }
      ],
      "flag": "🇵🇰",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "CN",
        "IN",
        "IR"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 586,
      "iso_3166_1_alpha2": "PK",
      "iso_3166_1_alpha3": "PAK",
      "tld": "pk",
      "vehicle_code": "PK",
      "fips10": "PK",
      "un_locode": "PK",
      "stanag_1059": "PAK",
      "ioc": "PAK",
      "fifa": "PAK",
      "itu": "PAK",
      "uic": "",
      "maritime": 463,
      "mmc": 410
    }
  },
  {
    "locale": "uz-AF",
    "language": {
      "name": "Uzbek",
      "name_local": "Oʻzbek",
      "iso_639_1": "uz",
      "iso_639_2": "uzb",
      "iso_639_3": "uzb",
      "countries": [
        {
          "name": "Afghanistan",
          "name_local": "افغانستان Afghānestān",
          "code": "AF"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Afghanistan",
      "name_local": "افغانستان Afghānestān",
      "code": "AF",
      "area_sq_km": 652230,
      "continent": "Asia",
      "region": "Southern Asia",
      "capital_name": "Kabul",
      "capital_latitude": 34.52813,
      "capital_longitude": 69.17233,
      "currency": "Afghani",
      "currency_local": "Afghan afghani",
      "currency_code": "AFN",
      "currency_symbol": "؋",
      "currency_numeric": 971,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Puls",
      "languages": [
        {
          "name": "Pashto",
          "name_local": "پښتو",
          "iso_639_1": "ps",
          "iso_639_2": "pus",
          "iso_639_3": "pus"
        },
        {
          "name": "Uzbek",
          "name_local": "Oʻzbek",
          "iso_639_1": "uz",
          "iso_639_2": "uzb",
          "iso_639_3": "uzb"
        },
        {
          "name": "Turkmen",
          "name_local": "Türkmen",
          "iso_639_1": "tk",
          "iso_639_2": "tuk",
          "iso_639_3": "tuk"
        }
      ],
      "flag": "🇦🇫",
      "timezones": [
        "UTC+04:30"
      ],
      "borders": [
        "IR",
        "PK",
        "TM",
        "UZ",
        "TJ",
        "CN"
      ],
      "is_landlocked": true,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 4,
      "iso_3166_1_alpha2": "AF",
      "iso_3166_1_alpha3": "AFG",
      "tld": "af",
      "vehicle_code": "AFG",
      "fips10": "AF",
      "un_locode": "AF",
      "stanag_1059": "AFG",
      "ioc": "AFG",
      "fifa": "AFG",
      "itu": "AFG",
      "uic": "68 AF",
      "maritime": 401,
      "mmc": 412
    }
  },
  {
    "locale": "uz-UZ",
    "language": {
      "name": "Uzbek",
      "name_local": "Oʻzbek",
      "iso_639_1": "uz",
      "iso_639_2": "uzb",
      "iso_639_3": "uzb",
      "countries": [
        {
          "name": "Afghanistan",
          "name_local": "افغانستان Afghānestān",
          "code": "AF"
        },
        {
          "name": "Uzbekistan",
          "name_local": "Oʻzbekiston",
          "code": "UZ"
        }
      ]
    },
    "country": {
      "name": "Uzbekistan",
      "name_local": "Oʻzbekiston",
      "code": "UZ",
      "area_sq_km": 447400,
      "continent": "Asia",
      "region": "Central Asia",
      "capital_name": "Tashkent",
      "capital_latitude": 41.26465,
      "capital_longitude": 69.21627,
      "currency": "Uzbekistan Sum",
      "currency_local": "Uzbekistani soʻm",
      "currency_code": "UZS",
      "currency_symbol": "so'm",
      "currency_numeric": 860,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Tiyin",
      "languages": [
        {
          "name": "Uzbek",
          "name_local": "Oʻzbek",
          "iso_639_1": "uz",
          "iso_639_2": "uzb",
          "iso_639_3": "uzb"
        },
        {
          "name": "Russian",
          "name_local": "Русский",
          "iso_639_1": "ru",
          "iso_639_2": "rus",
          "iso_639_3": "rus"
        }
      ],
      "flag": "🇺🇿",
      "timezones": [
        "UTC+05:00"
      ],
      "borders": [
        "AF",
        "KZ",
        "KG",
        "TJ",
        "TM"
      ],
      "is_landlocked": true,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 860,
      "iso_3166_1_alpha2": "UZ",
      "iso_3166_1_alpha3": "UZB",
      "tld": "uz",
      "vehicle_code": "UZ",
      "fips10": "UZ",
      "un_locode": "UZ",
      "stanag_1059": "UZB",
      "ioc": "UZB",
      "fifa": "UZB",
      "itu": "UZB",
      "uic": "29 UZ",
      "maritime": 437,
      "mmc": 434
    }
  },
  {
    "locale": "ve-ZA",
    "language": {
      "name": "Venda",
      "name_local": "Tshivenḓa",
      "iso_639_1": "ve",
      "iso_639_2": "ven",
      "iso_639_3": "ven",
      "countries": [
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "vi-VN",
    "language": {
      "name": "Vietnamese",
      "name_local": "Tiếng Việt",
      "iso_639_1": "vi",
      "iso_639_2": "vie",
      "iso_639_3": "vie",
      "countries": [
        {
          "name": "Vietnam",
          "name_local": "Viêt Nam",
          "code": "VN"
        }
      ]
    },
    "country": {
      "name": "Vietnam",
      "name_local": "Viêt Nam",
      "code": "VN",
      "area_sq_km": 331212,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Hanoi",
      "capital_latitude": 21.0245,
      "capital_longitude": 105.84117,
      "currency": "Dong",
      "currency_local": "Vietnamese đồng",
      "currency_code": "VND",
      "currency_symbol": "₫",
      "currency_numeric": 704,
      "currency_subunit_value": 10,
      "currency_subunit_name": "Hào",
      "languages": [
        {
          "name": "Vietnamese",
          "name_local": "Tiếng Việt",
          "iso_639_1": "vi",
          "iso_639_2": "vie",
          "iso_639_3": "vie"
        }
      ],
      "flag": "🇻🇳",
      "timezones": [
        "UTC+07:00"
      ],
      "borders": [
        "KH",
        "CN",
        "LA"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 704,
      "iso_3166_1_alpha2": "VN",
      "iso_3166_1_alpha3": "VNM",
      "tld": "vn",
      "vehicle_code": "VN",
      "fips10": "VM",
      "un_locode": "VN",
      "stanag_1059": "VNM",
      "ioc": "VIE",
      "fifa": "VIE",
      "itu": "VTN",
      "uic": "32 VN",
      "maritime": 574,
      "mmc": 452
    }
  },
  {
    "locale": "xh-ZA",
    "language": {
      "name": "Xhosa",
      "name_local": "isiXhosa",
      "iso_639_1": "xh",
      "iso_639_2": "xho",
      "iso_639_3": "xho",
      "countries": [
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  },
  {
    "locale": "zh-CN",
    "language": {
      "name": "Chinese",
      "name_local": "中文 (Zhōngwén)",
      "iso_639_1": "zh",
      "iso_639_2": "zho",
      "iso_639_3": "zho",
      "countries": [
        {
          "name": "China",
          "name_local": "中國 / 中国 / Zhōngguó",
          "code": "CN"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Taiwan",
          "name_local": "中華民國 / T’ai-wan",
          "code": "TW"
        }
      ]
    },
    "country": {
      "name": "China",
      "name_local": "中國 / 中国 / Zhōngguó",
      "code": "CN",
      "area_sq_km": 9706961,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Beijing",
      "capital_latitude": 39.9075,
      "capital_longitude": 116.39723,
      "currency": "Renminbi Yuan",
      "currency_local": "Chinese yuan",
      "currency_code": "CNY",
      "currency_symbol": "¥",
      "currency_numeric": 156,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Fen",
      "languages": [
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇨🇳",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "AF",
        "BT",
        "MM",
        "HK",
        "IN",
        "KZ",
        "NP",
        "KP",
        "KG",
        "LA",
        "MO",
        "MN",
        "PK",
        "RU",
        "TJ",
        "VN"
      ],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 156,
      "iso_3166_1_alpha2": "CN",
      "iso_3166_1_alpha3": "CHN",
      "tld": "cn",
      "vehicle_code": "CHN",
      "fips10": "CH",
      "un_locode": "CN",
      "stanag_1059": "CHN",
      "ioc": "CHN",
      "fifa": "CHN",
      "itu": "CHN",
      "uic": "33 RC",
      "maritime": "412, 413, 414",
      "mmc": "460, 461"
    }
  },
  {
    "locale": "zh-HK",
    "language": {
      "name": "Chinese",
      "name_local": "中文 (Zhōngwén)",
      "iso_639_1": "zh",
      "iso_639_2": "zho",
      "iso_639_3": "zho",
      "countries": [
        {
          "name": "China",
          "name_local": "中國 / 中国 / Zhōngguó",
          "code": "CN"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Taiwan",
          "name_local": "中華民國 / T’ai-wan",
          "code": "TW"
        }
      ]
    },
    "country": {
      "name": "Hong Kong",
      "name_local": "香港 / Xiānggǎng",
      "code": "HK",
      "area_sq_km": 1104,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Hong Kong",
      "capital_latitude": 22.28552,
      "capital_longitude": 114.15769,
      "currency": "Hong Kong Dollar",
      "currency_local": "Hong Kong dollar",
      "currency_code": "HKD",
      "currency_symbol": "$",
      "currency_numeric": 344,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇭🇰",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "CN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 344,
      "iso_3166_1_alpha2": "HK",
      "iso_3166_1_alpha3": "HKG",
      "tld": "hk",
      "vehicle_code": "HK",
      "fips10": "HK",
      "un_locode": "HK",
      "stanag_1059": "HKG",
      "ioc": "HKG",
      "fifa": "HKG",
      "itu": "HKG",
      "uic": "",
      "maritime": 477,
      "mmc": 454
    }
  },
  {
    "locale": "zh-MO",
    "language": {
      "name": "Chinese",
      "name_local": "中文 (Zhōngwén)",
      "iso_639_1": "zh",
      "iso_639_2": "zho",
      "iso_639_3": "zho",
      "countries": [
        {
          "name": "China",
          "name_local": "中國 / 中国 / Zhōngguó",
          "code": "CN"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Taiwan",
          "name_local": "中華民國 / T’ai-wan",
          "code": "TW"
        }
      ]
    },
    "country": {
      "name": "Macao",
      "name_local": "Macau, Aomen",
      "code": "MO",
      "area_sq_km": 30,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Concelho de Macau",
      "capital_latitude": 22.20056,
      "capital_longitude": 113.54611,
      "currency": "Macanese Pataca",
      "currency_local": "Macanese pataca",
      "currency_code": "MOP",
      "currency_symbol": "P",
      "currency_numeric": 446,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Avos",
      "languages": [
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        },
        {
          "name": "Portuguese",
          "name_local": "Português",
          "iso_639_1": "pt",
          "iso_639_2": "por",
          "iso_639_3": "por"
        }
      ],
      "flag": "🇲🇴",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "CN"
      ],
      "is_landlocked": false,
      "postal_code_format": "",
      "postal_code_regex": "",
      "iso_3166_1_numeric": 446,
      "iso_3166_1_alpha2": "MO",
      "iso_3166_1_alpha3": "MAC",
      "tld": "mo",
      "vehicle_code": "",
      "fips10": "MC",
      "un_locode": "MO",
      "stanag_1059": "MAC",
      "ioc": "",
      "fifa": "MAC",
      "itu": "MAC",
      "uic": "",
      "maritime": 453,
      "mmc": 455
    }
  },
  {
    "locale": "zh-SG",
    "language": {
      "name": "Chinese",
      "name_local": "中文 (Zhōngwén)",
      "iso_639_1": "zh",
      "iso_639_2": "zho",
      "iso_639_3": "zho",
      "countries": [
        {
          "name": "China",
          "name_local": "中國 / 中国 / Zhōngguó",
          "code": "CN"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Taiwan",
          "name_local": "中華民國 / T’ai-wan",
          "code": "TW"
        }
      ]
    },
    "country": {
      "name": "Singapore",
      "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
      "code": "SG",
      "area_sq_km": 710,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Singapore",
      "capital_latitude": 1.28967,
      "capital_longitude": 103.85007,
      "currency": "Singapore Dollar",
      "currency_local": "Singapore dollar",
      "currency_code": "SGD",
      "currency_symbol": "$",
      "currency_numeric": 702,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Malay",
          "name_local": "bahasa Melayu",
          "iso_639_1": "ms",
          "iso_639_2": "msa",
          "iso_639_3": "msa"
        },
        {
          "name": "Tamil",
          "name_local": "தமிழ்",
          "iso_639_1": "ta",
          "iso_639_2": "tam",
          "iso_639_3": "tam"
        },
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇸🇬",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "######",
      "postal_code_regex": "^(\\d{6})$",
      "iso_3166_1_numeric": 702,
      "iso_3166_1_alpha2": "SG",
      "iso_3166_1_alpha3": "SGP",
      "tld": "sg",
      "vehicle_code": "SGP",
      "fips10": "SN",
      "un_locode": "SG",
      "stanag_1059": "SGP",
      "ioc": "SGP",
      "fifa": "SIN",
      "itu": "SNG",
      "uic": "",
      "maritime": "563, 564, 565, 566",
      "mmc": 525
    }
  },
  {
    "locale": "zh-TW",
    "language": {
      "name": "Chinese",
      "name_local": "中文 (Zhōngwén)",
      "iso_639_1": "zh",
      "iso_639_2": "zho",
      "iso_639_3": "zho",
      "countries": [
        {
          "name": "China",
          "name_local": "中國 / 中国 / Zhōngguó",
          "code": "CN"
        },
        {
          "name": "Hong Kong",
          "name_local": "香港 / Xiānggǎng",
          "code": "HK"
        },
        {
          "name": "Macao",
          "name_local": "Macau, Aomen",
          "code": "MO"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        },
        {
          "name": "Taiwan",
          "name_local": "中華民國 / T’ai-wan",
          "code": "TW"
        }
      ]
    },
    "country": {
      "name": "Taiwan",
      "name_local": "中華民國 / T’ai-wan",
      "code": "TW",
      "area_sq_km": 36193,
      "continent": "Asia",
      "region": "Eastern Asia",
      "capital_name": "Taipei",
      "capital_latitude": 25.04776,
      "capital_longitude": 121.53185,
      "currency": "New Taiwan Dollar",
      "currency_local": "New Taiwan dollar",
      "currency_code": "TWD",
      "currency_symbol": "$",
      "currency_numeric": 901,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Chinese",
          "name_local": "中文 (Zhōngwén)",
          "iso_639_1": "zh",
          "iso_639_2": "zho",
          "iso_639_3": "zho"
        }
      ],
      "flag": "🇹🇼",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 158,
      "iso_3166_1_alpha2": "TW",
      "iso_3166_1_alpha3": "TWN",
      "tld": "tw",
      "vehicle_code": "RC",
      "fips10": "TW",
      "un_locode": "TW",
      "stanag_1059": "TWN",
      "ioc": "TPE",
      "fifa": "TPE",
      "itu": "",
      "uic": "",
      "maritime": 416,
      "mmc": 466
    }
  },
  {
    "locale": "ms-MY",
    "language": {
      "name": "Malay",
      "name_local": "bahasa Melayu",
      "iso_639_1": "ms",
      "iso_639_2": "msa",
      "iso_639_3": "msa",
      "countries": [
        {
          "name": "Brunei",
          "name_local": "نݢارا بروني دار السلام",
          "code": "BN"
        },
        {
          "name": "Singapore",
          "name_local": "Singapore / Singapura / 新加坡共和国 / சிங்கப்பூர்",
          "code": "SG"
        }
      ]
    },
    "country": {
      "name": "Malaysia",
      "name_local": "Malaysia",
      "code": "MY",
      "area_sq_km": 330803,
      "continent": "Asia",
      "region": "South-Eastern Asia",
      "capital_name": "Kuala Lumpur",
      "capital_latitude": 3.1412,
      "capital_longitude": 101.68653,
      "currency": "Ringgit",
      "currency_local": "Malaysian ringgit",
      "currency_code": "MYR",
      "currency_symbol": "RM",
      "currency_numeric": 458,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Sen",
      "languages": [
        {
          "name": "Malaysian",
          "name_local": "بهاس مليسيا",
          "iso_639_1": "ms",
          "iso_639_2": "zsm",
          "iso_639_3": "msa"
        }
      ],
      "flag": "🇲🇾",
      "timezones": [
        "UTC+08:00"
      ],
      "borders": [
        "BN",
        "ID",
        "TH"
      ],
      "is_landlocked": false,
      "postal_code_format": "#####",
      "postal_code_regex": "^(\\d{5})$",
      "iso_3166_1_numeric": 458,
      "iso_3166_1_alpha2": "MY",
      "iso_3166_1_alpha3": "MYS",
      "tld": "my",
      "vehicle_code": "MAL",
      "fips10": "MY",
      "un_locode": "MY",
      "stanag_1059": "MYS",
      "ioc": "MAS",
      "fifa": "MAS",
      "itu": "MLA",
      "uic": "",
      "maritime": 533,
      "mmc": 502
    }
  },
  {
    "locale": "zu-ZA",
    "language": {
      "name": "Zulu",
      "name_local": "isiZulu",
      "iso_639_1": "zu",
      "iso_639_2": "zul",
      "iso_639_3": "zul",
      "countries": [
        {
          "name": "South Africa",
          "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
          "code": "ZA"
        }
      ]
    },
    "country": {
      "name": "South Africa",
      "name_local": "Suid-Afrika / South Africa / Sewula Afrika",
      "code": "ZA",
      "area_sq_km": 1221037,
      "continent": "Africa",
      "region": "Southern Africa",
      "capital_name": "Pretoria",
      "capital_latitude": -25.74486,
      "capital_longitude": 28.18783,
      "currency": "South African Rand",
      "currency_local": "South African rand",
      "currency_code": "ZAR",
      "currency_symbol": "R",
      "currency_numeric": 710,
      "currency_subunit_value": 100,
      "currency_subunit_name": "Cents",
      "languages": [
        {
          "name": "Afrikaans",
          "name_local": "Afrikaans",
          "iso_639_1": "af",
          "iso_639_2": "afr",
          "iso_639_3": "afr"
        },
        {
          "name": "English",
          "name_local": "English",
          "iso_639_1": "en",
          "iso_639_2": "eng",
          "iso_639_3": "eng"
        },
        {
          "name": "Southern Ndebele",
          "name_local": "isiNdebele",
          "iso_639_1": "nr",
          "iso_639_2": "nbl",
          "iso_639_3": "nbl"
        },
        {
          "name": "Southern Sotho",
          "name_local": "Sesotho",
          "iso_639_1": "st",
          "iso_639_2": "sot",
          "iso_639_3": "sot"
        },
        {
          "name": "Swati",
          "name_local": "SiSwati",
          "iso_639_1": "ss",
          "iso_639_2": "ssw",
          "iso_639_3": "ssw"
        },
        {
          "name": "Tswana",
          "name_local": "Setswana",
          "iso_639_1": "tn",
          "iso_639_2": "tsn",
          "iso_639_3": "tsn"
        },
        {
          "name": "Tsonga",
          "name_local": "Xitsonga",
          "iso_639_1": "ts",
          "iso_639_2": "tso",
          "iso_639_3": "tso"
        },
        {
          "name": "Venda",
          "name_local": "Tshivenḓa",
          "iso_639_1": "ve",
          "iso_639_2": "ven",
          "iso_639_3": "ven"
        },
        {
          "name": "Xhosa",
          "name_local": "isiXhosa",
          "iso_639_1": "xh",
          "iso_639_2": "xho",
          "iso_639_3": "xho"
        },
        {
          "name": "Zulu",
          "name_local": "isiZulu",
          "iso_639_1": "zu",
          "iso_639_2": "zul",
          "iso_639_3": "zul"
        }
      ],
      "flag": "🇿🇦",
      "timezones": [
        "UTC+02:00"
      ],
      "borders": [
        "BW",
        "LS",
        "MZ",
        "NA",
        "SZ",
        "ZW"
      ],
      "is_landlocked": false,
      "postal_code_format": "####",
      "postal_code_regex": "^(\\d{4})$",
      "iso_3166_1_numeric": 710,
      "iso_3166_1_alpha2": "ZA",
      "iso_3166_1_alpha3": "ZAF",
      "tld": "za",
      "vehicle_code": "ZA",
      "fips10": "SF",
      "un_locode": "ZA",
      "stanag_1059": "ZAF",
      "ioc": "RSA",
      "fifa": "RSA",
      "itu": "AFS",
      "uic": "ZA",
      "maritime": 601,
      "mmc": 655
    }
  }
]